export default {
  'studio.business_bank_setting.title1': '个人/公司信息',
  'studio.business_bank_setting.guide1': '游戏分级<br/>审核必备材料',
  'studio.business_bank_setting.guide1_1': '请务必准备以下材料',
  'studio.business_bank_setting.guide1_2': '个人（未注册企业）：居民登记簿或护照',
  'studio.business_bank_setting.guide1_4': '公司（个体/法人）：营业执照',
  'studio.business_bank_setting.title2': '银行信息',
  'studio.business_bank_setting.guide2': '输入的账户信息将用于商品销售款项的结算！',
  'studio.business_bank_setting.bank_component_guide2_1': '请准备好存折复印件，填写相关信息。',
  'studio.business_bank_setting.group_settings': '团队设置',
  'studio.business_bank_setting.group_history': '管理历史',
  'studio.business_bank_setting.group_discontinue': '删除团队',
  'studio.business_bank_setting.guide2_1': '为什么需要个人/营业执照信息？ ',
  'studio.business_bank_setting.guide2_2': '发布游戏前，需要提供个人/企业信息才能进行游戏分级审核。<br/>审核最长需要3个工作日，建议提前申请。',
  'studio.business_bank_setting.guide2_3': '证明材料用途为何？',
  'studio.business_bank_setting.guide2_4': '用于确认输入的信息与实际文件是否一致。',
  'studio.business_bank_setting.guide2_5': '游戏制作（发行）业申报编号是什么？',
  'studio.business_bank_setting.guide2_6': '想要在韩国制作游戏进行销售或发行时，需要进行游戏制作（发行）业申报。该项为选填项，若不适用则无需填写！',
  'studio.business_bank_setting.guide2_7': '通信销售业申报编号是什么？',
  'studio.business_bank_setting.guide2_8': '想要在韩国向消费者网上销售商品时，需要进行通信销售业申报！<br/>该项为选填项，若不适用则无需填写！',
  'studio.business_bank_setting.guide2_9': '营业执照号 / 税务登记号',
  'studio.business_bank_setting.guide2_10': '可输入公司的营业执照号或税务登记号。<br/>营业执照号或税务登记号属于必填项。',
  'studio.business_bank_setting.guide2_11': '韩国游戏制作（发行）业申报编号是什么？',
  'studio.business_bank_setting.guide2_12': '想要在韩国制作游戏进行销售或发行时，需要进行游戏制作（发行）业申报。该项为选填项，若不适用则无需填写！',
  'studio.business_bank_setting.guide2_13': '韩国通信销售业申报编号是什么？',
  'studio.business_bank_setting.guide2_14': '想要在韩国向消费者网上销售商品时，需要进行通信销售业申报！<br/>该项为选填项，若不适用则无需填写！',
  'studio.business_bank_setting.guide2_15': '韩国营业执照号是什么？',
  'studio.business_bank_setting.guide2_16': '如果在韩国已办理营业登记，请上传韩国营业执照和注册号码。<br/>这是可选项，如不适用可以不填写！',
  'studio.business_bank_setting.guide2_17': '显示范例',
  'studio.business_bank_setting.in_review_guide1': '审核中',
  'studio.business_bank_setting.in_review_guide1_1':
    '审核需要约3个工作日，具体时间可能会根据情况有所调整。<br/>审核完成后，我们将通过邮件和系统通知您。',
  'studio.business_bank_setting.btn_details': '审核记录',
  'studio.business_bank_setting.btn_info': '提交内容',
  'studio.business_bank_setting.in_review_guide2': '审核中',
  'studio.business_bank_setting.in_review_guide2_1':
    '审核需要约3个工作日，具体时间可能会根据情况有所调整。<br/>审核完成后，我们将通过邮件和系统通知您。',
  'studio.business_bank_setting.reject1': '审核未通过',
  'studio.business_bank_setting.reject2': '图片上传失败。<br/>请检查后重新上传。',
  'studio.business_bank_setting.btn_modify': '修改',
  'studio.business_bank_setting.business_info1': '国家/地区',
  'studio.business_bank_setting.business_info2': '代表姓名',
  'studio.business_bank_setting.business_info3': '代表出生日期',
  'studio.business_bank_setting.business_info4': '营业执照号',
  'studio.business_bank_setting.business_info5': '类型',
  'studio.business_bank_setting.business_info6': '公司名称',
  'studio.business_bank_setting.business_info7': 'CEO姓名',
  'studio.business_bank_setting.bank_info1': '国家/地区',
  'studio.business_bank_setting.bank_info2': '银行名称 ',
  'studio.business_bank_setting.bank_info3': '开户人姓名',
  'studio.business_bank_setting.bank_info4': '银行账号',
  'studio.business_bank_setting.bank_info5': 'SWIFT CODE',
  'studio.business_bank_setting.individual.question1': '您有营业执照吗？',
  'studio.business_bank_setting.individual.question1_msg1': '请勾选必填项。',
  'studio.business_bank_setting.individual.select_y': '是的，有',
  'studio.business_bank_setting.individual.select_n': '不，没有',
  'studio.business_bank_setting.license_yn_select_req_msg': '请选择是否持有营业执照。',
  'studio.business_bank_setting.individual.quide1': '为什么需要个人/营业执照信息？ ',
  'studio.business_bank_setting.individual.quide2':
    '发布游戏前，需要提供个人/企业信息才能进行游戏分级审核。<br/>审核最长需要3个工作日，建议提前申请。',
  'studio.business_bank_setting.individual.quide3': '证明材料用途为何？',
  'studio.business_bank_setting.individual.quide4': '用于确认输入的信息与实际文件是否一致。',
  'studio.business_bank_setting.individual.question2': '请选择国家/地区。',
  'studio.business_bank_setting.individual.question2_checkmsg': '与目前纳税的国家/地区相同',
  'studio.business_bank_setting.individual.input_name': '代表姓名',
  'studio.business_bank_setting.individual.input_name_place_holder': '请输入代表姓名',
  'studio.business_bank_setting.individual.input_name_msg1': '请输入代表姓名。',
  'studio.common.def_key.exceed': '不能超过{length}个字。',
  'studio.business_bank_setting.individual.select_gender': '代表性别',
  'studio.business_bank_setting.individual.select_gender_male': '男',
  'studio.business_bank_setting.individual.select_gender_female': '女',
  'studio.business_bank_setting.individual.select_birth': '代表出生日期',
  'studio.business_bank_setting.individual.select_birth_place_holder': 'YYYY-MM-DD',
  'studio.business_bank_setting.individual.select_birth_msg1': '请输入代表出生日期。',
  'studio.business_bank_setting.individual.select_mobile_no': '代表联系方式',
  'studio.business_bank_setting.individual.select_mobile_no_place_holder': '请输入电话号码',
  'studio.business_bank_setting.individual.select_mobile_no_msg1': '请输入电话号码。',
  'studio.common.def_key.number_only_y': '只能输入数字。 ',
  'studio.business_bank_setting.individual.select_ceo_email': '代表邮箱',
  'studio.business_bank_setting.individual.select_ceo_email_place_holder': '请输入代表邮箱。',
  'studio.business_bank_setting.individual.select_ceo_email_msg1': '请输入代表邮箱。',
  'studio.business_bank_setting.individual.select_ceo_email_msg2': '邮箱格式错误。',
  'studio.business_bank_setting.individual.question3': '请选择纳税的国家/地区',
  'studio.business_bank_setting.individual.question3_msg1': '产生收益时将按所选国家/地区进行税务处理。',
  'studio.business_bank_setting.individual.info_view_b_adress': '代表地址',
  'studio.business_bank_setting.individual.info_global_adress_no': '邮政编码',
  'studio.business_bank_setting.individual.info_global_adress_no_place_holder': '邮政编码',
  'studio.business_bank_setting.individual.info_global_adress_no_required_n': '请搜索邮政编码。',
  'studio.business_bank_setting.individual.info_global_o_adress_place_holder': '请输入地址',
  'studio.business_bank_setting.individual.info_global_o_adress_msg1': '请输入地址。',
  'studio.business_bank_setting.individual.info_global_o_adress_detail_place_holder': '请输入详细地址',
  'studio.business_bank_setting.individual.info_global_o_adress_detail_msg1': '请输入详细地址。',
  'studio.business_bank_setting.individual.upload_resident': '居民登记簿',
  'studio.business_bank_setting.individual.upload_guide': '{info}以下',
  'studio.business_bank_setting.individual.upload_resident_guide': '请上传居民登记簿',
  'studio.business_bank_setting.individual.btn_attach': '查找文件',
  'studio.business_bank_setting.individual.info_global_street_place_holder': '请输入街道名称',
  'studio.business_bank_setting.individual.info_global_street_required_n': '请输入街道名称。',
  'studio.business_bank_setting.individual.info_global_building_place_holder': '请输入大楼名称',
  'studio.business_bank_setting.individual.info_global_building_required_n': '请输入大楼名称。',
  'studio.business_bank_setting.individual.info_global_city_place_holder': '请输入城市名称',
  'studio.business_bank_setting.individual.info_global_city_required_n': '请输入城市名称。',
  'studio.business_bank_setting.individual.info_global_county_place_holder': '请输入道/市/郡',
  'studio.business_bank_setting.individual.info_global_county_required_n': '请输入道/市/郡。',
  'studio.business_bank_setting.individual.review_officer_info': '审核负责人信息',
  'studio.business_bank_setting.individual.review_officer_info_name': '姓名',
  'studio.business_bank_setting.individual.review_officer_info_name_place_holder': '请输入姓名',
  'studio.business_bank_setting.individual.review_officer_info_name_msg2': '请输入姓名。',
  'studio.business_bank_setting.individual.review_officer_info_mobile_no': '联系方式',
  'studio.business_bank_setting.individual.review_officer_info_mobile_no_place_holder': '请输入联系方式',
  'studio.business_bank_setting.individual.review_officer_info_mobile_no_msg1': '请输入联系方式。',
  'studio.business_bank_setting.individual.review_officer_info_email': '邮箱',
  'studio.business_bank_setting.individual.review_officer_info_email_place_holder': '请输入邮箱',
  'studio.business_bank_setting.individual.review_officer_info_email_msg1': '邮箱格式错误。',
  'studio.business_bank_setting.individual.review_officer_info_email_msg2': '请输入邮箱。',
  'studio.business_bank_setting.individual.settlement_officer_info': '合同/结算负责人信息',
  'studio.business_bank_setting.individual.settlement_officer_info_guide1': '请输入负责合同及结算相关审核信息的团队主要负责人信息',
  'studio.business_bank_setting.individual.settlement_officer_info_name': '姓名',
  'studio.business_bank_setting.individual.settlement_officer_info_name_msg2': '请输入姓名。',
  'studio.business_bank_setting.individual.settlement_officer_info_name_place_holder': '请输入姓名',
  'studio.business_bank_setting.individual.settlement_officer_info_mobile_no': '联系方式',
  'studio.business_bank_setting.individual.settlement_officer_info_mobile_no_place_holder': '请输入联系方式',
  'studio.business_bank_setting.individual.settlement_officer_info_mobile_no_msg1': '请输入联系方式。',
  'studio.business_bank_setting.individual.settlement_officer_info_email': '邮箱',
  'studio.business_bank_setting.individual.settlement_officer_info_email_place_holder': '请输入邮箱',
  'studio.business_bank_setting.individual.settlement_officer_info_email_msg1': '邮箱格式错误。',
  'studio.business_bank_setting.individual.settlement_officer_info_email_msg2': '请输入邮箱。',
  'studio.business_bank_setting.individual.info_view_o_adress': '公司地址',
  'studio.business_bank_setting.individual.question4': '营业执照号（个体/法人）',
  'studio.business_bank_setting.individual.question4_place_holder': '请输入营业执照注册号',
  'studio.business_bank_setting.individual.enter_no_msg1': '请输入营业执照注册号。',
  'studio.business_bank_setting.individual.enter_no_msg3': '发生错误。<br/>请稍后重试。',
  'studio.business_bank_setting.individual.enter_no_msg4': '该营业执照号无法查询。 ',
  'studio.business_bank_setting.individual.info_view_b_name': '公司名称',
  'studio.business_bank_setting.individual.info_view_b_name_place_holder': '请输入公司名称',
  'studio.business_bank_setting.individual.info_view_r_name': 'CEO姓名',
  'studio.business_bank_setting.individual.info_view_r_name_kr_place_holder': '请输入法人代表姓名',
  'studio.business_bank_setting.individual.info_view_b_type': '行业',
  'studio.business_bank_setting.individual.info_view_b_type_place_holder': '请输入行业',
  'studio.business_bank_setting.individual.info_view_b_items': '种类',
  'studio.business_bank_setting.individual.info_view_b_items_place_holder': '请输入种类',
  'studio.business_bank_setting.individual.info_view_adress': '公司地址',
  'studio.business_bank_setting.individual.info_view_adress_place_holder': '请输入公司地址',
  'studio.business_bank_setting.individual.question5': '公司联系方式',
  'studio.business_bank_setting.individual.question5_kr_place_holder': '请输入公司联系方式',
  'studio.business_bank_setting.individual.select_enter_kr_no_msg1': '请输入公司联系方式。',
  'studio.business_bank_setting.individual.b_email': '公司邮箱',
  'studio.business_bank_setting.individual.b_email_place_holder': '请输入邮箱',
  'studio.business_bank_setting.individual.b_email_msg1': '请输入邮箱。',
  'studio.business_bank_setting.individual.b_email_msg2': '邮箱格式错误。',
  'studio.business_bank_setting.individual.upload_buisiness': '营业执照',
  'studio.business_bank_setting.individual.upload_buisiness_guide': '请上传营业执照',
  'studio.business_bank_setting.individual.upload_buisiness_req_msg': '请上传营业执照。',
  'studio.business_bank_setting.individual.biz_reg_num': '营业执照号（个体/法人）',
  'studio.business_bank_setting.individual.biz_reg_num_place_holder': '请输入营业执照注册号',
  'studio.business_bank_setting.individual.biz_reg_num_required': '请输入营业执照注册号。',
  'studio.business_bank_setting.individual.enter_no_msg5': '发生错误<br/>请稍后重试。<br/>如需手动输入公司信息，\\请点击【手动输入】。',
  'studio.business_bank_setting.individual.enter_no_msg5_manual': '手动输入',
  'studio.business_bank_setting.individual.enter_no_msg5_close': '以后再说',
  'studio.business_bank_setting.individual.info_view_no': '营业执照号',
  'studio.business_bank_setting.individual.info_view_no_place_holder': '请输入营业执照号',
  'studio.business_bank_setting.individual.info_view_type': '类型',
  'studio.business_bank_setting.individual.info_view_type1': '个体经营者',
  'studio.business_bank_setting.individual.info_view_type2': '法人公司',
  'studio.business_bank_setting.individual.manual_info_view_no_required': '请输入营业执照号。',
  'studio.business_bank_setting.individual.manual_info_view_b_name_required': '请输入公司名称。',
  'studio.business_bank_setting.individual.manual_info_view_r_name_kr_required': '请输入法人代表姓名。',
  'studio.business_bank_setting.individual.manual_info_view_b_type_required': '请输入行业。',
  'studio.business_bank_setting.individual.manual_info_view_b_items_required': '请输入种类。',
  'studio.business_bank_setting.individual.manual_info_view_adress_required': '请输入公司地址。',
  'studio.business_bank_setting.individual.question6': '选择游戏行业类型',
  'studio.business_bank_setting.individual.question6_guide': '如果同时进行游戏开发和发型，请选择中介公司（发行）。',
  'studio.business_bank_setting.individual.question6_select1': '游戏开发商',
  'studio.business_bank_setting.individual.question6_select2': '中介公司（发行）',
  'studio.business_bank_setting.individual.question6_select3': '不适用',
  'studio.business_bank_setting.individual.question7': '其他信息选填',
  'studio.business_bank_setting.individual.question7_guide': '如果您还有其他需要提交的信息，请阅读以下内容后进行选择。如无其他信息，可以不选。',
  'studio.business_bank_setting.individual.question7_select1': '游戏制作（发行）业',
  'studio.business_bank_setting.individual.question7_select2': '通信销售业',
  'studio.business_bank_setting.individual.game_production_no_guide': '请附上游戏制作（发行）业注册证',
  'studio.business_bank_setting.individual.game_production_no_place_holder': '请输入游戏制作（发行）业申报编号',
  'studio.business_bank_setting.individual.game_production_no_msg1': '请输入游戏制作（发行）业申报编号。',
  'studio.business_bank_setting.individual.telecom_sales_no_guide': '请附上通信销售业注册证',
  'studio.business_bank_setting.individual.telecom_sales_no_place_holder': '请输入通信销售业申报编号',
  'studio.business_bank_setting.individual.telecom_sales_no_msg1': '请输入通信销售业申报编号。',
  'studio.common.popup_case_save_btn': '保存',
  'studio.business_bank_setting.individual.btn_save_alert1':
    '按照填写的信息申请审核。<br/>最多需要1~3个工作日。<br/><br/>审核完成后，<br/>将发送电子邮件或通知。',
  'studio.common.popup_case_cf_btn': '确认',
  'studio.common.popup_case_cancel_btn': '取消',
  'studio.business_bank_setting.individual.btn_save_alert2': '审核申请已提交。 ',
  'studio.business_bank_setting.individual.btn_save_alert3': '正在审核个人/公司信息。<br/>请重新查看审核申请内容。',
  'studio.business_bank_setting.individual.settlement_officer_info_name_msg1': '不能超过{length}个字。 ',
  'studio.business_bank_setting.individual.info_view': '公司信息',
  'studio.business_bank_setting.individual.info_view_b_name_msg1': '请输入公司名称',
  'studio.business_bank_setting.individual.info_view_b_name_msg2': '不能超过{length}个字。 ',
  'studio.business_bank_setting.individual.info_view_r_name_non_kr_place_holder': '2人及以上时，请用“,”隔开',
  'studio.business_bank_setting.individual.info_view_r_name_non_kr_msg1': '2人及以上时，请用“,”隔开。',
  'studio.business_bank_setting.individual.info_view_r_name_msg2': '不能超过{length}个字。 ',
  'studio.business_bank_setting.individual.question5_non_kr_place_holder': '请输入电话号码',
  'studio.business_bank_setting.individual.select_enter_non_kr_no_msg1': '请输入电话号码。',
  'studio.business_bank_setting.individual.info_global_adress_no_msg1': '请输入邮政编码。',
  'studio.business_bank_setting.individual.info_global_o_adress': '地址',
  'studio.business_bank_setting.individual.info_global_o_adress_msg2': '请输入地址。',
  'studio.business_bank_setting.individual.info_global_o_adress_msg3': '不能超过{length}个字。 ',
  'studio.business_bank_setting.individual.info_global_o_adress_detail': '详细地址',
  'studio.business_bank_setting.individual.info_global_o_adress_detail_msg2': '不能超过{length}个字。 ',
  'studio.business_bank_setting.individual.busuness_no': '营业执照号',
  'studio.business_bank_setting.individual.busuness_no_place_holder': '请输入营业执照号',
  'studio.business_bank_setting.individual.busuness_no_msg1': '请输入营业执照号。',
  'studio.business_bank_setting.individual.info_view_tax': '税务登记号',
  'studio.business_bank_setting.individual.info_view_tax_place_holder': '请输入税务登记号（选填）',
  'studio.business_bank_setting.individual.info_view_tax_msg1': '请输入税务登记号。',
  'studio.business_bank_setting.individual.info_global_o_adress_box_place_holder1': '郡/省',
  'studio.business_bank_setting.individual.info_global_o_adress_box_place_holder2': '市/区',
  'studio.business_bank_setting.individual.info_global_street': '街道名称',
  'studio.business_bank_setting.individual.info_global_street_msg1': '请输入街道名称。',
  'studio.business_bank_setting.individual.info_global_street_msg2': '不能超过{length}个字。 ',
  'studio.business_bank_setting.individual.info_global_building': '大楼名称',
  'studio.business_bank_setting.individual.info_global_building_msg1': '请输入大楼名称。',
  'studio.business_bank_setting.individual.info_global_building_msg2': '不能超过{length}个字。 ',
  'studio.business_bank_setting.individual.info_global_city': '城市名称',
  'studio.business_bank_setting.individual.info_global_city_msg1': '请输入城市名称。',
  'studio.business_bank_setting.individual.info_global_city_msg2': '不能超过{length}个字。 ',
  'studio.business_bank_setting.individual.info_global_county': '道/市/郡',
  'studio.business_bank_setting.individual.info_global_county_msg1': '请输入道/市/郡。',
  'studio.business_bank_setting.individual.info_global_county_msg2': '不能超过{length}个字。 ',
  'studio.business_bank_setting.individual.question6_select1_kr': '韩国游戏制作（发行）业',
  'studio.business_bank_setting.individual.question6_select2_kr': '韩国通信销售业',
  'studio.business_bank_setting.individual.question6_select3_kr': '韩国营业执照',
  'studio.business_bank_setting.individual.game_production_no_kr_guide': '请附上游戏制作（发行）业注册证',
  'studio.business_bank_setting.individual.game_production_no_place_holder_kr': '请输入韩国游戏制作（发行）业申报编号',
  'studio.business_bank_setting.individual.game_production_no_msg1_kr': '请输入韩国游戏制作（发行）业申报编号。',
  'studio.business_bank_setting.individual.telecom_sales_no_kr_guide': '请附上韩国通信销售业注册证',
  'studio.business_bank_setting.individual.telecom_sales_no_place_holder_kr': '请输入韩国通信销售业申报编号',
  'studio.business_bank_setting.individual.telecom_sales_no_msg1_kr': '请输入韩国通信销售业申报编号。',
  'studio.business_bank_setting.individual.game_business_no_kr_guide': '请附上韩国营业执照 ',
  'studio.business_bank_setting.individual.game_business_no_place_holder_kr': '请输入韩国营业执照号',
  'studio.business_bank_setting.individual.game_business_no_msg1_kr': '请输入韩国营业执照号。',
  'studio.business_bank_setting.account.question1': '银行所在国家/地区',
  'studio.business_bank_setting.account.question2': '账户信息',
  'studio.business_bank_setting.account.question3_place_holder': '请选择银行',
  'studio.business_bank_setting.account.question3_msg1': '请选择银行。',
  'studio.business_bank_setting.account.question4_place_holder': '请输入银行账号',
  'studio.business_bank_setting.account.question4_msg1': '请输入银行账号。',
  'studio.business_bank_setting.account.question5_place_holder': '请输入开户人姓名',
  'studio.business_bank_setting.account.question5_msg1': '请输入开户人姓名。',
  'studio.business_bank_setting.account.question5_btn': '确认开户人',
  'studio.business_bank_setting.account.question6': '存折复印件',
  'studio.business_bank_setting.account.upload_guide': '{info}以下',
  'studio.business_bank_setting.account.question6_guide': '请附上存折复印件 ',
  'studio.business_bank_setting.account.btn_attach': '查找文件',
  'studio.business_bank_setting.account.question5_btn_msg2': '发生错误。<br/>请稍后重试。<br/>如需要手动输入账户信息，请点击【手动输入】。',
  'studio.business_bank_setting.account.question5_btn_msg2_btn1': '手动输入',
  'studio.business_bank_setting.account.question5_btn_msg2_btn2': '以后再说',
  'studio.business_bank_setting.account.question5_btn_msg3': '信息错误。',
  'studio.business_bank_setting.account.question5_btn_msg4': '开户人信息不一致。 ',
  'studio.business_bank_setting.account.question5_btn_msg4_retry_btn': '重新查询',
  'studio.business_bank_setting.info_review_req_btn': '申请审核',
  'studio.business_bank_setting.account.btn_save_alert1':
    '按照填写的信息申请审核。<br/>最多需要5个工作日。<br/> <br/>审核完成后，将发送电子邮件或通知。',
  'studio.business_bank_setting.account.btn_save_alert2': '请查询开户人信息。',
  'studio.business_bank_setting.account.question3': '银行信息',
  'studio.business_bank_setting.account.question3_usa_place_holder': '请输入银行名称',
  'studio.business_bank_setting.account.question3_usa_msg1': '请输入银行名称。',
  'studio.business_bank_setting.account.question7': '分行名称',
  'studio.business_bank_setting.account.question7_usa_place_holder': '请输入分行名称（选填）',
  'studio.business_bank_setting.account.question7_usa_msg1': '请输入分行名称。',
  'studio.business_bank_setting.account.question8': '银行地址',
  'studio.business_bank_setting.account.question8_usa_place_holder': '请输入银行地址',
  'studio.business_bank_setting.account.question8_usa_msg1': '请输入银行地址。',
  'studio.business_bank_setting.account.question9': 'SWIFT CODE',
  'studio.business_bank_setting.account.question9_usa_place_holder': '请输入银行代码（SWIFT CODE）',
  'studio.business_bank_setting.account.question9_usa_msg1': '请输入银行代码（SWIFT CODE）。',
  'studio.business_bank_setting.account.question10': 'routing No',
  'studio.business_bank_setting.account.question10_usa_place_holder': '请输入汇款编号',
  'studio.business_bank_setting.account.question10_usa_msg1': '请输入汇款编号。',
  'studio.business_bank_setting.account.question4': '银行账号',
  'studio.business_bank_setting.account.question5': '开户人姓名',
  'studio.business_bank_setting.account.question5_place_holder1': '姓名',
  'studio.business_bank_setting.account.question5_msg11': '请输入姓名。',
  'studio.business_bank_setting.account.question5_place_holder2': '姓',
  'studio.business_bank_setting.account.question5_msg12': '请输入姓',
  'studio.business_bank_setting.account.question11': 'IBAN CODE',
  'studio.business_bank_setting.account.question11_eu_place_holder': '请输入国际银行帐户号码（IBAN CODE） ',
  'studio.business_bank_setting.account.question10_eu_msg1': '请输入国际银行帐户号码（IBAN CODE）。 ',
  'studio.business_bank_setting.account.question12': 'CC CODE',
  'studio.business_bank_setting.account.question12_ca_place_holder': '请输入加拿大元银行的清算代码（CC CODE）',
  'studio.business_bank_setting.account.question12_ca_msg1': '请输入加拿大元银行的清算代码（CC CODE）。',
  'studio.business_bank_setting.list_name': '个人/公司信息审核记录',
  'studio.business_bank_setting.list_title1': '状态',
  'studio.business_bank_setting.list_title2': '个人/公司信息类型',
  'studio.business_bank_setting.list_title3': '代表姓名/公司名称',
  'studio.business_bank_setting.list_title4': '申请日期',
  'studio.business_bank_setting.list_title5': '结束日期',
  'studio.business_bank_setting.list_no_data': '暂无查询记录',
  'studio.business_bank_setting.account_list_name': '银行信息审核记录',
  'studio.business_bank_setting.account_list_title1': '状态',
  'studio.business_bank_setting.account_list_title2': '银行名称',
  'studio.business_bank_setting.account_list_title3': '银行账号',
  'studio.business_bank_setting.account_list_title4': '申请日期',
  'studio.business_bank_setting.account_list_title5': '结束日期',
  'studio.business_bank_setting.account_list_no_data': '暂无查询记录',
  'studio.gnb.common_language_ko': '한국어',
  'studio.gnb.common_language_us': 'English (US)',
  'studio.gnb.common_language_zh_cn': '简体中文',
  'studio.gnb.common_language_zh_tw': '繁體中文',
  'studio.gnb.common_language_ja': '日本語',
  'studio.gnb.common_product_key': '商品密钥',
  'studio.gnb.common_1depth_product_home': '商品主页',
  'studio.gnb.common_2depth_plan': '发布情况',
  'studio.gnb.common_1depth_product_management': '商品页面管理',
  'studio.gnb.common_2depth_setting': '商品设置',
  'studio.gnb.common_2depth_product_page': '商品页面',
  'studio.gnb.common_2depth_sale': '购买条件',
  'studio.gnb.common_2depth_early_access': '抢先体验文案设置',
  'studio.gnb.common_2depth_price': '价格',
  'studio.gnb.common_2depth_discount': '优惠',
  'studio.gnb.common_1depth_product_data': '商品数据管理',
  'studio.gnb.common_2depth_build': '构建管理',
  'studio.gnb.common_2depth_execution': '运行设置',
  'studio.gnb.common_2depth_tier_review': '游戏分级及构建审核',
  'studio.gnb.common_2depth_condition': '商品条款',
  'studio.gnb.common_2depth_stats': '能力值',
  'studio.gnb.common_2depth_ranking': '排名',
  'studio.gnb.common_2depth_challenges': '挑战任务',
  'studio.gnb.common_2depth_cloud': '云存储',
  'studio.gnb.common_2depth_match': '匹配',
  'studio.gnb.common_1depth_marketing': '商品营销管理',
  'studio.gnb.common_2depth_banner': '横幅图片',
  'studio.gnb.common_1depth_in_app_purchase': '游戏内商店',
  'studio.gnb.common_2depth_in_app_setting': '游戏内结算设置',
  'studio.gnb.common_2depth_in_app_shop': '游戏内商店',
  'studio.gnb.common_2depth_in_app_product': '游戏内商品',
  'studio.gnb.common_2depth_in_app_discount': '游戏内优惠商品',
  'studio.gnb.common_2depth_in_app_payment_history': '游戏内结算历史',
  'studio.lnb.common_1depth_studio_group': 'Studio团队',
  'studio.lnb.common_2depth_studio_home': '主页',
  'studio.lnb.common_2depth_product_management': '项目与商品管理',
  'studio.lnb.common_2depth_collection': '合集',
  'studio.lnb.common_2depth_store_community': '商店社区',
  'studio.lnb.common_2depth_studio_metrics': '指标',
  'studio.lnb.common_2depth_studio_settlement': '结算',
  'studio.lnb.common_2depth_member_management': '成员管理',
  'studio.lnb.common_2depth_business_info': '公司与银行信息',
  'studio.lnb.common_2depth_game_check': '游戏维护',
  'studio.lnb.common_1depth_studio_support': '扶持',
  'studio.lnb.common_2depth_creator_news': '创作者新闻',
  'studio.lnb.common_2depth_creator_benefit': '创作者扶持优惠',
  'studio.lnb.common_2depth_creator_community': '创作者社区',
  'studio.lnb.common_2depth_team_community': '团队社区',
  'studio.lnb.common_2depth_discord': 'Discord频道',
  'studio.lnb.common_2depth_studio_dev_guide': '开发者指南',
  'studio.lnb.common_2depth_studio_noti': 'Studio公告',
  'studio.common.popup_case_a': 'A. 保存确认弹窗',
  'studio.common.popup_case_a_without_saving': '存在修改内容。<br/>是否不保存而直接退出？',
  'studio.common.popup_case_a_without_saving_exit_btn': '退出',
  'studio.common.popup_case_b': 'B. 错误提示弹窗',
  'studio.common.popup_case_b_error_retry': '请刷新或重试。 ',
  'studio.common.popup_case_c': 'C. 保存成功与应用方式提示弹窗',
  'studio.common.popup_case_c_plan': '保存成功。<br/>请在发布中应用。',
  'studio.common.popup_case_d': 'D. 保存成功提示弹窗',
  'studio.common.popup_case_d_complete_save': '保存成功。 ',
  'studio.common.popup_case_e': 'E. 保存成功及客户端测试提示弹窗',
  'studio.common.popup_case_e_after_testing': '保存成功。<br/>请在PC客户端测试后，应用到LIVE版本。',
  'studio.common.popup_case_f': 'D.删除成功提示弹窗',
  'studio.common.popup_case_f_complete_del': '删除成功。',
  'studio.common.popup_case_g_not_view': '无查询权限。<br/>请咨询团队管理员。',
  'studio.common.popup_case_h_not_edit': '无编辑权限。<br/>请咨询团队管理员。',
  'studio.common.live_apply_btn': '应用至LIVE',
  'studio.common.popup_case_i_release_guide': '如需应用，请输入“RELEASE”。',
  'studio.common.popup_case_i_release_place_holder': 'RELEASE',
  'studio.common.popup_case_i_release_msg1': "请输入大写 'RELEASE'。",
  'studio.common.popup_case_apply_btn': '应用',
  'studio.ai_translation.title1_settings': '多语言设置',
  'studio.ai_translation.base_lang': '基础语言',
  'studio.ai_translation.base_lang_tool_tip': '这是多语言翻译的基准语言。<br/>仅团队负责人可以在团队主页点击语言按钮后修改。',
  'studio.ai_translation.base_lang_en': '英语',
  'studio.ai_translation.base_lang_ja': '日语',
  'studio.ai_translation.base_lang_zh_cn': '简体中文',
  'studio.ai_translation.base_lang_zh_tw': '繁體中文',
  'studio.ai_translation.progress_wait_msg': '正在进行AI翻译。<br/>请稍等片刻。 ',
  'studio.ai_translation.all_btn': '全部AI翻译',
  'studio.common.popup_case_ai_overwrite': '存在已输入的内容。<br/>是否全部进行AI翻译？<br/>翻译后将覆盖原内容。',
  'studio.common.popup_case_translation_in_progress_btn': '进行翻译',
  'studio.common.popup_case_ai_not_entered': '多语言设置中存在未填写的内容。<br/>输入多语言后方可发布。',
  'studio.common.popup_case_ai_modified': '有关多国语言设置的条目已修改。<br/>是否不修改多语言而直接保存？',
  'studio.ai_translation.title2_product': '商品名称',
  'studio.ai_translation.title3_creator': '创作者姓名',
  'studio.ai_translation.title4_distributor': '发行公司名称',
  'studio.ai_translation.title5_tagline': '一句话介绍',
  'studio.ai_translation.title6_product_des': '商品介绍',
  'studio.ai_translation.title7_absence': '主题',
  'studio.ai_translation.title8_link': '链接',
  'studio.ai_translation.title9_terms': '条款内容',
  'studio.ai_translation.title10_early': '抢先体验提示',
  'studio.ai_translation.title11_option': '运行选项{optionNo}',
  'studio.prj_prod.this_prod.stt_product_page_upcoming': '商品页面即将公开',
  'studio.prj_prod.this_prod.stt_product_page_released': '公开商品页面',
  'studio.prj_prod.this_prod.stt_product_page_withdrawn': '停止公开商品页面',
  'studio.prj_prod.this_prod.stt_pre_order_period': '预购中',
  'studio.prj_prod.this_prod.stt_official_released': '正式发布',
  'studio.prj_prod.this_prod.stt_release_sale_suspended': '停止销售',
  'studio.prj_prod.this_prod.stt_del_req_completed': '删除申请',
  'studio.prj_prod.this_prod.stt_del_req_rejected': '删除申请驳回',
  'studio.prj_prod.this_prod.stt_restriction_display_user_report': '展示限制（玩家举报）',
  'studio.prj_prod.this_prod.stt_restriction_install': '运行限制',
  'studio.prj_prod.this_prod.stt_restriction_for_sales': '购买限制',
  'studio.prj_prod.this_prod.stt_restriction_display_operator_stove': '展示限制',
  'studio.prj_prod_mngmt.review_restricted_case': '审核限制',
  'studio.prj_prod.status_in_review': '检查中',
  'studio.prj_prod.status_review_completed': '检查完成',
  'studio.prj_prod.this_prod.stt_restriction_for_collection': '合集购买限制',
  'studio.prj_prod.this_prod.stt_product_page_review_requested': '商品页面申请检查',
  'studio.prj_prod.this_prod.stt_product_page_in_review': '商品页面检查中',
  'studio.prj_prod.this_prod.stt_product_page_in_review_declined': '商品页面检查驳回',
  'studio.prj_prod.this_prod.stt_product_page_in_review_approved': '商品页面检查完成',
  'studio.prj_prod.this_prod.stt_product_page_display_suspended': '停止展示商品页面',
  'studio.prj_prod.this_prod.stt_product_page_display_resumed': '恢复展示商品页面',
  'studio.prj_prod.this_prod.stt_product_deletion_request': '商品删除申请',
  'studio.prj_prod.this_prod.stt_product_deletion_declined': '商品删除申请驳回',
  'studio.prj_prod.this_prod.stt_price_review_requested': '价格检查申请',
  'studio.prj_prod.this_prod.stt_price_in_review': '价格检查中',
  'studio.prj_prod.this_prod.stt_price_review_declined': '价格检查驳回',
  'studio.prj_prod.this_prod.stt_price_review_approved': '价格检查完成',
  'studio.prj_prod.this_prod.stt_build_rating_review_requested': '构建及游戏分级检查申请',
  'studio.prj_prod.this_prod.stt_build_rating_in_review': '构建及游戏分级检查中',
  'studio.prj_prod.this_prod.stt_build_rating_review_approved': '构建与游戏分级检查完成',
  'studio.prj_prod.this_prod.stt_build_rating_review_declined': '构建及游戏分级检查驳回',
  'studio.prj_prod.this_prod.stt_release_review_requested': '正式发布检查申请',
  'studio.prj_prod.this_prod.stt_release_in_review': '正式发布检查中',
  'studio.prj_prod.this_prod.stt_release_declined': '正式发布检查驳回',
  'studio.prj_prod.this_prod.stt_release_approved': '正式发布检查完成',
  'studio.prj_prod.this_prod.stt_release_upcoming': '等待发布',
  'studio.prj_prod.this_prod.stt_pre_order_started': '预购开始',
  'studio.prj_prod.this_prod.stt_pre_order_ended': '预购结束',
  'studio.prj_prod.this_prod.stt_release_sale_resumed': '恢复销售',
  'studio.loading_ui.msg': '正在处理。<br/>请稍等片刻。',
  'studio.page_not_found.msg1': '前往主页',
  'studio.page_not_found.msg2': '上一页',
  'studio.page_not_found.msg3': '无法找到页面。',
  'studio.page_not_found.msg4': '请返回后重试。 ',
  'studio.page_not_found.home_dir_btn': '5秒后将返回上一页。 ',
  'studio.stu_logged_in.pre_grp_join.nickname': 'Studio昵称',
  'studio.stu_logged_in.pre_grp_join.btn_my_info': '我的信息',
  'studio.stu_logged_in.pre_grp_join.btn_logout': '退出',
  'studio.stu_logged_in.pre_grp_join.create_grp_msg1': '如果您是团队代表',
  'studio.stu_logged_in.pre_grp_join.create_grp_msg2': '创建新团队',
  'studio.stu_logged_in.pre_grp_join.btn_create_new_grp': '创建新团队',
  'studio.stu_logged_in.pre_grp_join.create_grp_guide1': '请输入团队名称。',
  'studio.stu_logged_in.pre_grp_join.create_grp_guide2': '用于在Studio上管理团队，<br/>您可以输入开发商或发行公司名称。团队名称可以随时修改。',
  'studio.stu_logged_in.pre_grp_join.create_grp_name_place_holder': '请输入团队名称',
  'studio.stu_logged_in.pre_grp_join.create_grp_val_msg2': '请输入团队名称。',
  'studio.stu_logged_in.pre_grp_join.create_grp_val_msg3': '该名称已被使用，请使用其他名称。',
  'studio.stu_logged_in.pre_grp_join.btn_create_grp': '创建',
  'studio.stu_logged_in.pre_grp_join.create_over_10grp_msg': '最多可创建10个团队。',
  'studio.stu_logged_in.pre_grp_join.grp_join_stt_msg1': '如果您是团队成员',
  'studio.stu_logged_in.pre_grp_join.grp_join_stt_msg2': '查看团队加入状态',
  'studio.stu_logged_in.pre_grp_join.grp_join_stt_msg3':
    '收到邀请代码后，申请加入了吗？<br/>团队代表批准后，才能进入团队空间。<br/>请查看团队加入状态。',
  'studio.stu_logged_in.pre_grp_join.btn_chk_grp_join_stt': '查看加入状态',
  'studio.stu_logged_in.pre_grp_join.invitation_expired_msg1': '加入邀请代码已过期。',
  'studio.stu_logged_in.pre_grp_join.invitation_expired_msg2': '请向团队代表获取新的邀请链接并重新申请。',
  'studio.stu_logged_in.pre_grp_join.grp_join_req_done_msg1': '已申请加入团队。',
  'studio.stu_logged_in.pre_grp_join.grp_join_req_done_msg2': '请在加入状态中查看是否批准。',
  'studio.stu_logged_in.pre_grp_join.grp_join_req_accepted_msg': '团队加入申请已批准。',
  'studio.stu_logged_in.pre_grp_join.grp_go_to_grp_pg_guide': '即将跳转至团队页面。',
  'studio.stu_logged_in.pre_grp_join.btn_go_to_grp_pg': '前往团队空间',
  'studio.stu_logged_in.pre_grp_join.grp_join_req_accepted_noti': '{grpName}的加入申请已被批准。',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_title': '团队创建成功',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_msg1': '欢迎加入STOVE Studio。',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_msg2': 'Studio为您提供专业的团队协作空间，助力游戏开发与运营。',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_msg3': '请在已创建的团队中生成邀请码邀请成员加入，尽情体验STOVE Studio服务。',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_grp_name': '团队名称：',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_create_date': '创建日期： ',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_grp_pg_dir_btn': '前往Studio团队空间',
  'studio.gnb.group_myinfo.email': '邮箱',
  'studio.gnb.group_myinfo.nickname': '昵称',
  'studio.gnb.group_myinfo.nickname_edit1': '昵称',
  'studio.gnb.group_myinfo.nickname_edit2': '请输入想要修改的昵称',
  'studio.gnb.group_myinfo.btn_nickname_edit_save': '修改',
  'studio.gnb.group_myinfo.nickname_edit_place_holder': '请输入想要修改的昵称',
  'studio.gnb.group_myinfo.nickname_edit_val_msg1': '请输入2~20字。',
  'studio.gnb.group_myinfo.nickname_edit_val_msg2': '请输入想要修改的昵称。',
  'studio.gnb.group_myinfo.nickname_edit_val_msg3': '昵称重复，无法使用。<br/>请输入其他昵称。',
  'studio.gnb.group_myinfo.registration_time': 'Studio注册日期',
  'studio.gnb.group_myinfo.my_group': '我的团队',
  'studio.gnb.group_myinfo.my_group_role_type': '职责类型 ',
  'studio.gnb.group_myinfo.my_group_role_type_owner': '团队负责人',
  'studio.gnb.group_myinfo.my_group_role_type_mem': '团队成员',
  'studio.gnb.group_myinfo.waitlist': '等待目录 ',
  'studio.gnb.group_myinfo.my_group_group_name': '团队名称',
  'studio.gnb.group_myinfo.my_group_join_date_time': '加入日期',
  'studio.gnb.group_myinfo.my_group_none': '尚未加入任何团队',
  'studio.gnb.group_myinfo.terms_agreement': '同意记录',
  'studio.gnb.group_myinfo.terms_agreement.term1': 'Studio使用条款（{date}） ',
  'studio.gnb.group_myinfo.terms_agreement.term_agree_time': '{time}同意',
  'studio.gnb.group_myinfo.terms_agreement.btn_view_term1': '查看条款 ',
  'studio.gnb.group_myinfo.terms_agreement.term2': '同意收集和使用个人信息（{date}）',
  'studio.gnb.group_myinfo.terms_agreement_btn_view_term2': '查看条款 ',
  'studio.gnb.group_myinfo.terms_agreement_mkt': '同意接收广告信息',
  'studio.gnb.group_myinfo.terms_agreement_mkt1': '不论是否同意接收信息，均发送主要公告及活动参与提示等。',
  'studio.gnb.group_myinfo.terms_agreement_mkt_checkbox': '同意 ',
  'studio.gnb.group_myinfo.terms_agreement_mkt_agree_time': '{dateTime}同意 ',
  'studio.gnb.group_myinfo.terms_agreement_mkt_reject_time': '{dateTime}拒绝接收',
  'studio.gnb.group_myinfo.my_group.detailed_group_breadcrumb1': '我的信息 ',
  'studio.gnb.group_myinfo.my_group.detailed_group_breadcrumb2': '团队信息',
  'studio.gnb.group_myinfo.my_group.detailed_group_join_time': '{dateTime}加入',
  'studio.gnb.group_myinfo.my_group.detailed_group_permission': '团队功能权限',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_edit': '编辑',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_by_menu': '编辑权限',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_menu_name': '菜单',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_grp_home': '团队管理中心',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_prj_prod': '项目与商品',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_collection': '合集',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_store_comm': '商店社区',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_mem_mgmt': '成员管理',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_biz_bank_info': '设置公司与银行信息',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr': '编辑权限内容',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr1': '管理中心设置',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr2': '创建、修改、删除项目<br/>创建、删除商品',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr3': '创建、修改、删除合集',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr4': '创建、修改、删除社区',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr5': '邀请成员/创建和修改职责/移除成员',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr6': '登记/修改/审核公司信息<br/>银行信息登记/修改审核',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_view': '查询',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_by_menu': '菜单 ',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_home': '团队管理中心',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_prj_prod': '项目与商品',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_collection': '合集',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_store_comm': '商店社区',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_mem_mngmt': '成员管理',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_statistics': '指标',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_bill_settlement': '结算',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_biz_bank_info': '公司与银行信息',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_overall_maint': '游戏维护',
  'studio.gnb.group_myinfo.my_group.detailed_group_collapse_all_btn': '全部收起 ',
  'studio.gnb.group_myinfo.my_group.detailed_group_expand_all_btn': '全部展开',
  'studio.gnb.group_myinfo.my_group.detailed_group_prj_product_name': '商品',
  'studio.gnb.group_myinfo.my_group.detailed_group_prj_role': '职责 ',
  'studio.gnb.group_myinfo.my_group.detailed_group_permission_given_date': '权限赋予日期',
  'studio.gnb.group_myinfo.my_group.detailed_group_prj_name': '项目',
  'studio.gnb.group_myinfo.my_group.detailed_group_btn_leave_group': '退出团队',
  'studio.gnb.group_myinfo.my_group.detailed_group_product_num': '商品数量 ',
  'studio.gnb.group_myinfo.my_group.detailed_group_prj_num_none': '暂无目录',
  'studio.gnb.group_myinfo.my_group.detailed_group_leave_group_msg': '是否退出团队？',
  'studio.gnb.group_myinfo.my_group.detailed_group_btn_leave_cf': '退出',
  'studio.gnb.group_myinfo.my_group.detailed_group_leave_done_msg': '已成功退出团队。',
  'studio.gnb.group_myinfo.my_group.detailed_group_click_error_msg': '请刷新或重试。',
  'studio.gnb.group_myinfo.my_group.detailed_group_mkt_uncheck_msg': '不同意接收广告信息。',
  'studio.gnb.group_myinfo.my_group.detailed_group_mkt_check_msg': '同意接收广告信息。',
  'studio.gnb.group_myinfo.join_req_waitlist': '等待目录',
  'studio.gnb.group_myinfo.join_req_group_name': '团队名称',
  'studio.gnb.group_myinfo.join_req_date_time': '加入申请日期',
  'studio.gnb.group_myinfo.join_req_status': '状态',
  'studio.gnb.group_myinfo.join_req_none': '暂无目录',
  'studio.gnb.grp_myinfo.join_req_stt_rejected': '拒绝',
  'studio.gnb.group_myinfo.join_req_stt_waiting': '等待 ',
  'studio.gnb.group_myinfo_terms1_popup_usage_term': 'STOVE Studio使用条款',
  'studio.gnb.group_myinfo_terms1_popup_usage_term_title': 'STOVE Studio使用条款',
  'studio.gnb.group_myinfo_terms1_popup_btn_close': '关闭',
  'studio.gnb.group_myinfo_terms2_popup_usage_term': '同意收集及使用个人信息 ',
  'studio.gnb.group_myinfo_terms2_popup_btn_close': '关闭按钮 ',
  'studio.gnb.group_myinfo_terms2_popup_usage_term_title': '同意收集及使用个人信息 ',
  'studio.notice.none_guide': '暂无添加的公告。',
  'studio.notice.see_more_btn': '查看更多',
  'studio.lnb.notice': 'Studio公告',
  'studio.group.home.btn_create_new_group': '创建新团队',
  'studio.group.home.group_lnb_title': 'Studio团队',
  'studio.group.home.title_group_name': '团队{grpName}',
  'studio.group.home.title_group_name_change_title1': '请输入团队名称。',
  'studio.group.home.title_group_name_change_title2': '团队名称用于STOVE Studio中的团队管理，可以随时修改。',
  'studio.group.home.title_group_name_change_place_holder': '请输入团队名称',
  'studio.group.home.title_group_name_change_val_msg1': '请输入团队名称。',
  'studio.group.home.title_group_name_change_msg2': '该名称已被使用，请使用其他名称。',
  'studio.group.home.title_group_name_change_btn_modify': '修改',
  'studio.group.home.language_tool_tip': '这是多语言翻译的基准语言。<br/>仅团队负责人可以在团队主页点击语言按钮后修改。',
  'studio.group.home.language_standard_setting': '基础语言设置',
  'studio.group.home.language_standard_guide1': '团队内所有产品将自动使用您选择的语言进行AI翻译。',
  'studio.group.home.language_standard_guide2': '建议必要时更改。更改语言后，请确认AI翻译是否正常应用。',
  'studio.basic_lang_setting.us': '英语',
  'studio.basic_lang_setting.ko': '韩语',
  'studio.basic_lang_setting.ja': '日语',
  'studio.basic_lang_setting.zh_cn': '简体中文',
  'studio.basic_lang_setting.zh_tw': '繁體中文',
  'studio.group.home.language_standard_change': '更改',
  'studio.group.home.join_req_accepted_popup': '团队加入申请已被批准。<br/>即将跳转至团队页面。',
  'studio.group.home.join_req_accepted_popup_close_btn': '关闭',
  'studio.group.home.join_req_accepted_grp_dir_btn': '前往团队空间',
  'studio.group.home.join_req_accepted_noti': '{grpName}的加入申请已被批准。',
  'studio.group.home.board_type1': '项目与商品管理',
  'studio.group.home.board_type1_no_data1': '暂无持有项目。',
  'studio.group.home.board_type1_no_data2': '是否添加项目？',
  'studio.group.home.board_type1_no_data_btn': '前往添加',
  'studio.group.home.board_type1_data1': '项目',
  'studio.group.home.board_type1_data2': '商品',
  'studio.group.home.board_type2': '团队成员',
  'studio.group.home.board_type2_no_data1': '邀请成员，一起进行项目吧！',
  'studio.group.home.board_type2_mem_count': '{memCount}名',
  'studio.group.home.board_type3': '商品总销量排名',
  'studio.group.home.board_type3_data1': '总销量/购买转换率',
  'studio.group.home.board_type4': '{currentMonth}月预期销售额',
  'studio.group.home.board_type4_no_data1': '需填写团队银行信息方可进行结算。',
  'studio.group.home.board_type4_no_data2': '是否登记银行信息？',
  'studio.group.home.board_type4_no_data_btn': '前往添加',
  'studio.group.home.board_type5': '发布',
  'studio.group.home.board_type5_stt_to_be_opened_badge': '即将公开',
  'studio.group.home.board_type5_stt_to_be_opened_guide': '商品页面即将公开',
  'studio.group.home.board_type5_stt_live_applied_badge': '应用至LIVE',
  'studio.group.home.board_type5_stt_live_applied_guide': '预购开始',
  'studio.group.home.board_type5_stt_to_be_applied_badge': '等待应用',
  'studio.group.home.board_type5_stt_to_be_applied_guide': '正式发布',
  'studio.group.home.board_type6': '商店评价',
  'studio.group.home.board_type6_no_data1_after': '最近没有商品评价',
  'studio.group.home.board_type6_no_data2_after': '最近没有评论',
  'studio.group.home.board_type6_data1_after': '商品评价 ',
  'studio.group.home.board_type6_data2_after': '近期评论 ',
  'studio.group.home.board_type7': '商店社区',
  'studio.group.home.board_type7_no_data1_after': '最近没有帖子',
  'studio.group.home.board_type7_no_data2_after': '最近没有评论',
  'studio.group.home.board_type7_data1_after': '近期帖子 ',
  'studio.group.home.board_type7_data2_after': '近期评论 ',
  'studio.group.home.board_type7_not_existed': '没有社区。',
  'studio.group.home.board_type8': 'Lounge #标签',
  'studio.group.home.board_type8_no_data1_after': '暂无添加的标签',
  'studio.group.home.board_type8_data1_after': '最新帖子',
  'studio.group.home.board_type9': '商店心愿单',
  'studio.group.home.board_type9_data1_after': '心愿单',
  'studio.group.home.board_type10': '商品指标',
  'studio.group.home.board_type10_select_box1_tool_tip': '游戏同时在线人数',
  'studio.group.home.board_type10_select_box2_tool_tip': '商品页面访问人数',
  'studio.group.home.board_type10_select_box3_tool_tip': '每日游戏人数',
  'studio.group.home.first_page_register_guide1': '请先添加项目！',
  'studio.group.home.first_page_register_guide2': '添加项目后即可使用添加商品、发布商店商品等Studio的所有功能。',
  'studio.group.home.dash_board_setting': '管理中心设置',
  'studio.group.home.select_product': '选择商品',
  'studio.group.home.edit_list': '编辑目录',
  'studio.group.home.refresh_info': '商店信息每周一0点重置，可能与实时数据有所差异。',
  'studio.group.home.select_product.title': '选择商品',
  'studio.group.home.select_product.search_place_holder': '请搜索商品 ',
  'studio.group.home.select_product.search_no_result_msg': '无搜索结果。',
  'studio.group.home.select_product.search_no_select': '暂未选择商品。',
  'studio.group.home.edit_list.title': '编辑目录',
  'studio.group.home.edit_list.guide': '您可以选择显示在管理中心上的条目或者通过拖拽更改顺序。',
  'studio.group.home.edit_list.breadcrumb1': '团队主页',
  'studio.group.home.edit_list.breadcrumb2': '编辑目录',
  'studio.group.notice.title': 'Studio公告',
  'studio.group.notice.sub_title': 'Studio公告',
  'studio.group.notice.copy_text_button': '复制URL',
  'studio.group.notice.file_download_btn': '下载',
  'studio.group.notice.notice_list_dir_btn': '查看全部帖子',
  'studio.group.notice.list_header1': '类别',
  'studio.group.notice.list_header2': '标题',
  'studio.group.notice.list_header3': '编辑日期',
  'studio.group.notice.copied_toast_msg': '帖子URL复制成功。',
  'studio.group.pre_grp_landing.new_term_agreement_chkbox': '（必选）同意条款。',
  'studio.group.pre_grp_landing.all_terms_agreed_pop_msg1': '您已同意全部条款。',
  'studio.group.pre_grp_landing.all_terms_agreed_pop_msg2': '即将跳转至团队主页。',
  'studio.member_manage.member.member_title.nick_header': '昵称',
  'studio.member_manage.member.member_title.project_count_header': '所属项目',
  'studio.member_manage.member.member_title.regi_date_header': '加入日期',
  'studio.member_manage.member_all_title': '全部',
  'studio.member_manage.member_invite_btn': '邀请成员',
  'studio.member_manage.member_invite_alert1_msg': '无编辑权限。<br/>请咨询团队管理员。',
  'studio.member_manage.member.guide1': '您可以邀请和管理团队成员',
  'studio.member_manage.member.guide2': '可以给成员分配菜单/商品权限和职责',
  'studio.member_manage.member.guide3': '可以分配默认职责或根据创作者团队需求自定义职责设置。',
  'studio.member_manage.member_invite.mem_invite': '邀请成员',
  'studio.member_manage.member_invite.mem_invite_link': '邀请链接',
  'studio.member_manage.member_invite.link_expiry': '{remainingTimeNum}{timeUnit}后到期。',
  'studio.member_manage.member_invite.link_used_times': '当前次数： ',
  'studio.member_manage.member_invite.link_used_times_value': '{times}次',
  'studio.member_manage.member_invite.link_regen_btn': '重新创建链接',
  'studio.member_manage.member_invite.link_regen_guide': '重新创建邀请链接。<br/>无法继续使用该链接加入。',
  'studio.member_manage.member_invite.link_regen_cf_btn': '重新创建链接',
  'studio.member_manage.member_invite.link_regen_done': '邀请链接重新创建成功。',
  'studio.member_manage.member_invite.mem_invite_link_advanced_settings': '高级设置',
  'studio.member_manage.member_invite.mem_invite_link_activation_y_n': '是否激活',
  'studio.member_manage.member_invite.mem_invite_link_activation_guide': '将链接设置为未激活后，直到激活之前，将无法使用。',
  'studio.member_manage.member_invite.mem_invite_link_activation_y': '激活',
  'studio.member_manage.member_invite.mem_invite_link_activation_n': '未激活',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry': '链接到期时间',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_guide': '更改到期时间时，根据保存时间刷新到期时间。 ',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_def_7d_': '7天',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_30m': '30分钟',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_1h': '1小时',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_6h': '6小时',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_12h': '12小时',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_1d': '1天',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_n': '永久有效',
  'studio.member_manage.member_invite.mem_invite_link_guide': '邀请链接',
  'studio.member_manage.member_invite.mem_invite_link_guide1':
    '请复制生成的邀请链接并发送给想邀请的成员。收到邀请链接后，如果未注册Studio需先完成注册，如已注册则可直接申请加入团队',
  'studio.member_manage.member_invite.mem_invite_link_advanced_setting_guide': '高级设置',
  'studio.member_manage.member_invite.mem_invite_link_advanced_setting_guide1':
    '可以设置链接。更改后点击保存，才能更改设置。重新创建链接时，将根据默认值重新创建链接。',
  'studio.member_manage.member_invite.mem_invite_link_expired': '邀请链接已过期。',
  'studio.member_manage.member_invite.mem_invite_link_copied': '复制成功',
  'studio.member_manage.member.list_invite_date': '邀请日期',
  'studio.member_manage.member.list_resend_invite_btn': '重新发送',
  'studio.member_manage.member.list_cancel_invite_btn': '取消邀请',
  'studio.member_manage.member.invite_link_popup_case_4806': '已加入的团队。',
  'studio.member_manage.member.invite_link_popup_case_4500_01_4804': '链接无效或成员错误。',
  'studio.member_manage.member.invite_link_popup_case_4505': '{grpName}<br/>邀请代码已过期。<br/>请向团队代表获取新的邀请链接并重新申请。',
  'studio.member_manage.member.invite_link_popup_case_0_success': '{grpName}<br/>团队加入申请已完成。<br/>请在加入状态中查看是否批准。',
  'studio.member_manage.role_manage_btn': '职责管理',
  'studio.member_manage.role_value_operator': '运营',
  'studio.member_manage.role_value_marketer': '商务',
  'studio.member_manage.role_value_developer': '开发',
  'studio.member_manage.role_value_manager': '项目管理员',
  'studio.member_manage.role_manage_create_role_btn': '新建职责',
  'studio.member_manage.role_manage_create_role_msg1': '职责名称',
  'studio.member_manage.role_manage_create_role_place_holder': '请输入职责名称 ',
  'studio.member_manage.role_manage_create_role_alert1': '请输入职责名称。',
  'studio.member_manage.role_manage_create_role_val1': '职责名称重复。请确认后重新输入。',
  'studio.member_manage.role_manage_create_role_msg2': '权限设置',
  'studio.member_manage.role_manage_create_role_msg3': '可以单独赋予各商品主页中的各条功能权限。',
  'studio.member_manage.role_manage_create_role_menu_header1': '菜单',
  'studio.member_manage.role_manage_create_role_perm_view_header2': '查询',
  'studio.member_manage.role_manage_create_role_perm_edit_header3': '编辑',
  'studio.member_manage.role_manage_create_role_register_btn': '添加',
  'studio.member_manage.role_manage_create_role_msg6': '职责与各菜单权限设置',
  'studio.member_manage.role_manage_create_role_msg7': '不同菜单可设置不同的访问权限。<br/>建议设置易于区分的职责名称。<br/>职责名称不可重复！',
  'studio.member_manage.role_manage_create_role_msg8': '指标/结算权限设置',
  'studio.member_manage.role_manage_create_role_msg9': '选择指标/结算权限后将授予相应的团队功能访问权限。',
  'studio.member_manage.role_manage_create_role_register_alert_msg': '新职责创建成功。',
  'studio.member_manage.role_manage_details_title': '修改职责',
  'studio.member_manage.role_manage_details_save_btn': '保存',
  'studio.member_manage.role_manage_details_delete_btn': '删除职责',
  'studio.member_manage.role_manage_details_save_alert_msg': '职责保存成功。',
  'studio.member_manage.role_manage_details_delete_step1_msg': '确定要删除该职责吗？<br/>该职责下所有成员的职责权限将被移除。',
  'studio.member_manage.role_manage_details_delete_step1_delete_btn': '删除',
  'studio.member_manage.role_manage_details_delete_step2_delete_alert1_msg': '职责删除成功。',
  'studio.member_manage.role_manage_details_delete_step2_delete_alert2_msg': '请刷新<br/>或重试。',
  'studio.member_manage.role_manage_list_by_menu': '菜单',
  'studio.member_manage.role_manage_list_view_per': '查询',
  'studio.member_manage.role_manage_list_edit_per': '编辑',
  'studio.member_manage.role_manage_list_by_menu_release_plan': '发布',
  'studio.member_manage.role_manage_list_by_menu_prod_pg_mgmt': '商品页面管理',
  'studio.member_manage.role_manage_list_by_menu_prod_setting': '商品设置',
  'studio.member_manage.role_manage_list_by_menu_prod_pg': '商品页面',
  'studio.member_manage.role_manage_list_by_menu_prod_term': '商品条款',
  'studio.member_manage.role_manage_list_by_menu_price': '价格',
  'studio.member_manage.role_manage_list_by_menu_discount': '优惠',
  'studio.member_manage.role_manage_list_by_menu_pur_cond': '购买条件',
  'studio.member_manage.role_manage_list_by_menu_early_access': '抢先体验文案设置',
  'studio.member_manage.role_manage_list_by_menu_collection': '合集',
  'studio.member_manage.role_manage_list_by_menu_prod_data_mgmt': '商品数据管理',
  'studio.member_manage.role_manage_list_by_menu_build_mgmt': '构建管理',
  'studio.member_manage.role_manage_list_by_menu_exe_setting': '运行设置',
  'studio.member_manage.role_manage_list_by_menu_rating_build_review': '游戏分级及构建审核',
  'studio.member_manage.role_manage_list_by_menu_stats': '能力值',
  'studio.member_manage.role_manage_list_by_menu_ranking': '排名',
  'studio.member_manage.role_manage_list_by_menu_challenge': '挑战任务',
  'studio.member_manage.role_manage_list_by_menu_cloud_saving': '云存储',
  'studio.member_manage.role_manage_list_by_menu_match_making': '匹配',
  'studio.member_manage.role_manage_list_by_menu_prod_mkt_mgmt': '商品营销管理',
  'studio.member_manage.role_manage_list_by_menu_statistics': '指标',
  'studio.member_manage.role_manage_list_by_menu_bill_settlement': '结算',
  'studio.member_manage.role_manage_list_by_menu_ingame_store': '游戏内商店',
  'studio.member_manage.role_manage_list_by_menu_ingame_setting': '游戏内结算设置',
  'studio.member_manage.role_manage_list_by_menu_sub_ingame_store': '游戏内商店',
  'studio.member_manage.role_manage_list_by_menu_ingame_store_product': '游戏内商品',
  'studio.member_manage.role_manage_list_by_menu_ingame_store_discount': '游戏内优惠商品',
  'studio.member_manage.role_manage_list_by_menu_ingame_store_payment_history': '游戏内结算历史',
  'studio.member_manage.role_manage_details_msg1': 'Studio默认职责',
  'studio.member_manage.role_manage_details_msg2': 'Studio提供的默认职责无法编辑或删除。',
  'studio.member_manage.member_nick_header2': '昵称',
  'studio.member_manage.member_project_count_header3': '所属项目',
  'studio.member_manage.member_regi_date_header4': '加入日期',
  'studio.member_manage.member_invite_date_header5': '邀请日期',
  'studio.member_manage.search_place_holder': '请搜索昵称',
  'studio.member_manage.history': '查看历史',
  'studio.member_manage.search_nmrf': '没有找到符合搜索条件的结果。',
  'studio.member_manage.list_no_data': '暂无目录。',
  'studio.member_manage.mem_by_project_title': '项目成员',
  'studio.member_manage.project_project_name_header1': '项目',
  'studio.member_manage.project_no_of_member_header2': '成员人数',
  'studio.member_manage.project_project_name_header2': '创建日期',
  'studio.member_manage.project_list_member_title': '成员',
  'studio.member_manage.project_list_nickname_header3': '昵称',
  'studio.member_manage.project_list_product_name_header1': '商品',
  'studio.member_manage.project_list_role_header4': '职责',
  'studio.member_manage.project_list_date_authorized_header5': '权限赋予日期',
  'studio.member_manage.project_list_collapse_all_btn': '全部收起',
  'studio.member_manage.project_list_expand_all_btn': '全部展开',
  'studio.member_manage.join_waitlist_chk_btn': '等待加入',
  'studio.member_manage.join_waitlist_nickname': '昵称',
  'studio.member_manage.join_waitlist_req_date': '加入申请日期',
  'studio.member_manage.join_waitlist_stt': '状态',
  'studio.member_manage.join_waitlist_stt_waiting': '等待',
  'studio.member_manage.join_waitlist_no_data': '还没有申请加入该群组的成员。<br/>如需邀请成员，请生成并分享邀请链接。',
  'studio.member_manage.membership_requests_decline_btn': '拒绝',
  'studio.member_manage.membership_requests_approve_btn': '批准',
  'studio.member_manage.membership_requests_approve_alert_msg': '已完成加入审批。<br/>如需设置权限，请从列表中点击成员并进行权限设置。',
  'studio.member_manage.membership_requests_decline_alert_msg': '加入申请已被拒绝。',
  'studio.member_manage.membership_requests_action_alert_msg': '请在目录中选择成员。',
  'studio.member_manage.member_details_msg2': '昵称',
  'studio.member_manage.member_details_msg3': '加入日期',
  'studio.member_manage.member_details_group_menu_permission_title': '选择团队菜单权限',
  'studio.member_manage.member_details_product_permission_title': '选择商品权限',
  'studio.member_manage.member_details_right_guide1': '项目与商品权限',
  'studio.member_manage.member_details_right_guide2': '可以管理团队所属产品的权限设置。',
  'studio.member_manage.member_details_right_guide3': '自动分配职责',
  'studio.member_manage.member_details_right_guide4': '成员接受邀请后，添加商品时可以自动赋予权限，无需每次手动设置。 ',
  'studio.member_manage.member_details_right_guide5': '鉴于自动赋予权限，存在需要保密的项目或商品时，需在该成员的详细信息页面中进行修改。',
  'studio.member_manage.member_details_save_btn': '保存',
  'studio.member_manage.member_details_remove_btn': '移除成员',
  'studio.member_manage.member_details_remove_step1_msg': '确定要移除成员吗？',
  'studio.member_manage.member_details_remove_step1_remove_btn': '移除',
  'studio.member_manage.member_details_remove_step2_msg': '已将成员移出团队。',
  'studio.member_manage.member_details_group_menu_permission_msg1': '请选择要授予成员的团队菜单权限。',
  'studio.member_manage.member_details_group_menu_permission_msg2': '结算/指标菜单需要商品权限才能搜索。',
  'studio.member_manage.member_details_group_menu_permission_mail_or_notice_title': '邮件/通知',
  'studio.member_manage.member_details_group_menu_permission_mail_or_notice_msg': '接收与拥有权限的商品相关的邮件或通知。',
  'studio.member_manage.member_details_group_menu_permission_mail_or_notice_settlement_chkbox': '结算',
  'studio.member_manage.member_details_group_menu_permission_mail_or_notice_review_chkbox': '审核',
  'studio.member_manage.member_details_group_menu_permission_mail_or_notice_contract_chkbox': '合同',
  'studio.member_manage.member_details_product_permission_msg1': '请选择要分配给成员的商品和职责。',
  'studio.member_manage.member_details_product_permission_product_name_header1': '项目与商品名称',
  'studio.member_manage.member_details_product_permission_role_selection_dropbox_header2': '选择职责',
  'studio.member_manage.member_details_product_permission_apply_all_btn': '全部应用',
  'studio.member_manage.member_details_product_permission_full_btn': '全屏',
  'studio.member_manage.member_details_product_permission_msg2': '添加新产品时将自动分配相应职责。',
  'studio.member_manage.member_details_product_permission_product_place_holder': '暂无可授权产品。<br/>团队内需要至少有1个产品。',
  'studio.member_manage.history_nick_header1': '昵称',
  'studio.member_manage.history_summary_header2': '内容',
  'studio.member_manage.history_status_header3': '状态',
  'studio.member_manage.history_date_header4': '时间',
  'studio.member_manage.history_category_all': '全部',
  'studio.member_manage.history_category_joined': '加入',
  'studio.member_manage.history_category_rejected': '拒绝',
  'studio.member_manage.history_category_edit': '修改',
  'studio.member_manage.history_category_left_gr': '退出',
  'studio.member_manage.history_status_edit_depth_details_added': '[添加]',
  'studio.member_manage.history_status_edit_depth_details_removed': '[删除]',
  'studio.member_manage.history_status_invited': '邀请',
  'studio.member_manage.history_status_invited_details': '已邀请{email}。',
  'studio.member_manage.history_status_joined': '加入',
  'studio.member_manage.history_status_joined_details': '新成员加入！',
  'studio.member_manage.history_status_declined': '拒绝',
  'studio.member_manage.history_status_edit_product': '修改',
  'studio.member_manage.history_status_edit_product_details': '{nickName}的商品权限已修改。',
  'studio.member_manage.history_status_edit_menu': '修改',
  'studio.member_manage.history_status_edit_menu_details': '{nickName}的菜单权限已修改。',
  'studio.member_manage.history_status_dismiss': '退出',
  'studio.member_manage.history_status_dismiss_details': '{nickName}已被移出团队。',
  'studio.member_manage.history_status_left': '退出',
  'studio.member_manage.history_status_left_details': '{nickName}已退出团队。',
  'studio.member_manage.history_status_expand_details': '查看详情',
  'studio.member_manage.history_search_place_holder': '请搜索昵称',
  'studio.prod_home.pur_cond.pur_cond': '购买条件',
  'studio.prod_home.pur_cond.btn_save': '保存',
  'studio.prod_home.pur_cond.pur_cond_prod': '条件品',
  'studio.prod_home.pur_cond.pur_cond_prod_place_holder': '请搜索商品',
  'studio.prod_home.pur_cond.pur_cond_prod_no_result': '无搜索结果。',
  'studio.prod_home.pur_cond.pur_cond_type': '条件类型',
  'studio.prod_home.pur_cond.pur_cond_type1': 'AND条件',
  'studio.prod_home.pur_cond.pur_cond_type2': 'OR条件',
  'studio.prod_home.pur_cond.pur_cond_option': '是否设置购买条件',
  'studio.prod_home.pur_cond.pur_cond_option_y': '使用',
  'studio.prod_home.pur_cond.pur_cond_option_n': '未使用',
  'studio.prod_home.pur_cond.pur_cond_guide1': '可设为条件品的商品有哪些？',
  'studio.prod_home.pur_cond.pur_cond_guide1_detail':
    '可将自己所属团队的商品或合集商品设置为购买条件商品。<br/>注意：如果已将产品A设为产品B的购买条件，则产品B不能再被设为产品A的购买条件。',
  'studio.prod_home.pur_cond.pur_cond_guide2': 'AND条件类型是什么？',
  'studio.prod_home.pur_cond.pur_cond_guide2_detail': '只有拥有所有条件品的玩家才能购买该商品。 ',
  'studio.prod_home.pur_cond.pur_cond_guide3': 'OR条件类型是什么？',
  'studio.prod_home.pur_cond.pur_cond_guide3_detail': '玩家只需拥有1件条件品就可以购买该商品。 ',
  'studio.prod_home.pur_cond.pur_cond_guide5': '购买条件是指什么？',
  'studio.prod_home.pur_cond.pur_cond_guide5_detail': '将商品A设为某个商品的“条件品”时，只有拥有商品A的玩家，才能购买这件商品。',
  'studio.prod_home.pur_cond.pur_cond_stove_set': 'STOVE设置的条件品',
  'studio.prod_home.pur_cond.pur_cond_guide4': 'STOVE设置的条件品是什么？',
  'studio.prod_home.pur_cond.pur_cond_guide4_detail':
    'STOVE运营者设置的条件品。<br/>存在STOVE设置的条件品时，无法直接设置购买条件。如果想要把其他商品设为条件品，请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.prj_prod.this_prod.landing_msg1': '商品页面',
  'studio.prj_prod.this_prod.landing_create_btn': '创建',
  'studio.prj_prod.this_prod.landing_msg2': '创建和编辑商品页面，让你的商品脱颖而出吧！',
  'studio.prj_prod.this_prod.landing_msg3': '请准备30MB以下的主图、截图、图标和100MB以下的视频以及商品介绍后进行编辑。',
  'studio.prj_prod.this_prod.landing_create_pop_msg1': '请输入商品页面名称。 ',
  'studio.prj_prod.this_prod.landing_create_pop_msg2': '用于区分商品页面，不向玩家显示。',
  'studio.prj_prod.this_prod.landing_create_pop_page_name_place_holder': '请输入商品页面名称。',
  'studio.prj_prod.this_prod.landing_create_pop_input_msg1': '请输入商品页面名称。 ',
  'studio.prj_prod.this_prod.landing_create_pop_create_btn': '创建',
  'studio.prj_prod.this_prod.edit_page_name': 'SOULGAME商店主页',
  'studio.prj_prod.this_prod.edit_info_hover_msg': '这是多语言翻译的基准语言。<br/>仅团队负责人可以在团队主页点击语言按钮后修改。',
  'studio.prj_prod.edit_preview_toggle_msg': '收起预览区域可以更大地利用工作区域<br/>',
  'studio.prj_prod.this_prod.edit_sidebar_title': '编辑商品页面',
  'studio.prj_prod.this_prod.edit_sidebar_msg1': '查看必填项',
  'studio.prj_prod.this_prod.edit_preview_btn': '预览',
  'studio.prj_prod.this_prod.edit_mls_btn': '多语言设置',
  'studio.prj_prod.this_prod.text_missing_mls_n_popup': '输入一句话介绍后，可以设置多语言。<br/>请输入内容后重试。',
  'studio.prj_prod.this_prod.edit_save_step0_msg': '有必填项尚未填写。<br/>填写所有必填项，才能添加到发布计划。',
  'studio.prj_prod.this_prod.edit_display_prod_pg': '显示商品页面',
  'studio.prj_prod.this_prod.edit_display_countries_msg1': '显示国家/地区',
  'studio.prj_prod.this_prod.edit_display_countries_view_btn': '查看全部国家/地区',
  'studio.prj_prod.this_prod.edit_display_countries_select_all': '全部国家/地区',
  'studio.prj_prod.this_prod.edit_display_countries_select_partial': '部分国家/地区',
  'studio.prj_prod.this_prod.edit_display_countries_msg4': '选择国家/地区',
  'studio.prj_prod.this_prod.edit_display_countries_regions': '按区域查看',
  'studio.prj_prod.this_prod.edit_display_countries_search_country': '搜索单个国家/地区',
  'studio.prj_prod.this_prod.edit_display_countries_regions_all': '全部',
  'studio.prj_prod.this_prod.edit_display_countries_checkbox_val1': '请至少选择一个国家/地区。',
  'studio.prj_prod.this_prod.edit_display_countries_search_country_placeholder': '搜索国家/地区',
  'studio.prj_prod.this_prod.edit_gamepreview_hover_msg1': '我的电脑',
  'studio.prj_prod.this_prod.edit_gamepreview_hover_msg2': '存储器',
  'studio.prj_prod.this_prod.edit_gamepreview_hover_msg3': '编辑',
  'studio.prj_prod.this_prod.edit_gamepreview_import_this_media_alert2': '只能选择1个文件。',
  'studio.prj_prod.this_prod.edit_gamepreview_import_this_media_alert3': '不支持的文件格式。<br/>请确认文件扩展名后再上传文件。',
  'studio.prj_prod.this_prod.edit_gamepreview_import_this_media_alert4': '文件容量超出限制。<br/>请先确认最大容量后再上传文件。',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_title': '开始日期',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_immediate_radio_btn': '立即',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_select_time_radio_btn': '预约',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_req_msg': '请选择开始日期。',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_invalid_msg': '预约开始日期必须在当前日期之后。',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_pop1_msg': '是否立即应用到商品页面？',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_pop2_msg': '是否应用商品页面预约？',
  'studio.prj_prod.this_prod.edit_gamepreview_title': '视频与图片',
  'studio.prj_prod.this_prod.edit_gamepreview_msg1': '选择画面类型',
  'studio.prj_prod.this_prod.edit_gamepreview_radio1': '默认类型',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2': '视频背景类型',
  'studio.prj_prod.this_prod.edit_gamepreview_radio1_msg1': '商品页面背景图片（选择）',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2_msg1': '商品页面背景视频',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2_msg1_guide1': '将在手机和PC网页显示为商品页面背景。',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2_required_n': '请添加视频。',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2_msg2': '商品页面背景图片（选择）',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2_msg2_guide1': '将在客户端显示为商品页面背景。',
  'studio.prj_prod.this_prod.edit_gamepreview_msg6': '展示视频与图片',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn': '添加文件',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_link_btn': '视频链接',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_video_file_btn': '视频文件',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_image_btn': '图片',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_link_title': '视频链接 ',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_link_place_holder': '请先添加缩略图后输入视频URL。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_file_title': '视频文件',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_image_title': '图片',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn_alert1': '请上传视频或图片。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn_alert2': '请设置视频缩略图。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn_alert3': '请添加视频URL。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn_alert4': 'URL必须在1~2000字符之间。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn_alert5': 'URL格式错误。',
  'studio.prj_prod.this_prod.edit_gamepreview_msg7': '1:1图片',
  'studio.prj_prod.this_prod.edit_gamepreview_msg7_1': '用作商品的标题图片，显示在商品排名页面等。',
  'studio.prj_prod.this_prod.edit_gamepreview_1to1_info_hover_msg': '显示在商品页面的标注位置。',
  'studio.prj_prod.this_prod.edit_gamepreview_msg7_attach_msg1': '请添加图片。',
  'studio.prj_prod.this_prod.edit_gamepreview_language_setting_btn': '按语言添加',
  'studio.prj_prod.this_prod.edit_gamepreview_msg8': '16:9图片',
  'studio.prj_prod.this_prod.edit_gamepreview_msg8_1': '显示在商品目录、购物车、个人主页等。',
  'studio.prj_prod.this_prod.edit_gamepreview_msg8_attach_msg1': '请添加图片。',
  'studio.prj_prod.this_prod.edit_gamepreview_16to9_preview_btn': '预览',
  'studio.prj_prod.this_prod.edit_gamepreview_language_setting_guide':
    '含有商标的图片，不同语言使用不同商标时，可以按照语言分别添加。若未上传语言的图片，将显示基础语言的图片！',
  'studio.ai_translation.base_lang_ko': '韩语',
  'studio.ai_translation.base_lang_ch_cn': '简体中文',
  'studio.ai_translation.base_lang_ch_tw': '繁體中文',
  'studio.prj_prod.this_prod.edit_title_bg_img': '标题背景图片（选择）',
  'studio.prj_prod.this_prod.edit_title_bg_img_guide': '可以添加背景图片，让1:1图片更加显眼。',
  'studio.prj_prod.this_prod.edit_gamepreview_title_background_info_hover_msg': '显示在商品页面的标注位置。',
  'studio.prj_prod.this_prod.edit_gamepreview_msg9': '一句话介绍图片（选择）',
  'studio.prj_prod.this_prod.edit_gamepreview_msg9_1': '可添加显示在一句话介绍上方的图片。',
  'studio.prj_prod.this_prod.edit_gamepreview_headline_info_hover_msg': '显示在商品页面的标注位置。',
  'studio.prj_prod.this_prod.edit_gamepreview_16to9_preview_title': '预览16:9图片应用效果',
  'studio.prj_prod.this_prod.edit_gamepreview_16to9_preview_msg1': '本图片为帮助用户理解的示例图。',
  'studio.prj_prod.this_prod.edit_gamepreview_16to9_preview_msg2': '商店商品列表',
  'studio.prj_prod.this_prod.edit_gamepreview_16to9_preview_msg4': '购物车',
  'studio.prj_prod.this_prod.edit_texts': '文本',
  'studio.prj_prod.this_prod.edit_texts_subtitle_title': '主题（选择）',
  'studio.prj_prod.this_prod.edit_texts_subtitle_guide': '如有需要，您可以在商品名称前添加前置标签。建议选择能补充商品名称含义的文字。',
  'studio.prj_prod.this_prod.edit_texts_subtitle_place_holder': '请输入主题',
  'studio.prj_prod.this_prod.edit_texts_headline_title': '一句话介绍',
  'studio.prj_prod.this_prod.edit_texts_headline_place_holder': '请输入一句话介绍',
  'studio.prj_prod.this_prod.edit_texts_headline_alert1': '请输入一句话介绍。',
  'studio.prj_prod.this_prod.edit_writing_guidance_btn': '编辑指南',
  'studio.prj_prod.this_prod.edit_writing_guidance_info1': '一句话介绍能够帮助商品在搜索引擎中更容易被找到。',
  'studio.prj_prod.this_prod.edit_writing_guidance_info2': '建议这样编辑',
  'studio.prj_prod.this_prod.edit_writing_guidance_info3': '包含主要关键词',
  'studio.prj_prod.this_prod.edit_writing_guidance_info4': '概括商品的整体内容',
  'studio.prj_prod.this_prod.edit_writing_guidance_info5': '英文160字以内，韩文/日文/中文80字以内',
  'studio.prj_prod.this_prod.edit_writing_guidance_info6': '不建议这样编辑',
  'studio.prj_prod.this_prod.edit_writing_guidance_info7': '关键词出现2次以上',
  'studio.prj_prod.this_prod.edit_writing_guidance_info8': '包含与商品无关的关键词',
  'studio.prj_prod.this_prod.edit_writing_guidance_info9': '只输入商品名称',
  'studio.prj_prod.this_prod.edit_summary_title': '商品说明（选择）',
  'studio.prj_prod.this_prod.edit_summary_title_full_btn': '全屏',
  'studio.prj_prod.this_prod.edit_summary_place_holder1': '建议在游戏商品说明中输入以下内容！<br/>若有提示图片，可以添加。',
  'studio.prj_prod.this_prod.edit_summary_place_holder2': '玩家游戏后记',
  'studio.prj_prod.this_prod.edit_summary_place_holder3': '游戏的魅力亮点',
  'studio.prj_prod.this_prod.edit_summary_place_holder4': '角色介绍',
  'studio.prj_prod.this_prod.edit_summary_place_holder5': '剧情',
  'studio.prj_prod.this_prod.edit_summary_place_holder6': '操作方法',
  'studio.prj_prod.this_prod.edit_summary_place_holder7': '制作者备注',
  'studio.prj_prod.this_prod.edit_summary_info_hover_msg': '全屏可选择夜视模式输入。',
  'studio.prj_prod.this_prod.edit_summary_attatch_msg1': '我的电脑',
  'studio.prj_prod.this_prod.edit_summary_attatch_msg2': '存储器',
  'studio.prj_prod.this_prod.edit_summary_fullscreen_exit_btn': '退出全屏',
  'studio.prj_prod.this_prod.edit_summary_darkmode_btn': '夜视模式',
  'studio.prj_prod.this_prod.edit_additional_info_title': '附加信息',
  'studio.prj_prod.this_prod.edit_additional_info_tags_title': '标签（选择）',
  'studio.prj_prod.this_prod.edit_additional_info_tags_guide':
    '玩家可以使用添加的标签进行筛选，方便找到商品。<br/>按照设置的顺序显示标签，可以采用拖拽方式更改显示顺序。',
  'studio.prj_prod.this_prod.edit_additional_info_tags_search_place_holder': '请搜索标签',
  'studio.prj_prod.this_prod.edit_additional_info_tags_search_no_msg': '无搜索结果。 ',
  'studio.prj_prod.this_prod.edit_additional_info_tags_search_msg1': '根据平台政策，有可能优先显示特定标签。',
  'studio.prj_prod.this_prod.edit_additional_supporting_title': '支持功能（选择）',
  'studio.prj_prod.this_prod.edit_additional_supporting_languages_title': '产品内支持语言',
  'studio.prj_prod.this_prod.edit_additional_supporting_languages_val_msg1': '请选择至少1个支持语言。',
  'studio.prj_prod.this_prod.edit_additional_supporting_languages_msg1': '界面',
  'studio.prj_prod.this_prod.edit_additional_supporting_languages_msg2': '语音',
  'studio.prj_prod.this_prod.edit_additional_supporting_languages_msg3': '字幕',
  'studio.prj_prod.this_prod.edit_additional_requirements_title': '配置',
  'studio.prj_prod.this_prod.edit_additional_requirements_add_btn': '添加配置',
  'studio.prj_prod.this_prod.edit_additional_requirements_os_place_holder': '最低配置（必选）',
  'studio.prj_prod.this_prod.edit_additional_requirements_component': '项目',
  'studio.prj_prod.this_prod.edit_additional_requirements_component_min_place_holder': '最低配置（选择）',
  'studio.prj_prod.this_prod.edit_additional_requirements_component_recommended_place_holder': '推荐配置（选择）',
  'studio.prj_prod.this_prod.edit_additional_requirements_toggle': '输入推荐配置',
  'studio.prj_prod.this_prod.edit_additional_requirements_os_val_msg': '请输入OS项目',
  'studio.prj_prod.this_prod.edit_additional_requirements_processor_val_msg': '请输入处理器（Processor）',
  'studio.prj_prod.this_prod.edit_additional_requirements_memory_val_msg': '请输入内存（Memory）',
  'studio.prj_prod.this_prod.edit_additional_requirements_graphics_val_msg': '请输入显卡（Graphics）。',
  'studio.prj_prod.this_prod.edit_additional_requirements_directx_val_msg': '请输入DirectX',
  'studio.prj_prod.this_prod.edit_additional_requirements_storage_val_msg': '请输入存储（Storage）',
  'studio.prj_prod.this_prod.edit_additional_requirements_sound_val_msg': '请输入声卡（Sound）',
  'studio.prj_prod.this_prod.edit_additional_links_title': '相关链接（选择）',
  'studio.prj_prod.this_prod.edit_additional_links_add_btn': '添加链接',
  'studio.prj_prod.this_prod.edit_additional_links_name_place_holder': '输入链接标题',
  'studio.prj_prod.this_prod.edit_additional_links_name_val_msg1': '请输入链接标题。 ',
  'studio.prj_prod.this_prod.edit_additional_links_url_place_holder': '输入URL',
  'studio.prj_prod.this_prod.edit_additional_links_url_val_msg1': 'URL格式错误。 ',
  'studio.prj_prod.this_prod.edit_additional_awards_image_title': '获奖图片（选择）',
  'studio.prj_prod.this_prod.edit_additional_awards_image_add_btn': '添加获奖图片',
  'studio.prj_prod.this_prod.edit_additional_awards_image_val_msg1': '扩展名不同，无法上传。 ',
  'studio.prj_prod.this_prod.edit_additional_awards_image_val_msg2': '文件超出容量限制，无法上传。',
  'studio.prj_prod.this_prod.edit_additional_awards_this_image_name': '图片',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_title': '编辑图片',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_imagetype_subtitle': '16:9图片',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_msg1': '查看指南',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_info_tool_tip1':
    '请确认添加图片的位置。<br/>主图不得超过红线，标志不得超过黄线。<br/>不保存指引线。',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_info_tool_tip2':
    '请确认添加图片的位置。<br/>主图不得超过红线。<br/>不保存指引线。',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_msg2': '添加标志',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_local_btn': '我的电脑',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_storage_btn': '存储器',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_background_color_abbr': '背景颜色',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_background_color_full': '背景颜色',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_save_btn': '保存',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_save_storage_btn': '保存至存储器',
  'studio.prj_prod.this_proj.this_prod.status_header1': '状态',
  'studio.prj_prod.this_proj.this_prod.list_this_status_upcoming_msg': '等待应用',
  'studio.prj_prod.this_proj.this_prod.list_this_status_expired_msg': '结束',
  'studio.prj_prod.this_proj.this_prod.list_this_status_declined_msg': '检查驳回',
  'studio.prj_prod.this_proj.this_prod.list_this_status_active_msg': '应用至LIVE',
  'studio.prj_prod.this_proj.this_prod.list_this_status_suspend_msg': '停止展示',
  'studio.prj_prod.this_proj.this_prod.prod_page_name_header3': '商品页面名称',
  'studio.prj_prod.this_proj.this_prod.display_header2': '展示 ',
  'studio.prj_prod.this_proj.this_prod.registered_edited_date_header4': '添加日期<br/>（编辑日期）',
  'studio.prj_prod.this_proj.this_prod.list_kebab_edit_page_name_btn': '修改商品页面名称',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_btn': '复制',
  'studio.prj_prod.this_proj.this_prod.list_kebab_delete_btn': '删除',
  'studio.prj_prod.this_proj.this_prod.list_kebab_display_n_btn': '停止展示',
  'studio.prj_prod.this_proj.this_prod.list_kebab_display_y_btn': '恢复展示',
  'studio.prj_prod.this_proj.this_prod.release_period_header5': '时间',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop1_msg': '恢复展示',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop1_msg1': '如需开始展示，请点击“ON”。 ',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop1_display_y_btn': '恢复展示',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop2_msg': '停止展示',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop2_msg1': '如需停止展示，请输入“OFF”。 ',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop2_display_n_btn': '停止展示',
  'studio.prj_prod.this_proj.this_prod.list_this_status_in_review_msg': '检查中',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_title': '复制商品页面',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_msg': '请选中本商品页面所有需要复制的地方。',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_prod_page_count_title': '全部',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_search_place_holder': '请搜索商品 ',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_duplicate_btn': '复制',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_product_header2': '商品',
  'studio.prj_prod.this_proj.this_prod.list_kebab_delete_x_msg': '已经应用，无法删除。',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_limit_exceed_msg': '每次最多可以选择50个。',
  'studio.prj_prod.this_proj.this_prod.list_kebab_delete_pop_msg': '是否删除等待应用的商品页面？',
  'studio.prj_prod.this_proj.this_prod.list_kebab_delete_cf_btn': '删除',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_search_nmrf': '无搜索结果。',
  'studio.prj_prod.this_prod.list_edit_edit_msg1': '请输入商品页面名称。 ',
  'studio.prj_prod.this_prod.list_edit_edit_msg2': '用于区分商品页面，不向玩家显示。',
  'studio.prj_prod.this_prod.list_edit_edit_page_name_input_place_holder': '请输入商品页面名称。',
  'studio.prj_prod.this_prod.list_edit_edit_page_name_input_val_msg1': '请输入商品页面名称。 ',
  'studio.prj_prod.this_prod.edit_title': '编辑商品页面',
  'studio.prj_prod.this_prod.edit_page_not_status2_msg': '{releaseStatus}状态的商品页面。点击编辑按钮就可以编辑复制的商品页面。 ',
  'studio.prj_prod.this_prod.edit_duplicate_btn': '复制',
  'studio.prj_prod.this_prod.edit.pop_declined_items_msg': '驳回理由',
  'studio.prj_prod_mngmt.pg_title': '项目与商品管理',
  'studio.prj_prod_mngmt.btn_prj_reg': '创建项目',
  'studio.prj_prod_mngmt.prj_reg.breadcrumb1': '项目与商品管理 ',
  'studio.prj_prod_mngmt.prj_reg.breadcrumb2': '创建项目与商品',
  'studio.prj_prod_mngmt.prj_reg.pg_title': '创建项目',
  'studio.prj_prod_mngmt.prj_reg.prj_name': '项目名称',
  'studio.prj_prod_mngmt.prj_reg.prj_name_place_holder': '请输入项目名称',
  'studio.prj_prod_mngmt.prj_reg.prj_name_val_msg1': '请输入项目名称。 ',
  'studio.prj_prod_mngmt.prj_reg.prj_name_val_msg3': '项目名称重复。<br/>请输入其他项目名称。',
  'studio.prj_prod_mngmt.prj_reg.chkbox_add_prod': '同时创建本项目的商品',
  'studio.prj_prod_mngmt.prj_reg.btn_reg': '添加',
  'studio.prj_prod_mngmt.prj_reg.prj_num_over100_val_msg1': '最多可创建500个项目。',
  'studio.prj_prod_mngmt.prj_reg.prj_num_over100_val_msg2': '请先删除原有项目后，再重新创建。',
  'studio.prj_prod_mngmt.prj_reg.prj_guide1': '项目是什么？',
  'studio.prj_prod_mngmt.prj_reg.prj_guide2': '创建项目后，可以在项目内创建多个商品。<br/>以项目为单位进行签约和结算。',
  'studio.prj_prod_mngmt.prj_reg.prod_name': '商品名称',
  'studio.prj_prod_mngmt.prj_reg.prod_name_place_holder': '请输入商品名称',
  'studio.prj_prod_mngmt.prj_reg.prod_name_val_msg1': '请输入商品名称。',
  'studio.prj_prod_mngmt.prj_reg.prod_name_val_msg3': '商品名称重复。请输入其他商品名称。',
  'studio.prj_prod_mngmt.prj_reg.prod_type': '商品类型',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide': '设置商品类型后无法更改，请慎重选择。',
  'studio.prj_prod_mngmt.prj_reg.dropbox_prod_type': '请选择商品类型',
  'studio.prj_prod_mngmt.prj_reg.prod_type_val_msg': '请选择商品类型。',
  'studio.prj_prod_mngmt.prj_reg.prod_guide1': '商品是什么？',
  'studio.prj_prod_mngmt.prj_reg.prod_guide2': '商品指在商店销售的Game/Utility。<br/>可以为每个商品创建商店商品页面。',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide1': '商品类型是什么？',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide2': '商品类型不同，可上传的文件不同。 ',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide3': '可上传游戏相关构建',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide4': '可以上传图片、音频、视频等',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide5': '可以上传游戏制作引擎或工具',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide6': '创建商品后，可在“商品设置”菜单中设置Demo和DLC。',
  'studio.prj_prod_mngmt.prj_reg.prod_num_over1000_val_msg1': '最多可创建1,000个商品。',
  'studio.prj_prod_mngmt.prj_reg.prod_num_over1000_val_msg2': '请先删除原有商品后，再重新创建。',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_list': '项目',
  'studio.prj_prod_mngmt.prj_prod_reg_done.btn_prj_list_collapse': '全部收起',
  'studio.prj_prod_mngmt.prj_prod_reg_done.btn_prj_list_expand': '全部展开',
  'studio.prj_prod_mngmt.prj_prod_reg_done.srch_place_holder': '搜索项目名称或商品名称',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_list_sort': '项目',
  'studio.prj_prod_mngmt.post_prj_reg.prod_num_sort': '商品数量',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_file': '项目文件 ',
  'studio.prj_prod_mngmt.prj_prod_reg_done.create_date': '创建日期',
  'studio.prj_prod_mngmt.prj_prod_reg_done.btn_prj_reg': '创建项目',
  'studio.prj_prod_mngmt.prj_prod_reg_done.btn_prod_reg': '创建商品 ',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_breadcrumb1': '项目与商品管理',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_title': '创建商品',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_name': '商品名称',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_name_place_holder': '请输入商品名称',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_name_val_msg1': '请输入商品名称。',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_name_val_msg2': '商品名称重复。请输入其他商品名称。',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type': '商品类型',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide': '设置商品类型后无法更改，请慎重选择。',
  'studio.prj_prod_mngmt.post_prj_reg.dropbox_prod_reg_type': '请选择商品类型',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_game': 'Game',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_contents': 'Content',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_utility': 'Utility',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_val_msg': '请选择商品类型。',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_guide1': '商品是什么？',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_guide2': '商品指在商店销售的Game/Utility。<br/>可以为每个商品创建商店商品页面。',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide1': '商品类型是什么？',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide2': '商品类型不同，可上传的文件不同。 ',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide3': '可上传游戏相关构建',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide4': '可以上传图片、音频、视频等',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide5': '可以上传游戏制作引擎或工具',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide6': '创建商品后，可在“商品设置”菜单中设置Demo和DLC。',
  'studio.prj_prod_mngmt.post_prj_reg.btn_prod_reg_cf': '添加',
  'studio.prj_prod_mngmt.post_prj_reg.prod_num_over1000_val_msg1': '最多可创建1,000个商品。',
  'studio.prj_prod_mngmt.post_prj_reg.prod_num_over1000_val_msg2': '请先删除原有商品后，再重新创建。',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_list': '商品',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_sort': '商品',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_type_sort': '商品类型',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_release_status': '状态 ',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_price': '售价 ',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_discount_rate': '优惠率',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_create_date': '创建日期 ',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_discount_price': '优惠价格',
  'studio.prj_prod_mngmt.prj_prod_list.discount_rate_by_currency': '(各类货币设置)',
  'studio.prj_prod_mngmt.prj_prod_list.discount_price_by_currency': '(各类货币设置)',
  'studio.prj_prod_mngmt.prj_prod_list.price_by_currency_guide': '各类货币设置',
  'studio.prj_prod_mngmt.srch_no_result': '无搜索结果。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.title': '批量添加商品',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.prod_num': '添加数量',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.guide1': '最多可批量添加50个商品，添加时将根据商品名称自动添加编号。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.guide2':
    '批量添加商品时，添加的商品类型相同，并且添加后无法更改，建议同批上传规定数量的同一类型商品。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.prod_num_input_place_holder': '请输入添加商品数量',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.prod_num_input_val_msg': '请输入添加商品数量。 ',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.prod_num_input_val_msg2': '商品添加数量可输入2~50个。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_title': '{prjName}批量添加',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_guide1': '批量添加商品时，将通过自动添加编号生成商品名。商品名可以手动修改。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_guide2': '添加后无法更改商品类型，请慎重选择。批量添加时可能耗时1分钟完成添加。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_prod_name': '商品名称',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_prod_type': '商品类型',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_prod_name_place_holder': '请输入商品名称',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_dup_name_val_msg': '商品名称重复。请输入其他商品名称。',
  'email.prj_reg.completed.title': '邮件标题：【STOVE Studio】项目{prjName}添加完成',
  'email.prj_reg.completed.msg1': '项目添加成功',
  'email.prj_reg.completed.msg2': '已成功添加项目。在Studio创建商品，即可生成商品主页。',
  'email.prj_reg.completed.msg3': '在商品主页添加商品页面并上传构建，尝试发布。',
  'email.completed.info_grp_name': '团队名称',
  'email.completed.info_prj_name': '项目名称',
  'email.completed.grp_home_dir_btn': '前往Studio团队主页',
  'email.prj_del.completed.title': '邮件标题：【STOVE Studio】项目{prjName}删除成功',
  'email.prj_del.completed.msg1': '项目删除成功',
  'email.prj_del.completed.msg2': '已成功删除项目。删除的项目信息将无法恢复。',
  'email.prj_del.completed.msg3': '无法查看项目和游戏关联信息、构建信息等，所有成员权限将被重置。',
  'studio.prj_prod_mngmt.btn_prj_edit': '修改项目名称',
  'studio.prj_prod_mngmt.btn_prj_del': '删除',
  'studio.prj_prod_mngmt.prj_edit_guide1': '请输入项目名称。 ',
  'studio.prj_prod_mngmt.prj_edit_guide2': '用于在Studio中统一管理多个商品，可随时修改。',
  'studio.prj_prod_mngmt.prj_edit_name_place_holder': '请输入项目名称',
  'studio.prj_prod_mngmt.prj_edit_name_val_msg1': '请输入项目名称。 ',
  'studio.prj_prod_mngmt.prj_edit_name_val_msg3': '项目名称重复。<br/>请输入其他项目名称。',
  'studio.prj_prod_mngmt.prj_edit_name_cf': '保存',
  'studio.prj_prod_mngmt.popup_prj_del_guide1': '删除项目',
  'studio.prj_prod_mngmt.popup_prj_del_guide2': '项目里的所有商品和存储器将一并被删除。<br/>如需删除，请输入“DELETE”。<br/>删除后将无法恢复。',
  'studio.prj_prod_mngmt.kebap_suspend_sale': '停止销售',
  'studio.prj_prod_mngmt.kebap_del_request': '删除申请',
  'studio.prj_prod_mngmt.del_req_x_included_in_collection_guide1': '该商品已包含在合集中。',
  'studio.prj_prod_mngmt.del_req_x_included_in_collection_guide2': '请从合集列表中删除该商品后，再次尝试。',
  'studio.prj_prod_mngmt.del_req_x_on_sale_guide1': '商品还在销售。',
  'studio.prj_prod_mngmt.popup_suspend_sale_title': '停止销售',
  'studio.prj_prod_mngmt.popup_suspend_cf_btn': '停止',
  'studio.prj_prod_mngmt.popup_restart_sale_title': '恢复销售',
  'studio.prj_prod_mngmt.popup_restart_sale_guide': '如需重新开始销售，请输入“START”。 ',
  'studio.prj_prod_mngmt.popup_restart_cf_btn': '恢复',
  'studio.prod_list.kebap_del_request_popup_title': '删除申请',
  'studio.prod_list.kebap_del_request_popup_msg': '如需申请删除，请输入“DELETE”。STOVE运营者批准（2~3日）后删除，删除后无法恢复。',
  'studio.prj_prod_mngmt.popup_prod_del_cf_btn': '删除',
  'studio.prj_prod_mngmt.popup_prod_del_req_completed_msg': '删除申请已提交。',
  'studio.prj_prod_mngmt.prod_del_req_stt': '删除申请',
  'studio.prj_prod_mngmt.cancel_prod_del_req_btn': '取消删除申请',
  'studio.prj_prod_mngmt.popup_prod_del_req_cancelled_msg': '删除申请已取消。',
  'studio.prj_prod_mngmt.kebap_prod_pg_open_suspend_btn': '停止公开',
  'studio.prj_prod_mngmt.kebap_del_req_btn': '删除申请',
  'studio.prj_prod_mngmt.del_req_x_prod_pg_open_guide1': '商品页面处于公开状态。',
  'studio.prj_prod_mngmt.del_req_x_prod_pg_open_guide2': '请停止公开后，再重新申请删除。',
  'studio.prj_prod_mngmt.popup_prod_pg_open_suspend_title': '停止公开商品页面',
  'studio.prj_prod_mngmt.popup_prod_pg_open_suspend_guide': '如需停止公开商品页面，请输入“SUSPEND”。 ',
  'studio.prj_prod_mngmt.kebap_prod_pg_open_resume_btn': '恢复公开',
  'studio.prj_prod_mngmt.del_req_completed_msg': '已成功申请删除。',
  'studio.prj_prod_mngmt.kebap_del_req_cancel_btn': '取消删除申请',
  'studio.prj_prod_mngmt.kebap_del_req_cancelled_msg': '已成功取消删除申请。',
  'studio.prj_prod_mngmt.kebap_unreleased_prod_del_btn': '删除',
  'studio.prj_prod_mngmt.popup_unreleased_prod_del_title': '删除商品',
  'studio.prj_prod_mngmt.popup_unreleased_prod_del_guide1': '如需删除，请输入“DELETE”。 ',
  'studio.prj_prod_mngmt.popup_unreleased_prod_del_guide2': '删除后将无法恢复。',
  'studio.prj_prod_mngmt.popup_prod_pg_reopen_title': '恢复公开商品页面',
  'studio.prj_prod_mngmt.popup_prod_pg_reopen_guide': '如需重新公开商品页面，请输入“ON”。 ',
  'studio.prj_prod_mngmt.noti_release_del_completed_msg':
    '已成功删除发布{prodName}。<br/>删除的商品信息无法恢复，根据STOVE运营政策，将保留已删除商品的销售历史及结算信息。  ',
  'studio.prj_prod_mngmt.del_req_rejected_tooltip':
    "删除申请被驳回。需与运营者事先协商后才能删除。<br/>如需协商，请通过邮件（stoveindie{'@'}smilegate.com）联系我们。",
  'studio.prj_prod_mngmt.display_restricted_case_user_report': '展示限制（玩家举报）',
  'studio.prj_prod_mngmt.display_restricted_case_operator_set': '展示限制（运营者）',
  'studio.prj_prod_mngmt.purchase_restricted_case': '购买限制',
  'studio.mail.case_prod_del_request_title': '申请删除商品',
  'studio.mail.case_prod_del_request_msg1': '商品删除申请已提交。',
  'studio.mail.case_prod_del_request_msg2': '运营者需要1-3天时间进行确认，删除的商品信息将无法恢复。',
  'studio.mail.case_prod_del_request_msg3': '根据STOVE运营政策，将保留已删除商品的销售记录及结算信息。',
  'studio.mail.this_release_info_1_grp_name': '团队名称：',
  'studio.mail.this_release_info_2_prj_name': '项目名称：',
  'studio.mail.this_release_info_3_prod_pg': '商品页面：',
  'studio.mail.prod_home_dir_btn': '前往Studio商品主页',
  'studio.prj_prod.release_info_del_completed': '商品删除成功',
  'studio.mail.this_release_info_del_completed_detail_msg1': '发布信息已成功删除。删除的发布信息将无法恢复。 ',
  'studio.mail.this_release_info_del_completed_detail_msg2': '根据STOVE运营政策，将保留已删除商品的销售记录及结算信息。',
  'studio.mail.grp_home_dir_btn': '前往Studio团队主页',
  'studio.prj_prod.release_info_del_rejected': '驳回商品删除申请',
  'studio.mail.this_release_info_del_rejected_detail_msg1': 'STOVE运营者审核已完成。',
  'studio.mail.this_release_info_del_rejected_detail_msg2': '发布删除申请已被驳回。',
  'studio.mail.this_release_info_del_rejected_detail_msg3':
    "如果商品发布后，顾客购买过该商品，需要提前协商有关告知停止销售商品、结算和撤销合同等相关事宜后，才能删除商品。有关协商，请通过下面的邮箱咨询。<br/>stoveindie{'@'}smilegate.com",
  'studio.prj_prod_mngmt.btn_storage': '存储器',
  'studio.prj_prod_mngmt.storage_intro_guide': '以项目为单位管理的存储器。<br/>可以提前上传商品图片、视频等资源，方便装扮商品页面或添加图片。',
  'studio.prj_prod_mngmt.storage.title': '{prjName}存储器',
  'studio.prj_prod_mngmt.storage_no_folder_file.guide1': '请拖拽或点击上传文件按钮。<br/>每次最多可上传10个文件。',
  'studio.prj_prod_mngmt.storage_no_folder_file.guide2': '可以上传的文件：JPG、PNG、GIF、WEBP、ICO、MP4',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_btn': '新文件夹',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_title': '创建文件夹',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_place_holder': '请输入文件夹名称。',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_cf_btn': '创建',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_val_msg1': '请输入文件夹名称。',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_val_msg2': '文件夹名称重复。请输入其他文件夹名称。',
  'studio.prj_prod_mngmt.storage_only_folder.title': '文件夹',
  'studio.prj_prod_mngmt.storage_only_folder.btn_edit_folder_name': '修改文件夹名称',
  'studio.prj_prod_mngmt.storage_only_folder.btn_del_folder': '删除',
  'studio.prj_prod_mngmt.storage_only_folder.edit_folder_name_title': '修改文件夹名称',
  'studio.prj_prod_mngmt.storage_only_folder.btn_edit_folder_name_cf': '更改',
  'studio.prj_prod_mngmt.storage_only_folder.del_folder_popup_msg':
    '是否删除所选文件夹？<br/>删除文件夹时，文件夹内的文件也将一并删除，删除后无法恢复。',
  'studio.prj_prod_mngmt.storage_only_folder.btn_del_folder_cf': '删除',
  'studio.prj_prod_mngmt.storage_upload_method1.btn_upload': '上传文件',
  'studio.prj_prod_mngmt.storage_upload_method1.btn_open': '打开',
  'studio.prj_prod_mngmt.storage_upload_method1.file_num_over10_msg': '每次最多可选择10个文件上传。',
  'studio.prj_prod_mngmt.storage_upload_method1.wrong_format_msg1': '不支持的文件格式。<br/>请先在保管箱中确认文件扩展名后，再上传文件。',
  'studio.prj_prod_mngmt.storage_upload_method1.wrong_format_msg2': '支持的文件',
  'studio.prj_prod_mngmt.storage_upload_method1.wrong_format_msg3': 'JPG, PNG, GIF, WEBP, ICO, MP4',
  'studio.prj_prod_mngmt.storage_upload_method1.storage_exceed_msg': '文件容量超出存储器容量。<br/>请删除原有文件或上传其他文件。',
  'studio.prj_prod_mngmt.storage_upload_method1.uploading_msg': '正在上传至文件存储器。请稍等片刻。',
  'studio.prj_prod_mngmt.storage_upload_method1.upload_cancel_msg': '上传已取消。',
  'studio.prj_prod_mngmt.storage_upload_method1.upload_done_msg': '成功上传{fileNum}个文件。',
  'studio.prj_prod_mngmt.storage_upload_method1.upload_failed_msg': '文件上传失败，<br/>请重试。',
  'studio.prj_prod_mngmt.storage_upload_method1.upload_damaged_msg': '文件受损。<br/>请确认文件后上传。',
  'studio.prj_prod_mngmt.storage_upload_method1.upload_limit_msg': '上传的文件不得超过100MB。<br/>请确认容量后上传。 ',
  'studio.prj_prod_mngmt.storage_upload.file_drop_guide': '请将文件拖拽至此处。 ',
  'studio.prj_prod_mngmt.storage_upload_done.file_title': '文件',
  'studio.prj_prod_mngmt.storage_upload_done.file_info1': '尺寸',
  'studio.prj_prod_mngmt.storage_upload_done.file_info2': '大小：',
  'studio.prj_prod_mngmt.storage_upload_done.btn_move_to_folder': '文件夹移动',
  'studio.prj_prod_mngmt.storage_upload_done.btn_download': '下载原版',
  'studio.prj_prod_mngmt.storage_upload_done.btn_del': '删除',
  'studio.prj_prod_mngmt.storage_upload_done.popup_del_msg': '是否删除所选{fileNum}个文件？<br/>删除后将无法恢复。',
  'studio.prj_prod_mngmt.storage_upload_done.del_completed_msg': '文件已删除。',
  'studio.prj_prod_mngmt.storage_upload_done.popup_move_to_folder_title': '文件夹移动',
  'studio.prj_prod_mngmt.storage_upload_done.storage_folder': '存储器',
  'studio.prj_prod_mngmt.storage_upload_done.btn_move': '移动',
  'studio.prj_prod_mngmt.storage_upload_done.move_completed_msg': '文件已移动。',
  'studio.prj_prod_mngmt.storage_multiple_select.del_all_msg': '是否删除所选{fileNum}个文件？<br/>删除后将无法恢复。',
  'studio.prj_prod_mngmt.storage_multiple_select.del_btn': '删除',
  'studio.prj_prod_mngmt.storage_multiple_select.del_all_done_msg': '已删除{fileNum}个文件。',
  'studio.prj_prod_mngmt.storage_srch_result.srchbar_place_holder': '搜索{folderName}',
  'studio.prj_prod_mngmt.storage_srch_result.no_result_msg1': '没有找到与{searchValue}的相关搜索结果。',
  'studio.prj_prod_mngmt.storage_srch_result.no_result_msg2': '请使用其他关键词搜索。',
  'studio.prj_prod_mngmt.storage_srch_sorting_value1': '按最新',
  'studio.prj_prod_mngmt.storage_srch_sorting_value2': '按最早',
  'studio.prj_prod_mngmt.storage_srch_sorting_value3': '升序排序',
  'studio.prj_prod_mngmt.storage_srch_sorting_value4': '降序排序',
  'studio.prj_prod_mngmt.storage_folder_selected.no_file_msg': '该文件夹为空。',
  'studio.prj_prod_mngmt.storage_srch_in_folder.no_result_msg1': '没有找到与{searchValue}的相关搜索结果。',
  'studio.prj_prod_mngmt.storage_srch_in_folder.no_result_msg2': '请使用其他关键词搜索。',
  'studio.prj_prod_mngmt.storage_select_attachment.no_folder_file.subtitle': '选择附件',
  'studio.prj_prod_mngmt.storage_select_attachment.no_folder_file.guide':
    '无添加到存储器上的文件。<br>可在<em class="font-medium text-on-surface-elevation-2">项目管理 &gt; 存储器</em>中添加文件。',
  'studio.prj_prod_mngmt.storage_select_attachment.no_folder_file.btn_go_to_prj_mngmt': '前往项目管理页面',
  'studio.prj_prod_mngmt.storage_select_attachment.no_folder_file.btn_upload_file': '添加所选文件',
  'studio.prj_prod_mngmt.storage_select_attachment.no_folder_file.title': '{prjName}存储器',
  'studio.prj_prod_mngmt.prod_home.prod_terms.pg_title': '商品条款',
  'studio.prj_prod_mngmt.prod_home.prod_terms.guide_1':
    '发布商品时，可设置需要的条款。<br/>在STOVE PC客户端安装游戏时，显示EULA条款。<br/>使用游戏内商店或支持网络服务器时，有可能需要服务使用条款。',
  'studio.prj_prod_mngmt.prod_home.prod_terms.guide_2': '运行属性只选择“手机”的用户不需要设置条款。',
  'studio.prj_prod_mngmt.prod_home.prod_terms.sample1': '显示默认（客户端）<br/>软件用户同意条款（EULA）',
  'studio.prj_prod_mngmt.prod_home.prod_terms.sample2': '游戏内显示<br/>服务使用条款',
  'studio.prj_prod_mngmt.prod_home.prod_terms.create_btn': '添加',
  'studio.prj_prod_mngmt.prod_home.create_term.pg_title': '添加条款',
  'studio.prj_prod_mngmt.prod_home.create_term.select_type': '选择条款种类 ',
  'studio.prj_prod_mngmt.prod_home.create_term.select_type_guide': '可以选择想要添加的条款种类。输入内容随着选择的种类而改变。',
  'studio.prj_prod_mngmt.prod_home.create_term.select_type_dropbox': '请选择',
  'studio.prj_prod_mngmt.prod_home.create_term.select_type_required_msg': '请选择条款种类。',
  'studio.prj_prod_mngmt.prod_home.create_term.title': '添加条款',
  'studio.prj_prod_mngmt.prod_home.create_term.overall_guide': '条款种类都有哪些？',
  'studio.prj_prod_mngmt.prod_home.create_term.overall_guide_content': '向玩家发布商品之前，根据想要使用的功能，可以制作多种条款。',
  'studio.prj_prod_mngmt.prod_home.create_term.type1_guide': '最终用户许可协议（EULA）',
  'studio.prj_prod_mngmt.prod_home.create_term.type1_guide_1': '对于需要安装的游戏或软件，可以提前告知用户条款内容，用户同意后，再允许安装。',
  'studio.prj_prod_mngmt.prod_home.create_term.type2_guide': '服务使用条款',
  'studio.prj_prod_mngmt.prod_home.create_term.type2_guide_1':
    '对于打包游戏或游戏内不支持结算的游戏，不属于必填项。需要用户同意服务使用条件时，需要填写。',
  'studio.prj_prod_mngmt.prod_home.create_term.type3_guide': '结算前注意事项',
  'studio.prj_prod_mngmt.prod_home.create_term.type3_guide_1':
    '使用STOVE的游戏币充值服务时，才会使用。可以编辑充值游戏币时显示的结算窗口中的提示内容。',
  'studio.prj_prod_mngmt.prod_home.create_term.type4_guide': '同意向第三方提供信息',
  'studio.prj_prod_mngmt.prod_home.create_term.type4_guide_1': '从游戏里获取玩家信息之后，提供给除STOVE以外的第3方时，使用该条款。',
  'studio.prj_prod_mngmt.prod_home.create_term.type5_guide': '监护人同意使用游戏',
  'studio.prj_prod_mngmt.prod_home.create_term.type5_guide_1': '对于打包游戏或游戏内不支持结算的游戏，不属于必选项。',
  'studio.prj_prod_mngmt.prod_home.create_term.type5_guide_2': '未满18周岁的青少年使用游戏且需要监护人同意时，可以显示相关内容。',
  'studio.prj_prod_mngmt.prod_home.create_term.type6_guide': '同意收集监护人的个人信息',
  'studio.prj_prod_mngmt.prod_home.create_term.type6_guide_1': '对于打包游戏或游戏内不支持结算的游戏，不属于必选项。',
  'studio.prj_prod_mngmt.prod_home.create_term.type6_guide_2': '未成年人在游戏内结算且需要监护人同意时，可以显示相关内容。',
  'studio.prj_prod_mngmt.prod_home.create_term.type7_guide': '同意收集及使用个人信息',
  'studio.prj_prod_mngmt.prod_home.create_term.type7_guide_1': '从游戏里获取玩家信息之后，向玩家发送活动内容时，使用该条款。',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_duplicate_popup': '已添加该条款。<br/>如需修改条款内容，请在列表中搜索该条款。',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_eula': '最终用户许可协议（EULA）',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_usage': '服务使用条款',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_pre_payment_caution': '结算前注意事项',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_3rd_party': '同意向第三方提供信息',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_guardian': '监护人同意使用游戏',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_guardian_info': '同意收集监护人的个人信息',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_personal_info': '同意收集及使用个人信息',
  'studio.prj_prod_mngmt.prod_home.create_term.term_name': '条款管理名称',
  'studio.prj_prod_mngmt.prod_home.create_term.term_name_guide': '输入的条款管理名称只向自己显示，不显示在玩家界面。',
  'studio.prj_prod_mngmt.prod_home.create_term.term_name_place_holder': '请输入条款管理名称',
  'studio.prj_prod_mngmt.prod_home.create_term.term_content_title': '条款内容 ',
  'studio.prj_prod_mngmt.prod_home.create_term.term_content_guide': '修改已发布的条款内容时，需要创建新版条款。发布前只能保存！',
  'studio.prj_prod_mngmt.prod_home.create_term.eula_content_sample':
    '本文件具有法律效力，用以定义最终用户与{businessName}（以下简称“公司”）之间提供的软件运行文件或安装文件（以下简称“产品”）、安装指南、用户指南等文件（以下简称“文件”）等所有文件的权利与义务。<br/>下载、安装、复制、访问本“产品”被视为同意本合约条款，并已阅读所有合约内容，理解了所有条件。<br/>如果不同意本合约中的条款，请不要下载、安装、复制、运行和使用本“产品”。同时，需要删除已经安装的“产品”，并立即销毁下载的“产品”和“文件”。如果您已购买“产品”，根据退款政策返还许可证后，方可办理退款。',
  'studio.prj_prod_mngmt.prod_home.create_term.term_version_select': '加载',
  'studio.prj_prod_mngmt.prod_home.create_term.btn_multi_lang_setting': '多语言设置',
  'studio.prj_prod_mngmt.prod_home.create_term.btn_input_fullscr': '全屏',
  'studio.prj_prod_mngmt.prod_home.create_term.btn_create': '添加',
  'studio.prj_prod_mngmt.prod_home.create_term.btn_exit_fullscr': '退出全屏',
  'studio.prj_prod_mngmt.prod_home.prod_terms.release_applied_term_ver': '发布应用版本',
  'studio.prj_prod_mngmt.prod_home.prod_terms.release_applied_term_name': '条款管理名称',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_type': '条款种类',
  'studio.prj_prod_mngmt.prod_home.prod_terms.release_applied_term_apply_date': '条款实施日期',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_ver': '版本',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_name': '条款管理名称',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_create_date': '创建日期',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_apply_date': '条款实施日期',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_del_btn': '删除',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_del_guide': '删除商品条款',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_del_guide1': '如需删除，请输入“DELETE”。<br/>删除后将无法恢复。 ',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_del_cf_btn': '删除',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.pg_title': '条款详情',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_name': '条款管理名称',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_name_guide': '输入的条款管理名称只向自己显示，不显示在玩家界面。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_name_place_holder': '请输入条款管理名称',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_content_title': '条款内容 ',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_content_edit_guide': '修改已发布的条款内容时，需要创建新版条款。发布前只能保存！',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_eula_content_place_holder':
    '本文件具有法律效力，定义了最终用户与{bizName}（以下简称“公司”）之间对所提供软件的可运行文件或安装文件（以下简称“产品”）、安装指南、用户指南等所有文件（以下简称“文件”）的权利和义务。<br/>下载、安装、复制、访问“产品”即表示同意本协议条款，并表示已阅读所有协议内容并理解所有条件。<br/>若不同意本协议条件，请勿下载、安装、复制、访问及使用“产品”。应删除已安装的“产品”，并立即销毁已下载的“产品”及“文件”。若已购买“产品”，请按照退款政策退还许可证并获得退款。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_version_select': '加载',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date': '条款实施日期',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_guide':
    '可设置条款的实施日期。如果还没有设置实施日期，可以使用预约功能随意选择一个日期。 ',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_immediate': '立即',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_select_time': '预约',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_case_1': '检测到正在使用的条款。<br/>是否立即替换成新条款？',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_case_2': '立即使用编辑的条款。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_sel_guide': '实施日期只能选择未来的日期。<br/>请重新确认实施日期。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_sched_guide': '检测到正在使用的条款。<br/>是否预约替换成新条款？',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_change_x': '可以预约更改正在使用的条款日期。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_saved_popup': '保存成功。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.save_as_new_ver_popup_msg':
    '对于已发布过的条款，需要添加新版本才能修订。<br/>是否将编辑的内容创建为新版本？',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.save_as_new_ver_cf_btn': '添加',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.saved_as_new_ver_cf_msg': '新版本添加成功。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.view_mode_term_name': '条款管理名称',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.view_mode_term_content': '条款内容 ',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.view_mode_term_apply_date': '条款实施日期',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_app_suspend_btn': '停止',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_app_suspend_guide_title': '停止条款',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_app_suspend_guide': '如需停止，请输入“SUSPEND”。<br/>停止后将无法恢复。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_app_suspend_cf_btn': '停止',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_none_guide': '游戏支持游戏内商店时，必须添加服务使用条款。',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_content_place_holder': '输入时请参考右侧指南样品“公平交易委员会标准条款”。',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide': '服务使用条款',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide_1':
    '服务使用条款与STOVE及Studio使用条款无关，对用户与开发商之间发生的纠纷不承担任何责任。',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide_2':
    '如果您依旧不知如何编辑内容，请点击下面的链接，参考自身游戏的特殊事项后，编辑服务使用条款。',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide_standard_ref': '公平交易委员会标准条款 > ',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide_3':
    '*更改服务使用条款时，一般建议开发商提前7天告知消费者。存在重大更改或不利于消费者的改动时，一般建议提前30天告知。',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide_preview': '示范图片）',
  'studio.prj_prod_mngmt.prod_home.create_term.pre_payment_caution_content_sample':
    '供应商：{businessName}<br/>购买的游戏币将发送至ID（账号），购买后可以立即使用。<br/>充值的游戏币有效期为自最后使用之日起5年。<br/>自充值之日起7天以内可退还未使用的游戏币，退款将退至购买时使用的支付方式。如果支付方式不支持退款或已超过退款期限时，将退还至客户的银行账号。<br/>有关取消订单和退款详细事项，请参考付费服务条款。<br/>获取和使用游戏币需要确保网络处于连接状态，建议使用最新版本的Internet Explorer11或谷歌浏览器。使用游戏币购买内容或道具时，运行游戏或服务可能需要不同的技术配置要求，请在结算前认真阅读各游戏或服务主页上的“系统配置”。<br/>请在主页下方查看消费者咨询电话。',
  'studio.prj_prod_mngmt.prod_home.create_term.pre_payment_caution_guide': '结算前注意事项',
  'studio.prj_prod_mngmt.prod_home.create_term.pre_payment_caution_guide_1':
    '在“STOVE”管理游戏币时才会使用本条款。可以编辑需要显示的内容，在充值游戏币之前显示。',
  'studio.prj_prod_mngmt.prod_home.create_term.term_content_place_holder': '请输入条款内容',
  'studio.prj_prod_mngmt.prod_home.create_term.3rd_party_info_use_guide': '同意向第三方提供信息',
  'studio.prj_prod_mngmt.prod_home.create_term.3rd_party_info_use_guide_1':
    '除了STOVE和开发商以外，需要将玩家信息提供给第3方时，用来获取同意的条款。',
  'studio.prj_prod_mngmt.prod_home.create_term.guardian_agree_guide': '监护人同意使用游戏',
  'studio.prj_prod_mngmt.prod_home.create_term.guardian_agree_guide_1':
    '未满18周岁的青少年使用游戏且需要监护人同意时，可以显示同意的内容。监护人可以通过身份验证进行同意！',
  'studio.prj_prod_mngmt.prod_home.create_term.guardian_info_guide': '同意收集监护人的个人信息',
  'studio.prj_prod_mngmt.prod_home.create_term.guardian_info_guide_1': '未成年人在游戏内结算且需要监护人同意时，可以发送提示的条款！',
  'studio.prj_prod_mngmt.prod_home.create_term.personal_info_guide': '同意收集和使用个人信息',
  'studio.prj_prod_mngmt.prod_home.create_term.personal_info_guide_1': '收集和使用用户的个人信息时，使用的同意条款！',
  'studio.prj_prod.this_prod.home_search_place_holder': '请搜索商品',
  'studio.prj_prod.this_project.this_product.home_search_nmrf_msg': '无搜索结果。',
  'studio.prj_prod.prod_home.tabs_home': '商品主页',
  'studio.prj_prod.this_prod.home_setting_guide': '请输入基本信息，并关联Demo/DLC等相关商品。',
  'studio.prj_prod.this_prod.home_product_page_guide': '请先装备好图片、视频、说明后，装扮商品页面。',
  'studio.prj_prod.this_prod.home_price_guide': '请设置商品销售价格。',
  'studio.prj_prod.this_prod.home_discount_guide': '可以添加限时优惠。',
  'studio.prj_prod.this_prod.home_sale_guide': '可以设置仅限拥有特定商品的玩家，才能购买本商品。',
  'studio.prj_prod.this_prod.home_early_access_guide': '如需提前销售未完成的商品，请输入提示文本。',
  'studio.gnb.common_2depth_stove_pc_sdk': 'STOVE PC SDK',
  'studio.prj_prod.this_prod.home_stove_pc_sdk_guide': '可以使用业主制、指标管理等STOVE的附加服务。',
  'studio.prj_prod.this_prod.home_build_guide': '可上传在商店销售的Game、Utility构建。',
  'studio.prj_prod.this_prod.home_execution_guide': '可以设置商品的运行平台和启动方法。',
  'studio.gnb.common_2depth_client_test': '客户端运行测试',
  'studio.prod_home.component_client_test': '客户端运行测试',
  'studio.prj_prod.this_prod.home_client_test_guide': '请下载STOVE PC客户端，亲自进行测试。',
  'studio.prj_prod.this_prod.home_tier_review_guide': '可以接受STOVE免费提供的“自主评级”审核服务。',
  'studio.prj_prod.this_prod.home_condition_guide': '可以使用标准条款或自己拟定的自定义条款。',
  'studio.prj_prod.this_prod.home_stats_guide': '联动SDK的商品可以保存和管理数值数据。',
  'studio.prj_prod.this_prod.home_ranking_guide': '利用能力值数据，可以查看玩家排名。',
  'studio.prj_prod.this_prod.home_challenges_guide': '可以设置目标，查看玩家是否完成。',
  'studio.prj_prod.this_prod.home_cloud_guide': '无论在任何设备上，都可以同步到最新存储文件。',
  'studio.prj_prod.this_prod.home_match_guide': '保持较低的网络延迟。',
  'studio.prj_prod.this_prod.home_banner_guide': '添加横幅图片可以让商品在列表中更加醒目。',
  'studio.prj_prod.this_prod.home_in_app_setting_guide': '可以选择是否使用游戏内商店。 ',
  'studio.prj_prod.this_prod.home_in_app_shop_guide': '可以在游戏内设立商店。 ',
  'studio.prj_prod.this_prod.home_in_app_product_guide': '可以添加在游戏内销售的道具。 ',
  'studio.prj_prod.this_prod.home_in_app_discount_guide': '可以用优惠价销售道具。',
  'studio.prj_prod.this_prod.home_in_app_payment_history_guide': '可以确认和管理游戏内的道具销售历史。 ',
  'studio.prj_prod.this_prod.home_in_app_discount_pre_release_access_n': '优惠菜单仅在商品发布后可用。<br/>发布时可单独设置发布优惠。',
  'studio.prj_prod.this_prod.home_product_setting_title': '商品设置',
  'studio.prj_prod.this_prod.home_product_setting_basic_title': '基本信息',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg1': '可使用多语言设置功能查看输入的基本信息翻译。',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg2': '商品名称',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg2_place_holder': '请输入商品名称',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg2_required_n': '请输入商品名称。',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg4_invalid':
    "- : [ ] . TM ® # ( ) ' ! ? • {'|'} & _ \"   ~ , < > * / 、。，以外的特殊字符无法使用。",
  'studio.prj_prod.this_prod.home_product_setting_basic_msg3': '创作者姓名',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg3_place_holder': '请输入创作者姓名',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg3_required_n': '请输入创作者姓名。',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg4': '发行公司名称',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg4_place_holder': '请输入发行公司名称',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg4_required_n': '请输入发行公司名称。',
  'studio.prj_prod.this_prod.home_product_setting_category': '类型',
  'studio.prj_prod.this_prod.home_product_setting_category_val_msg': '请选择至少1个类型。 ',
  'studio.prj_prod.this_prod.home_product_setting_representative_category': '主要类型',
  'studio.prj_prod.this_prod.home_product_setting_prod_type': '商品类型',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_guide': '发布之前可以自由更改类型，如有相关商品或正式发布以后，将无法更改。',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_basic': '基础游戏',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_demo': 'Demo游戏',
  'studio.prj_prod.this_prod.home_product_setting_prod_search_place_holder': '请搜索商品',
  'studio.prj_prod.this_prod.home_product_setting_prod_add_btn': '添加',
  'studio.prj_prod.this_prod.home_product_setting_prod_supported_type': '支持功能',
  'studio.prj_prod.this_prod.home_product_setting_prod_supported_type_online': '在线 - 通过互联网网络连接服务器',
  'studio.prj_prod.this_prod.home_product_setting_prod_supported_type_vr': 'VR - VR功能必需或支持 ',
  'studio.prj_prod.this_prod.home_product_setting_guide1': '基本信息与类型',
  'studio.prj_prod.this_prod.home_product_setting_guide1_1':
    '输入的信息将在商品页面向用户展示，同时也是申请游戏分级的重要信息。基础信息请先用基准语言填写，然后通过多语言设置使用AI翻译。<br/>自主评级的商品如需修改商品名称、创作者名称、类型，需要通过内容修改申报重新获取游戏分级。',
  'studio.prj_prod.this_prod.home_product_setting_guide2': '商品类型',
  'studio.prj_prod.this_prod.home_product_setting_guide2_1':
    '系统默认选择类型为基础游戏。但您也可以在正式发布前更改为Demo游戏。<br/>您可以在Demo游戏发布后将类型更改为基础游戏进行发布，也可以为基础游戏创建新的Demo游戏商品并关联后进行单独管理。请根据需要灵活选择。',
  'studio.prj_prod.this_prod.home_product_setting_guide6': '关联商品',
  'studio.prj_prod.this_prod.home_product_setting_guide6_1':
    '若正式发布的商品有相关的Demo、DLC、Utility等单独的构建，您可创建并关联至即将发布的游戏商品，实现在商品页面同时展示。<br/>注意，每个关联商品的页面和构建均需在各自管理菜单中完成信息填写、审核和发布流程。（已发布的DLC无法解除关联）<br/>※ 已关联到其他商品的内容需先解除关联后方可添加。',
  'studio.prj_prod.this_prod.home_product_setting_guide9': '商品页面 - Demo应用范例',
  'studio.prj_prod.this_prod.home_product_setting_guide8': '商品页面 - DLC/Utility应用范例',
  'studio.prj_prod.this_prod.home_product_setting_prod_search_nmrf': '没有可供选择的商品。',
  'studio.prj_prod.this_prod.home_product_setting_depth_search_add_btn': '添加新商品',
  'studio.prj_prod.this_prod.home_product_setting_search_all_prod_chkbox': '全部商品',
  'studio.prj_prod.this_prod.home_product_setting_multiple_select_case': '{productName} ({productID})以外还有{extraSelectedNum}个商品',
  'studio.prj_prod.this_prod.home_product_setting_demo_add_pop_msg': '请输入新增的Demo商品名称。',
  'studio.prj_prod.this_prod.home_product_setting_new_add_pop_place_holder': '请输入商品名称',
  'studio.prj_prod.this_prod.home_product_setting_val_required_n': '请输入商品名称。 ',
  'studio.prj_prod.this_prod.home_product_setting_val_duplication_msg': '商品名称重复。请输入其他商品名称。',
  'studio.prj_prod.this_prod.home_product_setting_add_register_btn': '添加',
  'studio.prj_prod.this_prod.home_product_setting_dlc_add_pop_msg': '请输入新创建的DLC商品名称。',
  'studio.prj_prod.this_prod.home_product_setting_content_add_pop_msg': '请输入新创建的内容商品名称。',
  'studio.prj_prod.this_prod.home_product_setting_utility_add_pop_msg': '请输入新创建的Demo商品名称。',
  'studio.prj_prod.this_prod.home_product_setting_prod_id_header1': '商品编号',
  'studio.prj_prod.this_prod.home_product_setting_prod_name_header2': '商品名称',
  'studio.prj_prod.this_prod.home_product_setting_prod_status_header3': '发布状态',
  'studio.prj_prod.this_prod.home_product_setting_prod_haspage_header4': '独立页面',
  'studio.prj_prod.this_prod.home_product_setting_prod_haspage_hover_msg': '若需显示作为 Demo 新增的商品的商店商品页面，请启用此选项。',
  'studio.prj_prod.this_prod.home_product_setting_list_unlink_btn': '解除',
  'studio.prj_prod.this_prod.home_product_setting_demo_list_unlink_pop_msg1': '是否解除Demo连接？',
  'studio.prj_prod.this_prod.home_product_setting_list_unlink_pop_cnf_btn': '解除',
  'studio.prj_prod.this_prod.home_product_setting_dlc_list_unlink_pop_msg1': '是否解除DLC连接？',
  'studio.prj_prod.this_prod.home_product_setting_content_list_unlink_pop_msg1': '是否解除内容连接？',
  'studio.prj_prod.this_prod.home_product_setting_utility_list_unlink_pop_msg1': '是否解除Utility连接？',
  'studio.prj_prod.this_prod.home_product_setting_type_list_change_pop_msg1': '是否更改商品类型？',
  'studio.prj_prod.this_prod.home_product_setting_type_list_change_pop_msg2': '通过发布计划应用Live时，需要重新设置用户的现有所有权。',
  'studio.prj_prod.this_prod.home_product_setting_list_unlink_pop_change_btn': '更改',
  'studio.prj_prod.this_prod.home_product_setting_dlc_link_x_pop_msg1': 'DLC连接不稳定提示',
  'studio.prj_prod.this_prod.home_product_setting_dlc_link_x_pop_msg2':
    '已设置游戏内结算。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.prj_prod.this_prod.home_product_setting_dlc_link_x_dir_ingame_setting_btn': '立即前往',
  'studio.prj_prod.this_prod.home_product_setting.demo_prod_pg_yn_tooltip': '禁用此选项后将只能管理完整版商品页面。',
  'studio.prj_prod.this_prod.home_product_setting.demo_prod_pg_yn_tooltip_details':
    'Demo商品页面不公开<br/>Demo商品的评价及用户评分不公开<br/>Demo商品的论坛由完整版商品版块代替<br/>在完整版商品页面显示Demo商品的条款和游戏分级',
  'studio.prj_prod.this_prod.home_product_setting_linked_game': '热门游戏',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_prod_id_header1': '商品编号',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_prod_name_header2': '商品名称',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_prod_status_header3': '发布状态',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_release_stt_requesting': '发布请求',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_release_stt_rejected': '发布被驳回',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_release_stt_coming_soon': '预定发布',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_release_stt_available': '发布中',
  'studio.prj_prod.this_prod.home_product_setting_higher_game': '热门游戏',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_no': '商品编号',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_name': '商品名称',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_stt_under_review': '检查中',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_stt_release_awaiting': '等待发布',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_stt_released': '发布中',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_stt_release_suspended': '停止发布',
  'studio.prj_prod.this_prod.home_product_setting_guide5': '解除连接',
  'studio.prj_prod.this_prod.home_product_setting_guide5_1': '如需解除关联，请前往关联的完整版商品的商品设置菜单操作。',
  'studio.prj_prod.this_prod.home_product_setting_guide11': '商品类型',
  'studio.prj_prod.this_prod.home_product_setting_guide11_1':
    '商品连接为Demo商品时，无法更改商品类型。如果需要正式发布，建议解除连接后，再更改商品类型。',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_msg0': '独立页面设置为不显示。',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_publish_edit_btn': '修改',
  'studio.prj_prod.this_prod.home_product_setting_guide6_2':
    '将包含商品内容的Demo构建连接到新商品上，就可以在商品页面显示Demo商品。<br/>但是，关联商品的页面与版本需要在相应的商品管理菜单上输入信息后，进行检查和发布。<br/>※ 如果商品已与其他商品有关联，则无法添加。需要解除连接后，才能添加。',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_msg1': '发布之前可以自由更改类型，如有相关商品或正式发布以后，将无法更改。',
  'studio.prj_prod.this_prod.home_product_setting_content_type': '具体类型',
  'studio.prj_prod.this_prod.home_product_setting_content_sound_hover_msg': '声槽、全语音等与声音相关的内容',
  'studio.prj_prod.this_prod.home_product_setting_content_image_hover_msg': '插图、美术画册等与图片相关的内容',
  'studio.prj_prod.this_prod.home_product_setting_content_video_hover_msg': 'PV、电影视频等与视频相关的内容',
  'studio.prj_prod.this_prod.home_product_setting_content_type_val_msg': '请选择详细类型。',
  'studio.prj_prod.this_prod.home_product_setting_guide7': '基本信息',
  'studio.prj_prod.this_prod.home_product_setting_guide7_1':
    '输入的信息是商品页面中向玩家显示的重要信息。请用基础语言输入后，使用多语言设置进行AI翻译。',
  'studio.prj_prod.this_prod.home_product_setting_guide2_2':
    '考虑到正式发布，默认选择了内容类型。但在正式发布前，可以先选择Demo进行发布。<br/>发布Demo之后，可以改为内容来正式发布。还可以创建新的Demo产品，单独进行管理。请您自由选择。',
  'studio.prj_prod.this_prod.home_product_setting_guide4': '具体类型',
  'studio.prj_prod.this_prod.home_product_setting_guide4_1': '根据选择的类型，商品将在商店页面中分类显示。请确认选择的类型与上传的文件相符。',
  'studio.prj_prod.this_prod.home_product_setting_guide6_3':
    '可以将包含正式版内容的体验版内容上传到新商品并关联，这样可以在正式发布的商品页面同时展示Demo商品。<br/>但是，关联的各个商品页面和构建需要在相应商品的管理菜单中输入信息后进行审核和发布。<br/>※ 已关联到其他商品时，则无法添加，需解除关联后才能添加。',
  'studio.prj_prod.this_prod.home_product_setting_linked_content': '热门内容',
  'studio.prj_prod.this_prod.home_product_setting_guide2_3':
    '系统默认选择类型为Utility。但您也可以在正式发布前更改为Demo Utility。<br/>可以在Demo Utility发布后将类型更改为正式Utility进行发布，也可以为正式Utility创建新的Demo Utility商品并关联后进行单独管理。请根据需要灵活选择。',
  'studio.prj_prod.this_prod.home_product_setting_guide6_4':
    '若正式发布的商品有相关的Demo或DLC单独构建，可创建并关联至即将发布的Utility商品上，实现在商品页面同时展示。<br/>注意，每个关联商品的页面和构建均需在各自管理菜单中完成信息填写、审核和发布流程。（已发布的DLC无法解除关联）<br/>※已关联到其他商品的内容需先解除关联后方可添加。',
  'studio.prj_prod.this_prod.home_product_setting_guide10': '商品页面 - DLC应用范例',
  'studio.prj_prod.this_prod.home_product_setting_linked_utility': '热门使用程序',
  'studio.prj_prod.this_prod.home_product_setting_guide6_5':
    '如果存在另外的Demo构建，可以创建商品并将其连接到正式发布的公用产品，在商品页面上一起显示。<br/>但是，链接的每个商品页面和构建必须在该商品的管理菜单中设置信息，然后进行审核和发布。<br/>※ 如果商品已连接到其他商品，则无法添加。解除连接后可以添加。请在重新设置后重新注册到发布计划中。',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_stt': '检查中',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_guide': 'LIVE发布检查中无法修改。请等待检查完成。',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_prod_name': '商品名称',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_creator_name': '创作者姓名',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_distrib_co_name': '发行公司名称',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_genre': '类型',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_prod_type': '商品类型',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_supported_type': '支持功能',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_supported_type1_onl': '在线',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_supported_type2_onl_vr': '在线、VR',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_supported_type3_none': '无相关内容',
  'studio.common.live_apply_popup_title': '应用至LIVE',
  'studio.common.popup_case_ii_release_guide': '如需应用，请输入“RELEASE”。<br/>内容修改申报审核通过后，将自动显示商品名称、创作者姓名和游戏类型。',
  'studio.common.popup_case_iv_release_guide': '已应用于LIVE版本。',
  'studio.common.popup_case_v_release_guide': '没有修改内容。<br/>请重新确认。',
  'studio.common.popup_case_vi_release_guide': '检测到修改内容。<br/>是否不应用而直接退出？',
  'studio.common.popup_case_vi_release_guide_close_btn': '关闭',
  'studio.prj_prod.this_prod.home_product_setting_rating_under_review_edit_x_guide': '游戏分级审核期间无法修改基础信息。',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_prod_detailed_type': '具体类型',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_title':
    "商品类型变更提示（Demo <i class='stove-ui-icon h-20 w-20 text-3xl before:ic-v2-control-arrow-right-line'></i> {basicType}）",
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_guide1':
    '要更改为{basicType}，需要先中止现有Demo商品的发布，重新设置构建、商品页面和价格等正式发布所需的必要项目，然后重新发布才能生效。',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_copyright_setting': '商品所有权',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_copyright_setting_withdraw': '回收',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_copyright_setting_withdraw_guide':
    '（回收玩家对Demo商品的所有权，就可以重置所有权的同时正式发布。）',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_copyright_setting_remain': '保持 ',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_copyright_setting_remain_guide':
    '（玩家的Demo商品所有权也将适用于正式版。）',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_guide2_1': '如需再次发布，请输入“CONFIRM”。',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_guide2_2': '执行此操作后将无法恢复，请谨慎选择。',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_cf_btn': '重新发布时进行',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_complete_popup':
    '已停止发布。<br/>请先设置正式发布所需的必填项，再进行发布。',
  'studio.prj_prod.post_release.demo_to_game.popup_msg1': '原DEMO商品已停止销售。',
  'studio.prj_prod.post_release.demo_to_game.popup_msg2': '已开放正式发布所需的必要功能。',
  'studio.prj_prod.post_release.demo_to_game.popup_msg3': '（价格、优惠、抢先体验）<br/>请通过发布按钮进行正式发布。',
  'studio.prj_prod.this_prod.home_early_access_title': '抢先体验文案设置',
  'studio.prj_prod.this_prod.home_early_access_save_btn': '保存',
  'studio.prj_prod.this_prod.home_early_access_msg': '抢先体验提示',
  'studio.prj_prod.this_prod.home_early_access_preview_btn': '预览',
  'studio.prj_prod.this_prod.home_early_access_full_btn': '全屏查看',
  'studio.prj_prod.this_prod.home_early_access_prompt1': 'Q. 为什么要进行抢先体验？',
  'studio.prj_prod.this_prod.home_early_access_place_holder': 'A.请输入内容。',
  'studio.prj_prod.this_prod.home_early_access_prompt2': 'Q.这款游戏的抢先体验期限是多少？',
  'studio.prj_prod.this_prod.home_early_access_prompt3': 'Q.正式版本与抢先体验版有什么不同？',
  'studio.prj_prod.this_prod.home_early_access_prompt4': 'Q.抢先体验期间与抢先体验结束后，游戏价格不同吗？',
  'studio.prj_prod.this_prod.home_early_access_prompt5': 'Q.开发过程成中，计划如何参与社区？',
  'studio.prj_prod.this_prod.home_early_access_prompt_required_n': '请填写抢先体验提示。',
  'studio.prj_prod.this_prod.home_early_access_guide1': '抢先体验版是什么？',
  'studio.prj_prod.this_prod.home_early_access_guide1_1':
    '告知玩家目前游戏还处于开发中，在这种情况下销售的商品就是抢先体验版。抢先体验版商品即使尚未完全完成，也必须处于可游玩状态，并且需要有持续开发并正式发布的计划。',
  'studio.prj_prod.this_prod.home_early_access_guide2': '必须编辑抢先体验提示文本吗？',
  'studio.prj_prod.this_prod.home_early_access_guide2_1':
    '如需进行抢先体验发布，必须填写抢先体验提示文案。填写的说明文案将在抢先体验期间显示于商店页面。',
  'studio.prj_prod.this_prod.home_early_access_tooltip_hover_msg': '全屏可选择夜视模式输入。',
  'studio.prj_prod.this_prod.home_early_access_preview_title': '抢先体验文案预览',
  'studio.prj_prod.this_prod.home_early_access_preview_guide1': '此为抢先体验版本。',
  'studio.prj_prod.this_prod.home_early_access_preview_guide2': '后续更新中内容或价格可能有所调整。',
  'studio.prj_prod.this_prod.home_early_access_preview_see_creator_comment': '查看创作者备注',
  'studio.prj_prod.this_prod.home_early_access_text_display': '显示选项',
  'studio.prj_prod.this_prod.home_early_access_text_display_y': '显示',
  'studio.prj_prod.this_prod.home_early_access_text_display_n': '隐藏',
  'studio.prj_prod.this_prod.home_early_access_full_exit_btn': '退出全屏',
  'studio.prj_prod.this_prod.home_early_access_darkmode': '夜视模式',
  'studio.prj_prod.this_prod.marketing_banner_rectangular_image_title': '矩形图片',
  'studio.prj_prod.this_prod.marketing_banner_portrait_image_title': '纵向图片',
  'studio.prj_prod.this_prod.marketing_banner_landscape_image_title': '横向图片',
  'studio.prj_prod.this_prod.marketing_banner_preview_btn': '预览',
  'studio.prj_prod.this_prod.marketing_banner_image_title': '横幅图片',
  'studio.prj_prod.this_prod.marketing_banner_guide1': '条幅图片是什么？必须添加吗？',
  'studio.prj_prod.this_prod.marketing_banner_guide1_1':
    '横幅图片不是必填项。<br/>添加横幅图片后，STOVE商店运营者可以将其设置为在商品列表页面显示。<br/>已添加该图片的商品可在商品列表中获得更显眼的展示位置。',
  'studio.prj_prod.this_prod.marketing_banner_preview_title': '预览图片',
  'studio.prj_prod.this_prod.marketing_banner_preview_msg': '本图片为帮助用户理解的示例图。',
  'studio.prj_prod.this_prod.marketing_banner_preview_sample_title1': '旧世界（Old World）',
  'studio.prj_prod.this_prod.marketing_banner_preview_sample_title2': '寓言之地（Fabledom）',
  'studio.prj_prod_mngmt.rating_build_review.popup_no_view_per': '无查询权限。<br/>请咨询团队管理员。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.guide1': '游戏发布前需要对上传的构建进行审核',
  'studio.prj_prod_mngmt.rating_build_review.self_review.guide1_1': '接受审核之前，请确认是否包含以下内容<br/>审核最多需要7天，需要提前准备',
  'studio.prj_prod_mngmt.rating_build_review.self_review.bims_bank_info': '个人/公司信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.bims_bank_info_guide': '输入个人/公司信息时，需提前准备居民登记簿、护照、身份证、营业执照',
  'studio.prj_prod_mngmt.rating_build_review.self_review.build_upl': '上传构建',
  'studio.prj_prod_mngmt.rating_build_review.self_review.build_upl_guide': '请预先上传需要审核的构建',
  'studio.prj_prod_mngmt.rating_build_review.self_review.game_content': '游戏内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.game_content_guide': '请提前准备游戏视频 / CG图片 / 剧本文件。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.bims_bank_info_pg_dir_btn': '前去输入信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.build_mgmt_pg_dir_btn': '前去上传',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb1': '项目与商品管理',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb2': '{productName}',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb3': '游戏分级及构建审核',
  'studio.prj_prod_mngmt.rating_build_review.self_review.pg_title': '游戏分级及构建审核',
  'studio.prj_prod_mngmt.rating_build_review.self_review.popup_no_info': '无添加个人/公司信息。<br/>请先输入个人/公司信息。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_reg_x': '正在审核个人/公司信息。<br/>审核结束后，才能添加。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_req_btn': '审核登记',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history_btn': '查看历史',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.game_info_title': '游戏基本信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.game_name': '游戏名称',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.dev_company': '开发商名称',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.genre': '主要类型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.info_edit_btn': '修改信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.biz_info_title': '公司/负责人信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.country': '所在国家/地区',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.biz_reg_num': '营业执照号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.biz_type': '公司类型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.biz_category': '制作/发行类型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.biz_name': '公司名称',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.representative_name': '代表姓名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.pic_name': '负责人姓名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.email': '邮箱',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.contact': '联系方式',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.contact_guide':
    '{grpName}中负责接收审核消息的负责人信息方式。<br/>审核消息将发送至输入的联系方式。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide1': '这里都是做什么的呢？',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide1_1':
    '正式发布需要评定游戏分级。<br/>请选择需要审核的分级类型并关联发布构建版本。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide2': 'GRAC自主评级分类',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide2_1':
    '可通过STOVE申请GRAC游戏分级审核。如果是首次申请评级，不妨尝试一下！<br/>完全免费。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide3': '查询韩国分级编码',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide3_1':
    '可以直接输入已完成审核的韩国分级编码来录入游戏分级。<br/>运行设置只有WEB选项时，只能通过直接输入方式录入。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide4': '国际分级编号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide4_1':
    '除GRAC外，如有其他国际分级编号，可直接输入游戏分级。<br/>设置的游戏分级将如下图所示',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_1': '添加审核信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.title': '添加审核信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.select_rating': '选择游戏分级',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.select_rating_grac_self_review': 'GRAC（韩国）自主评级分类',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.guide': '未成年人禁止使用的游戏不可以进行自审。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.guide_ex': '示范',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.build': '构建',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.build_place_holder': '请选择构建',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.build_no_result': '无搜索结果。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.origin_country': '原产国家/地区',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.origin_country_guide': '请选择游戏实际诞生的原作国家',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.description': '简介',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.description_guide': '请编辑介绍游戏的简介。',
  'studio.prj_prod_mngmt.rating_build_review.rating_reg.intl_org.chkbox': '已有国际分级编号。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.select_org_dropbox_place_holder': '请选择',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.ESRB': 'ESRB（北美/南美）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.PEGI': 'PEGI（欧洲/中东）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.PEGI2': 'PEGI 2（葡萄牙）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.USK': 'USK（德国）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.ACB': 'ACB（澳大利亚）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.CLASS_IND': 'Classlnd（巴西）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.CERO': 'CERO（日本）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.IARC': 'IARC（其他国家/地区）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.select_rating_dropbox_place_holder': '请选择',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.enter_rating_reg_num_place_holder': '请输入分级编号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.none_rating_reg_num_val_msg1': '请输入至少一个国际机构的游戏分级。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.self_review.rating_reg.intl_org.allowed_char_msg': '只能输入数字、"-”和英文字母。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.add_rating_reg_num_btn': '添加 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.rating_num_exceed_case1_popup':
    '每个国际游戏分级最多可添加2个分级。<br/>',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.rating_num_exceed_case2_popup':
    '每个国际游戏分级最多可添加1个分级。<br/>',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.region_org': '地区',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.rating': '分级',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.rating_reg_num': '编码',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.rating_num_exceed_case3_popup':
    '每个国际游戏分级<br/>最多可添加2个分级。<br/>是否要重置列表？',
  'studio.prj_prod_mngmt.rating_build_review.rating_reg.next_btn': '继续 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.teenagers_prohibited_review_x_guide_popup':
    "如果待审核游戏属于<span class='text-tint-red-a400 font-bold'>未成年人禁止使用</span>，<br/><span class='text-on-surface-elevation-1 font-medium'>不能通过自主审核获得分级</span>，<br/>必须通过GRAC（游戏管理委员会）<br/>审核获得分级。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_missing_popup': '游戏基本信息和公司信息属于必填项。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.fill_qtn_tab': '填写问卷',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_reg_title': '添加审核信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_tab': '上传审核材料',
  'studio.prj_prod_mngmt.rating_build_review.self_review.pre_qtn': '0. 事前问卷',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_violence': '1.暴力性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_sexuality': '2.煽情性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_gambling': '3.赌博性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_horror': '4.恐怖',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_language': '5.语言',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_drug': '6.药物',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_crime': '7.犯罪',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_progress': '进度：{percentage}%',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_next_btn': '继续',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_back_btn': '返回',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_btn': '上传<br/>审核资料',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_country_of_origin': '选择原作国家/地区',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_country_of_origin_guide': '请选择游戏实际诞生的原作国家',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_country_of_origin_place_holder': '选择',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_country_of_origin_val_msg': '请选择原创国家/地区。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_descr': '游戏说明',
  'studio.common.full_scr_btn': '全屏',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_descr_guide': '请输入审核所需的游戏说明',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_descr_req_val_msg': '请编辑游戏说明。',
  'studio.common.exit_full_scr_btn': '退出全屏',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_create_method': '游戏操作方法',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_create_method_guide': '请描述如何操作游戏。<br/>也可以上传截图。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_create_method_req_val_msg': '请描述游戏操作方法。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc': '上传审核材料',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_guide':
    '可以上传文件或输入下载链接。<br/>（示例：游戏说明书、CG图、游戏演示视频、语言脚本文件）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_link_format_val_msg': '请输入正确的网址。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_add_dl_link_btn': '添加链接',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_add_btn': '附件',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_size_limit_val_msg1': '附件的容量不得超过2GB。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_size_limit_val_msg2': '若文件超出容量限制，请添加下载链接以提交审核。<br/> ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_num_limit_val_msg1': '附件不能超过10个。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_num_limit_val_msg2': '若附件超出数量限制，请添加下载链接以提交审核。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide': '必须上传的审核资料',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1': '1.游戏操作视频',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_1':
    '请将文件分成初期/中期/后期分别上传。（多结局游戏需要上传所有结局视频）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_2': '请将含有性暗示或暴力内容的视频在文件中单独标记后上传',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_3': '请上传mp4、avi等视频格式的文件',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_4': '若视频文件过大，可以在“游戏说明”中提供视频下载链接',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_ex1': '游戏初期（6分钟）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_ex2': '游戏中期（6分钟）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_ex3': '游戏后期（6分钟）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide2': 'CG图片',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide2_1': '请上传游戏中所有角色的CG图片',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide2_2': '请将含有性暗示或暴力内容的图片在文件中单独标记后上传',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide2_3': '请上传png、jpg、gif等图片格式的文件',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide3': '3.语言文件',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide3_1': '请上传游戏中出现的所有文本类文件。（如角色对话、旁白、UI等）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide3_2': '如果没有辱骂或性暗示的对话，可不上传',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide3_3': '请上传word、pdf、hwp等文档格式的附件',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_1': '{rating}+<br/>{category}',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_2': '预计年龄限制',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_3': '审核过程中无法更改商品信息和公司信息。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_4': '审核完成后，更改商品名称、创作者名称或类型时，<br/>需要重新审核。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_req_cf_btn': '申请审核',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide2_1':
    '预计被评为<span class="text-tint-red-a400">未成年人禁止使用</span>游戏',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide2_2': '未成年人禁止使用的游戏<br/>需要由游戏等级管理委员会直接审核。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide2_3': "如需直接审核相关帮助，请联系<br/>stove.rating{'@'}smilegate.com。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide3_1': '审核申请已提交。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide3_2': '预计需要2~4个工作日处理。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide3_3': '审核结果将通过邮箱和通知向您发送。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_guide1': '审核中。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_guide2': '最多需要2~4个工作日。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_stt_1': '审核前',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_stt_2': '审核中',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_stt_3': '完成',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_detail_pg_dir_btn': '查看正在审核的信息 ',
  'studio.prj_prod_mngmt.rating_build_review.info_detailed_pg_dir_btn': '详细信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_name': '游戏名称',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_company': '开发商名称',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_genre': '主要类型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_rating_type': '分级类型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_rating_assigned_date': '分级日期',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_rating_classif': '分级类别',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_rating_classif_detail': '分类内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_rating_reg_num': '分级编号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_build_id': '构建ID',
  'studio.prj_prod_mngmt.rating_build_review.reg_btn': '添加',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_done_guide': '审核已完成。<br/>可以发布游戏啦。',
  'studio.prj_prod_mngmt.rating_build_review.release_plan_dir_btn': '发布',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_done_re_reg_guide':
    '已存在通过自主评级获得的游戏分级。<br/>如添加新分级，需要手动输入分级编号，之前获得的分级将被删除。<br/><br/>是否添加新分级？',
  'studio.prj_prod_mngmt.rating_build_review.see_history_btn': '查看历史',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rejected_guide': '审核已被<span class="text-[#EC3B47]">驳回</span>。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rejected_stt': '驳回',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rejected_reason_chk_btn': '查看驳回理由',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rejected_reason_pg_title': '查看驳回理由',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_2': '查看驳回理由',
  'email.review_result_noti.completed.title': '{prodName}审核完成 ',
  'email.review_result_noti.completed.msg_1': '{prodname}的审核已完成。 ',
  'email.review_result_noti.completed.msg_2': '自主评级审核结果为{rating}级。',
  'email.review_result_noti.go_to_review_pg_btn': '立即前往 ',
  'email.review_result_noti.rejected.title': '{prodname}审核驳回',
  'email.review_result_noti.rejected.msg_1': '{prodName}的审核已被驳回。<br/>点击[立即前往]即可查看驳回理由。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn01_guide1': '正当权利是什么？',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn01_guide2':
    '正当权利是指“法律依据”。<br/>使用正当的著作权制作的游戏均可以申请审核。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1': '重新分级对象标准',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_1':
    '游戏的主要内容（剧情、角色、道具等）、视频、音频等要素经过修改或添加，已经能够影响分级判定。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_2': '修改游戏玩家的充值、转账、使用等方式。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_3':
    '修改存在其他赌博性质或有可能导致用户过度沉迷的游戏玩法。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_4': '作为街机游戏，修改游戏的内容、使用方法或系统。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_5': '长时间未进行内容修改申报或添加大量内容。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_6': '其他需要变更分级的修改情况。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2': '赌博性游戏',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_1': '游戏结果为现金奖励  ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_2': '通过信息通信网络提供的博彩性游戏，并且符合以下任一条',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_3': '1）用现金充值游戏币',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_4': '2）用户之间可以在游戏内转账',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_5':
    '3）通过游戏内胜负结果获得的分数或游戏币，可以兑换成现金',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_6': '4）通过游戏内胜负结果，可以获得现金或其他物品',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_7':
    '5）通过游戏内胜负结果获得的分数或游戏币，可以经由直接或间接的交易渠道兑换成实物或虚拟奖励。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn01_copyright_n_popup':
    '拥有对游戏的著作权，<br/>才能进行审核。<br/>请确认著作权后，重新选择。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn023_gambling_y_popup': '赌博性游戏无法采用自主评级<br/>来进行审核。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn031_crime_y_popup':
    '含有该内容的游戏<br/>无法采用自主评级来进行审核。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide1': '人形角色',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide1_1':
    '包含实际人类或人类形象的角色及怪物（例如：鹰身女妖、半人马等）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide2': '暴力展现示例',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide2_1': '以下图片为示例，仅供参考。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide2_1_1': '用简单和漫画风格的特效展现',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide2_1_2': '展现了鲜血，但采用了漫画风格',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide3': '武器类和攻击展现示例',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide3_1': '以下图片为示例，仅供参考。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide3_1_1': '展现了暴力的攻击行为',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide3_1_2': '明确展现了暴力的攻击行为',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide4': '展现了鲜血、损坏身体和尸体',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide4_1': '以下图片为示例，仅供参考。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide4_1_1': '存在行为，但没有直接展现',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide4_1_2': '明确存在毁坏，但仅限于极少数情况',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide5': '资源掠夺要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide5_1': '普通水平：<br/>入侵对方的领土，消耗对方收集的资源（普通）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide5_2':
    '轻微水平：<br/>入侵领土可以夺走对方的资源。但是，24小时内无法再次进攻同一块领土，每周掠夺次数不得超过3次',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide': '性暗示描写',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide1': '以下图片为示例，仅供参考。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide1_1': '暴露部分位置的轻微暴露',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide1_2': '上半身（胸部）、下半身轻微暴露',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide1_3': '露骨性质的暴露，带有性暗示',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide1_4': '除生殖器外，暴露其他重要部位',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide1': '赌博性要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide1_1':
    '轻微水平：<br/>无赌博、博彩要素。包含卡片、转盘规则，但仅存在于游戏中<br/>无扑克、21点纸牌、单张牌要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide1_2':
    '有限水平：<br/>极少数的小游戏包含扑克和单张牌，但不得具有博彩要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide1_3':
    '明确包含：<br/>存在扑克、21点纸牌、单张牌或韩国花图要素<br/>从游戏中获得的货币拥有类似于现金的价值<br/>拥有用户之间可以交易的竞拍系统',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide2': '概率型道具（抽奖等）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide2_1':
    '想要获得游戏角色或道具，需要充值游戏币，随机抽取角色或道具之后，才能进行游戏',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide2_2':
    '在游戏中充值或获得的货币可以在交易所与其他玩家交易，或者在现实中交易',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide': '恐怖描写',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide1': '以下图片为示例，仅供参考。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide1_1': '仅用背景烘托气氛',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide1_2': '展现了阴森黑暗的气氛',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide1_3': '明确展现了恐怖氛围',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide1_4': '过度展现了恐怖要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn5_guide': '语言要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn5_guide_1': '轻微水平：<br/>滚开、闭嘴、傻X等',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn5_guide_2': '有限水平：<br/>X死、X痴、混X、X子等',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn5_guide_3': '过度水平：<br/>不良用语过度展现，且未设置脏话过滤机制',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn6_guide': '药物要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn6_guide_1':
    '轻微水平：<br/>吸烟、酒水只以背景形式存在（采用圆点或漫画风格展现）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn6_guide_2':
    '有限水平：<br/>用户可以吸烟、喝酒（玩家）<br/>只有极少的动作或使用效果',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn6_guide_3': '直接水平：<br/>可以吸烟、喝酒、吸毒（玩家）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn7_guide': '犯罪要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn7_guide_1':
    '轻微水平：<br/>包含抢劫、杀人要素的文字描写<br/>无性侵犯要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn7_guide_2': '有限水平：<br/>包含以图文形式描写的抢劫、杀人等犯罪行为',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn7_guide_3': '直接水平：<br/>明确展现了抢劫、杀人、性侵犯要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_detail_pg_title': '审核详细信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.detailed_pg.appeal_btn': '申诉申请',
  'studio.prj_prod_mngmt.rating_build_review.self_review.detailed_pg.appeal_info_edited_popup_msg1':
    '对要进行申诉申请的游戏分级应用的游戏名称、开发商名称和主要类型已更改。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.detailed_pg.appeal_info_edited_popup_msg2': '请先进行内容修改申报。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.detailed_pg.next_btn': '继续 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_title': '申诉申请',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_detail_input': '编辑内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_qtn': '填写问卷',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_attch_doc': '上传审核材料',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_rating': '申请调整分级',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_rating_place_holder': '选择',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_rating_val_msg': '请选择申请调整分级。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_use_existed_info_chkbox': '沿用以前填写的问卷内容。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_select_content': '请选择游戏中包含的内容。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_violence': '暴力性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_sexuality': '性暗示',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_gambling': '赌博性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_horror': '恐怖',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_lang': '语言',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_drug': '药物',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_crime': '犯罪',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_reason_input': '编辑申诉申请理由',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_reason_val_msg': '请填写申诉申请理由。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_next_btn': '继续 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_guide': '申诉申请',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_guide1': '如对审核完成的分级有异议，可以进行申诉申请。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_guide2': '请选择希望调整的分级和游戏包含的内容，并说明申诉申请理由。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_guide3': '如果您想沿用以前填写的问卷内容，请勾选下面的复选框。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_guide4': '申诉申请以首次评定的分级为准进行，每个商品只能申请1次。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_raise_title': '发起申诉',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_btn': '申请审核',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_noti_popup_msg1': '审核申诉申请的过程中，<br/>无法更改商品信息和公司信息。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_noti_popup_msg2': '无论申诉审核结果如何，<br/>只能提起1次申诉申请。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_cf_btn': '申诉申请 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_done_popup_msg1':
    '审核申请已提交。<br/>预计需要2~4个工作日处理。<br/>审核结果将通过邮箱和通知向您发送。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_under_review_guide': '申诉申请审核中。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_under_review_guide_1': '最多需要2~4个工作日。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_chk_req_detail_btn': '查看正在审核的信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_review_done_msg': '申诉申请已审核完成。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_review_result': '{assignedRating} → {requestedRating}',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info': '最近审核完成信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_guide':
    '这是尚未发布的预审游戏分级信息。发布后将更新为“游戏分级审核信息”。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_rejected_msg': "申诉申请审核已被<span class='text-error'>驳回</span>。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_rejected_reason_chk_btn': '查看驳回理由',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_rejected_result': '驳回',
  'email.appeal_review_result_noti.completed.title': '{prodName}审核完成',
  'email.appeal_review_result_noti.completed.msg_done': '{prodName}的审核已完成。',
  'email.appeal_review_result_noti.completed.msg_assigned_rating': '原分级：“{assignedRating}”',
  'email.appeal_review_result_noti.completed.msg_requested_rating': '申请分级：“{requestedRating}”',
  'email.appeal_review_result_noti.completed.msg_assigned_category': '原分类内容：“{assignedCategory}”',
  'email.appeal_review_result_noti.completed.msg_requested_category': '申请分类内容：“{requestedCategory}”',
  'email.appeal_review_result_noti.rejected.title': '{prodName}审核驳回',
  'email.appeal_review_result_noti.rejected.msg_rejected': '{prodName}的审核已驳回。',
  'email.appeal_review_result_noti.rejected.msg_assigned_rating': '原分级：“{assignedRating}”',
  'email.appeal_review_result_noti.rejected.msg_requested_rating': '申请分级：“{requestedRating}”',
  'email.appeal_review_result_noti.rejected.msg_assigned_category': '原分类内容：“{assignedCategory}”',
  'email.appeal_review_result_noti.rejected.msg_requested_category': '申请分类内容：“{requestedCategory}”',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change_btn': '内容修改申报',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.title': '内容修改申报',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.basic_info': '游戏基本信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.basic_info_name': '游戏名称',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.basic_info_company': '开发商名称',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.basic_info_genre': '主要类型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_info': '游戏分级审核信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_rating': '分级类别',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_category': '包含内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide1': '内容修改申报是什么？',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide1_1':
    '申报游戏后，如果游戏内容有任何变更，需要申报说明具体变更内容。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide2': '修改申报范围',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide2_1':
    '如果构建仅包含简单的Bug修复，可以直接发布构建而无需报告内容修改。<br/>如果游戏相关内容发生变更，或游戏基本信息有所改变，则需要附上审核资料说明变更内容并接受审核。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide2_2':
    '只更改游戏名称、开发商名称（创作者姓名），进行内容修改申报时，将自动完成申报',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide3': '填写问卷',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide3_1':
    '如果更改事项不属于游戏分类内容（示例：暴力性、性暗示），可以勾选使用以前的问卷内容选项，直接沿用之前填写的问卷内容。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide3_2': '但Studio负责人可能会额外审核修改内容是否与问卷内容一致。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.build_id': '构建ID',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.build_id_place_holder': '请选择构建',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.build_id_val_msg': '请选择构建。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info': '更改事项',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_guide': '如果仅为简单Bug修复，可以直接发布构建而无需报告内容修改',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_game_name': '更改游戏名称',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_company': '更改开发商名称（创作者名称）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_genre': '更改主要类型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_background': '更改背景或视频',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_sys_ui': '更改基础系统或UI',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_billing_sys': '更改付费系统',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_mission_scenario': '更改任务或剧情',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_char_item': '更改角色或道具',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_intl_rating': '更改国际机构游戏分级',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.req_val_msg': '请至少选择一个更改事项。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_detail': '更改内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.use_existed_info_chkbox': '沿用以前填写的问卷内容。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_intl_rating_chkbox': '更改国际机构游戏分级',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.next_btn': '继续 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_name': '游戏名称',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_rating_type': '分级类型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_rating_assigned_date': '分级日期',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_rating_classif': '分级类别',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_rating_classif_detail': '包含内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_rating_reg_num': '分级编号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_build_id': '构建ID',
  'email.review_result_noti.change_update_completed.msg_1': '{prodname}的内容修改申报已完成审核。',
  'email.review_result_noti.change_update_completed.msg_2': '可以发布已完成审核的构建',
  'email.review_result_noti.change_update_rejected.msg_1': '{prodName}的内容修改申报审核已被驳回。',
  'email.review_result_noti.change_update_rejected.reason_chk_guide': '点击[立即前往]即可查看驳回理由。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.title': '查询韩国分级编码',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.sub_title': '查询韩国分级编码',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.place_holder': '请输入分级编号',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.required_msg': '请输入分级编号。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.allowed_char_msg': '只能输入数字、"-”和英文字母。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.add_btn': '添加',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.rating_info_game_title': '游戏名称',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.rating_info_rating': '使用分级',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.rating_info_category': '包含内容',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.rating_info_reg_num': '分级编号',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.rating_info_assigned_date': '分级日期',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.inquiry_failed_reg_num_not_existed': '该信息不存在。<br/>请确认分级编号。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.failed_reg_num_limit': '每个游戏最多可添加2个分级。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.guide': '查询韩国分级编码',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.guide_1': '您可以直接输入已完成审核的韩国分级编码来录入游戏分级。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_btn': '添加',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed': '游戏分级信息<br/>已添加。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.required_val_popup': '请至少添加一个分级信息。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb5': '查询韩国分级编码',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed_guide': '添加成功。<br/>可以发布游戏啦。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed.rating_existed_guide': '检测到已添加的游戏分级。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed.rating_existed_new_reg_guide':
    '如需重新添加，将通过自主审核进行，此前获得的游戏分级将被删除。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed.rating_existed_edit_guide':
    '如果需要修改，<br/>请在详细信息中进行修改。<br/>是否重新添加？',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_8': '游戏分级详细信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_detailed_pg_title': '游戏分级详细信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_basic': '游戏基本信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_basic_name': '游戏名称',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_basic_company': '开发商名称',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_basic_genre': '主要类型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz': '公司/负责人信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_country': '所在国家/地区',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_type': '公司类型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_name': '公司名称',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_reg_num': '营业执照号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_category': '制作/发行类型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_representative_name': '代表姓名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_pic_name': '负责人姓名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_pic_email': '邮箱',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_pic_contact': '联系方式',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_pic_guide':
    '这是企业在审核过程中接收通知的负责人联系信息。<br/>我们会将审核进展通知给自主评级负责人。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_select': '选择游戏分级',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_select_self_review': 'GRAC（韩国）自主评级分类',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_select_direct_input': '查询韩国分级编码',
  'studio.prj_prod_mngmt.rating_build_review.edit_cf_msg3': '原分级信息可以在“查看历史”中确认。',
  'studio.prj_prod_mngmt.rating_build_review.edit_done_msg': '游戏分级信息<br/>已新添加。',
  'studio.prj_prod_mngmt.rating_build_review.rating_info_title': '游戏分级信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_monitoring_rating_adj_guide':
    "经过后续监测，该游戏已被归类为需要进行<span class='text-tint-red-a400 font-bold'>分级调整处理对象</span>。请查看详细内容。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.adj_see_detail_btn': '详情确认',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_3': '分级调整处理',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_title': '分级调整处理提示',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_rating': '调整分级',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_category': '包含内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_applied_date': '生效预定日期',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_reason': '调整理由',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_accept_btn': '接受分级',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_accepted_msg1': '接受调整处理指定分级',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_accepted_msg2': '在分级生效预定日期之前无法进行游戏分级及构建审核。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_accepted_cf_msg': '已接受分级调整处理指定的分级。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.reject_adj_change_msg1': '不接受调整结果，修改游戏内容。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.reject_adj_change_msg2': '在审核完成之前，游戏将在商店中暂停展示，无法销售。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change_guide_popup': '请在游戏分级及构建审核菜单中<br/>完成内容修改申报。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_change_x': '正在审核个人/公司信息。<br/>审核结束后，才能进行内容修改申报。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_guide': '分级调整处理提示',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_guide1':
    '接受分级后，在分级生效预定日期之前将无法添加构建和进行分级审核。在生效预定日期将应用变更后的分级。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_guide2_1': '如果要对内容进行修改，审核完成前，游戏将停止在商店展示且无法销售。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_guide2_2':
    '内容修改申报审核结束后，<br/>可以重新将游戏添加到发布计划中开始销售。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_accepted_guide':
    "已<span class='text-brand-primary font-bold'>接受</span>分级调整处理。在{reclassifyDate}之前无法申请新的构建和分级审核。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change_required_guide':
    '需要进行内容修改申报。审核结束之前，将停止展示游戏，并且无法销售。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_guide':
    "经过后续监测，该游戏已被归类为需要进行<span class='text-tint-red-a400 font-bold'>强制重新分级对象</span>。请查看详细内容。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_4': '强制重新分级',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_pg_title': '强制重新分级',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_title': '强制重新分级提示',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_accepted_cf_msg': '已接受强制重新分级的分级结果。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_announce': '强制重新分级提示',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_guide1_1': '接受分级后，游戏将在分级生效预定日期前停止在商店展示且无法销售。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_guide1_2': '变更后的分级将在生效预定日期适用。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_guide1_3':
    '内容修改申报审核结束后，可以重新将获得{rating}分级的游戏添加到发布计划中开始销售。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_guide2':
    '如果要对内容进行修改，审核完成前，游戏将停止在商店展示且无法销售。<br/>内容修改申报审核完成后，<br/>您可以重新添加游戏发布计划并恢复销售。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_accepted_guide':
    "已接受强制重新分级的<span class='text-brand-primary font-bold'>调整内容</span>。{date}之前，将停止展示游戏，并且无法销售。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.adj_adj_see_detail_btn': '详情确认',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_report_change_required_guide':
    '需要进行内容修改申报。审核结束之前，将停止展示游戏，并且无法销售。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_teenager_x_info_reg_guide':
    '本游戏通过强制重新分级获得未成年人禁止使用分级。请添加通过GRAC（游戏等级管理委员会）审核后获得的分级信息。',
  'studio.prj_prod_mngmt.rating_build_review.edit_cf_msg2': '如果游戏已经发布，修改将在之后生效。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_guide':
    "该游戏经过后续监测被判定为<span class='text-tint-red-a400 font-bold'>分级取消对象</span>。游戏将停止展示，无法销售及运行。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_5': '分级取消',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_pg_title': '分级取消',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_title': '分级取消提示',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_appeal_detail': '申辩内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_appeal_req_btn': '申请申辩 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_appeal_req_done_popup': '申辩申请已提交。<br/>处理申辩需要3~4个工作日。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_guide_title': '分级取消提示',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_guide1_1': '游戏分级已被取消。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_guide1_2': '如不提出申诉，分级将于生效预定日期取消。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_guide1_3': '生效预定日期以后，游戏将停止展示、销售和运行。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_guide':
    "该游戏经过后续监测被判定为<span class='text-tint-red-a400 font-bold'>拒绝分级对象</span>。游戏将停止展示，无法销售及运行。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_6': '拒绝分级',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_pg_title': '拒绝分级',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_title': '拒绝分级提示',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_appeal_detail': '申辩内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_announce': '拒绝分级提示',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_guide1_1': '游戏分级已被拒绝。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_guide1_2': '如不提出申辩，分级将于生效预定日期被拒绝。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_guide1_3': '生效预定日期以后，游戏将停止展示、销售和运行。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_7': '查看历史',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history_pg_title': '查看历史',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.report_change_approved': '游戏分级内容修改申报',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.dropbox_latest_order': '按最新',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case1_approved_title': '游戏分级提交',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_a': '游戏名称',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_b': '分级类型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_c': '分级日期',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_d': '分级类别',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_e': '包含内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_f': '分级编号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_h': '国际分级编号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case2_rejected_title': '游戏分级驳回',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_g': '构建ID',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_i': '理由',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case3_registered_title': '游戏分级提交',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case4_edit_title': '游戏分级修改',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case5_change_approved_title': '游戏分级内容修改申报',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_j': '更改事项',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case6_change_rejected_title': '游戏分级内容修改申报驳回',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case7_rating_adj_title': '游戏分级等级调整',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_k': '实施日期 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case8_auth_adj_title': '游戏分级强制重新分级',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case9_rating_cancelled_title': '游戏分级取消',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case10_rating_rejected_title': '拒绝游戏分级',
  'studio.prj_prod_mngmt.rating_build_review.latest_review_req_info_title': '最近审核完成信息',
  'studio.prj_prod_mngmt.rating_build_review.latest_review_req_info_guide': '这是尚未发布的预审游戏分级信息。发布后将更新为“游戏分级审核信息”。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_prod_name': '游戏名称',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_company': '开发商名称',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_genre': '主要类型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_type': '分级类型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_assigned_date': '分级日期',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_classif': '分级类别',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_classif_detail': '包含内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_reg_num': '分级编号',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_build_id': '构建ID',
  'studio.prj_prod_mngmt.rating_build_review.rating_review_info_title': '游戏分级审核信息',
  'studio.prj_prod.this_prod.prod_mgmt_price_breadcrumb1': '项目与商品管理 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_breadcrumb2': '{prodName}',
  'studio.prj_prod.this_prod.prod_mgmt_price_breadcrumb3': '商品页面',
  'studio.prj_prod.this_prod.prod_mgmt_price_title': '价格',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_btn': '添加',
  'studio.prj_prod.this_prod.prod_mgmt_price_landing_guide1': '请添加商品销售价格。<br/>您也可以手动输入不同币种的价格。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_x_under_review_pop_msg1': '检测到检查状态的价格信息。<br/>取消或删除后，才能修改。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_title': '添加价格',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_sales_type_title': '销售类型',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_sales_type_paid_msg': '付费',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_sales_type_free_msg': '免费',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_base_price_title': '标准售价',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_base_price_required_val_msg': '请设置标准售价。 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_base_price_msg': '请选择或输入美元价格。设置标准售价后，可以手动修改不同币种价格。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_btn': '手动输入',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_guide1': '为什么商店显示价格与结算价格的币种不同？',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_guide1_1': '实际结算采用：全球-USD($)，韩国-KRW(￦)。商店显示价格仅供参考，可能因每日汇率而异。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_guide2': '价格输入条件有哪些？',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_guide2_1': '输入的美元价格不得低于0.99。韩元价格不得低于10，并且以10为单位输入。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_title': '手动输入',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_apply_btn': '应用',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_title': '各币种价格',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_header1': '商店显示价格',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_checkout_price_header2': '结算价格',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_usd_msg': '美国',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_krw_msg': '韩国',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_cny_msg': '中国',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_eur_msg': '欧盟',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_gbp_msg': '英国',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_hkd_msg': '香港特别行政区',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_idr_msg': '印度尼西亚',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_jpy_msg': '日本',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_myr_msg': '马来西亚',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_php_msg': '菲律宾',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_sgd_msg': '新加坡',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_thb_msg': '泰国',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_vnd_msg': '越南',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_required_val_msg1': '请输入标准售价后，进行应用。 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_required_val_msg2': '存在未填写项目。请检查各币种结算价格。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_invalid_val_msg2': '结算价格仅可输入数字和小数点。',
  'studio.prj_prod.this_prod.prod_mgmt_price_edit_btn': '修改',
  'studio.prj_prod.this_prod.prod_mgmt_price_msg1': '商品发布后，将使用以下价格。',
  'studio.breadcrumb.price_edit': '修改价格',
  'studio.prj_prod.this_prod.prod_mgmt_price_edit_title': '修改价格',
  'studio.prj_prod.this_prod.prod_mgmt_price_ msg0': '检查中',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_msg': '应用至LIVE',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_from_msg': '{dateTime}应用',
  'studio.prj_prod.this_prod.prod_mgmt_price_edit_adjust_live_price_pop_msg':
    '修改价格时，需要进行检查。<br/>检查最多需要5个工作日。<br/>检查通过后，将立即应用修改价格。 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_edit_adjust_live_price_pop_review_req_btn': '申请检查',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_awaiting_review_msg1': '申请检查',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_awaiting_review_msg2': '检查通过后立即应用',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_awaiting_review_cancel_pop_msg': '是否取消检查？<br/>选择取消时，检查中的数据将被删除。',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_awaiting_review_cancel_pop_withdraw_review_btn': '取消检查',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_in_review_msg1': '检查中',
  'studio.prj_prod.this_prod.prod_mgmt_price_declined_review_msg': '检查驳回',
  'studio.prj_prod.this_prod.prod_mgmt_price_declined_review_timestamp_msg': '{dateTime}驳回',
  'studio.prj_prod.this_prod.prod_mgmt_price_delete_btn': '删除',
  'studio.prj_prod.this_prod.prod_mgmt_price_declined_reason_guide': '驳回理由',
  'studio.prj_prod.this_prod.prod_mgmt_price_delete_pop_msg': '是否删除检查驳回状态的价格？',
  'studio.prj_prod.this_prod.prod_mgmt_price_delete_pop_delete_btn': '删除',
  'studio.prj_prod.this_prod.prod_mgmt_discount_title': '优惠',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_btn': '添加',
  'studio.prj_prod.this_prod.prod_mgmt_discount_landing_guide1':
    '可添加多个商品优惠。<br/>以[售价]中输入的价格为标准，计算优惠率。<br/>还可以举行限量优惠销售。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_title': '添加优惠',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_name_title': '优惠名称',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_name_place_holder': '请输入优惠名称',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_name_required_val_msg1': '请输入优惠名称。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_start_date_title': '开始日期',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_start_date_immed_apply': '立即',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_start_date_schedule_apply': '预约',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_end_date_title': '结束日期',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_dup_period_val_msg1': '同一时间存在其他优惠。请更改时间后，重新尝试。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_reset_time_val_msg2': '预约日期不得早于当前时间。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_end_date_invalid_val_msg3': '结束日期不得早于开始日期。 ',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_rate_title': '优惠率',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_rate_req_val_msg1': '请输入优惠率。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_rate_valid_num_val_msg2': '优惠率应介于0到100之间。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide1': '优惠名称是什么？',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide1_1': '可以输入区分优惠的名称。不向玩家显示。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide2': '优惠率如何计算？',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide2_1': '在优惠期间，以售价为标准，计算优惠率。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide3': '使用限量优惠销售有什么效果？',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide3_1':
    '设置限量优惠销售后，当规定数量售罄时，优惠价格销售就会结束。<br/>即使规定数量未售罄，结束日期后，优惠销售也会结束。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_title': '优惠价格',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_msg':
    '以下价格基于当前售价，如更改售价则会相应变化。<br/>商店显示价格可能因每日汇率而异。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_displayed_price_header1': '商店显示价格',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_checkout_price_header2': '结算价格',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_free_guide':
    '当前价格设置为免费。无论优惠率是多少，优惠后的价格均显示免费。 ',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_free_msg': '免费',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_title': '限量优惠销售',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_enable_msg': '使用',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_disable_msg': '未使用',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_quantity_title': '限量销售数量',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_quantity_unit_msg': '个',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_quantity_valid_num_val_msg': '销售数量应介于1到9,999,999之间。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_status_header1': '状态',
  'studio.prj_prod.this_prod.prod_mgmt_discount_name_header2': '优惠名称',
  'studio.prj_prod.this_prod.prod_mgmt_discount_discount_rate_header3': '优惠率',
  'studio.prj_prod.this_prod.prod_mgmt_discount_remaining_quantity_header4': '剩余数量',
  'studio.prj_prod.this_prod.prod_mgmt_discount_period_header5': '时间',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_delete_btn': '删除',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_suspend_btn': '停止',
  'studio.prj_prod.this_prod.prod_mgmt_discount_status_upcoming_msg': '等待应用',
  'studio.prj_prod.this_prod.prod_mgmt_discount_status_active_msg': '应用至LIVE',
  'studio.prj_prod.this_prod.prod_mgmt_discount_status_expired_msg': '结束',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_suspend_pop_msg1': '停止优惠',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_suspend_pop_msg2': '如需停止，请输入“SUSPEND”。<br/>停止后将无法恢复。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_suspend_pop_withdraw_btn': '停止',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_delete_pop_msg': '是否删除等待应用的优惠？',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_delete_pop_delete_btn': '删除',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_filter_all_msg': '全部',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_filter_active_or_upcoming_msg': '应用至LIVE/等待应用',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_filter_expired_msg': '结束',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_filter_no_data': '没有找到符合选择条件的结果。',
  'studio.breadcrumb.discount_details': '优惠详情',
  'studio.prj_prod.this_prod.prod_mgmt_discount_this_discount_details_title': '优惠详情',
  'studio.prj_prod.this_prod.prod_mgmt_discount_this_discount_details_limited_sales_remaining_quantity_msg': '（剩余数量：{remainingNum}个）',
  'studio.prj_prod.this_prod.home_release_status': 'Studio商品发布情况',
  'studio.prj_prod.this_prod.home_release_status_msg1': '发布商品或更新已发布商品时，可以查看进度。',
  'studio.prj_prod.this_prod.home_release_status_msg2': '更新已发布商品时，可以使用相应功能立即更新或预约更新。 ',
  'studio.prj_prod.this_prod.home_release_btn': '发布',
  'studio.prj_prod.this_prod.home_guide1': '请准备<br/>商品页面。',
  'studio.prj_prod.this_prod.home_guide1_1': '商品设置和商品页面全部完成输入后，可以先发布商品页面。',
  'studio.prj_prod.this_prod.home_guide2': '与构建一同<br/>发布。',
  'studio.prj_prod.this_prod.home_guide2_1': '根据预购、抢先体验等发布计划，将商品页面与构建一同正式发布吧。',
  'studio.prj_prod.this_prod.home_guide3': '发布之后轻松<br/>体验更新。',
  'studio.prj_prod.this_prod.home_guide3_1': '选择需要应用的选项，轻松更新。<br/>修改各项功能后，可以立即更新或预约更新。',
  'studio.prj_prod.this_prod.home_release_status_timezone': 'Studio商品发布情况（UTC+9）',
  'studio.prj_prod.this_prod.home_prod_page_title': '商品页面',
  'studio.prj_prod.this_prod.home_build_title': '构建',
  'studio.prj_prod.this_prod.home_build_msg1': '正式发布时，将显示构建状态',
  'studio.prj_prod.this_prod.home_sales_title': '价格（优惠率）与优惠价格',
  'studio.prj_prod.this_prod.home_sales_msg': '正式发布时，将显示售价',
  'studio.prj_prod.this_prod.home_review_progress_title': '检查与应用至LIVE',
  'studio.prj_prod.this_prod.home_review_progress_tooltip_msg':
    '申请检查时，将显示申请检查、检查中、检查完成、检查驳回等状态，<br/>发布后更新各项功能时，将显示应用时间。',
  'studio.prj_prod.this_prod.home_review_progress_stt1': '申请检查',
  'studio.prj_prod.this_prod.home_review_progress_stt2': '检查中',
  'studio.prj_prod.this_prod.home_review_progress_stt3': '检查完成',
  'studio.prj_prod.this_prod.home_review_progress_stt4': '检查驳回',
  'studio.prj_prod.this_prod.home_release_stt_title': '发布状态',
  'studio.prj_prod.this_prod.home_release_stt_tooltip_msg':
    '仅公开商品页面时显示“公开商品页面”<br/>正式发布时显示“预购”、“即将发布”或“正式发布”。<br/>处于限制状态时会显示图标，请确认状态。',
  'studio.prj_prod.this_prod.home_pre_release_guide': '将根据发布计划显示状态',
  'studio.prj_prod.this_prod.home_release_stt_chk_btn': '商品发布情况',
  'studio.prj_prod.this_prod.home_apply_stt1': '等待应用',
  'studio.prj_prod.this_prod.home_apply_stt2': '应用至LIVE',
  'studio.prj_prod.this_prod.stt_restriction_display_operator': '展示限制（运营者）',
  'studio.prj_prod.this_prod.stt_prod_pg_go_live_y': '商品页面应用至LIVE',
  'studio.prj_prod.this_prod.stt_prod_pg_go_live_n': '商品设置应用至LIVE',
  'studio.prj_prod.this_prod.stt_community_go_live_y': '社区未应用LIVE',
  'studio.prj_prod.this_prod.stt_community_go_live_n': '社区应用至LIVE',
  'studio.prj_prod.this_prod.stt_discount_go_live_y': '优惠应用至LIVE',
  'studio.prj_prod.this_prod.stt_discount_go_live_n': '运行设置应用至LIVE',
  'studio.prj_prod.this_prod.stt_ingame_store_go_live_y': '游戏内商店应用至LIVE',
  'studio.prj_prod.this_prod.stt_ingame_store_go_live_n': '游戏内商店未应用LIVE',
  'studio.prj_prod.this_prod.stt_term_go_live_y': '商品条款应用至LIVE',
  'studio.prj_prod.this_prod.stt_term_go_live_n': '商品条款未应用LIVE',
  'studio.prj_prod.this_prod.stt_achievement_go_live_y': '挑战任务应用至LIVE',
  'studio.prj_prod.this_prod.stt_achievement_go_live_n': '挑战任务LIVE未应用',
  'studio.prj_prod.this_prod.stt_ranking_go_live_y': '排名应用至LIVE',
  'studio.prj_prod.this_prod.stt_ranking_go_live_n': '排名未应用LIVE',
  'studio.prj_prod.this_prod.stt_cloud_saving_go_live_y': '云存储应用至LIVE',
  'studio.prj_prod.this_prod.stt_cloud_saving_go_live_n': '云存储未应用LIVE',
  'studio.prj_prod.this_prod.stt_match_making_go_live_y': '匹配系统应用至LIVE',
  'studio.prj_prod.this_prod.stt_match_making_go_live_n': '匹配未应用LIVE',
  'studio.prj_prod.this_prod.release_stt_browser_title': 'Studio商品发布情况',
  'studio.prj_prod.this_prod.release_stt_title': 'Studio商品发布情况',
  'studio.prj_prod.this_prod.release_stt_msg': '预约发布或更新商品时，将在日历上显示进行情况。根据添加的事项，还可以查看具体信息和状态。',
  'studio.prj_prod.this_prod.release_stt_browser_release_btn': '发布',
  'studio.prj_prod.this_prod.release_stt_calendar_today_btn': '今天',
  'studio.prj_prod.this_prod.release_stt_filter_cbox_all': '全部',
  'studio.prj_prod.this_prod.release_stt_filter_cbox_prod_page': '商品页面',
  'studio.prj_prod.this_prod.release_stt_filter_cbox_build': '构建及游戏分级',
  'studio.prj_prod.this_prod.release_stt_filter_cbox_price_and_discounts': '价格与优惠',
  'studio.prj_prod.status_review_requested': '申请检查',
  'studio.prj_prod.status_review_declined': '检查驳回/限制',
  'studio.prj_prod.status_live': '应用至LIVE',
  'studio.prj_prod.status_suspend_or_deleted': '停止/删除',
  'studio.prj_prod.this_prod.release_stt_calendar_event_date': '{eventDate}天',
  'studio.prj_prod.this_prod.release_stt_calendar_event_msg': '暂无商品历史。',
  'studio.prj_prod.this_prod.release_stt_event_list_ex_msg': '暂无商品历史。',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_request_review_btn': '申请检查',
  'studio.prj_prod.this_prod.release_details_pbar_msg1': '正在准备发布',
  'studio.prj_prod.this_prod.release_details_pbar_prep_completed': '发布准备已完成。请申请检查。',
  'studio.prj_prod.this_prod.review_status_pbar_under_review': '运营者正在检查，最多需要5个工作日。',
  'studio.prj_prod.this_prod.release_details_pbar_rejected': '已被驳回。请确认内容后，申请检查。',
  'studio.prj_prod.this_prod.review_status_pbar_msg5': '检查已完成。正在等待发布。',
  'studio.prj_prod.this_prod.release_stt_pbar_msg6': '商品已发布，正在应用至LIVE中。',
  'studio.prj_prod.this_prod.release_stt_pbar_release_terminated': '已停止发布。可以恢复发布或删除发布。',
  'studio.prj_prod.this_prod.release_details_page_only_title': '仅公开商品页面。',
  'studio.prj_prod.this_prod.release_details_page_only_msg': '商品即将发布，您可以通过提前显示商品来进行宣传，或者通过社区与玩家沟通。',
  'studio.prj_prod.this_prod.release_details_with_build_msg': '准备好所有发布所需的事项了吗？您可以制定预发布、抢先体验等方案来销售商品。',
  'studio.prj_prod.this_prod.release_details_product_page_info_title': '准备商品页面',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_setting_title': '商品设置',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_setting_msg1':
    '请检查商品基本信息（商品名称、创作者姓名、发行公司名称）、类型、商品类型是否全部填写。',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_setting_redirect_btn': '立即前往',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_setting_complete_msg': '已输入所有商品设置。',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_setting_missing_msg': '未进行商品设置。',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_page_title': '商品页面',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_page_msg': '只有填写所有必填项，商品页面才能显示在列表中。',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_page_redirect_btn': '立即前往',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_page_dbox_default_msg': '请选择商品页面',
  'studio.prj_prod.this_prod.release_details_product_page_preview_dir_btn': '预览',
  'studio.prj_prod.this_prod.release_details_product_page_option_title': '商品页面选项',
  'studio.prj_prod.this_prod.release_details_product_page_option_store_community_title': '商店社区',
  'studio.prj_prod.this_prod.release_details_product_page_option_store_community_msg1': '如果尚未创建社区，公开商品页面后，将自动创建社区。',
  'studio.prj_prod.this_prod.release_details_product_page_option_store_community_mgmt_dir_btn': '立即前往',
  'studio.prj_prod.this_prod.release_details_product_page_option_store_community_msg2':
    '公开商品页面后，将自动创建社区。<br/>如果希望将社区与其他商品合并，请在团队主页 > 商店社区菜单中进行合并设置。',
  'studio.prj_prod.this_prod.release_details_release_plan_title': '发布计划',
  'studio.prj_prod.this_prod.release_details_release_plan_product_page_open_title': '商品页面公开',
  'studio.prj_prod.this_prod.release_details_release_plan_product_page_open_date_title': '商品页面公开日期',
  'studio.timezone_preview_view_btn': '查看主要城市UTC',
  'studio.timezone_preview_pop_title': '主要城市UTC',
  'studio.timezone_preview_pop_seoul': '首尔',
  'studio.timezone_preview_pop_tokyo': '东京',
  'studio.timezone_preview_pop_beijing': '北京 ',
  'studio.timezone_preview_pop_taipei': '台北',
  'studio.timezone_preview_pop_london': '伦敦',
  'studio.timezone_preview_pop_nyc': '纽约',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_title': '发布信息',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_msg': '将按设置的顺序应用并发布至商店。',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_current_status_msg': '当前（发布前）',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_this_status_msg': '商品页面公开',
  'studio.prj_prod.this_prod.release_details_release_form_confirmation': '将按照设置的信息发布。',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_info_mismatch_msg1': '各项功能上设置的数据与发布信息不一致。 ',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_info_mismatch_msg2': '请查看内容后，点击刷新按钮。',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_msg1': '检查过程中无法修改或删除输入的发布信息。',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_msg2': 'STOVE运营者检查需要1~5天完成。',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item_title': '检查事项',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item1': '商品设置',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item2': '商品页面 ',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item3': '发布计划',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_manual_release_select_msg': '检查完成后，只需调整设置的日程即可立即发布。',
  'studio.prj_prod.this_prod.release_details_browser_request_review_request_review_alert_msg': '检查申请已提交。',
  'studio.prj_prod.this_prod.release_details_browser_withdraw_review_request_btn': '取消检查申请',
  'studio.prj_prod.this_prod.release_details_browser_withdraw_review_request_pop_msg1': '是否确定取消检查申请？',
  'studio.prj_prod.this_prod.release_details_browser_withdraw_review_request_pop_msg2': '取消后重新申请检查时，需要1~5天。',
  'studio.common.popup_case_close_btn': '关闭',
  'studio.prj_prod.this_prod.release_details_browser_withdraw_review_request_msg1': '检查申请已取消。',
  'studio.prj_prod.this_prod.release_details_browser_withdraw_review_request_msg2': '请确认必填项之后，重新申请检查。',
  'studio.prj_prod.this_prod.release_stt_browser_product_release_info_btn': '商品发布信息',
  'studio.noti.review_req_for_release.completed_msg':
    '{prodName}（{prodNo}）的商品发布检查申请已提交。<br/>STOVE运营者将尽快进行审核。检查时间最长可达一周（工作日），检查审核期间无法修改商品信息。',
  'studio.mail.case_review_request.title': '申请检查',
  'studio.mail.case_review_request.mail_content': '发布检查申请已提交。',
  'studio.prj_prod.prod_release_info_pg_dir_btn': '商品发布信息',
  'studio.mail.case_in_review.title': '检查中',
  'studio.mail.case_in_review.content_msg1': 'STOVE运营者正在检查中。',
  'studio.mail.case_in_review.content_msg2': '检查过程中，无法修改商品信息。',
  'studio.mail.review_status_in_review_detail_msg3': '※Studio审核完成后，商品页面将按发布日期公开，届时即可销售商品。',
  'studio.mail.review_status_in_review_detail_msg4': '检查时间最长可达一周，检查审核期间无法修改商品信息或再次申请检查。',
  'studio.noti.review_req_rejected_msg': '{prodName}（{prodNo}）的检查申请已被驳回。<br/>请查看驳回理由后，重新申请检查。 ',
  'studio.prj_prod.this_prod.review_status_pbar_msg4_1': '已被驳回。',
  'studio.prj_prod.this_prod.review_status_pbar_msg4_2': '查看并修改项目后，请点击刷新按钮，请求检查！',
  'studio.prj_prod.release_info_checklist_stt_incompleted': '未完成',
  'studio.prj_prod.this_prod.release_details_rejection_criteria_msg': '驳回理由',
  'studio.mail.case_review_rejected.title': '检查驳回',
  'studio.mail.case_review_rejected.content_msg1': 'STOVE运营者审核已完成。',
  'studio.mail.case_review_rejected.content_msg2': '商品发布已被驳回，请在商品发布情况中查看理由后，重新申请检查。',
  'studio.prj_prod.this_prod.popup_product_page_change_saved_msg': '已应用发布信息。',
  'studio.mail.case_review_completed.title': '检查完成',
  'studio.mail.case_review_completed.content_msg1': 'STOVE运营者审核已完成。',
  'studio.mail.case_review_completed.content_msg2': '商品页面将根据发布日程在商店公开。',
  'studio.mail.case_review_completed.content_msg3': '设置为手动发布的商品需要亲自在商品发布情况中进行发布。',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_btn': '手动应用至LIVE',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_pop_title': '应用至LIVE',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_pop_msg': '如需应用商品页面，请输入“RELEASE”。 ',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_apply_pop_msg1': '恭喜！ ',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_apply_pop_msg2': '商品页面已公开。',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_apply_pop_msg3': '请前往商店查看商品页面。',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_apply_pop_redirect_store_btn': '前往商店',
  'studio.prj_prod.this_prod.home_release_stt_browser_manual_release_btn': '手动应用至LIVE',
  'studio.noti.prod_pg_opened_msg': '恭喜！<br/>{prodName}（prodNo}）商品页面已公开。',
  'studio.prj_prod.this_prod.release_stt_calendarview_store_dir_btn': '前往商店',
  'studio.prj_prod.this_prod.release_stt_calendarview_community_dir_btn': '社区',
  'studio.mail.case_release_notice.title': '发布提示',
  'studio.mail.case_release_notice.content_msg1': '恭喜！',
  'studio.mail.case_release_notice.content_msg2': '商品页面已在STOVE商店公开。',
  'studio.mail.redirect_product_page_btn': '前往商店商品页面',
  'studio.prod_home.release_info_open_suspend_btn': '停止公开商品页面',
  'studio.prod_home.popup_prod_pg_open_suspend_msg1': '停止公开商品页面时，可删除商品，商店将自动取消展示。',
  'studio.prod_home.popup_prod_pg_open_suspend_msg2': '是否停止公开商品页面？',
  'studio.prod_home.popup_prod_pg_open_suspend_cf_btn': '停止公开',
  'studio.prod_home.prod_pg_reopen_btn': '恢复公开商品页面',
  'studio.prod_home.popup_prod_pg_reopen_msg1': '是否恢复公开？',
  'studio.prod_home.popup_prod_pg_reopen_msg2': '商品页面将在商店展示。',
  'studio.prj_prod.this_prod.stt_release_sale_suspended_guide.case_prod_pg_only':
    '已停止公开商品页面。您可以重新公开或者前往项目和商品管理页面进行删除。',
  'studio.prj_prod.this_prod.stt_release_sale_suspended_guide.case_prod_pg_build': '已停止销售。您可以恢复销售或者前往项目和商品管理页面进行删除。',
  'studio.prod_home.release_info_sale_suspend_btn': '停止销售',
  'studio.prod_home.popup_release_info_sale_suspend_msg1': '是否停止销售？',
  'studio.prod_home.popup_release_info_sale_suspend_msg2': '在商店中显示为已停止销售状态。',
  'studio.prod_home.release_info_restart_sale_btn': '恢复销售',
  'studio.prj_prod.this_prod.del_req_rejected_reason_1':
    "如果发布后想要停止公开商品页面，需要与运营者提前协商后，才可以删除。<br/>关于协商，请通过邮箱（stoveindie{'@'}smilegate.com）进行咨询。",
  'studio.prj_prod.this_prod.del_req_rejected_reason_2':
    "对于已发布且有用户购买历史的商品，如果想要停止销售，需要与运营者提前协商通知方式、结算和撤销合同等相关事宜后，才可以删除。<br/>关于协商，请通过邮箱（stoveindie{'@'}smilegate.com）进行咨询。",
  'studio.prj_prod.release_info_official_release_date_input_n': '未填写',
  'studio.prj_prod.this_prod.release_details_product_page_guide':
    '您可以在填完所有必填项的商品页面中进行选择。考虑到检查时间，发布日期最早可设置为一周后。',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_title': '抢先体验文案',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_msg': '该功能用于提示用户商品尚在开发中。',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_preview_btn': '预览',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_redirect_btn': '立即前往',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_content_place_holder': '尚未设置抢先体验文案。',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_title': '设置时间',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_msg': '抢先体验文案在正式发布后也可以自由设置和显示。',
  'studio.release_details.period_settings.start_date_before_open_val_msg2': '开始日期不得早于商品页面公开日期。',
  'studio.prj_prod.this_prod.release_details_build_title': '构建准备',
  'studio.prj_prod.this_prod.release_details_build_execution_title': '运行设置',
  'studio.prj_prod.this_prod.release_details_build_execution_msg': '上传构建后，请进行设置以便能在STOVE PC客户端上运行构建。',
  'studio.prj_prod.this_prod.release_details_build_execution_place_holder2': '已输入所有运行设置。',
  'studio.prj_prod.this_prod.release_details_build_execution_place_holder1': '没有进行运行设置。',
  'studio.prj_prod.this_prod.release_details_build_execution_redirect_btn': '立即前往',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review_title': '构建管理及游戏分级',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review_msg1': '请选择要发布的构建。构建列表将按游戏分级审核完成的最新构建顺序显示。',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review_msg2': '若列表中未显示构建，请检查是否已在构建管理中上传并完成游戏分级审核。',
  'studio.prj_prod.build_mgmt_pg_dir_btn': '构建管理',
  'studio.prj_prod.rating_build_review_pg_dir_btn': '游戏分级及构建审核',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review_build_dbox_place_holder': '请选择要发布的构建',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review_build_dbox_required_val': '请选择要发布的构建。',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review.self_review_expected_rating_guide':
    '游戏分级审核已完成，预定分级为{expectedRating}，将在正式发布时生效。',
  'studio.prj_prod.this_prod.release_details_studio_support_title': '游戏支持服务设置',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_title': '游戏内商店 ',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_msg':
    '可以在游戏里创建道具后销售给玩家的功能。激活游戏内商店时，请务必设置商品条款 > 使用服务与结算前注意事项。',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_redirect_btn': '立即前往',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_shop_name_msg': '商店名称',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_quantity_msg': '商品数量',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_server_hosting_msg': '是否拥有游戏服务器',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_place_holder': '没有添加游戏内商店',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review.rating_none_guide': '尚未获得游戏分级。',
  'studio.prj_prod.this_prod.release_details_studio_support_term_title': '商品条款',
  'studio.prj_prod.this_prod.release_details_studio_support_term_msg': '发布商品时，需要添加条款。请前往商品条款设置，提前创建和添加条款。',
  'studio.prj_prod.this_prod.release_details_studio_support_no_term_msg': '没有添加商品条款。',
  'studio.prj_prod.this_prod.release_details_studio_support_term_category': '条款种类',
  'studio.prj_prod.this_prod.release_details_studio_support_term_name': '条款管理名称',
  'studio.prj_prod.this_prod.release_details_studio_support_term_version': '版本',
  'studio.prj_prod.this_prod.release_details_studio_support_term_redirect_btn': '立即前往',
  'studio.prj_prod.this_prod.release_details_studio_support_achievements_title': '挑战任务',
  'studio.prj_prod.this_prod.release_details_studio_support_achievements_msg':
    '可以通过关联游戏数据来创建挑战任务，显示并应用至商品页面。联动SDK后，需要添加和设置挑战任务才能应用。',
  'studio.prj_prod.this_prod.release_details_studio_support_achievements_redirect_btn': '立即前往',
  'studio.prj_prod.this_prod.release_details_studio_support_achievements_registered_challenges_msg': '挑战任务添加数量',
  'studio.prj_prod.this_prod.release_details_studio_support_achievements_place_holder': '尚未添加挑战任务。',
  'studio.prj_prod.this_prod.release_details_studio_support_ranking_title': '排名',
  'studio.prj_prod.this_prod.release_details_studio_support_ranking_msg':
    '可以在商品页面上显示和应用基于能力值的玩家排名。联动SDK后，需要添加和设置排名才能生效。',
  'studio.prj_prod.this_prod.release_details_studio_support_ranking_redirect_btn': '立即前往',
  'studio.prj_prod.this_prod.release_details_studio_support_ranking_registered_ranking_to_total_number_msg': '排名添加数量',
  'studio.prj_prod.this_prod.release_details_studio_support_ranking_place_holder': '尚未添加排名。',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_title': '云存储',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_msg':
    '可以将玩家的游戏数据文件应用到云服务器上的功能。联动SDK后，请设置是否应用云存储。',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_redirect_btn': '立即前往',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_savefile_location_msg': '存储文件保存路径',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_savefile_info_msg': '存储文件信息',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_savefile_place_holder': '没有设置云存储功能。',
  'studio.prj_prod.this_prod.release_details_studio_support_match_title': '匹配',
  'studio.prj_prod.this_prod.release_details_studio_support_match_msg': '确保玩家在游戏过程中保持较低网络延迟而提供的功能，需要联动SDK才能激活。 ',
  'studio.prj_prod.this_prod.release_details_studio_support_match_redirect_btn': '立即前往',
  'studio.prj_prod.this_prod.release_details_studio_support_match_status_intergrated_msg': '匹配联动已完成。',
  'studio.prj_prod.this_prod.release_details_studio_support_match_status_not_prepared_msg': '没有设置匹配功能。',
  'studio.prj_prod.this_prod.release_details_sales_setting_title': '销售设置',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_title': '价格设置',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_msg': '请查看添加的售价。如果与输入的售价不同，请在价格页面进行修改。',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_redirect_btn': '立即前往',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_sales_type_msg': '销售类型',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_sales_type_this_type_free': '免费',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_case_free_place_holder': '没有设置价格。',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_sales_type_this_type_paid': '付费',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_price_msg': '售价',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_title': '发布优惠设置',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_msg': '如果发布时需要设置优惠，可以在此处进行设置。',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_radio_enable_msg': '使用',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_radio_disable_msg': '未使用',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_period_title': '优惠时间',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_period_msg': '自正式发布之日起',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_period_in_days_msg': '每天',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_discount_rate_title': '优惠率',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_discounted_price_title': '优惠价格',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_discounted_price_msg1':
    '下方价格以当前使用的售价为标准计算，售价改变时，下方价格也会改变。 ',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_discounted_price_msg2':
    '商店显示价格可能因每日汇率而异。',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_discounted_price_regional_price_btn':
    '查看各国家/地区售价',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_displayed_price_header1': '商店显示价格',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_checkout_price_header2': '结算价格',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_discounted_price_regional_price_pop_title':
    '各国家/地区价格',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_title': '限量销售设置',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_msg': '正式发布以后，当规定数量售罄或活动时间结束后，将停止销售。',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_radio_sales_by_volume_msg': '销售数量售罄时停止',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_radio_sales_by_period_msg': '活动时间结束时停止',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_radio_deactivated_msg': '未使用',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_quantity_limit_title': '销售数量设置',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_quantity_limit_counting_unit_ko': '个',
  'studio.release_info_setting.limited_sales_quantity_required_msg': '请输入销售数量。',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_period_setting': '结束日期设置',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_period_input_n_val_msg': '请设置结束日期。',
  'studio.prj_prod.this_prod.release_details_pur_cond_title': '购买选项',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_title': '购买条件设置',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_msg1': '可以设置购买当前发布商品前需要先购买其他商品的条件。 ',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_msg2': '设置商品列表后，将显示在购买条件中。',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_cond_type_title': '条件类型',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_cond_type_this_type_and': 'AND条件',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_cond_type_this_type_or': 'OR条件',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_place_holder': '没有设置购买条件。',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_redirect_btn': '立即前往',
  'studio.prj_prod.this_prod.release_details_plan_title': '发布计划',
  'studio.prj_prod.this_prod.release_details_plan_product_page_open_title': '公开商品页面',
  'studio.prj_prod.this_prod.release_details_plan_product_page_open_msg': '考虑到检查时间，商品页面公开日期最早可设置为一周后。',
  'studio.prj_prod.this_prod.release_details_plan_product_page_open_date_title': '商品页面公开日期',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_title': '预购设置',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_msg':
    '如果您想在正式发布日期之前，提前开始销售，可以进行预购设置。还可以设置预购玩家们的下载安装和运行选项。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_radio_enable_msg': '使用',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_radio_disable_msg': '未使用',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_title': '设置正式发布日期',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_msg':
    '如果您还没有决定正式发布日期，可以设置向玩家显示的选项。发布之前，可以随时自由更改。',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_release_option': '显示选项',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_release_option_dbox_opt1_upcoming': '即将发布',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_release_option_dbox_opt4_quarter': '{relYear} {quarter}季度',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_release_date_title': '正式发布日期',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_schedule_setting_title': '设置时间',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_schedule_setting_end_date_input_n_val_msg1': '请选择结束日期。 ',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_schedule_setting_end_date_after_official_release_val_msg2':
    '结束日期不得晚于正式发布日期。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_download_and_installation_title': '下载安装',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_download_and_installation_allow': '允许',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_download_and_installation_not_allow': '禁止',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_title': '运行',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_allow_all': '全部允许',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_allow_by_stove_mem_no': '添加STOVE会员编号',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_stove_mem_no_reg_tooltip':
    '登录STOVE后，查看我的信息 > 会员编号，将其添加到模板上，即可限制仅允许指定玩家运行。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_allow_by_ip_address': '添加IP地址',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_ip_address_reg_tooltip':
    '运行游戏时，仅允许IP地址被添加到模板上的指定玩家运行。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_not_allow': '禁止',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_reg_template_placeholder': '请下载模板后上传。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_reg_file_upload_btn': '上传',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_alert1': '上传失败。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_alert2_case_mem_no': '{memNo}有误。请修改后重新上传。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_alert2_case_ip_address':
    '{ipAddress}有误。请修改后重新上传。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_case_invalid_input_value':
    '上传失败：Excel文件中含有不支持的文本格式。请检查文件。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_case_over_1000':
    '上传失败：支持人数超过1000人。请删减人数之后，重新尝试。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_case_invalid_format':
    '上传失败：文件格式错误。请使用系统支持的文件格式。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_reg_template_download_btn': '下载模板',
  'studio.file_excel_whitelist_sheet1_guide_header2': '指南（Guide）',
  'studio.file_excel_whitelist_sheet1_introduction':
    '请输入注册STOVE的会员编号。<br/>最多可输入1,000人。<br/>Please enter STOVE membership number.<br/>You can enter up to 1,000 Users.',
  'studio.file_excel_whitelist_sheet2_introduction':
    '请输入允许运行游戏的IP地址。<br/>最多可输入1,000人。<br/>Please enter your IP address. You can enter up to 1,000 Users.',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_view_guide': '请确认添加的信息。',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_present': '当前（发布前）',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_prod_pg_open': '公开商品页面',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_early_access_display_on': '显示抢先体验文案',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_end_date_invalid_val_msg1': '结束日期不得晚于正式发布日期。',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_pre_order': '预购',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_official_release': '正式发布',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_discount': '发布优惠',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_discount_start_date_invalid_val_msg':
    '请根据正式发布日期设置发布优惠的开始日期。',
  'studio.prj_prod.this_prod.release_details_opt_switch.prod_pg_release_only_popup_msg1': '除商品页面相关信息外，当前输入的信息将被重置。 ',
  'studio.prj_prod.this_prod.release_details_opt_switch.prod_pg_release_only_popup_msg2': '是否更改为只公开商品页面？',
  'studio.common.popup_case_change_btn': '更改',
  'studio.prj_prod.release_info_checklist_stt_completed': '完成',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item4': '运行设置',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item5': '构建管理及游戏分级',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item6': '价格设置',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item7': '发布优惠',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item8': '销售数量设置',
  'studio.home.release_timeline.prod_pg_item.community_open': '公开社区',
  'studio.home.release_timeline.prod_pg_item.community_early_access': '抢先体验',
  'studio.home.release_timeline.prod_pg_item.community_ingame_store': '游戏内商店',
  'studio.home.release_timeline.prod_pg_item.community_term': '商品条款',
  'studio.home.release_timeline.prod_pg_item.community_achievements': '挑战任务',
  'studio.home.release_timeline.prod_pg_item.community_ranking': '排名',
  'studio.home.release_timeline.prod_pg_item.community_cloud_saving': '云存储',
  'studio.home.release_timeline.prod_pg_item.community_match_making': '匹配',
  'studio.home.release_timeline.prod_pg_item.price_release_discount': '发布优惠',
  'studio.home.release_timeline.prod_pg_item.price_discount_period': '{discountDayNum}天',
  'studio.home.release_timeline.prod_pg_item.price_sale_limit': '销售数量',
  'studio.home.release_timeline.prod_ptyitem.price_sale_limit_quantity': '{limitedNum}个',
  'studio.home.release_timeline.prod_pg_item.price_sale_limit_guide': '销售数量售罄时停止',
  'studio.home.release_timeline.prod_pg_item.price_sale_period_terminate_guide': '活动时间结束时停止',
  'studio.home.release_timeline.prod_pg_item.price_purchase_cond_set': '购买条件设置',
  'studio.home.release_timeline.prod_pg_item.release_plan_prod_page_open': '公开商品页面',
  'studio.home.release_timeline.prod_pg_item.release_plan_pre_order': '预购',
  'studio.home.release_timeline.prod_pg_item.release_plan_download_install_allow_yn': '允许下载安装',
  'studio.home.release_timeline.prod_pg_item.release_plan_exe_allow_yn': '允许所有人运行',
  'studio.home.release_timeline.prod_pg_item.release_plan_official_release_date': '正式发布日期',
  'studio.prj_prod.this_prod.release_details_save_btn': '保存',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_start_end_date_equal_val_msg1':
    '结束日期不得早于开始日期。请重新设置开始日期和结束日期。',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_start_date_before_open_val_msg2':
    '开始日期不得早于商品页面公开日期。',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_end_date_input_n_val_msg3': '请设置结束日期。 ',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_end_date_after_official_release_val_msg4':
    '结束日期不得晚于正式发布日期。',
  'studio.group.home.board_type5_to_be_applied_item1_prod_pg': '商品页面',
  'studio.group.home.board_type5_to_be_applied_item2_build_rating': '构建及游戏分级',
  'studio.group.home.board_type5_to_be_applied_item3_price': '价格',
  'studio.group.home.board_type5_to_be_applied_item4_discount': '优惠',
  'studio.mail.this_release_info_4_build': '构建：',
  'studio.mail.this_release_info_5_sale_prep': '销售准备：',
  'studio.mail.this_release_info_6_release_plan': '发布计划：',
  'studio.mail.this_release_info_6_1_official_release': '正式发布：',
  'studio.mail.this_release_info_6_2_pre_order': '预购：',
  'studio.mail.case_pre_order_started.title': '预购开始',
  'studio.mail.case_pre_order_started.mail_content': '恭喜！<br/>您的商品已在STOVE商店开启预购。',
  'studio.mail.case_official_released.title': '正式发布',
  'studio.mail.case_official_released.mail_content': '恭喜！<br/>您的商品已在STOVE商店正式发布。',
  'studio.noti.case_restricted':
    '{prodName}已变更为{resrictionType}状态。<br/>商品的展示和销售已停止。请在发布情况菜单中确认限制理由，并进行更新以解除限制。',
  'studio.prj_prod.restriction_type_user_report': '玩家举报',
  'studio.prj_prod.restriction_criteria_policy_violation': '违反法律',
  'studio.prj_prod.restriction_criteria_adult_content': '黄色内容',
  'studio.prj_prod.restriction_criteria_defamation': '损害名誉',
  'studio.prj_prod.restriction_criteria_copyright_violation': '侵犯著作权',
  'studio.prj_prod.restriction_criteria_child_bully': '虐待儿童',
  'studio.prj_prod.restriction_criteria_malicious_code': '恶意代码',
  'studio.prj_prod.this_prod.release_details_pbar_msg10_user_report': '导致停止发布。请修改后申请检查。',
  'studio.prj_prod.this_prod.release_details_pbar_msg11_operator':
    '运营者<span class="font-medium text-tint-red-a400">{restrictionType}</span>，停止发布。请修改后申请检查。',
  'studio.prj_prod.this_prod.release_details_restriction_criteria_partners_title': '展示限制',
  'studio.prj_prod.this_prod.release_details_pbar_msg11_operator_review_restriction_msg1': '运营者审核限制，停止发布。请修改后申请检查。',
  'studio.prj_prod.this_prod.release_details_pbar_msg11_operator_review_restriction_msg2': '请前往游戏分级及构建审核页面，查看详细内容后申请检查。',
  'studio.prj_prod.this_prod.release_details_pbar_redirect_btn': '立即前往',
  'studio.mail.this_release_status.checklist_btn': '核对清单',
  'studio.mail.this_release_status.checklist_popup_title': '核对清单',
  'studio.prj_prod.release_info_checklist_review_stt': '检查状态',
  'studio.prj_prod.release_info_checklist_review_stt_prep': '准备中',
  'studio.prj_prod.release_info_checklist_official_release_date': '正式发布日期',
  'studio.prj_prod.release_info_checklist_official_release_stt_pre_release': '发布前',
  'studio.prj_prod.release_info_checklist_official_release_stt_to_be_release': '即将发布',
  'studio.mail.this_release_status_checklist_release_date': '正式发布日期',
  'studio.mail.this_release_status_checklist_release_upcoming': '即将发布',
  'studio.mail.this_release_status.checklist_popup_item1_prod_pg_prep': '准备商品页面',
  'studio.mail.this_release_status.checklist_popup_item1_prod_pg_prep.prod_setting': '设置商品',
  'studio.mail.this_release_status_checklist_product_page_info_product_page': '编辑商品页面',
  'studio.mail.this_release_status_checklist_product_page_option_title': '商品页面选项',
  'studio.mail.this_release_status_checklist_product_page_option_community': '应用社区',
  'studio.mail.this_release_status_checklist_prod_pg_opt_early_access_guide': '显示抢先体验文案',
  'studio.mail.this_release_status_checklist_release_plan_title': '发布计划',
  'studio.mail.this_release_status_checklist_release_plan_open_date_input': '输入商品页面公开日期',
  'studio.mail.this_release_status_checklist_monetization_setting_title': '销售收入金额结算准备',
  'studio.mail.this_release_status_checklist_monetization_setting_business_info': '添加公司信息',
  'studio.mail.this_release_status_checklist_monetization_setting_bank_account_info': '添加银行信息（选项）',
  'studio.prj_prod.status_rejected': '检查驳回',
  'studio.mail.this_release_status_checklist_build_title': '构建准备',
  'studio.mail.this_release_status_checklist_build_execution': '运行设置',
  'studio.mail.this_release_status_checklist_build_file_upload': '上传构建文件',
  'studio.mail.this_release_status_checklist_build_ratings_and_review': '获取游戏分级及构建审核',
  'studio.mail.this_release_status_checklist_studio_support_title': '游戏支持服务',
  'studio.mail.this_release_status_checklist_studio_support_in_app_shop': '应用游戏内商店',
  'studio.mail.this_release_status_checklist_studio_support_condition': '应用商品条款',
  'studio.mail.this_release_status_checklist_studio_support_challenges': '应用挑战任务',
  'studio.mail.this_release_status_checklist_studio_support_ranking': '应用排名',
  'studio.mail.this_release_status_checklist_studio_support_cloud': '应用云存储',
  'studio.mail.this_release_status_checklist_studio_support_match': '应用匹配',
  'studio.mail.this_release_status_checklist_sales_setting_title': '销售设置',
  'studio.mail.this_release_status_checklist_sales_setting_price_and_discount': '应用价格与优惠',
  'studio.mail.this_release_status_checklist_sales_setting_sale': '购买条件设置',
  'studio.mail.this_release_status_checklist_release_plan_early_access': '预购设置（选项）',
  'studio.mail.this_release_status_checklist_release_plan_schedule': '设置正式发布日期',
  'studio.prj_prod.post_release.price_update.popup_msg':
    '修改价格时，需要进行检查。<br/>检查最多需要5个工作日。<br/>检查通过后，将立即应用修改价格。 ',
  'studio.prj_prod.post_release.price_update.popup_request_cf_btn': '申请检查',
  'studio.prj_prod.post_release.price_update.stt_requested': '申请检查',
  'studio.prj_prod.post_release.price_update.request_cancel_btn': '取消',
  'studio.prj_prod.post_release.price_update.requested_guide': '检查通过后立即应用',
  'studio.prj_prod.post_release.price_update.popup_request_cancel_msg': '是否取消检查？<br/>选择取消时，检查中的数据将被删除。',
  'studio.prj_prod.post_release.price_update.popup_cancel_cf_btn': '取消检查',
  'studio.prj_prod.this_prod.release_status_in_promotion': '优惠应用至LIVE',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_discount_rate': '优惠',
  'studio.build_mgmt.case_build_upload_error.upload_failure_error_name': '上传失败',
  'studio.build_mgmt.case_build_upload_error.upload_failure_error_msg': '上传过程中发生未知错误。<br/>请结束上传后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.build_copy_failure_error_name': '构建复制失败',
  'studio.build_mgmt.case_build_upload_error.build_copy_failure_error_msg': '构建文件复制时发生错误。<br/>请结束上传后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.build_comparison_failure_error_name': '构建对比失败',
  'studio.build_mgmt.case_build_upload_error.build_comparison_failure_error_msg': '对比旧构建时发生错误。<br/>请结束上传后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.installjaon_file_creation_failure_error_name': 'InstallJaon文件创建失败',
  'studio.build_mgmt.case_build_upload_error.installjaon_file_creation_failure_error_msg':
    '安装信息文件编辑时发生错误。<br/>请结束上传后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.compression_folder_creation_failure_error_name': '压缩文件夹生成失败',
  'studio.build_mgmt.case_build_upload_error.compression_folder_creation_failure_error_msg': '生成目录时发生错误。<br/>请结束上传后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.compression_folder_copy_failure_error_name': '压缩文件夹复制失败',
  'studio.build_mgmt.case_build_upload_error.compression_folder_copy_failure_error_msg': '构建文件复制时发生错误。<br/>请结束上传后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.compression_failure_error_name': '压缩失败',
  'studio.build_mgmt.case_build_upload_error.compression_failure_error_msg': '构建文件压缩时发生错误。<br/>请结束上传后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.game_list_fetch_failure_error_name': '可用的游戏目录加载失败',
  'studio.build_mgmt.case_build_upload_error.game_list_fetch_failure_error_msg': '加载商品目录时发生错误。<br/>请结束上传后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.game_info_fetch_failure_error_name': '游戏信息加载失败',
  'studio.build_mgmt.case_build_upload_error.game_info_fetch_failure_error_msg': '加载游戏信息时发生错误。<br/>请结束上传后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.history_deletion_failure_error_name': '历史删除失败',
  'studio.build_mgmt.case_build_upload_error.history_deletion_failure_error_msg': '删除上传文件历史时发生错误。<br/>请结束上传后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.folder_creation_failure_error_name': '文件夹生成失败',
  'studio.build_mgmt.case_build_upload_error.folder_creation_failure_error_msg': '生成文件夹时发生错误。<br/>请结束上传后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.checklist_creation_failure_error_name': 'CheckList生成失败',
  'studio.build_mgmt.case_build_upload_error.checklist_creation_failure_error_msg': '生成CheckList时发生错误。<br/>请结束上传后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.buildsetting_creation_failure_error_name': 'BuildSetting生成失败',
  'studio.build_mgmt.case_build_upload_error.buildsetting_creation_failure_error_msg': '生成BuildSetting时发生错误。<br/>请结束上传后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.drmmaker_info_creation_failure_error_name': 'DRMMaker信息生成失败',
  'studio.build_mgmt.case_build_upload_error.drmmaker_info_creation_failure_error_msg': '生成DRMMaker信息时发生错误。<br/>请结束上传后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.upload_termination_build_cancel_error_name': '取消停止上传构建',
  'studio.build_mgmt.case_build_upload_error.upload_termination_build_cancel_error_msg': '没有上传所需的构建信息。',
  'studio.build_mgmt.case_build_generate_error.build_file_download_failure_error_name': 'Build文件下载失败',
  'studio.build_mgmt.case_build_generate_error.build_file_download_failure_error_msg':
    '下载构建文件时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_build_generate_error.build_file_zip_unzip_failure_error_name': 'Build文件zip解压失败',
  'studio.build_mgmt.case_build_generate_error.build_file_zip_unzip_failure_error_msg':
    '解压构建文件时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_build_generate_error.uploaded_files_wrong_format_error_name': 'UploadedFiles格式错误',
  'studio.build_mgmt.case_build_generate_error.uploaded_files_wrong_format_error_msg':
    '发现无效的构建文件格式。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_build_generate_error.base_build_file_comparison_failure_error_name': 'Base构建文件比对错误',
  'studio.build_mgmt.case_build_generate_error.base_build_file_comparison_failure_error_msg':
    '对比旧构建时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_build_generate_error.new_build_file_verification_failure_error_name': '检查新构建文件错误',
  'studio.build_mgmt.case_build_generate_error.new_build_file_verification_failure_error_msg':
    '检查构建文件信息时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_build_generate_error.base_build_file_download_failure_error_name': 'Base构建文件下载失败',
  'studio.build_mgmt.case_build_generate_error.base_build_file_download_failure_error_msg':
    '下载旧构建文件时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_build_generate_error.md5_hash_failure_error_name': 'MD5校验失败',
  'studio.build_mgmt.case_build_generate_error.md5_hash_failure_error_msg':
    'MD5校验失败。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_build_generate_error.new_file_update_classification_failure_error_name': '分类新文件及更新文件错误',
  'studio.build_mgmt.case_build_generate_error.new_file_update_classification_failure_error_msg':
    '分类构建文件时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_build_generate_error.s3_failure_error_name': 'S3失败',
  'studio.build_mgmt.case_build_generate_error.s3_failure_error_msg':
    'S3失败。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_build_generate_error.status_update_failure_error_name': '状态更新失败',
  'studio.build_mgmt.case_build_generate_error.status_update_failure_error_msg':
    '更新构建状态时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_build_generate_error.file_deletion_failure_error_name': '删除失败',
  'studio.build_mgmt.case_build_generate_error.file_deletion_failure_error_msg':
    '删除构建文件时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_build_generate_error.metadata_file_read_failure_error_name': '元文件读取错误',
  'studio.build_mgmt.case_build_generate_error.metadata_file_read_failure_error_msg':
    '检查构建文件信息时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_build_generate_error.drmmaker_application_failure_error_name': 'DRM Maker应用失败',
  'studio.build_mgmt.case_build_generate_error.drmmaker_application_failure_error_msg':
    '应用DRM Maker时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_build_generate_error.drmmaker_application_failure_error_msg_2971':
    '应用DRM Maker时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_build_generate_error.drmmaker_application_failure_error_msg_2972':
    '应用DRM Maker时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_build_generate_error.unknown_error_error_name': '未知错误',
  'studio.build_mgmt.case_build_generate_error.unknown_error_error_msg':
    '发生未知错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.program_execution_parameter_error_error_name': '运行程序参数错误',
  'studio.build_mgmt.case_security_inspection_error.program_execution_parameter_error_error_msg':
    '发现无效参数。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.logger_setup_failure_error_name': 'Logger设置失败',
  'studio.build_mgmt.case_security_inspection_error.logger_setup_failure_error_msg':
    '设置Logger时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.config_parsing_failure_error_name': 'Config解析失败',
  'studio.build_mgmt.case_security_inspection_error.config_parsing_failure_error_msg':
    '解析Config时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.work_directory_setup_failure_error_name': '工作目录设置失败',
  'studio.build_mgmt.case_security_inspection_error.work_directory_setup_failure_error_msg':
    '设置工作目录时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.task_ini_parsing_failure_error_name': 'Task INI解析失败',
  'studio.build_mgmt.case_security_inspection_error.task_ini_parsing_failure_error_msg':
    '解析Task INI时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1099_error_name': '未知错误',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1099_error_msg':
    '检查账号安全时发生未知错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.download_failure_error_name': '下载失败',
  'studio.build_mgmt.case_security_inspection_error.download_failure_error_msg':
    '下载构建文件时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1199_error_name': '未知错误',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1199_error_msg':
    '检查账号安全时发生未知错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.invalid_path_for_extracted_file_error_name': '解压目标路径非文件夹路径',
  'studio.build_mgmt.case_security_inspection_error.invalid_path_for_extracted_file_error_msg':
    '检查解压目标路径时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1299_error_name': '未知错误',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1299_error_msg':
    '发生未知错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.possible_malware_code_found_error_name': '病毒扫描结果显示存在恶意代码',
  'studio.build_mgmt.case_security_inspection_error.possible_malware_code_found_error_msg':
    '可能存在恶意代码。<br/>如果希望继续使用该构建，请申请特殊安全检查。',
  'studio.build_mgmt.case_security_inspection_error.no_file_found_for_scan_error_name': '病毒扫描目标不存在',
  'studio.build_mgmt.case_security_inspection_error.no_file_found_for_scan_error_msg':
    '找不到扫描目标文件。<br/>如果希望继续使用该构建，请申请特殊安全检查。',
  'studio.build_mgmt.case_security_inspection_error.too_many_rescan_attempts_error_name': '病毒扫描重试次数超限',
  'studio.build_mgmt.case_security_inspection_error.too_many_rescan_attempts_error_msg':
    '超出病毒扫描重试次数上限。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.time_limit_exceeded_for_scan_error_name': '病毒扫描超时',
  'studio.build_mgmt.case_security_inspection_error.time_limit_exceeded_for_scan_error_msg':
    '病毒扫描超时。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.server_error_during_scan_error_name': '病毒扫描服务器错误',
  'studio.build_mgmt.case_security_inspection_error.server_error_during_scan_error_msg':
    '病毒扫描时发生服务器错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.malware_found_and_file_deleted_error_name': '检查目标文件时发现恶意代码且已消除危险',
  'studio.build_mgmt.case_security_inspection_error.malware_found_and_file_deleted_error_msg':
    '可能存在恶意代码。<br/>如果希望继续使用该构建，请申请手动安全检查。',
  'studio.build_mgmt.case_security_inspection_error.malware_found_and_file_removed_error_name': '检查目标文件时发现恶意代码且已删除',
  'studio.build_mgmt.case_security_inspection_error.malware_found_and_file_removed_error_msg':
    '可能存在恶意代码。<br/>如果希望继续使用该构建，请申请手动安全检查。',
  'studio.build_mgmt.case_security_inspection_error.unverifiable_file_for_security_scan_error_name': '目标文件属于无法审核的类型',
  'studio.build_mgmt.case_security_inspection_error.unverifiable_file_for_security_scan_error_msg':
    '此文件类型无法进行自动安全审核。<br/>如果希望继续使用该构建，请申请手动安全检查。',
  'studio.build_mgmt.case_security_inspection_error.file_encrypted_and_scan_unavailable_error_name': '目标文件与密码一起加密导致无法检查',
  'studio.build_mgmt.case_security_inspection_error.file_encrypted_and_scan_unavailable_error_msg':
    '存在无法进行自动安全审核的加密文件。<br/>如果希望继续使用该构建，请申请手动安全检查。',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1399_error_name': '未知错误',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1399_error_msg':
    '发生未知错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.status_update_attempts_exceeded_error_name': '状态更新API重试次数超限',
  'studio.build_mgmt.case_security_inspection_error.status_update_attempts_exceeded_error_msg':
    '更新文件状态时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_invalid_format_error_name': '状态更新API应答格式无效',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_invalid_format_error_msg':
    '更新文件状态时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_invalid_response_error_name': '状态更新API应答代码非成功',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_invalid_response_error_msg':
    '更新文件状态时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_failure_due_to_other_reason_error_name': '其他原因导致状态更新API应答处理失败',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_failure_due_to_other_reason_error_msg':
    '更新文件状态时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1499_error_name': '未知错误',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1499_error_msg':
    '发生未知错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.work_directory_deletion_failure_error_name': '工作目录删除失败',
  'studio.build_mgmt.case_security_inspection_error.work_directory_deletion_failure_error_msg':
    '删除工作目录时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.unconfigured_option_error_name': '使用未定义动作选项值',
  'studio.build_mgmt.case_security_inspection_error.unconfigured_option_error_msg':
    '发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1599_error_name': '未知错误',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1599_error_msg':
    '发生未知错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1999_error_name': '未知错误',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1999_error_msg':
    '发生未知错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.case_drm_maker.setup_failed_error_name': '安装错误',
  'studio.build_mgmt.case_drm_maker.setup_failed_error_msg': '安装时发生错误。',
  'studio.build_mgmt.case_drm_maker.download_failed_error_name': '下载失败',
  'studio.build_mgmt.case_drm_maker.download_failed_error_msg': '下载文件时发生错误。',
  'studio.build_mgmt.case_drm_maker.zip_decompression_failed_error_name': '文件解压失败',
  'studio.build_mgmt.case_drm_maker.zip_decompression_failed_error_msg': '解压文件时发生错误。',
  'studio.build_mgmt.case_drm_maker.drm_application_failed_error_name': 'DRM Maker运行错误',
  'studio.build_mgmt.case_drm_maker.drm_application_failed_error_msg': '应用DRM时发生错误。',
  'studio.build_mgmt.case_drm_maker.api_call_error_name': '更新API调用错误',
  'studio.build_mgmt.case_drm_maker.api_call_error_msg': '连接服务器时发生错误。',
  'studio.build_mgmt.case_drm_maker.file_compression_failed_error_name': '待上传文件压缩失败',
  'studio.build_mgmt.case_drm_maker.file_compression_failed_error_msg': '压缩文件时发生错误。',
  'studio.build_mgmt.case_drm_maker.s3_upload_failed_error_name': 'S3文件上传错误',
  'studio.build_mgmt.case_drm_maker.s3_upload_failed_error_msg': '将文件上传至服务器时发生错误。',
  'studio.build_mgmt.case_drm_maker.upload_api_error_name': '上传更新API调用错误',
  'studio.build_mgmt.case_drm_maker.upload_api_error_msg': '连接服务器时发生错误。',
  'studio.build_mgmt.case_drm_maker.unknown_error_error_name': '未知错误',
  'studio.build_mgmt.case_drm_maker.unknown_error_error_msg': '发生未知错误。',
  'studio.prj_prod.this_prod.product_data.build.home_title': '构建管理',
  'studio.prj_prod.this_prod.product_data.build.home_product_key_msg': '商品密钥',
  'studio.prj_prod.this_prod.product_data.build.home_product_key_tooltip_prod_id_row1': '商品编号',
  'studio.toast.link_copied': '复制成功',
  'studio.prj_prod.this_prod.product_data.build.home_sdk_guide_btn': 'SDK联动指南',
  'studio.prj_prod.this_prod.product_data.build.home_upload_btn': '上传',
  'studio.prj_prod.this_prod.product_data.build.home_guide1': '请上传要销售的商品构建，准备发布！',
  'studio.prj_prod.this_prod.product_data.build.home_guide2':
    '不属于PC安装型游戏（例如：网页游戏和手机游戏）时，请在商品数据管理 > 运行设置菜单中输入链接。 ',
  'studio.prj_prod.this_prod.product_data.build.home_guide3': '使用STOVE提供的PC SDK，即可利用Studio提供的能力值、排名、挑战任务、匹配等增值服务。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_pop1_msg1': '请安装上传程序',
  'studio.prj_prod.this_prod.product_data.build.home_upload_pop1_msg2': '下载安装上传程序后，<br/>才能上传文件。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_latest_badge': '最新 ',
  'studio.prj_prod.this_prod.product_data.build.home_upload_install_client_btn': '下载上传程序',
  'studio.prj_prod.this_prod.product_data.build.home_upload_pop2_msg1': '请更新上传程序',
  'studio.prj_prod.this_prod.product_data.build.home_upload_pop2_msg2': '发现新版本。<br/>请下载安装文件，安装后继续进行。 ',
  'studio.prj_prod.this_prod.product_data.build.home_upload_alert_msg': 'STOVE Studio Uploader<br/>正在运行中。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_title': '安装STOVE Studio Uploader',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_msg1': '许可协议',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_msg2': '安装STOVE Studio Uploader之前，请仔细阅读许可协议内容。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_msg3': '如需要阅读许可协议同意事项的剩余部分，请点击[Page Down]按钮。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_msg4':
    '最终用户许可协议<br/><br/>在您将“STOVE” Studio Uploader程序安装到您的电脑之前，请仔细阅读下面的最终用户许可协议（以下简称“本许可协议”或“本协议”），并对本许可协议进行同意。<br/>本Uploader软件程序（以下简称“本软件”）将在您阅读本许可协议内容后，点击“同意”按钮时，才开始安装。如果点击“取消”按钮，将停止安装流程。<br/>如果您不同意本许可协议中的条款，请停止安装和运行本软件。<br/><br/>[最终用户许可协议]<br/>软件名称：“STOVE” Studio Uploader程序<br/>将本软件安装到用户计算机硬件上，即表示用户同意以下协议条款。<br/>本协议用于㈱Smilegate STOVE授权用户在个人拥有或管控下的单台及多台电脑上安装本软件，向用户提供仅限个人用途的使用许可证。<br/>本许可协议适用于“STOVE” Studio Uploader软件协议，与网络游戏服务使用协议不同。有关网络游戏服务的使用条款，请在注册时参考官网（http://www.onstove.com）内容。<br/><br/>1.软件使用许可<br/>①㈱Smilegate STOVE（以及所有明确拥有本软件所有权的合作伙伴）允许用户使用本软件，在STOVE Studio（PC打包游戏运营平台）上添加、修改和管理游戏。但是，本软件的任何自身权利均不会转移给用户。<br/>②㈱Smilegate STOVE有权随时更新、修改或更改本使用许可协议中规定的条款。<br/>③禁止用户以未在本使用许可协议中未明确列举的方法使用软件或二次发布软件，事先未经㈱Smilegate STOVE的书面同意，不得进行修改、复制、销售、租赁、流通或将软件用于其他盈利目的。<br/>④用户不得利用本软件，翻译、分析、反编译、反汇编、仿制其他程序。此外，不得利用本程序二次创作作品。<br/><br/>2.有关更改与更新的使用许可<br/>①㈱Smilegate STOVE有权对本软件进行更新、更改或修复错误，方便用户持续使用STOVE Studio添加、修改和管理游戏。<br/>②使用本软件持续添加、修改和管理游戏，代表用户接受与本软件相关的所有更改事项。同时，也代表用户同意许可协议，允许应用这些更新、更改或错误修复。<br/>③其他事项请参考第1条（软件使用许可）<br/><br/>3.有限责任与免责<br/>①用户在㈱Smilegate STOVE提供的“STOVE” Studio（PC打包游戏运营平台）上，添加、修改和管理游戏时，免费向用户提供本软件。<br/>②按当前状态提供本软件，对于本软件的内容和使用后的功能、有效性、准确性、稳定性以及使用本软件后没有获得预期效果或丢失等问题，㈱Smilegate STOVE不提供任何保证，也不承担任何责任。<br/>③㈱Smilegate STOVE不保证本软件可以在所有条件下正常使用和运行，对于使用本软件造成的损害或损失，不承担任何责任。但是，因㈱Smilegate STOVE故意或重大过失而导致问题的情况除外。<br/>④发生符合第3条的情况时，㈱Smilegate STOVE只对用户在合法使用本软件时发生的实质性的直接损失进行赔偿。㈱Smilegate STOVE对第三方的不当使用等问题造成的结果不承担任何责任。<br/><br/>4.使用权解除<br/>①用户可以随时通过删除或丢弃本软件来解除本使用许可协议。<br/>②如果用户存在违反本使用许可协议中规定的行为，㈱Smilegate STOVE有权单方面终止该用户的许可协议，无需提供任何补偿。在这种情况下，视为用户同意立即删除本软件，并销毁包括本软件的副产品在内的所有内容。<br/>③如果本许可协议因任何原因而终止，协议中㈱Smilegate STOVE授予用户关于本软件的所有许可立即终止。<br/>④即使根据本协议第1款或第2条款终止了协议，本协议第1条第3款、第4款和第5款在协议解除后依旧有效。<br/><br/>5.其他事项<br/>本使用权许可中的所有事项均遵循大韩民国法律，用户与㈱Smilegate STOVE之间就本使用权许可产生纷争而提起诉讼时，双方当事人可以向民事诉讼法规定的管辖法院提起诉讼。<br/><br/>附录（2020.12.10）<br/>（实施日期）本使用权许可自2020年12月10日实施。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_msg5':
    '如果您同意以上内容，请点击“同意”。安装STOVE Studio Uploader必须同意以上内容。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_previous_btn': '< 返回',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_agree_btn': '同意',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_cancel_pop_title': '安装',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_cancel_pop_msg1': '是否取消安装STOVE Studio Uploader？',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_cancel_pop_yes_btn': '是',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_cancel_pop_no_btn': '否',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_msg1': '选择安装位置',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_msg2': '请选择安装STOVE Studio Uploader的文件夹。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_msg3':
    'STOVE Studio Uploader将安装到以下文件夹。<br/>如需安装到其他文件夹，请点击“浏览”按钮选择其他文件夹。<br/>要开始安装，请点击“安装”按钮。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_destination_folder_title': '安装文件夹',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_browse_btn': '浏览',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_msg4': '所需磁盘空间：{reqDiskCapa}',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_msg5': '剩余磁盘空间：{availDiskCapa}',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_install_btn': '安装',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_browse_pop_title': '浏览文件夹',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_browse_pop_msg': 'STOVE Studio Uploader将安装到以下文件夹：',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_browse_pop_new_folder_btn': '创建新文件夹',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step4_msg1': '安装中',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step4_msg2': '正在安装STOVE Studio Uploader，请稍候。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step4_msg3': '正在解压……',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step5_msg1': 'STOVE Studio Uploader安装完成',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step5_msg2': '点击【完成】结束安装。<br/>请登录STOVE Studio后进行上传。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_finish_btn': '完成',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_msg1': '请选择上传文件所在的文件夹位置，并开始上传。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_select_file_title': '上传文件',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_select_file_place_holder': '请选择构建文件所在的文件夹路径',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_select_req_val': '请选择构建文件所在的文件夹路径。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_select_file_browse_btn': '浏览',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_temp_folder_title': '临时文件保存文件夹',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_temp_folder_place_holder': '未输入时，保存到临时文件的默认文件夹中',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_temp_folder_change_btn': '更改',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_build_detail': '构建说明',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_build_detail_place_holder': '请输入用于区分上传文件的内容',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_file_upload_guide_title': '提示事项',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_file_upload_guide1': '可根据上传进度继续操作。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_file_upload_guide2': '上传失败时请重新上传。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_file_upload_guide3':
    '上传完成后系统将自动进行安全检查并创建构建，上传状态也将同步更新。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_start_upload_btn': '开始上传',
  'studio.prj_prod.this_prod.product_data.build.uploader_terminate_pop_msg': '是否关闭<br/>STOVE Studio Uploader？',
  'studio.prj_prod.this_prod.product_data.build.uploader_terminate_pop_cf_btn': '结束',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_start_upload_alert1_msg': '检测到无法上传的文件或文件夹。<br/>请删除后重新尝试。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_start_upload_alert2_msg': '缺少dll文件。<br/>请重新下载文件，添加dll后再次尝试。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_start_upload_alert3_msg': '用户身份验证信息已过期。<br/>请重新运行Uploader。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_select_file_browse_cf_alert_msg1': '团队存储容量不足。<br/>请删除旧构建后，重新尝试。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_this_action_cf_alert_msg':
    '磁盘空间不足，无法上传。<br/>请重新设置临时文件保存文件夹。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_incompleted_bld_exist_popup_title': '停止上传',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_incompleted_bld_exist_popup_msg': '检测到停止上传的构建。<br/>是否重新开始上传？',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_incompleted_bld_exist_popup_cont_upload_btn': '继续',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_incompleted_bld_exist_popup_start_new_upload_btn': '重新开始',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_msg': '正在确认文件…… ',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_remaining_time_msg': '剩余时间',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_cancel_upload_btn': '取消上传',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_retry_btn': '重试',
  'studio.prj_prod.this_prod.product_data.build.uploader_quitting_attempt_pop_msg': '是否关闭STOVE Studio Uploader？',
  'studio.prj_prod.this_prod.product_data.build.uploader_cannot_cont_upload_popup': '没有找到停止上传的文件。<br/>请删除后重新上传。 ',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_file_transfer_paused_msg': '发生网络错误，暂时停止上传。<br/>请继续上传。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_file_transfer_failed_msg':
    '安装信息文件复制错误，上传失败。<br/>请确认错误代码后，重新尝试。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_error_case1_temp_paused': '暂停。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_continue_upload_btn': '继续',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt3_2_upload_failed':
    '上传失败。{overallProg}%（{completedFileNum}/{totalFileNum}）',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt1_checking': '正在确认文件。{overallProg}% ',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt2_1_compressing': '正在压缩文件。{overallProg}% ',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt2_2_compress_failed': '文件压缩失败。{overallProg}% ',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt3_1_uploading': '正在上传……',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_finish_btn': '完成',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide1_sdk_sync_guide_btn': '查看SDK联动方法',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide2_title': 'PC客户端运行测试',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide2_client_download': '下载客户端',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide3_title': '能力值',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide3_2': '能力值代表游戏的相关数值。<br/>可以按照能力值来创建排名或挑战任务。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide4_title': '云存储',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide4_1':
    '安装游戏后，通过STOVE PC客户端将游戏数据保存在云端，从而实现最新文件同步的服务。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide5_title': '匹配',
  'studio.prj_prod.this_prod.product_data.build_build_count_title': '全部',
  'studio.prj_prod.this_prod.product_data.build_redirect_execution_btn': '前往设置',
  'studio.prj_prod.this_prod.product_data.build_guide1': '请测试上传的构建能否正常运行。<br/>可以在STOVE PC客户端中分别对商品进行测试。',
  'studio.prj_prod.this_prod.product_data.build_guide2': '客户端运行测试',
  'studio.prj_prod.this_prod.product_data.build_client_download_btn': '下载客户端',
  'studio.prj_prod.this_prod.product_data.build_group_storage_msg': '{totalCapa}GB中已用{usedCapa}GB',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_total_capacity_msg': '团队存储容量（{totalCapa}GB）',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_occupied_capacity_msg': '{usedCapa}GB',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_remaining_capacity_msg': '{totalCapa}GB',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_request_more_storage_btn': '扩容申请',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_request_sent': '申请完成',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_request_more_storage_pop_msg1': '团队存储容量扩容申请',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_request_more_storage_pop_msg2':
    '未经事先协商的申请可能会被拒绝。详情请咨询STOVE Studio运营者。',
  'studio.prj_prod.this_prod.product_data.build_group_storage_pop_inquiry_btn': '咨询',
  'studio.prj_prod.this_prod.product_data.build_group_storage_pop_request_btn': '申请',
  'studio.prj_prod.this_prod.product_data.build.home_build_id_header1': '构建编号',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_header2': '上传状态',
  'studio.prj_prod.this_prod.product_data.build.home_integrity_header4': '完整性',
  'studio.prj_prod.this_prod.product_data.build.home_file_size_header5': '容量',
  'studio.prj_prod.this_prod.product_data.build.home_edited_date_header6': '添加日期<br/>（修改日期）',
  'studio.prj_prod.this_prod.product_data.build.home_prod_status_header7': '发布状态',
  'studio.prj_prod.this_prod.product_data.build.home_list_delete_n_alert_msg': '正在进行检查或正在发布的商品文件无法删除。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop1_msg1': '停止上传',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop1_msg2': '检测到上传途中停止上传的记录。<br/>请选择继续上传或删除记录。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop1_delete_build_btn': '删除构建',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop1_resume_btn': '继续',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop2_msg1': '无法上传',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop2_msg2': '本账号无法继续上传。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop2_delete_build_btn': '删除构建',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_failed_pop_msg': '上传失败',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_testing_pop_build_status_creating_msg': '创建构建',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_testing_pop_security_test_msg': '安全检查',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_testing_pop_build_status_failed_msg': '构建创建失败',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_testing_pop_security_test_failed_msg': '安全检查失败',
  'studio.prj_prod.this_prod.product_data.build.security_test_failed_manual_test_request_btn': '手动安全检查申请',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_failed_manual_test_requested_msg': '手动安全检查申请中',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_failed_manual_test_declinded_msg': '手动安全检查驳回',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_title': '手动安全检查申请与同意书',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_name_place_holder': '姓名 or 公司名称',
  'studio.build.request_manual_test_pop.request_form_name_req_msg': '请输入姓名或公司名称。',
  'studio.common.def_key.special_character_n': '不可以输入特殊符号。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_agreement_text': '本人已确认并同意上述提示及同意事项。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_year': '年',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_req_msg': '请输入日期。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_month': '月',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_day': '日',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_signature_applicant_place_holder': '姓名 or 法人代表姓名',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_signature_applicant_req_msg': '请输入姓名或法人代表姓名。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_submit_btn': '提交',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_reason_for_requst_place_holder': '请输入申请原因。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_submit_pop_title': '手动检查申请成功',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_submit_pop_msg2':
    '已收到您提交的同意书。<br/>经STOVE Studio运营者确认后，将更新结果。',
  'studio.prj_prod.this_prod.product_data.build_del_pop_title': '删除构建',
  'studio.prj_prod.this_prod.product_data.build_del_pop_msg': '如需删除，请输入“DELETE”。<br/>删除后将无法恢复。',
  'studio.prj_prod.this_prod.product_data.build_del_pop_del_cf_btn': '删除',
  'studio.build_mgmt.build_upload_stt1_paused': '停止上传',
  'studio.build_mgmt.build_upload_stt2_upload_failed': '上传失败',
  'studio.build_mgmt.build_upload_stt3_inspecting': '检查中',
  'studio.build_mgmt.build_upload_stt4_build_gen_failed': '构建创建失败',
  'studio.build_mgmt.build_upload_stt5_security_inspection_failed': '安全检查失败',
  'studio.build_mgmt.build_upload_stt6_failed': '失败',
  'studio.build_mgmt.build_upload_stt7_completed': '完成',
  'studio.build_mgmt.build_detail.description_place_holder': '请填写构建说明',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_build_size_row3': '容量',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_date_upload_row4': '添加日期',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_modified_date_row5': '修改日期',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_release_status_row6': '发布状态',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_upload_status_row7': '上传状态',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_upload_status1_paused_guide':
    '检测到上传途中停止上传的记录。<br/>请选择继续上传或删除记录。',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_upload_status_resume_btn': '继续',
  'studio.prj_prod.this_prod.product_data.build.security_test_failed_manual_test_requested_stt': '手动安全检查申请中',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_upload_status_request_manual_test_rejected_stt': '手动安全检查驳回',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_upload_status_testing_build_msg': '检查中',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_option_msg': '是否应用',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_option_apply_yes_msg': '应用',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_option_apply_no_msg': '未应用',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_title': '完整性检查',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_msg1': '使用STOVE PC客户端运行游戏时，确认所需文件是否正常安装在电脑上。',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_msg2': '当DLC文件与上级商品文件相同时，系统将以DLC文件为准。',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_files_msg': '应用文件',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_files_place_holder': '请选择需要应用的文件。',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_files_file_selected_text': '{fileName}以外还有{extraSelectedFileNum}个',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_files_select_file_btn': '选择文件',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_timeout_setting_title': '验证超时',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_msg': '应用文件',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_applied': '应用完成',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_failed': '应用失败',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_applying': '申请应用',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_withdrawed': '申请解除',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_select_file_pop_title': '选择DRM Maker文件',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_pop_total_file': '全部',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_pop_filename_header2': '文件名称',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_select_file_pop_status_header3': '应用状态',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_select_file_pop_title': '选择检查完整性文件',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_type_exist_hash_msg':
    'EXIST_HASH：检查文件是否存在并对比哈希值，如果不同则进行验证',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_type_exist_msg': 'EXIST：检查文件是否存在，如果不存在则进行验证',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_select_file_pop_test_type_header3': '验证类型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_stt_3_rejected': '审核驳回',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_stt_4': '审核完成',
  'studio.prj_prod.this_prod.home_prod_stt_terminated': '结束',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update_btn': '更新构建',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.title': '更新构建',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.badge_live_apply_y': '应用中',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item_check': '当前应用的构建与所选构建有哪些变更？',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item1_bug_fix': 'Bug修复',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item2_background_img_vid': '更改背景或视频',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item3_ui': '更改基础系统或UI',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item4_billing_sys': '更改付费系统',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item5_scenario': '更改任务或剧情',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item6_char_item': '更改角色或道具',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.info_change_report_guide':
    '内容修改申报审核完成后才能应用至LIVE。',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.info_change_report_rating_menu_dir_btn': '游戏分级及构建审核',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.info_change_report_stt_under_review': '正在审核。',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.change_report_complete.build_apply_date': '构建应用日期',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.change_report_complete.immed_apple': '立即',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.change_report_complete.schedule_apply': '预约',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.change_report_complete.schedule_req_msg1': '请选择开始日期。',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.change_report_complete.schedule_invalid_msg2':
    '请选择当前时间之后的日期。',
  'studio.prj_prod.this_prod.execution_register_btn': '添加',
  'studio.prj_prod.this_prod.execution_guide1': '请输入在PC客户端运行商品所需的必填信息。',
  'studio.prj_prod.this_prod.execution_guide1_1': '请添加应用于客户端30MB以下的商品图片和ico文件。',
  'studio.prj_prod.this_prod.execution_setting_option_title': '运行选项',
  'studio.prj_prod.this_prod.execution_setting_option_msg': '根据选择的平台，请输入运行所需的必填项。',
  'studio.prj_prod.this_prod.execution_setting_option_platform_msg': '平台',
  'studio.prj_prod.this_prod.execution_setting_option_platform_dropbox_place_holder': '请选择平台',
  'studio.prj_prod.this_prod.execution_setting_option_platform_dropbox_req_msg': '请选择平台。',
  'studio.prj_prod.this_prod.execution_setting_option_add_btn': '添加选项',
  'studio.prj_prod.this_prod.execution_setting_option_name': '选项名称',
  'studio.prj_prod.this_prod.execution_setting_option_name_place_holder': '请输入选项名称',
  'studio.prj_prod.this_prod.execution_setting_option_name_req_msg': '请输入选项名称。',
  'studio.prj_prod.this_prod.execution_setting_option_name_duplicate_msg': '选项名称重复。请重新输入。',
  'studio.prj_prod.this_prod.execution_setting_option_executing_file_msg': '运行文件',
  'studio.prj_prod.this_prod.execution_setting_option_executing_file_place_holder': '请输入运行文件',
  'studio.prj_prod.this_prod.execution_setting_option_executing_file_req_msg': '请输入运行文件。',
  'studio.prj_prod.this_prod.execution_setting_option_parameter_msg': '参数值',
  'studio.prj_prod.this_prod.execution_setting_option_parameter_place_holder': '请输入参数值',
  'studio.prj_prod.this_prod.execution_setting_option_working_directory_msg': '工作路径',
  'studio.prj_prod.this_prod.execution_setting_option_working_directory_place_holder': '请输入工作路径',
  'studio.prj_prod.this_prod.execution_setting_option_process_name_msg': '进程文件',
  'studio.prj_prod.this_prod.execution_setting_option_process_name_place_holder': '请输入进程文件',
  'studio.prj_prod.this_prod.execution_setting_option_collapse_all_msg': '简要视图',
  'studio.prj_prod.this_prod.execution_setting_option_expand_all_msg': '查看更多',
  'studio.prj_prod.execution_setting_option_requirements_cpp_place_holder': '不选择',
  'studio.prj_prod.execution_setting_option_platform_msg': '平台',
  'studio.prj_prod.execution_setting_option_platform_dropbox_place_holder': '请选择平台',
  'studio.prj_prod.execution_setting_option_platform_dropbox_req_msg': '请选择平台。',
  'studio.prj_prod.execution_setting_option_delete_btn': '删除',
  'studio.prj_prod.execution_setting_option_delete_cf_btn': '删除',
  'studio.prj_prod.execution_setting_option_name': '选项名称',
  'studio.prj_prod.execution_setting_option_name_place_holder': '请输入选项名称',
  'studio.prj_prod.execution_setting_option_name_req_msg': '请输入选项名称。',
  'studio.prj_prod.execution_setting_exe_url': '运行URL',
  'studio.prj_prod.execution_setting_exe_url_place_holder': '请包含http://或https://前缀',
  'studio.prj_prod.execution_setting_exe_url_req_msg': '请输入可运行的URL或官网URL。',
  'studio.prj_prod.execution_setting_option_mob_store_url_title': '手机商店URL',
  'studio.prj_prod.execution_setting_option_mob_store_url_place_holder': '请包含http://或https://前缀',
  'studio.prj_prod.execution_setting_option_mob_store_url_req_msg': '至少输入1个URL。',
  'studio.prj_prod.this_prod.execution_setting_title': '安装设置',
  'studio.prj_prod.this_prod.execution_setting_folder_title': '安装文件夹',
  'studio.prj_prod.this_prod.execution_setting_folder_msg': '请输入玩家下载商品时，安装在本地驱动的文件夹名称。',
  'studio.prj_prod.this_prod.execution_setting_folder_name_placeholder': '请输入安装文件夹名称',
  'studio.prj_prod.this_prod.execution_setting_folder_name_req_msg': '请输入安装文件夹名称。',
  'studio.prj_prod.this_prod.execution_setting_folder_name_invalid_msg': '安装文件夹名称错误。请重新确认。',
  'studio.prj_prod.execution_setting_pc_client_title': 'PC客户端设置',
  'studio.prj_prod.execution_setting_pc_client_launcher_image_title': '安装后Windows商品运行图标',
  'studio.prj_prod.execution_setting_pc_client_launcher_image_format_guide': '{acceptFileExtAttributeLabel} \\| {size}MB以下',
  'studio.prj_prod.execution_setting_pc_client_launcher_image_req_msg': '请添加图片。',
  'studio.prj_prod.execution_setting_pc_client_logo_image_title': 'PC客户端商品缩略图',
  'studio.prj_prod.execution_setting_pc_client_logo_image_format_guide': '{info}以下',
  'studio.prj_prod.execution_setting_pc_client_logo_image_req_msg': '请添加图片。',
  'studio.prj_prod.execution_setting_pc_client_client_wallpaper_image_title': 'PC客户端主推荐图',
  'studio.prj_prod.execution_setting_pc_client_img_preview_btn': '预览',
  'studio.prj_prod.execution_setting_pc_client_preview_title': 'PC客户端图片应用预览',
  'studio.prj_prod.execution_setting_pc_client_preview_msg1': '本图片为帮助用户理解的示例图。',
  'studio.prj_prod.execution_setting_pc_client_preview_msg2': '主页商品推荐',
  'studio.prj_prod.execution_setting_pc_client_preview_play_btn': '开始游戏',
  'studio.prj_prod.execution_setting_pc_client_preview_random_search_title': '随机搜索',
  'studio.prj_prod.execution_setting_pc_client_preview_random_search_msg': '点击图标时，将推荐其他游戏。',
  'studio.prj_prod.execution_save_btn': '保存',
  'studio.prj_prod.this_prod.execution_setting_option_platform_alert_msg': '保存成功。<br/>请上传构建。',
  'studio.prj_prod.build_upload_pg_dir_btn': '上传构建',
  'studio.prj_prod.execution_basic_guide1': '运行设置',
  'studio.prj_prod.execution_basic_guide1_1': '请输入所有必填项后，测试能否在STOVE PC客户端上正常运行。',
  'studio.prj_prod.execution_install_set_enabled_guide2': '安装文件夹',
  'studio.prj_prod.execution_pc_client_set_enabled_guide2': 'PC客户端设置',
  'studio.prj_prod.execution_pc_client_set_enabled_guide2_1': '请添加在STOVE客户端上向玩家显示的商品图片。添加的图片将用作图标、缩略图、横幅。',
  'studio.prj_prod.execution_pc_client_set_enabled_guide3': '运行图标',
  'studio.prj_prod.execution_pc_client_set_enabled_guide3_1': '玩家安装游戏后，用作Windows桌面图标的图片。',
  'studio.prj_prod.execution_pc_client_set_enabled_guide4': 'PC客户端商品缩略图',
  'studio.prj_prod.execution_pc_client_set_enabled_guide4_1': '添加的游戏缩略图将显示在STOVE客户端左侧STOVE游戏菜单或收藏菜单中。',
  'studio.prj_prod.execution_pc_client_set_enabled_guide5': '推荐图片',
  'studio.prj_prod.execution_pc_client_set_enabled_guide5_1': '只有经过STOVE运营者确认的游戏，才能显示在PC客户端主页。',
  'studio.prj_prod.execution_exe_opt_enabled_guide2': '运行选项',
  'studio.prj_prod.execution_exe_opt_enabled_guide3_1':
    '可以自由设置进行测试。发布后也可以更改，但请注意在正式环境中应用错误的信息可能导致无法正常运行。',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_1_1': '运行文件',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_2_1': '参数值',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_2_2': '- 请输入运行文件时需要一起调用的值。',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_3_1': '工作路径',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_3_2': '- exe运行文件与需要运行的必备文件所在位置不同时，需要输入工作路径。',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_4_1': '进程文件',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_4_2': '- 对于安装文件和运行文件分离的构建，需要在进程文件名称中输入实际运行文件。',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_5_1': '必需程序',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_5_2': '- 请注意，没有选择运行游戏所需的程序时，游戏有可能无法正常运行。',
  'studio.prj_prod.execution_exe_opt_enabled_guide5_1': '运行URL',
  'studio.prj_prod.execution_exe_opt_enabled_guide5_2': '- 请输入可以通过链接立即运行游戏的URL或跳转至官网的URL。',
  'studio.prj_prod.execution_exe_opt_enabled_guide6_1': '手机商店URL',
  'studio.prj_prod.execution_exe_opt_enabled_guide6_2': '- 支持从商店商品页面跳转至手机应用商店，请输入手机商店网址。',
  'studio.prj_prod.execution_setting_folder_title': '安装文件夹',
  'studio.prj_prod.execution_setting_folder_msg1': '请输入玩家下载商品时，安装在本地驱动的文件夹名称。',
  'studio.prj_prod.execution_setting_folder_msg2': 'DLC将安装在主游戏文件夹的子目录下。如需保存在相同文件夹中，请输入句点。',
  'studio.prj_prod.execution_setting_folder_name_placeholder': '请输入安装文件夹名称',
  'studio.prj_prod.execution_setting_folder_name_req_msg': '请输入安装文件夹名称。',
  'studio.prj_prod.execution_setting_folder_name_invalid_msg': '安装文件夹名称错误。请重新确认。',
  'studio.prj_prod.execution_setting_dlc_auto_install_title': '自动安装DLC',
  'studio.prj_prod.execution_setting_dlc_auto_install_msg1': '玩家购买DLC后，将自动安装。',
  'studio.prj_prod.execution_setting_dlc_auto_install_y': '使用',
  'studio.prj_prod.execution_setting_dlc_auto_install_n': '未使用',
  'studio.prj_prod.execution_setting.post_release_update_guide': 'LIVE发布检查中无法修改。请等待检查完成。',
  'studio.prj_prod.execution_setting.post_release_update_info_run_option': '运行选项',
  'studio.prj_prod.execution_setting.post_release_update_info_platform': '平台',
  'studio.prj_prod.execution_setting.post_release_update_info_opt_name': '选项名称',
  'studio.prj_prod.execution_setting.post_release_update_info_exe_file': '运行文件',
  'studio.prj_prod.execution_setting.post_release_update_info_exe_url': '运行URL',
  'studio.prj_prod.execution_setting.post_release_update_info_folder': '安装文件夹',
  'studio.prj_prod.execution_setting.post_release_update_info_argument_value': '参数值',
  'studio.prj_prod.execution_setting.post_release_update_info_path': '工作路径',
  'studio.prj_prod.execution_setting.post_release_update_info_process_file': '进程文件',
  'studio.group.collection.title': '合集',
  'studio.group.collection.make_btn': '创建',
  'studio.group.collection.guide1': '收集2个或更多商品来创建合集。<br/>您可以将多个商品组合在一起进行打包销售。',
  'studio.group.collection.register_title': '添加合集',
  'studio.group.collection.register_header_name': '合集商品设置',
  'studio.group.collection.register_product_config': '商品组成',
  'studio.group.collection.register_product_config_place_holder': '请搜索商品',
  'studio.group.collection.register_product_config_nation_btn': '商品显示国家/地区',
  'studio.group.collection.register_product_config_list_msg1': '至少选择2个商品。',
  'studio.group.collection.register_product_config_list_msg2': '存在已移交的商品。请删除商品{prodNo}。',
  'studio.group.collection.register_product_config_list_msg3': '存在已移交的商品。请删除商品{prodNo}。',
  'studio.group.collection.register_product_config_list_msg4': '尚未选择商品。 ',
  'studio.group.collection.register_product_config_place_holder_msg1': '无搜索结果。',
  'studio.group.collection.register_product_config_list_no': '商品编号',
  'studio.group.collection.register_product_config_list_type': '类型',
  'studio.group.collection.register_product_config_list_name': '商品名称',
  'studio.group.collection.register_product_config_list_status': '状态',
  'studio.group.collection.register_product_config_check_box': '加载主要商品信息',
  'studio.group.collection.register_product_config_check_box_guide': '合集基本信息和商品页面将根据所选主要商品的信息自动组成，您可以自由编辑。',
  'studio.group.collection.register_product_config_select_apply_btn': '应用',
  'studio.group.collection.register_product_config_nation_btn_select_region': '选择区域',
  'studio.group.collection.register_basic_info': '基本信息',
  'studio.group.collection.register_lang_setting_btn': '多语言设置',
  'studio.group.collection.register_basic_info_name': '商品名称',
  'studio.group.collection.register_basic_info_name_place_holder': '请输入商品名称',
  'studio.group.collection.register_basic_info_name_msg1': '请输入商品名称。',
  'studio.group.collection.register_basic_info_name_msg2': '商品名称重复。请输入其他商品名称。',
  'studio.group.collection.register_basic_info_creator_name': '创作者姓名',
  'studio.group.collection.register_basic_info_creator_name_place_holder': '请输入创作者姓名',
  'studio.group.collection.register_basic_info_creator_name_msg1': '请输入创作者姓名。',
  'studio.group.collection.register_basic_info_distributor_name': '发行公司名称',
  'studio.group.collection.register_basic_info_distributor_name_place_holder': '请输入发行公司名称',
  'studio.group.collection.register_basic_info_distributor_name_msg1': '请输入发行公司名称。',
  'studio.group.collection.register_product_page': '商品页面',
  'studio.group.collection.register_product_page_guide': '您可以编辑将在商店中显示的合集商品页面。',
  'studio.group.collection.register_product_page_edit_btn': '编辑商品页面',
  'studio.group.collection.register_sales_settings': '销售设置',
  'studio.group.collection.register_sales_settings_previous_price': '合集优惠前价格',
  'studio.group.collection.register_launch_discount': '发布优惠',
  'studio.group.collection.register_launch_discount_y': '使用',
  'studio.group.collection.register_launch_discount_n': '未使用',
  'studio.group.collection.register_discount_period': '优惠时间',
  'studio.group.collection.register_discount_period_text1': '自正式发布之日起 ',
  'studio.group.collection.register_discount_period_text2': '每天',
  'studio.group.collection.register_discount_rate': '优惠率',
  'studio.group.collection.register_discount_rate_msg1': '请输入合集优惠率。',
  'studio.discount.register_rate_valid_msg': '请输入1~100之间的值。',
  'studio.group.collection.register_price_preview': '预览价格',
  'studio.group.collection.register_price_preview_guide': '以下价格基于当前售价，如更改售价则会相应变化。<br/>商店显示价格可能因每日汇率而异。',
  'studio.group.collection.register_price_preview_select1': '商店显示价格',
  'studio.group.collection.register_price_preview_select2': '结算价格',
  'studio.group.collection.register_price_preview_sub_title1': '此合集中包含的商品',
  'studio.group.collection.register_price_preview_sub_title2': '共{prodNum}个 ',
  'studio.group.collection.register_price_preview_pay_info1': '商品价格',
  'studio.group.collection.register_price_preview_pay_info2': '合集优惠',
  'studio.group.collection.register_price_preview_pay_info3': '合集优惠金额',
  'studio.group.collection.register_price_preview_pay_info4': '最终售价',
  'studio.group.collection.register_limited_sale': '限量销售设置',
  'studio.group.collection.register_limited_sale_guide': '正式发布以后，卖完规定数量或活动时间结束后，停止销售。',
  'studio.group.collection.register_limited_sale_option1': '销售数量售罄时停止',
  'studio.group.collection.register_limited_sale_option2': '活动时间结束时停止',
  'studio.group.collection.register_limited_sale_option3': '未使用',
  'studio.group.collection.register_sales_quantity': '销售数量',
  'studio.group.collection.register_sales_quantity_text': '个',
  'studio.group.collection.register_sales_quantity_msg1': '请输入销售数量。',
  'studio.group.collection.register_end_date': '结束日期设置',
  'studio.group.collection.register_end_date_msg1': '结束日期不得早于正式发布日期。',
  'studio.group.collection.register_plan': '发布',
  'studio.group.collection.register_plan_open_date': '商品页面公开日期',
  'studio.group.collection.register_plan_utc_view_btn': '查看主要城市UTC',
  'studio.group.collection.register_plan_pre_order': '预购设置',
  'studio.group.collection.register_plan_pre_order_guide': '如果您想在正式发布之前，提前开始销售商品，可以设置预购。',
  'studio.group.collection.register_plan_pre_order_y': '使用',
  'studio.group.collection.register_plan_pre_order_n': '未使用',
  'studio.group.collection.register_plan_pre_order_period': '预购时间设置',
  'studio.group.collection.register_plan_pre_order_period_start': '开始日期',
  'studio.group.collection.register_plan_pre_order_period_end': '结束日期',
  'studio.group.collection.register_plan_pre_order_period_msg1': '开始日期不得早于商品页面公开日期。',
  'studio.group.collection.register_plan_pre_order_period_msg2': '结束日期不得早于开始日期。',
  'studio.group.collection.register_plan_pre_order_period_msg3': '结束日期不得晚于正式发布日期。',
  'studio.group.collection.register_plan_official_release_date_option': '正式发布预定日显示的选项',
  'studio.group.collection.register_plan_official_release_date_option_def_value': '即将发布',
  'studio.group.collection.register_plan_official_release_date': '正式发布日期',
  'studio.group.collection.register_plan_official_release_date_msg1': '请选择正式发布日期。',
  'studio.group.collection.register_banner_img': '横幅图片',
  'studio.group.collection.register_banner_img_preview_btn': '预览',
  'studio.group.collection.register_banner_img_rectangular': '矩形图片',
  'studio.group.collection.register_banner_img_portrait': '纵向图片',
  'studio.group.collection.register_banner_img_landscape': '横向图片',
  'studio.group.collection.register_banner_img_preview_title': '预览图片',
  'studio.group.collection.register_banner_img_preview_guide': '本图片为帮助用户理解的示例图。',
  'studio.group.collection.register_pass_validation': '是否将合集应用于LIVE？',
  'studio.group.collection.list_total': '全部',
  'studio.group.collection.list_header_status': '状态',
  'studio.group.collection.list_header_display': '展示',
  'studio.group.collection.list_header_collection_name': '合集商品名称',
  'studio.group.collection.list_header_product_count': '商品数量',
  'studio.group.collection.list_header_discount_rate': '优惠率',
  'studio.group.collection.list_header_release_date': '发布（预计）日期',
  'studio.group.collection.list_header_discount_btn': '优惠设置',
  'studio.group.collection.list_search_place_holder': '搜索合集商品名称',
  'studio.group.collection.list_more_btn_sales_suspention': '停止销售',
  'studio.group.collection.list_more_btn_display_suspention': '停止展示',
  'studio.group.collection.list_more_btn_go_to_store': '前往商店',
  'studio.group.collection.list_more_btn_opening_suspention': '停止公开',
  'studio.group.collection.list_more_btn_reopening': '恢复展示',
  'studio.group.collection.list_more_btn_delete_request': '删除申请',
  'studio.group.collection.list_more_btn_cancel_delete_request': '取消删除申请',
  'studio.group.collection.list_more_btn_delete_request_pop_guide': '如需申请删除，请输入“DELETE”。STOVE运营者批准（2~3日）后删除，删除后无法恢复。',
  'studio.group.collection.list_more_btn_delete_request_place_holder': 'DELETE',
  'studio.group.collection.list_more_btn_delete_request_del_btn': '删除',
  'studio.group.collection.list_more_btn_delete_request_del_btn_msg1': '删除申请已提交。',
  'studio.prj_prod.this_prod.stt_release_sale_resumed_guide': '如需重新开始销售，请输入“START”。 ',
  'studio.prj_prod.this_prod.stt_release_sale_resumed_place_holder': 'START',
  'studio.prj_prod.this_prod.stt_release_resumed_btn': '恢复',
  'studio.prj_prod.this_prod.stt_product_page_withdrawn_guide': '如需停止公开商品页面，请输入“SUSPEND”。 ',
  'studio.prj_prod.this_prod.stt_product_page_withdrawn_place_holder': 'SUSPEND',
  'studio.prj_prod.this_prod.stt_product_page_withdrawn_btn': '停止',
  'studio.group.collection.list_more_btn_delete_request_del_btn_msg2': '无法删除的合集。',
  'studio.prj_prod.this_prod.stt_release_display_resumed': '恢复展示',
  'studio.prj_prod.this_prod.stt_release_display_resumed_guide': '如需重新开始展示，请输入“ON”。 ',
  'studio.prj_prod.this_prod.stt_release_display_resumed_place_holder': 'ON',
  'studio.prj_prod.this_prod.stt_release_display_suspended': '停止展示',
  'studio.prj_prod.this_prod.stt_release_display_suspended_guide': '如需停止展示，请输入“OFF”。 ',
  'studio.prj_prod.this_prod.stt_release_display_suspended_place_holder': 'OFF',
  'studio.group.collection.list_more_btn_delete_request_del_btn_msg3': '删除申请已取消。',
  'studio.group.collection.list_search_result': '{searchKeyWord}搜索结果 ',
  'studio.group.collection.list_search_result_no': '没有找到符合搜索条件的结果。',
  'studio.group.collection.list.details_title': '合集详情',
  'studio.group.collection.list.details_del_statuts_info': '正在申请删除的商品信息。无法更改商品信息。',
  'studio.group.collection.list.details_restriction_info1':
    '因<span class="font-medium text-tint-red-a400">{reportedReason}</span>而停止发布。<br/>如需重新发布，请修改内容后，前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.group.collection.list.details_restriction_info2':
    '因运营者<span class="font-medium text-tint-red-a400">{restrictionType}</span>而停止发布。<br/>如需重新发布，请修改内容后，前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.group.collection.list.details_restriction_info3': '含有违规内容。',
  'studio.group.collection.list.details_collection_restriction_info':
    '因<span class="font-medium text-tint-red-a400">{restrictionType}</span>而停止发布。如需重新发布，请删除移交商品后，再进行保存。',
  'studio.group.collection.discount_title': '优惠',
  'studio.group.collection.discount_registration_btn': '添加',
  'studio.group.collection.discount_main_guide':
    '您可以为合集商品添加多个优惠。<br/>优惠率将根据合集商品的原价进行计算。<br/>也可以进行限量优惠销售。',
  'studio.breadcrumb.discount_registration': '添加优惠',
  'studio.group.collection.discount_registration_title': '添加优惠',
  'studio.group.collection.discount_registration_discount_name': '优惠名称',
  'studio.group.collection.discount_registration_discount_name_place_holder': '请输入优惠名称',
  'studio.group.collection.discount_registration_discount_name_msg1': '请输入优惠名称。',
  'studio.group.collection.discount_registration_start_date': '开始日期',
  'studio.group.collection.discount_registration_start_date_option1': '立即',
  'studio.group.collection.discount_registration_start_date_option2': '预约',
  'studio.group.collection.discount_registration_end_date': '结束日期',
  'studio.group.collection.discount_registration_end_date_msg1': '同一时间存在其他优惠。请更改时间后，重新尝试。',
  'studio.group.collection.discount_registration_end_date_msg2': '预约日期不得早于当前时间。',
  'studio.group.collection.discount_registration_rate': '优惠率',
  'studio.group.collection.discount_registration_rate_msg1': '请输入优惠率。',
  'studio.group.collection.discount_registration_limited_sale': '限量优惠销售',
  'studio.group.collection.discount_registration_limited_sale_y': '使用 ',
  'studio.group.collection.discount_registration_limited_sale_n': '未使用',
  'studio.group.collection.discount_registration_limited_quantity': '限量销售数量',
  'studio.group.collection.discount_registration_limited_quantity_text': '个',
  'studio.group.collection.discount_registration_limited_quantity_msg1': '销售数量应介于1到9,999,999之间。',
  'studio.group.collection.discount_registration_header_info': '设置的价格是免费。只有付费商品才能添加优惠。',
  'studio.group.collection.discount_registration_header_info_free': '免费',
  'studio.group.collection.discount_registration_list_sorting1': '全部',
  'studio.group.collection.discount_registration_list_sorting2': '应用至LIVE/等待应用',
  'studio.group.collection.discount_registration_list_sorting3': '结束',
  'studio.transfer.mgmt_history.detail_pg_tittle': '团队移交详情',
  'studio.transfer.mgmt_history.detail_pg_guide1':
    '需要填写基本信息才能接收团队移交。<br/>我们将基于您提供的信息进行STOVE检查，检查完成后方可进行移交。<br/>STOVE检查期最长需要一周时间。',
  'studio.transfer.mgmt_history.detail_pg_guide2': 'STOVE已根据相关法律，将原有团队与项目相关的知识产权等一切权利和义务转让给新团队，',
  'studio.transfer.mgmt_history.detail_pg_guide3': '仅在新团队依法有效承接上述权利和义务的情况下，方可确保项目移交的有效性。',
  'studio.transfer.mgmt_history.detail_pg_info1_grp_name': '团队名称',
  'studio.transfer.mgmt_history.detail_pg_info1_grp_name_place_holder': '请输入团队名称',
  'studio.transfer.mgmt_history.detail_pg_info1_grp_name_req_msg': '请输入团队名称。',
  'studio.transfer.mgmt_history.detail_pg_info1_grp_name_dup_msg': '无法使用重复的团队名称。<br/>请输入其他团队名称。',
  'studio.transfer.mgmt_history.request_review_btn': '申请审核',
  'studio.transfer.mgmt_history.request_review_cf_popup_msg': '是否提交当前填写的信息进行审核？',
  'studio.business_bank_setting.group_discontinue_guide_popup_msg1': '删除团队后，所有相关信息将被删除，<br/>删除的信息无法恢复。',
  'studio.business_bank_setting.group_discontinue_guide_popup_msg2': '是否确认操作？',
  'studio.business_bank_setting.group_discontinue_completed_popup_msg': '团队已删除。',
  'studio.business_bank_setting.group_discontinue_not_allowed_popup_msg1': '无法删除团队。',
  'studio.business_bank_setting.group_discontinue_not_allowed_popup_msg2': '存在项目或正在进行移交时，无法删除团队。',
  'studio.business_bank_setting.title': '企业银行信息设置',
  'studio.business_bank_setting.individual.select_gender_required_msg': '请选择代表性别。',
  'studio.business_bank_setting.individual.select_birth_wrong_format_msg': '日期无效，请重新确认。',
  'studio.business_bank_setting.individual.game_production_no_guide_req_msg': '请上传韩国游戏制作（发行）业注册证。',
  'studio.business_bank_setting.individual.telecom_sales_no_guide_req_msg': '请上传通信销售业注册证。',
  'studio.business_bank_setting.account.question4_invalid_msg': '输入的账号无效。请重新输入。',
  'studio.business_bank_setting.account.question5_invalid_msg': '输入的户名无效。请重新输入。',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_basic_game': '基础游戏',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_demo_game': 'Demo游戏',
  'studio.prj_prod.this_prod.home_product_setting_prod_link': '关联商品 ',
  'studio.prj_prod.this_prod.home_product_setting_prod_link_guide': '请添加相关商品。关联的商品将自动更改为对应类型。',
  'studio.prj_prod.this_prod.home_product_setting_info_mismatch_new_reg_popup': '输入的基本信息与自主评级不符。<br/>请申请新的游戏分级。',
  'studio.prj_prod.this_prod.home_product_setting__new_reg_btn': '重新申请',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_basic_content': '正式内容',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_demo_content': 'Demo内容',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_basic_util': '正式Utility',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_demo_util': 'Demo Utility',
  'studio.prj_prod.this_prod.edit_display_countries_regions_north_america': '北美洲',
  'studio.prj_prod.this_prod.edit_display_countries_regions_central_america': '中美洲',
  'studio.prj_prod.this_prod.edit_display_countries_regions_south_america': '南美洲',
  'studio.prj_prod.this_prod.edit_display_countries_regions_western_europe': '西欧',
  'studio.prj_prod.this_prod.edit_display_countries_regions_eastern_europe': '东欧',
  'studio.prj_prod.this_prod.edit_display_countries_regions_northern_europe': '北欧',
  'studio.prj_prod.this_prod.edit_display_countries_regions_east_asia': '东亚',
  'studio.prj_prod.this_prod.edit_display_countries_regions_southeast_asia': '东南亚',
  'studio.prj_prod.this_prod.edit_display_countries_regions_western_asia': '西亚',
  'studio.prj_prod.this_prod.edit_display_countries_regions_southern_asia': '南亚',
  'studio.prj_prod.this_prod.edit_display_countries_regions_central_asia': '中亚',
  'studio.prj_prod.this_prod.edit_display_countries_regions_oceania': '大洋洲',
  'studio.prj_prod.this_prod.edit_display_countries_regions_north_africa': '北非',
  'studio.prj_prod.this_prod.edit_display_countries_regions_western_africa': '西非',
  'studio.prj_prod.this_prod.edit_display_countries_regions_central_africa': '中非',
  'studio.prj_prod.this_prod.edit_display_countries_regions_east_africa': '东非',
  'studio.prj_prod.this_prod.edit_display_countries_regions_southern_africa': '南非',
  'studio.prj_prod.this_prod.edit_display_countries_regions_other': '其他',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_req_val_msg1': '请输入基础售价。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_invalid_val_msg3': '请输入至少0.99 USD。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_price_invalid_val_msg5': '最大金额可输入8位数字，包含小数点后2位。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_payment_price_req_val_msg1': '请输入结算价格。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_payment_price_invalid_val_msg2': '请以10为单位输入至少10 KRW。 ',
  'studio.member_manage.member.invite_link_popup_case_4809': '{grpName}<br/>已提交加入申请。<br/>等待团队管理员审核批准。',
  'studio.member_manage.role_manage_list_by_menu_coupon': '优惠券',
  'studio.member_manage.role_manage_list_by_menu_event': '活动',
  'studio.member_manage.role_manage_list_by_menu_banner_img': '横幅图片',
  'studio.member_manage.member_details_pg_title': '成员详情',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_content1':
    '本手动安全检查申请及同意书（以下简称“本同意书”）旨在规定Smilegate Holdings, Inc.通过线上平台提供的STOVE Studio服务（以下简称“STOVE”）中，合作伙伴（以下简称“合作伙伴”）入驻平台销售商品（程序等）时，关于商品手动安全检查申请及相关责任的事项。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_content2':
    '若合作伙伴拟在STOVE上架销售的商品虽不含病毒、蠕虫、特洛伊木马、后门、间谍软件、勒索软件、广告软件、恶意机器人等恶意程序及其他有害程序（以下简称“恶意程序”），但因任何原因未能通过STOVE的自动安全检查时，需同意以下内容并通过手动安全检查后方可销售商品。本同意书的内容适用于合作伙伴提交本同意书后上架的所有商品。<br/>①    合作伙伴保证其上架的所有商品不含任何恶意程序，且同意承担因商品上架及已上架商品而产生的一切后果责任。<br/>②    除非存在STOVE方面的故意或重大过失，否则STOVE不承担因合作伙伴上架的商品而引起的任何损失或问题的责任，若因此引发法律纠纷，合作伙伴应自费为STOVE提供免责保护，并赔偿STOVE因此遭受的全部损失。',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_security_standard_header2': '安全等级',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_security_standard_high': '高',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_security_standard_basic': '普通',
  'studio.build_mgmt.build_gen_steps_0_build_prep': '等待创建构建',
  'studio.build_mgmt.build_steps_count': '（第{currentStep}/{totalStep}步）',
  'studio.build_mgmt.build_gen_steps_1_build_download': '正在下载构建源文件',
  'studio.build_mgmt.build_gen_steps_2_build_extract': '正在解压构建源文件',
  'studio.build_mgmt.build_gen_steps_3_prev_build_check': '正在检查历史构建',
  'studio.build_mgmt.build_gen_steps_4_drm_apply': 'DRM应用中',
  'studio.build_mgmt.build_gen_steps_5_build_file_compare': '正在对比构建文件',
  'studio.build_mgmt.build_gen_steps_6_generate': '正在创建构建文件',
  'studio.build_mgmt.build_gen_steps_7_waiting_for_completion': '等待完成',
  'studio.build_mgmt.security_inspection_steps_0_waiting': '等待安全检查',
  'studio.build_mgmt.security_inspection_steps_1_download': '正在下载构建源文件',
  'studio.build_mgmt.security_inspection_steps_2_extract': '正在解压构建源文件',
  'studio.build_mgmt.security_inspection_steps_3_scan': '正在扫描构建文件',
  'studio.build_mgmt.security_inspection_steps_4_waiting_for_completion': '等待完成',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_inspection_failed_title': '安全检查失败',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_inspection_success_title': '安全检查完成',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_success_msg': '已完成。 ',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_success_title': '已生成构建',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_applicant_name': '签名',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_applicant_signature': '（印）',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_num': '{numByItems}个',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_file_tooltip': '可预先将项目共享图片与视频上传到存储器，方便在管理商品页面时使用。',
  'studio.prod_pg.img_edit_popup.img_type1_prod_pg_bg_img': '商品页面背景图片',
  'studio.prod_pg.img_edit_popup.img_type2_display_vid_thumbnail': '展示视频及图片（视频缩略图）',
  'studio.prod_pg.img_edit_popup.img_type3_display_img': '展示视频及图片（图片）',
  'studio.prod_pg.img_edit_popup.img_type4': '1:1图片',
  'studio.prod_pg.img_edit_popup.img_type5': '16:9图片',
  'studio.prod_pg.img_edit_popup.img_type6_title_bg_img': '标题背景图片',
  'studio.prod_pg.img_edit_popup.img_type7_one_line_intro_img': '一句话介绍图片',
  'studio.prod_pg.img_edit_popup.img_type8_award_img': '获奖图片',
  'studio.prod_pg.img_edit_popup.img_type9': '内容横幅_矩形图片_2x2',
  'studio.prod_pg.img_edit_popup.img_type10': '内容横幅_纵向图片_1x2',
  'studio.prod_pg.img_edit_popup.img_type11': '内容横幅_横向图片_2x1',
  'studio.prod_pg.img_edit_popup.img_type12_pc_logo_img': 'PC客户端商品缩略图',
  'studio.prod_pg.img_edit_popup.img_type13_pc_recommended_img': 'PC客户端主推荐图',
  'studio.common.popup_case_lang_setting_input_required': '输入{reqValue}后方可设置多语言。<br/>请输入内容后重试。',
  'studio.common.file_upl_guide1_1': '{acceptFileExtAttributeLabel}',
  'studio.common.file_upl_guide1_2': '{size}MB以下',
  'studio.prj_prod.execution_pc_client_logo_img_content1_fav_search': '收藏',
  'studio.prj_prod.execution_pc_client_logo_img_content2': 'LOST ARK',
  'studio.prj_prod.execution_pc_client_logo_img_content3': 'LORDNINE',
  'studio.prj_prod.execution_pc_client_logo_img_content4_guide1': '自由选择武器&成长，打造专属战斗风格。',
  'studio.prj_prod.execution_pc_client_logo_img_content5': 'MMORPG · 19+',
  'studio.prj_prod.execution_pc_client_logo_img_content6_play': '开始游戏',
  'studio.prj_prod.execution_pc_client_logo_img_content7_random_search': '随机搜索',
  'studio.prj_prod.execution_pc_client_logo_img_content8_guide2': '点击图标<br>推荐其他账号。',
  'studio.common.def_key.space_not_allowed': '不能输入空格，请重新输入。 ',
  'studio.common.popup_case_no_access_per': '无该团队访问权限。<br/>请联系团队负责人。',
  'studio.lnb.common_2depth_tutorial_vid': 'Studio公告',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.build_required_msg': '请选择构建。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.origin_country_place_holder': '选择',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.origin_country_required_msg': '请选择原创国家/地区。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.description_required_msg': '请填写游戏简介。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_request_required_msg': '请填写所有必填信息后再提交审核。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_rating_by_age': '{rating}+',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_rating_all': '全年龄',
  'studio.prj_prod_mngmt.rating_build_review.self_review_req.qtn_required_msg': '请选择问卷项目。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_select_content_required_msg': '请至少选择游戏包含的1项内容。',
  'studio.rating_build_review.reason_input_place_holder': '请输入申辩内容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_appeal_required_msg': '请输入申辩内容。',
  'studio.prj_prod_mngmt.rating_build_review.intl_org_save_msg':
    '<span class="font-bold">正在保存国际分级编号信息。</span><br/>将立即应用于当前分级信息。',
  'studio.prj_prod_mngmt.rating_build_review.report_change_required_msg': '请至少选择1项更改内容。 ',
  'studio.prj_prod_mngmt.rating_build_review.report_change_item_name_kr': '韩文名称：',
  'studio.prj_prod_mngmt.rating_build_review.report_change_item_name_en': '英文名称：',
  'studio.gnb.group_myinfo.pg_title': 'Studio我的信息',
  'studio.registration.agreement-required': '完成Studio注册需要同意服务使用条款',
  'studio.registration.email': '邮箱',
  'studio.registration.terms-privacy-agree': '请同意Studio服务条款及个人信息使用条款。',
  'studio.registration.all-agree': '同意全部条款。',
  'studio.stove.terms-service-required': '【STOVE】服务使用条款（必选）',
  'studio.stove.privacy-required': '【STOVE】个人信息收集及使用同意（必选）',
  'studio.stove.ads-consent-optional': '【STOVE】同意接收广告性信息（可选）',
  'studio.registration.terms-service-required': '【Studio】服务使用条款（必选）',
  'studio.registration.privacy-required': '【Studio】个人信息收集及使用同意（必选）',
  'studio.registration.ads-consent-optional': '【Studio】同意接收广告性信息（可选）',
  'studio.registration.view-terms': '查看条款',
  'studio.registration.sign_up_btn': '注册',
  'studio.registration.cancel-confirm': '是否取消Studio注册？<br/>取消后输入的内容将会消失。',
  'studio.national_code.af': '阿富汗',
  'studio.national_code.al': '阿尔巴尼亚',
  'studio.national_code.ax': '奥兰群岛',
  'studio.national_code.an': '荷属安的列斯',
  'studio.national_code.bv': '布韦岛',
  'studio.national_code.hm': '赫德岛和麦克唐纳群岛',
  'studio.national_code.tf': '法属南部领地',
  'studio.national_code.um': '美国本土外小岛屿',
  'studio.national_code.dz': '阿尔及利亚',
  'studio.national_code.as': '美属萨摩亚',
  'studio.national_code.ad': '安道尔',
  'studio.national_code.ao': '安哥拉',
  'studio.national_code.ai': '安圭拉',
  'studio.national_code.aq': '南极大陆',
  'studio.national_code.ag': '安提瓜和巴布达',
  'studio.national_code.ar': '阿根廷',
  'studio.national_code.am': '亚美尼亚',
  'studio.national_code.aw': '阿鲁巴',
  'studio.national_code.au': '澳大利亚',
  'studio.national_code.at': '奥地利',
  'studio.national_code.az': '阿塞拜疆',
  'studio.national_code.bs': '巴哈马',
  'studio.national_code.bh': '巴林',
  'studio.national_code.bd': '孟加拉国',
  'studio.national_code.bb': '巴巴多斯',
  'studio.national_code.by': '白俄罗斯',
  'studio.national_code.be': '比利时',
  'studio.national_code.bz': '伯利兹',
  'studio.national_code.bj': '贝宁',
  'studio.national_code.bm': '百慕大',
  'studio.national_code.bt': '不丹',
  'studio.national_code.bo': '玻利维亚',
  'studio.national_code.bq': '博奈尔岛',
  'studio.national_code.ba': '波斯尼亚和黑塞哥维那',
  'studio.national_code.bw': '博茨瓦纳',
  'studio.national_code.br': '巴西',
  'studio.national_code.io': '英属印度洋领地',
  'studio.national_code.vg': '英属维尔京群岛',
  'studio.national_code.bn': '文莱',
  'studio.national_code.bg': '保加利亚',
  'studio.national_code.bf': '布基纳法索',
  'studio.national_code.bi': '布隆迪',
  'studio.national_code.kh': '柬埔寨',
  'studio.national_code.cm': '喀麦隆',
  'studio.national_code.ca': '加拿大',
  'studio.national_code.cv': '佛得角',
  'studio.national_code.ky': '开曼群岛',
  'studio.national_code.cf': '中非共和国',
  'studio.national_code.td': '乍得',
  'studio.national_code.cl': '智利',
  'studio.national_code.cn': '中国',
  'studio.national_code.cx': '圣诞岛',
  'studio.national_code.cc': '科科斯群岛',
  'studio.national_code.co': '哥伦比亚',
  'studio.national_code.km': '科摩罗',
  'studio.national_code.cg': '刚果共和国',
  'studio.national_code.ck': '库克群岛',
  'studio.national_code.cr': '哥斯达黎加',
  'studio.national_code.ci': '科特迪瓦',
  'studio.national_code.hr': '克罗地亚',
  'studio.national_code.cu': '古巴',
  'studio.national_code.cw': '库拉索',
  'studio.national_code.cy': '塞浦路斯',
  'studio.national_code.cz': '捷克',
  'studio.national_code.dk': '丹麦',
  'studio.national_code.dj': '吉布提',
  'studio.national_code.dm': '多米尼克',
  'studio.national_code.do': '多米尼加共和国',
  'studio.national_code.ec': '厄瓜多尔',
  'studio.national_code.eg': '埃及',
  'studio.national_code.sv': '萨尔瓦多',
  'studio.national_code.gq': '赤道几内亚',
  'studio.national_code.er': '厄立特里亚',
  'studio.national_code.ee': '爱沙尼亚',
  'studio.national_code.et': '埃塞俄比亚',
  'studio.national_code.fk': '福克兰群岛',
  'studio.national_code.fo': '法罗群岛',
  'studio.national_code.fj': '斐济',
  'studio.national_code.fi': '芬兰',
  'studio.national_code.fr': '法国',
  'studio.national_code.gf': '法属圭亚那',
  'studio.national_code.pf': '法属波利尼西亚',
  'studio.national_code.ga': '加蓬',
  'studio.national_code.gm': '冈比亚',
  'studio.national_code.ge': '格鲁吉亚',
  'studio.national_code.de': '德国',
  'studio.national_code.gh': '加纳',
  'studio.national_code.gi': '直布罗陀',
  'studio.national_code.gr': '希腊',
  'studio.national_code.gl': '格陵兰',
  'studio.national_code.gd': '格林纳达',
  'studio.national_code.gp': '瓜德罗普',
  'studio.national_code.gu': '关岛',
  'studio.national_code.gt': '危地马拉',
  'studio.national_code.gg': '根西岛',
  'studio.national_code.gn': '几内亚',
  'studio.national_code.gw': '几内亚比绍',
  'studio.national_code.gy': '圭亚那',
  'studio.national_code.ht': '海地',
  'studio.national_code.hn': '洪都拉斯',
  'studio.national_code.hk': '香港特别行政区',
  'studio.national_code.hu': '匈牙利',
  'studio.national_code.is': '冰岛',
  'studio.national_code.in': '印度',
  'studio.national_code.id': '印度尼西亚',
  'studio.national_code.ir': '伊朗',
  'studio.national_code.iq': '伊拉克',
  'studio.national_code.ie': '爱尔兰',
  'studio.national_code.im': '马恩岛',
  'studio.national_code.il': '以色列',
  'studio.national_code.it': '意大利',
  'studio.national_code.jm': '牙买加',
  'studio.national_code.jp': '日本',
  'studio.national_code.je': '泽西岛',
  'studio.national_code.jo': '约旦',
  'studio.national_code.kz': '哈萨克斯坦',
  'studio.national_code.ke': '肯尼亚',
  'studio.national_code.sz': '埃斯瓦蒂尼',
  'studio.national_code.ki': '基里巴斯',
  'studio.national_code.kw': '科威特',
  'studio.national_code.kg': '吉尔吉斯斯坦',
  'studio.national_code.la': '老挝',
  'studio.national_code.lv': '拉脱维亚',
  'studio.national_code.lb': '黎巴嫩',
  'studio.national_code.ls': '莱索托',
  'studio.national_code.lr': '利比里亚',
  'studio.national_code.ly': '利比亚',
  'studio.national_code.li': '列支敦士登',
  'studio.national_code.lt': '立陶宛',
  'studio.national_code.lu': '卢森堡',
  'studio.national_code.mo': '澳门特别行政区',
  'studio.national_code.mk': '北马其顿',
  'studio.national_code.mg': '马达加斯加',
  'studio.national_code.mw': '马拉维',
  'studio.national_code.my': '马来西亚',
  'studio.national_code.mv': '马尔代夫',
  'studio.national_code.ml': '马里',
  'studio.national_code.mt': '马耳他',
  'studio.national_code.mh': '马绍尔群岛',
  'studio.national_code.mq': '马提尼克',
  'studio.national_code.mr': '毛里塔尼亚',
  'studio.national_code.mu': '毛里求斯',
  'studio.national_code.yt': '马约特',
  'studio.national_code.mx': '墨西哥',
  'studio.national_code.fm': '密克罗尼西亚',
  'studio.national_code.md': '摩尔多瓦',
  'studio.national_code.mc': '摩纳哥',
  'studio.national_code.mn': '蒙古',
  'studio.national_code.me': '黑山',
  'studio.national_code.ms': '蒙特塞拉特',
  'studio.national_code.ma': '摩洛哥',
  'studio.national_code.mz': '莫桑比克',
  'studio.national_code.mm': '缅甸',
  'studio.national_code.na': '纳米比亚',
  'studio.national_code.nr': '瑙鲁',
  'studio.national_code.np': '尼泊尔',
  'studio.national_code.nl': '荷兰',
  'studio.national_code.nc': '新喀里多尼亚',
  'studio.national_code.nz': '新西兰',
  'studio.national_code.ni': '尼加拉瓜',
  'studio.national_code.ne': '尼日尔',
  'studio.national_code.ng': '尼日利亚',
  'studio.national_code.nu': '纽埃',
  'studio.national_code.nf': '诺福克岛',
  'studio.national_code.kp': '朝鲜民主主义人民共和国',
  'studio.national_code.mp': '北马里亚纳群岛',
  'studio.national_code.no': '挪威',
  'studio.national_code.om': '阿曼',
  'studio.national_code.pk': '巴基斯坦',
  'studio.national_code.pw': '帕劳',
  'studio.national_code.ps': '巴勒斯坦',
  'studio.national_code.pa': '巴拿马',
  'studio.national_code.pg': '巴布亚新几内亚',
  'studio.national_code.py': '巴拉圭',
  'studio.national_code.pe': '秘鲁',
  'studio.national_code.ph': '菲律宾',
  'studio.national_code.pn': '皮特凯恩群岛',
  'studio.national_code.pl': '波兰',
  'studio.national_code.pt': '葡萄牙',
  'studio.national_code.pr': '波多黎各',
  'studio.national_code.qa': '卡塔尔',
  'studio.national_code.re': '留尼汪',
  'studio.national_code.ro': '罗马尼亚',
  'studio.national_code.ru': '俄罗斯',
  'studio.national_code.rw': '卢旺达',
  'studio.national_code.bl': '圣巴泰勒米',
  'studio.national_code.sh': '圣赫勒拿',
  'studio.national_code.kn': '圣基茨和尼维斯',
  'studio.national_code.lc': '圣卢西亚',
  'studio.national_code.mf': '法属圣马丁',
  'studio.national_code.pm': '圣皮埃尔和密克隆',
  'studio.national_code.vc': '圣文森特和格林纳丁斯',
  'studio.national_code.ws': '萨摩亚',
  'studio.national_code.sm': '圣马力诺',
  'studio.national_code.st': '圣多美和普林西比',
  'studio.national_code.sa': '沙特阿拉伯',
  'studio.national_code.sn': '塞内加尔',
  'studio.national_code.rs': '塞尔维亚',
  'studio.national_code.sc': '塞舌尔',
  'studio.national_code.sl': '塞拉利昂',
  'studio.national_code.sg': '新加坡',
  'studio.national_code.sx': '荷属圣马丁',
  'studio.national_code.sk': '斯洛伐克',
  'studio.national_code.si': '斯洛文尼亚',
  'studio.national_code.sb': '所罗门群岛',
  'studio.national_code.so': '索马里',
  'studio.national_code.za': '南非共和国',
  'studio.national_code.gs': '南乔治亚和南桑德韦奇群岛',
  'studio.national_code.kr': '韩国',
  'studio.national_code.ss': '南苏丹',
  'studio.national_code.es': '西班牙',
  'studio.national_code.lk': '斯里兰卡',
  'studio.national_code.sd': '苏丹',
  'studio.national_code.sr': '苏里南',
  'studio.national_code.sj': '斯瓦尔巴和扬马延',
  'studio.national_code.se': '瑞典',
  'studio.national_code.ch': '瑞士',
  'studio.national_code.sy': '叙利亚',
  'studio.national_code.tw': '台湾',
  'studio.national_code.tj': '塔吉克斯坦',
  'studio.national_code.tz': '坦桑尼亚',
  'studio.national_code.th': '泰国',
  'studio.national_code.cd': '刚果民主共和国',
  'studio.national_code.tl': '东帝汶',
  'studio.national_code.tg': '多哥',
  'studio.national_code.tk': '托克劳',
  'studio.national_code.to': '汤加',
  'studio.national_code.tt': '特立尼达和多巴哥',
  'studio.national_code.tn': '突尼斯',
  'studio.national_code.tr': '土耳其',
  'studio.national_code.tm': '土库曼斯坦',
  'studio.national_code.tc': '特克斯和凯科斯群岛',
  'studio.national_code.tv': '图瓦卢',
  'studio.national_code.vi': '美属维尔京群岛',
  'studio.national_code.ug': '乌干达',
  'studio.national_code.ua': '乌克兰',
  'studio.national_code.ae': '阿拉伯联合酋长国',
  'studio.national_code.gb': '英国',
  'studio.national_code.us': '美国',
  'studio.national_code.uy': '乌拉圭',
  'studio.national_code.uz': '乌兹别克斯坦',
  'studio.national_code.vu': '瓦努阿图',
  'studio.national_code.va': '梵蒂冈城国',
  'studio.national_code.ve': '委内瑞拉',
  'studio.national_code.vn': '越南',
  'studio.national_code.wf': '瓦利斯和富图纳',
  'studio.national_code.eh': '西撒哈拉',
  'studio.national_code.ye': '也门',
  'studio.national_code.zm': '赞比亚',
  'studio.national_code.zw': '津巴布韦',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_maint': '游戏维护',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr7': '添加、修改、删除商品维护',
  'studio.gnb.group_myinfo.my_group.detailed_group_my_prj': '我的项目',
  'studio.gnb.group_myinfo.my_group.detailed_group_prj_product_list': '{prjName}的商品[{prodNum}]',
  'studio.gnb.group_myinfo_btn_join_req_accept': '接受',
  'studio.gnb.group_myinfo_btn_join_req_reject': '拒绝',
  'studio.gnb.group_myinfo.invitation.detailed_group_group_name': '{grpName}团队',
  'studio.gnb.group_myinfo.invitation.detailed_group_join_time': '邀请日期',
  'studio.gnb.group_myinfo.invitation.detailed_group_invite_status': '状态',
  'studio.gnb.group_myinfo.invitation.detailed_invited_permissions': '受邀团队菜单权限',
  'studio.gnb.group_myinfo.invitation.detailed_invited_prj': '受邀项目',
  'studio.gnb.group_myinfo.invitation.detailed_prj_product_list': '{prjName}的商品[{prodNum}]',
  'studio.gnb.group_myinfo.invitation.detailed_prj_product_name': '商品名称',
  'studio.gnb.group_myinfo.invitation.detailed_prj_role': '职责',
  'studio.gnb.group_myinfo.invitation.detailed_permission_given_date': '权限授予日期',
  'studio.gnb.group_myinfo.invitation.detailed_prj_name': '项目名称',
  'studio.gnb.group_myinfo.invitation.detailed_product_num': '商品数量',
  'studio.gnb.group_myinfo.invitation.detailed_btn_accept': '接受',
  'studio.gnb.group_myinfo.invitation.detailed_btn_reject': '拒绝',
  'studio.gnb.group_myinfo.join_req_btn_reject_msg': '是否拒绝团队邀请？',
  'studio.gnb.group_myinfo.join_req_btn_reject_cf': '拒绝',
  'studio.gnb.group_myinfo.join_req_btn_accept_msg': '是否接受团队邀请？',
  'studio.gnb.group_myinfo.join_req_btn_accept_cf': '接受',
  'studio.gnb.group_myinfo.join_req_reject_done_msg': '已拒绝团队邀请。',
  'studio.gnb.group_myinfo.join_req_accept_done_msg': '已接受团队邀请。',
  'studio.gnb.group_myinfo.join_req_btn_close': '关闭',
  'studio.gnb.group_myinfo.join_req_btn_visit_group': '访问团队',
  'studio.gnb.group_myinfo.join_req_unknown_err_msg': '请刷新或重试。',
  'studio.gnb.group_myinfo.join_req_join_req_withdrawn_msg': '此邀请请求已被取消。',
  'studio.group.home.notice': 'Studio公告',
  'studio.group.home.notice_no': '暂无添加的公告。',
  'studio.group.home.notice_read_more': '查看更多',
  'studio.group.home.board_type2_data1': '新成员已加入。',
  'studio.group.home.board_type4_data1': '同比上月 ',
  'studio.group.home.board_type5_plan_stt_released': '发布',
  'studio.group.home.board_type5_plan_stt_expected': '即将公开',
  'studio.group.notice.details_popup_title': 'Studio公告',
  'studio.group.notice.details_popup_download': '下载',
  'studio.member_manage.member.member_title.email_header': '邮箱',
  'studio.member_manage.member.guide4': '菜单权限',
  'studio.member_manage.member.guide5': '商品权限',
  'studio.member_manage.member.guide6': '邀请成员',
  'studio.member_manage.member.guide7': '授予菜单权限、商品权限',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use': '最大使用次数',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_guide': '更改使用次数时，如果已有成员超过更改后的次数，则该链接将无法使用。',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_def_100': '100次',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_1': '1次',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_5': '5次',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_10': '10次',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_25': '25次',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_50': '50次',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_n': '无限制',
  'studio.member_manage.member_invite.msg2': '邀请成员列表（1/50）',
  'studio.member_manage.member_invite.inviting_member_perm_btn': '权限',
  'studio.member_manage.member_invite.invite_btn': '邀请',
  'studio.member_manage.member_invite.invite_pop_msg': '已邀请成员。',
  'studio.member_manage.member_invite.email_add_step0_msg': '输入的邮箱对应到N个STOVE账号。<br/>请选择要邀请的账号。',
  'studio.member_manage.member_invite.email_add_step0_header2': '类型',
  'studio.member_manage.member_invite.email_add_step0_header3': '昵称',
  'studio.member_manage.member_invite.email_add_step0_cnf_btn': '确认',
  'studio.member_manage.member_invite.email_add_step0_alert1_msg': '已加入团队的账号无法邀请。',
  'studio.member_manage.member_invite.email_add_step0_alert2_msg': '该账号已收到团队邀请请求。',
  'studio.member_manage.role_manage_role_name_header1': '职责名称',
  'studio.member_manage.member_email_header1': '邮箱',
  'studio.member_manage.project_list_email_header2': '邮箱',
  'studio.member_manage.member_details_msg1': '邮箱',
  'studio.member_manage.member_details_remove_cf_btn': '移除',
  'studio.member_manage.member_details_save_alert_msg': '已保存。',
  'studio.member_manage.history_selbox_status_all': '状态：全部',
  'studio.prj_prod.this_prod.edit_display_show_msg0': '显示选项',
  'studio.prj_prod.this_prod.edit_display_show_exposed_btn': '显示',
  'studio.prj_prod.this_prod.edit_display_show_unexposed_btn': '隐藏',
  'studio.prj_prod.this_prod.edit_gamepreview_image_guide1': '{acceptFileExtAttributeLabel} \\| {size}MB以下',
  'studio.prj_prod.this_prod.edit_gamepreview_video_guide1': '{acceptFileExtAttributeLabel} \\| {size}MB以下',
  'studio.prj_prod.this_prod.edit_gamepreview_msg9_2': '可添加显示在一句话介绍上方的图片。',
  'studio.prj_prod.this_prod.edit_additional_requirements_component_val_msg': '请输入条目名称。 ',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_prj_name': '项目名称',
  'studio.mail.this_release_info_del_completed_detail_msg3': '根据STOVE运营政策，将保留已删除商品的销售记录及结算信息。',
  'studio.prj_prod.this_prod.home_product_setting_category_msg': '请选择代表类型。',
  'studio.member_manage.member_invite.email_add_btn': '添加',
  'studio.prj_prod.this_prod.home_product_setting_msg1': 'Demo',
  'studio.prj_prod.this_prod.home_product_setting_msg2': 'DLC',
  'studio.prj_prod.this_prod.home_product_setting_msg4': 'Utility',
  'studio.prj_prod_mngmt.popup_release_prod_exist_msg1': '包含正在发布的商品。',
  'studio.prj_prod_mngmt.popup_release_prod_exist_msg2': '请前往商品主页 > 停止发布后重试。',
  'studio.prj_prod_mngmt.btn_prod_del': '删除',
  'studio.prj_prod_mngmt.popup_prod_del_guide1': '删除商品',
  'studio.prj_prod_mngmt.popup_prod_del_guide2': '如需删除，请输入“DELETE”。 ',
  'studio.prj_prod_mngmt.popup_prod_del_guide3': '删除后将无法恢复。',
  'studio.prj_prod_mngmt.popup_prod_del_place_holder': 'DELETE',
  'studio.business_bank_setting.guide1_3': '<span>居民登记簿</span>',
  'studio.business_bank_setting.guide1_5': '<span>营业执照</span>',
  'studio.business_bank_setting.individual.select_birth_msg2': '只能输入数字。',
  'studio.business_bank_setting.individual.select_birth_msg3': '注册格式错误，请检查出生日期。',
  'studio.business_bank_setting.individual.info_global_o_btn_adress': '查找地址',
  'studio.business_bank_setting.individual.info_global_o_adress_box_place_holder3': '郡',
  'studio.business_bank_setting.individual.info_global_o_adress_box_place_holder4': '区',
  'studio.business_bank_setting.individual.info_global_o_adress_box_required_n': '请选择地址。',
  'studio.business_bank_setting.individual.btn_no_check': '查询',
  'studio.business_bank_setting.individual.btn_attach_alert1': '扩展名不同，无法上传。',
  'studio.business_bank_setting.individual.btn_attach_alert2': '文件超出容量限制，无法上传。',
  'studio.business_bank_setting.individual.game_production_no': '游戏制作（发行）业申报编号',
  'studio.business_bank_setting.individual.telecom_sales_no': '通信销售业申报编号',
  'studio.business_bank_setting.individual.nation_change_alert1': '更改国家信息时，将以最后一个国家信息为基准，完成审核后，于下个月1号进行变更处理。',
  'studio.business_bank_setting.individual.game_business_no_kr': '韩国营业执照号',
  'studio.gnb.common_2depth_metrics': '指标',
  'studio.gnb.group_myinfo.my_group.detailed_group_role_type': '类型',
  'studio.group.home.board_type10_select_box1': 'ACU',
  'studio.group.home.board_type10_select_box2': 'NRU',
  'studio.group.home.board_type10_select_box3': 'DAU',
  'studio.member_manage.member_invite.email_add_msg1': '已加入团队的账号无法邀请。',
  'studio.member_manage.member_invite.email_add_msg2': '该账号已收到团队邀请请求。',
  'studio.member_manage.member_invite.email_add_msg3': '该账号未在STOVE注册。',
  'studio.member_manage.member_invite.email_add_msg4': '请输入有效的邮箱地址。',
  'studio.member_manage.member_invite.email_add_msg5': '不能超过允许邀请的最大成员数。',
  'studio.member_manage.member_invite.msg4': '邀请的邮箱地址',
  'studio.member_manage.member_invite.msg5': '可以邀请已注册STOVE的用户加入Studio。只有已注册STOVE的用户会收到邀请邮件！',
  'studio.member_manage.member_invite.email_add_step1_msg1': '选择团队菜单权限',
  'studio.member_manage.member_invite.email_add_step1_msg2': '请选择要授予成员的团队菜单权限。',
  'studio.member_manage.member_invite.email_add_step1_all_check': '全选',
  'studio.member_manage.member_invite.email_add_step1_menuname_header1': '菜单名称',
  'studio.member_manage.member_invite.email_add_step1_view_header2': '查询',
  'studio.member_manage.member_invite.email_add_step1_edit_header3': '编辑',
  'studio.member_manage.member_invite.email_add_step1_msg3': '邮件/通知',
  'studio.member_manage.member_invite.email_add_step1_msg4': '关于具有此权限的商品，您将收到邮件或通知。',
  'studio.member_manage.member_invite.email_add_step1_msg5': '结算',
  'studio.member_manage.member_invite.email_add_step1_msg6': '审核',
  'studio.member_manage.member_invite.email_add_step1_msg7': '合同',
  'studio.member_manage.member_invite.email_add_step1_pro_btn': '继续',
  'studio.member_manage.member_invite.email_add_step2_msg1': '选择商品权限',
  'studio.member_manage.member_invite.email_add_step2_fullscreen_btn': '全屏',
  'studio.member_manage.member_invite.email_add_step2_msg2': '请选择要分配给成员的商品和职责。',
  'studio.member_manage.member_invite.email_add_step2_msg3': '必须选择至少1个权限。',
  'studio.member_manage.member_invite.email_add_step2_selbox_place_holder': '选择',
  'studio.member_manage.member_invite.email_add_step2_prjnproduct_header1': '项目与商品名称',
  'studio.member_manage.member_invite.email_add_step2_msg5': '将商品添加到团队时，所选职责将自动设置。',
  'studio.member_manage.member_invite.email_add_step2_pre_btn': '返回',
  'studio.member_manage.member_invite.email_add_step2_msg6': '暂无可授予权限的商品。<br/>团队中必须至少有1个商品。',
  'studio.member_manage.member_invite.email_add_step2_help_menuname_header1': '菜单名称',
  'studio.member_manage.member_invite.email_add_step2_help_perm_detail_header2': '编辑权限内容',
  'studio.member_manage.member_invite.email_add_step2_help_msg1': '管理中心设置',
  'studio.member_manage.member_invite.email_add_step2_help_msg2': '创建、修改、删除项目',
  'studio.member_manage.member_invite.email_add_step2_help_msg3': '创建、修改、删除商品',
  'studio.member_manage.member_invite.email_add_step2_help_msg4': '创建、修改、删除合集',
  'studio.member_manage.member_invite.email_add_step2_help_msg5': '创建、修改、删除社区',
  'studio.member_manage.member_invite.email_add_step2_help_msg6': '邀请成员、修改权限、移除成员',
  'studio.member_manage.member_invite.email_add_step2_help_msg7': '添加、修改、审核公司信息',
  'studio.member_manage.member_invite.email_add_step2_help_msg8': '添加、修改、审核银行信息',
  'studio.member_manage.member_invite.email_add_step2_help_msg9': '添加、修改、删除商品维护',
  'studio.member_manage.member.list_resend_invite_pop_msg': '将再次发送邀请请求到该邮箱。',
  'studio.member_manage.member.list_resend_invite_pop_resend_btn': '重新发送',
  'studio.member_manage.member.list_cancel_invite_pop_msg': '取消邀请请求。<br/>如果注册已在进行中，可能无法取消。',
  'studio.member_manage.member.list_cancel_invite_pop_close_btn': '关闭',
  'studio.member_manage.member.list_cancel_invite_pop_cancel_invite.btn': '取消邀请',
  'studio.member_manage.member.list_action_alert1_msg': '请刷新或重试。',
  'studio.member_manage.member.list_action_alert1_cnf_btn': '确认',
  'studio.member_manage.member.list_action_alert2_msg': '该成员已接受团队邀请。',
  'studio.member_manage.member.list_action_alert3_msg': '该成员已拒绝邀请。',
  'studio.member_manage.role_manage_modified_date_header2': '修改日期',
  'studio.build_rating_review.self_review.build_search_place_holder': '搜索',
  'studio.build_rating_review.self_review.build_search_none_registered_build': '尚无添加的构建。',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_example_title': '未成年人禁止使用示例',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_example_category': '种类',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_example_description': '内容',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type1_sexual': '煽情性',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type1_sexual_descr':
    '包含性暗示内容：臀部裸露、乳头展示、下体部分暴露，以及性行为暗示的声音效果',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type2_violence': '暴力性',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type3_violence_descr':
    '包含暴力血腥内容：组织损伤、内脏器官、肢体残缺，以及写实武器表现或大量血迹效果',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type3_horror': '恐怖',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type3_horror_descr':
    '包含NPC的血肉模型（包括肌肉组织、骨骼结构、血迹效果），恐怖犯罪场景（屠宰场景等），以及可能引起惊吓的元素',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type4_language': '语言',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type4_language_descr': '包含极端粗俗语言：严重的亵渎性语言、侮辱性词汇和过度粗俗用语',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type5_drug': '药物',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type5_drug_descr': '包含药物滥用内容：过度展示酒精、烟草、毒品等成瘾性物质',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type6_crime': '犯罪',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type6_crime_descr':
    '包含极端暴力内容：涉及绑架、性侵犯、性暴力、谋杀等行为的过度图像及文字描述',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type7_gambling': '赌博性',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type7_gambling_descr':
    '包含赌博元素：扑克、21点、花札等博彩活动，以及赌资系统（筹码、现金）的视觉表现',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_descr_sample':
    '示例）<br/>游戏类型：<br/><br/>游戏剧情：<br/><br/><br/>游戏介绍：<br/><br/>角色：',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed.rating_existed_new_reg_btn': '新建',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.dropbox_oldest_order': '按最早',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.review_info_title': '审核信息',
  'studio.prj_prod_mngmt.rating_build_review.see_history.case_no_data_msg': '暂无可查询得审核信息。 ',
  'studio.prj_prod_mngmt.rating_build_review.pre_release_change.case_info_mismatch_guide':
    '与商品设置中添加的信息（{fields}）不符。请删除最近审核完成信息后重新申请。',
  'studio.prj_prod_mngmt.rating_build_review.case_info_mismatch.rel_info_del_btn': '删除审核信息',
  'studio.prj_prod_mngmt.rating_build_review.case_info_mismatch.rel_info_del_cf_popup': '是否删除审核信息？<br/>删除后需要重新进行游戏分级审核。',
  'studio.prj_prod_mngmt.rating_build_review.case_info_mismatch.rel_info_del_cf_btn': '删除',
  'studio.notice.category_stu_notice': 'Studio公告',
  'studio.group.home.board_type2_mem_invite_mgmt_guide': '您可以邀请和管理团队成员。',
  'studio.group.home.board_type3_no_data2': '尚无已售出的商品。',
  'studio.common.popup_case_i_logout': '是否退出登录？<br/>退出登录后，未保存的内容将会丢失。',
  'studio.common.popup_case_logout_btn': '退出',
  'studio.common.footer.stu_usage_term': 'Studio使用条款',
  'studio.common.footer.stove_usage_term': '使用条款',
  'studio.common.footer.stu_personal_info_protection': '隐私政策',
  'studio.common.popup_case_ai_trans_failed': 'AI自动翻译失败。<br/>请重试或直接输入。',
  'studio.common.popup_case_ai_trans_required_field': '有必填项尚未填写。<br/>填写所有必填项，才能添加到发布计划。',
  'studio.ai_translation.badge': 'AI翻译',
  'studio.common.calendar_week_day.sun': '日',
  'studio.common.calendar_week_day.mon': '月',
  'studio.common.calendar_week_day.tue': '二',
  'studio.common.calendar_week_day.wed': '三',
  'studio.common.calendar_week_day.thurs': '四',
  'studio.common.calendar_week_day.fri': '五',
  'studio.common.calendar_week_day.sat': '六',
  'studio.prj_prod.this_prod.execution_setting_option_add_limit_popup': '最多可添加100个运行选项。',
  'studio.member_manage.member_details_role_setting_required_popup': '请选择职责。',
  'studio.group.collection.register_discount_rate_placeholder': '0',
  'studio.group.collection.register_discount_period_req_msg': '请输入优惠期限。 ',
  'studio.group.collection.register_discount_period_placeholder': '1~99',
  'studio.group.collection.list.details_save_completed_popup': '合集信息<br/>已保存。',
  'studio.build_mgmt.step_waiting': '等待中',
  'studio.build_mgmt.step_file_download': '正在下载文件',
  'studio.build_mgmt.step_file_scan': '正在扫描文件',
  'studio.build_mgmt.step_waiting_for_completion': '等待完成',
  'studio.build_mgmt.step_build_check': '正在检查构建',
  'studio.build_mgmt.step_make_build': '正在创建构建',
  'studio.build_mgmt.step_drm_apply': '正在应用DRM保护',
  'studio.build_mgmt.case_build_upload_error.db_gen_error_msg': '创建数据库时出现错误。<br/>请退出Uploader后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.path_check_error_msg': '检查路径时出现错误。<br/>请退出Uploader后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.previous_build_check_error_msg': '检查先前构建时出现错误。<br/>请退出Uploader后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.file_compare_error_msg': '对比文件时出现错误。<br/>请退出Uploader后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.storage_check_error_msg': '检查存储器时出现错误。<br/>请退出Uploader后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.file_list_gen_error_msg': '生成文件列表时出现错误。<br/>请退出Uploader后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.build_regist_error_msg': '上传构建时发生错误。<br/>请退出Uploader后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.upload_prep_error_msg': '准备上传时出现错误。<br/>请退出Uploader后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.upload_error_msg': '上传过程中出现错误。<br/>请退出Uploader后，重新尝试。',
  'studio.build_mgmt.case_build_upload_error.upload_complete_error_msg': '完成上传时出现错误。<br/>请退出Uploader后重，重新尝试。',
  'studio.build_mgmt.build_pipeline_common_error.unknown_error_msg':
    '发生未知错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord咨询Studio运营团队</a>。',
  'studio.build_mgmt.build_pipeline_common_error.process_prep_error_msg':
    '准备进程时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.vaccine_task_error.file_download_error_msg':
    '下载文件时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.vaccine_task_error.file_scan_error_msg':
    '扫描文件时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.vaccine_task_error.malicious_code_error_msg': '检测到恶意代码可疑文件。<br/>如需继续，请申请手动安全检查。',
  'studio.build_mgmt.vaccine_task_error.vaccine_task_impossible_error_msg': '检测到无法完成安全检查的文件。<br/>如需继续，请申请手动安全检查。',
  'studio.build_mgmt.make_build_task_error.build_check_error_msg':
    '检查构建时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.make_build_task_error.make_build_error_msg':
    '生成构建时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.make_build_task_error.drm_apply_error_msg':
    '应用DRM时发生错误。<br/>请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.build_mgmt.drm_maker_task_error.process_prep_error_msg': '准备进程时发生错误。',
  'studio.build_mgmt.drm_maker_task_error.prod_info_check_error_msg': '检查商品信息时发生错误。',
  'studio.build_mgmt.drm_maker_task_error.build_info_check_error_msg': '检查构建信息时发生错误',
  'studio.build_mgmt.drm_maker_task_error.file_check_error_msg': '检查文件时发生错误。',
  'studio.build_mgmt.drm_maker_task_error.storage_check_error_msg': '检查存储器时发生错误。',
  'studio.build_mgmt.drm_maker_task_error.drm_apply_error_msg': '应用DRM时发生错误。',
  'studio.build_mgmt.drm_maker_task_error.build_reconfig_error_msg': '重构构建时发生错误。',
  'studio.prj_prod.this_prod.product_data.build.home_product_key_tooltip_game_id': '游戏ID',
  'studio.prj_prod.this_prod.product_data.build.home_upload_alert_msg2': 'STOVE Uploader<br/>仅支持Windows操作系统。',
  'studio.build_mgmt.build_upload.existing_upload_guide_popup_title': '上传流程提示',
  'studio.build_mgmt.build_upload.existing_upload_guide_msg1': '检测到上传中断的构建。<br/>重新开始将导致该构建上传失败。',
  'studio.build_mgmt.build_upload.existing_upload_guide_msg2': '※仅可使用相同账号继续上传。',
  'studio.build_mgmt.upload_in_progress_exist_popup_msg1': '当前有正在上传的构建。<br/>是否重新开始上传？',
  'studio.build_mgmt.upload_in_progress_exist_popup_msg2': '※ 当前上传的构建将标记为失败。',
  'studio.build_mgmt.upload_terminate_btn': '结束',
  'studio.build_mgmt.upload_start_new_btn': '重新开始',
  'studio.build_mgmt.build_aborted_for_new_start_popup_msg': '由于在其他PC设备上启动上传，<br/>当前上传已取消。',
  'studio.build_mgmt.uploader.exe_impossible_guide_popup': '程序运行时出现问题。<br/>如问题持续，请咨询STOVE Studio运营者。',
  'studio.build_mgmt.uploader.exe_impossible_inquiry_btn': '咨询',
  'studio.build_mgmt.uploader.terminate_guide_popup': '是否关闭<br/>STOVE Studio Uploader？',
  'studio.build_mgmt.uploader.terminate_cf_btn': '结束',
  'studio.build_mgmt.uploader.error_retry_guide_popup': '发生错误。<br/>请稍后重试。',
  'studio.build_mgmt.uploader.info_not_found_guide_popup': '无法找到商品信息。<br/>请确认商品后重试。',
  'studio.build_mgmt.uploader.verified_info_expired_guide_popup': '用户身份验证信息更新失败。<br/>请重新运行Uploader。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_msg1': '正在创建文件列表……',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_msg2': '正在准备上传……',
  'studio.build_mgmt.uploader.guide_popup_path_not_found': '未找到文件。<br/>请重新选择文件夹路径。 ',
  'studio.build_mgmt.uploader.guide_popup_invalid_folder_file_name': '请确认要上传的文件夹和文件名。<br/>（不可使用\\ / : * ? ＂ < > \\|）',
  'studio.build_mgmt.uploader.guide_popup_invalid_file_exist': '存在无法上传的文件。<br/>请移除后重试。',
  'studio.build_mgmt.uploader.guide_popup_build_no_change': '未检测到更新文件。<br/>请检查文件后重试。',
  'studio.build_mgmt.uploader.guide_popup_inefficient_storage_msg1': '团队存储器容量不足。<br/>请删除未发布的构建后重试。',
  'studio.build_mgmt.uploader.guide_popup_inefficient_storage_msg2': '额外需<span class="lackingCapa"></span>存储空间',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt4_upload_completed': '上传成功。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_terminate_upload_btn': '上传终止',
  'studio.build_mgmt.build_upload_stt0_in_progress': '正在上传',
  'studio.prj_prod.this_prod.product_data.build.security_test_failed_learn_more_btn': '查看详情',
  'studio.build_mgmt.build_detail.pg_title': '构建详情',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_security_standard_tooltip':
    '应用DRM Maker时将采用高级安全设置，如应用失败请切换为常规模式后重试。',
  'studio.business_bank_setting.individual.info_passport_copy': '护照复印件',
  'studio.business_bank_setting.individual.info_passport_attach_guide': '请上传护照复印件。',
  'studio.business_bank_setting.individual.info_passport_copy_req_msg': '请上传护照复印件。',
  'studio.business_bank_setting.individual.query_req_msg': '请查询营业执照号。',
  'studio.file_upload.val_popup_size_exceed': '请检查文件大小。',
  'studio.file_upload.val_popup_select_one': '只能选择1个文件。',
  'studio.file_upload.val_popup_file_format_not_supported': '不支持的文件格式。<br/>请确认文件扩展名后再上传文件。',
  'studio.business_bank_setting.individual.upload_resident_req_msg': '请附上居民登记簿。',
  'studio.business_bank_setting.individual.game_production_no_kr_req_msg': '请附上游戏制作（发行）业注册证。',
  'studio.business_bank_setting.individual.telecom_sales_no_kr_req_msg': '请附上韩国通信销售业注册证。',
  'studio.business_bank_setting.individual.game_business_no_kr_req_msg': '请附上韩国营业执照。',
  'studio.business_bank_setting.account.question6_req_msg': '请附上存折复印件。',
  'studio.business_bank_setting.account.guide1': '账户信息用途说明',
  'studio.business_bank_setting.account.guide1_1': '输入的账户信息将用于销售款项的结算！',
  'studio.business_bank_setting.account.guide2': '如何修改账户信息？',
  'studio.business_bank_setting.account.guide2_1':
    '对于已完成结算和支付的情况，审核通过后将从下一结算日起转入新账户。<br/>可在结算菜单中查看结算明细。',
  'studio.business_bank_setting.list_stt_approve': '批准',
  'studio.business_bank_setting.list_stt_reject': '驳回',
  'studio.business_bank_setting.list_stt_in_review': '审核中',
  'studio.business_bank_setting.list_biz_type_indiv': '个人',
  'studio.business_bank_setting.list_biz_type_indiv_biz_owner': '个体经营者',
  'studio.business_bank_setting.list_biz_type_business': '法人企业',
  'studio.prj_prod_mngmt.storage_upload_done.popup_del_cf_btn': '删除',
  'studio.prj_prod_mngmt.prod_home.create_term.term_name_req_msg': '请输入条款管理名称。',
  'studio.prj_prod_mngmt.prod_home.create_term.eula_content_place_holder': '请输入条款内容',
  'studio.prj_prod_mngmt.prod_home.create_term.eula_content_req_msg': '请输入条款内容。',
  'studio.prod_home.pur_cond.select_prod_req_msg': '请选择商品。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_thumbnail_link': '缩略图{thumbnailSize}',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_file_thumbnail_guide': '* 未选择缩略图时将自动使用视频首帧！',
  'studio.prj_prod.this_prod.edit_summary_place_holder0': '请输入商品说明。',
  'studio.supported_lang.en': '英语',
  'studio.supported_lang.ko': '韩语',
  'studio.supported_lang.zh_tw': '繁體中文',
  'studio.supported_lang.zh_cn': '简体中文',
  'studio.supported_lang.ja': '日语',
  'studio.supported_lang.ge': '德语',
  'studio.supported_lang.fr': '法语',
  'studio.supported_lang.es': '西班牙语',
  'studio.supported_lang.pt': '葡萄牙语',
  'studio.supported_lang.vi': '越南语',
  'studio.supported_lang.id': '印度尼西亚语',
  'studio.supported_lang.th': '泰语',
  'studio.supported_lang.it': '意大利语',
  'studio.supported_lang.ru': '俄语',
  'studio.supported_lang.pt_br': '葡萄牙语（巴西）',
  'studio.prj_prod.this_prod.edit_additional_links_name_length_val_msg1': '链接标题必须介于1~35个字符之间。',
  'studio.prj_prod.this_prod.edit_additional_links_name_length_val_msg2': '链接标题必须介于1~15个字符之间。',
  'studio.prj_prod.this_prod.edit_additional_links_url_req_msg1': '请输入链接URL。',
  'studio.prj_prod.this_prod.edit_additional_links_url_length_val_msg1': 'URL必须在1~2000字符之间。',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_logo': '标志',
  'studio.prj_prod.this_proj.this_prod.list_kebab_delete_pop_msg_case2': '是否删除商品页面？',
  'studio.group.collection.guide1_1': '什么是合集？',
  'studio.group.collection.guide1_2':
    '合集功能允许您将团队内2至100个产品打包销售。<br/>如果商品组合中包含无法销售的商品，系统将自动排除这些商品后创建合集。',
  'studio.group.collection.guide2': '可构成合集的商品的条件有哪些？',
  'studio.group.collection.guide2_1': '仅可选择满足以下所有条件的商品：',
  'studio.group.collection.guide2_1_a': '团队内具有项目管理权限的产品',
  'studio.group.collection.guide2_1_b': '类型为游戏、Contents、Ultility、DLC的商品',
  'studio.group.collection.guide2_1_c': '处于预购中或正式发布状态的商品',
  'studio.group.collection.guide3': '已购买合集部分商品的玩家还能购买合集吗？',
  'studio.group.collection.guide3_1': '若已购买其中部分游戏，可仅购买尚未拥有的游戏，并按照合集优惠率计算价格。',
  'studio.group.collection.guide4': '如何设置合集价格？',
  'studio.group.collection.guide4_1': '可对组成商品的总售价指定优惠率并设置价格。如个别商品已应用优惠，则按商品优惠率 + 合集优惠率计算最终价格。 ',
  'studio.group.collection.guide5': '是否必须添加横幅图片？',
  'studio.group.collection.guide5_1':
    '横幅图片不属于必选项。<br/>添加横幅图片，STOVE商店运营者即可设置商品显示在商品目录页面。<br/>还可以让添加的商品在商品目录上更加显眼。',
  'studio.group.collection.del_prod_from_list_btn': '删除',
  'studio.group.collection.register_product_page_req_info_val': '商品页面有未填写的必填信息。',
  'studio.group.collection.register_sales_quantity_place_holder': '最多可输入1,000,000。',
  'studio.registration.email_title': '邮箱',
  'studio.registration.email_place_holder': '请输入邮箱',
  'studio.registration.email_req_msg': '请输入邮箱。',
  'studio.registration.email_invalid_msg': '邮箱格式错误。',
  'studio.registration.send_verification_code_btn': '发送验证码',
  'studio.registration.resend_verification_code_btn': '重新发送',
  'studio.registration.send_verification_code_completed_popup': '验证码已发送至输入的邮箱。',
  'studio.registration.verification_code_not_received_guide': '如未收到验证码，请查看邮箱的垃圾箱或点击重新发送按钮。',
  'studio.registration.verification_stt_complete': '验证成功',
  'studio.registration.verification_stt_failed': '验证失败',
  'studio.registration.verification_stt_code_expired': '验证过期',
  'studio.registration.verification_code_place_holder': '请输入验证码',
  'studio.registration.verification_code_req_msg': '请输入验证码。',
  'studio.build_run_test.lnb_stu_build_test': 'Studio构建测试',
  'studio.build_run_test.stu_redir_btn': '立即前往Studio',
  'studio.build_run_test.select_prod_guide': '请选择项目和商品。',
  'studio.build_run_test.select_pj_prod_dropbox_place_holder': '选择项目/商品',
  'studio.build_run_test.select_pj_prod.case_no_pj_msg': '无添加的项目。',
  'studio.build_run_test.select_pj_prod.case_no_prod_msg': '无添加的商品。',
  'studio.build_run_test.filter_search_by_prod_no': '商品编号',
  'studio.build_run_test.filter_search_by_build_no': '构建编号',
  'studio.build_run_test.no_search_results_msg': '未找到相关搜索结果。',
  'studio.build_run_test.no_access_per_msg1': '无该商品的访问权限。',
  'studio.build_run_test.no_access_per_msg2': '请在Studio成员管理中分配职责。',
  'studio.build_run_test.no_build_uploaded_msg1': '无可测试的构建。',
  'studio.build_run_test.build_list': '构建列表',
  'studio.build_run_test.build_list.header1_build_no': '构建No.',
  'studio.build_run_test.build_list.header2_build_descr': '构建说明',
  'studio.build_run_test.build_list.header3_build_stt': '构建状态',
  'studio.build_run_test.build_list.build_stt_test': '测试',
  'studio.build_run_test.build_list.build_stt_released': '发布',
  'studio.build_run_test.build_list.header4_release_stt': '发布状态',
  'studio.build_run_test.build_list.test_btn': '测试',
  'studio.back_to_list_btn': '前往列表',
  'studio.build_run_test.build_info': '构建信息',
  'studio.build_run_test.build_info1_grp': '团队',
  'studio.build_run_test.build_info2_prj_name': '项目名称',
  'studio.build_run_test.build_info3_prod_name': '商品名称',
  'studio.build_run_test.build_info4_prod_type': '商品类型',
  'studio.build_run_test.build_info5_build_no': '构建No.',
  'studio.build_run_test.build_info6_decsr': '说明',
  'studio.build_run_test.build_info7_reg_date': '创建日期',
  'studio.build_run_test.build_info8_build_stt': '构建状态',
  'studio.build_run_test.build_info9_release_stt': '发布状态',
  'studio.prj_prod.this_prod.release_details.opt_1to2_switch_popup': '是否要与构建一同正式发布？<br/>请输入除商品页面外的必要信息后申请检查。',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_period_place_holder': '1~99',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_rate_place_holder': '0',
  'studio.age-restriction-message':
    '未满14周岁无法使用Studio服务。<br/>详情请咨询<a href="{link}" class="font-medium underline">商店游戏客服中心</a>。',
  'studio.brand_page.sign_up_btn': '注册STOVE Studio',
  'studio.brand_page.sign_up_btn_alert': '请在PC环境进行注册。',
  'studio.brand_page.easy_and_fast_title': '尝试轻松便捷地<br/>在商店发布游戏吧！',
  'studio.brand_page.easy_and_fast_guide': '通过教程指引，即可高效便捷地完成游戏发布流程。<br/>将您自主开发的游戏上传至STOVE Studio平台吧。',
  'studio.brand_page.feature_preview': 'STOVE Studio功能一览',
  'studio.brand_page.global_service_guide0':
    '<span class="text-[#13D4FF] md:text-brand-primary">全球化游戏发行</span>更轻松<br/>AI翻译助力突破<br/>语言壁垒',
  'studio.brand_page.global_sevice_guide': '借助AI翻译解决方案让创作者轻松实现游戏全球化。',
  'studio.brand_page.global_sevice_interaction': '综合游戏平台STOVE商店！<br/>体验AI驱动的全球化服务。',
  'studio.brand_page.store_btn': '立即前往STOVE商店',
  'studio.brand_page.all_in_one_go_title': '从审核到营销，<br class="sm:hidden">STOVE Studio提供一站式服务！',
  'studio.brand_page.all_in_one_go_guide': '不再为游戏审核烦恼，<span class="text-brand-primary">STOVE Studio</span>全程协助',
  'studio.brand_page.stove_rating_title': 'STOVE Studio提供游戏分级评定支持',
  'studio.brand_page.stove_rating_guide': '每款游戏可获得约100万韩元的审核费用，并提供为期一个月的审核申请及补充材料支持。',
  'studio.brand_page.stove_marketing_title': '携手STOVE Studio，开启推广之旅',
  'studio.brand_page.stove_marketing_guide': '助力关键词推广、媒体投放、新闻稿发布，实现多维度曝光。',
  'studio.brand_page.stove_event_title': '零距离与玩家沟通',
  'studio.brand_page.stove_event_guide': '通过线下游戏活动支持，为您带来更多展示机会。',
  'studio.brand_page.game_indicator_title': '数据分析一目了然',
  'studio.brand_page.game_indicator_guide': '实时追踪收入、销量、访问量等核心数据。',
  'studio.brand_page.game_review_title': '与玩家互动，<span class="text-on-surface-elevation-1 md:text-brand-primary">收集游戏后记和意见</span>！',
  'studio.brand_page.game_review_guide': '在Lounge与所有玩家交流互动。通过#标签<span class="md:font-bold">发现了解玩家反馈，助力游戏优化！</span>',
  'studio.direct_stove_lounge_btn': '立即前往STOVE Lounge',
  'studio.brand_page.full_service_title1': '开发无忧，尽在STOVE Studio',
  'studio.brand_page.full_service_title2': '无需分心，专注创作',
  'studio.brand_page.full_service_guide': '为您提供PC客户端SDK、登录验证、商品结算、游戏服务等多样化平台开发工具。',
  'studio.direct_dev_guide_page_btn': '查看开发商指南',
  'studio.lnb.common_2depth_tutorial_video': '教程视频',
  'login.redirect-login-page': '移动至登录页面',
  'login.studio-redirect-brand-site': '移动至品牌页面',
  'studio.gnb.common_language_setting': '语言设置',
  'studio.common.lang_setting.invalid_char_val_msg': "- : [ ] . TM ® # ( ) ' ! ? • {'|'} & _ \"   ~ , < > * / 、。 ，以外的特殊字符无法使用。",
  'studio.redirect_prod_home_btn': '移动至商品主页',
  'studio.common.language_settings.pro_pg_ai_trans_badge': '显示AI翻译徽章',
  'studio.common.language_settings.pro_pg_ai_trans_tooltip': '请选择使用AI翻译的语言。<br/>商品页面将显示“AI翻译”徽章。',
  'studio.registration.redirect-login-page': '移动至登录页面',
  'studio.pro_prj_mgmt.prod_name_translating_guide': '商品正在创建。',
  'studio.prj_prod_mngmt.prj_prod_reg_done.release_prep_tooltip_tiltle': '前往商品主页！ ',
  'studio.prj_prod_mngmt.prj_prod_reg_done.release_prep_tooltip_msg': '点击列表移动至商品主页！<br/>可在商品主页准备发布。',
  'studio.event_period_settings.case1_pp_open_after_pre_purchase_start': '不得晚于预购开始日期。',
  'studio.event_period_settings.case2_pp_open_after_pre_purchase_end': '不得晚于预购结束日期。',
  'studio.event_period_settings.case3_pp_open_after_official_release': '不得晚于正式发布日期。',
  'studio.event_period_settings.case4_pp_open_after_limited_sale_end': '不得晚于限量销售结束日期。',
  'studio.event_period_settings.case5_pre_purchase_start_before_pp_open': '不得早于商品页面公开日期。',
  'studio.event_period_settings.case6_pre_purchase_start_after_pre_purchase_end': '不得晚于预购结束日期。',
  'studio.event_period_settings.case7_pre_purchase_start_after_official_release': '不得晚于正式发布日期。',
  'studio.event_period_settings.case8_pre_purchase_start_after_limited_sale_end': '不得晚于限量销售结束日期。',
  'studio.event_period_settings.case9_pre_purchase_end_before_pp_open': '不得早于商品页面公开日期。',
  'studio.event_period_settings.case10_pre_purchase_end_before_pre_purchase_start': '不得早于预购开始日期。',
  'studio.event_period_settings.case11_pre_purchase_end_after_official_release': '不得晚于正式发布日期。',
  'studio.event_period_settings.case12_pre_purchase_end_after_limited_sale_end': '不得晚于限量销售结束日期。',
  'studio.event_period_settings.case13_official_release_before_pp_open': '不得早于商品页面公开日期。',
  'studio.event_period_settings.case14_official_release_before_pre_purchase_start': '不得早于预购开始日期。',
  'studio.event_period_settings.case15_official_release_before_pre_purchase_end': '不得早于预购结束日期。',
  'studio.event_period_settings.case16_official_release_after_limited_sale_end': '不得晚于限量销售结束日期。',
  'studio.event_period_settings.case17_limited_sale_end_before_pp_open': '不得早于商品页面公开日期。',
  'studio.event_period_settings.case18_limited_sale_end_before_pre_purchase_start': '不得早于预购开始日期。',
  'studio.event_period_settings.case19_limited_sale_end_before_pre_purchase_end': '不得早于预购结束日期。',
  'studio.event_period_settings.case20_limited_sale_end_before_official_release': '不得早于正式发布日期。',
  'studio.calendar_event_period.val_msg_start_time_before_current_time': '公开日期不得早于当前时间。',
  'studio.group.collection.register_product_none_to_select': '无已添加的商品。',
  'studio.group.collection.collection_info': '合集信息',
  'studio.group.collection.collection_basic_info': '基本信息',
  'studio.group.collection.collection_basic_info1_prod_name': '商品名称',
  'studio.group.collection.collection_basic_info1_prod_name_place_holder': '请输入商品名称',
  'studio.group.collection.collection_basic_info1_prod_name_required': '请输入商品名称。',
  'studio.group.collection.collection_basic_info1_prod_name_duplicate': '商品名称重复。请输入其他商品名称。',
  'studio.group.collection.collection_basic_info1_prod_name_invalid':
    "- : [ ] . TM ® # ( ) ' ! ? • {'|'} & _ \"   ~ , < > * / 、。 ，以外的特殊字符无法使用。",
  'studio.group.collection.collection_basic_info2_publisher_name': '创作者姓名',
  'studio.group.collection.collection_basic_info2_publisher_name_place_holder': '请输入创作者姓名',
  'studio.group.collection.collection_basic_info2_publisher_name_required': '请输入创作者姓名。',
  'studio.group.collection.collection_basic_info3_distributor_name': '发行公司名称',
  'studio.group.collection.collection_basic_info3_distributor_name_place_holder': '请输入发行公司名称',
  'studio.group.collection.collection_basic_info3_distributor_name_required': '请输入发行公司名称。',
  'studio.group.collection.register_btn': '添加合集',
  'studio.group.collection.register_product_config_select_none_available_msg': '无法加载商品页面<br/>请确认商品页面状态。',
  'studio.group.collection.register_product_page_list_dir_btn': '商品页面',
  'studio.supported_features.single_player': '单人模式',
  'studio.supported_features.multi_player': '多人模式',
  'studio.supported_features.pvp': 'PvP',
  'studio.supported_features.cooperative': '合作',
  'studio.supported_features.vr_support': '支持VR',
  'studio.supported_features.controller_some_support': '部分支持游戏手柄',
  'studio.supported_features.controller_perfect_support': '完全支持游戏手柄',
  'studio.supported_features.cloud_saving': '云存储',
  'studio.supported_features.user_stat': '玩家能力值',
  'studio.supported_features.challenge': '挑战课题',
  'studio.supported_features.match_making': '匹配',
  'studio.supported_features.leader_board': '排行榜',
  'studio.supported_features.ingame_payment': '游戏内结算',
  'studio.tooltip.product_count': '商品数量',
  'studio.group.collection_list.filter_all': '全部',
  'studio.group.collection_list.filter_prod_pg_only': '商品页面',
  'studio.group.collection_list.filter_official_release': '正式发布',
  'studio.group.collection_list.filter_suspended_or_deleted': '停止/删除',
  'studio.group.collection.storage_select_popup_guide': '要在合集中使用存储器，必须选择项目。',
  'studio.group.collection.storage_select_prj_dropbox': '请选择项目。',
  'studio.group.collection.storage_select_prj_cf_btn': '选择',
  'studio.group.collection.storage_select_prj_required_msg': '请选择项目。',
  'studio.group.collection.storage_select_prj_none_popup': '无可使用的存储器。',
  'studio.group.collection.storage_search_no_result': '没有搜到结果。',
  'studio.group.collection.discount_case_registration_impossible': '发布前无法添加优惠选项。<br/>请在发布后重试。',
  'studio.member_manage.role_manage_reg_modified_date': '添加/修改日期',
  'studio.member_manage.role_manage_create_role_msg4': '获得发布权限的会员必须拥有全部权限。',
  'studio.common.search_place_holder': '搜索',
  'studio.business_bank_setting.individual.review_officer_info_guide1': '请输入负责审核游戏发布信息的团队内部联系人信息。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.biz_info_not_set_msg': '未设置公司信息无法审核。<br/><br/>请设置公司信息。',
  'studio.business_info_redirect_btn': '公司信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.prod_setting_not_completed_guide_popup': '未完成商品设置，无法审核。<br/><br/>请设置商品。',
  'studio.direct_prod_setting_pg_btn': '商品设置',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg3_duplicate': '商品名称重复。请输入其他商品名称。请确认多语言设置。',
  'studio.prj_prod.this_prod.home_product_setting_linked_product_exist_popup': '存在重复连接的商品。<br/>请刷新后重新连接。',
  'studio.product_setting.under_review_info_genre_representative': '主要',
  'studio.prj_prod.this_prod.edit_gamepreview_import_this_media_alert1': '请确认图片长*宽 尺寸。',
  'studio.pro_pg_edit.gamepreview_spotlights_video_thumbnail_required_msg': '请在添加缩略图后，输入视频URL。',
  'studio.pro_pg_edit.gamepreview_spotlights_video_link_guide': '视频链接仅支持YOUTUBE链接！',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_thumbnail_file': '缩略图860x483px（可选）',
  'studio.prj_prod.this_prod.edit_additional_links_stove_cs': 'STOVE客服中心',
  'studio.rating_build_review.self_review_req.qtn1_guide8': '玩家对战要素',
  'studio.rating_build_review.self_review_req.qtn1_guide8_1': '普通水平：<br/>可以进行对战，但没有损失时，不会掠夺对方货币',
  'studio.rating_build_review.self_review_req.qtn1_guide8_2': '轻微水平：<br/>对战有少量奖励和轻微损失时，玩家可能会获得或失去积分',
  'studio.rating_build_review.self_review_req.qtn1_guide8_3': '有限水平：<br/>玩家之间可进行对战，但需要进入专属PvP区域，或对战功能存在等级限制',
  'studio.rating_build_review.self_review_req.qtn1_guide8_4': '过度水平：<br/>PvP不受限制，对战失败者可能会被夺取经验值、道具或损失货币',
  'studio.rating_build_review.self_review_req.qtn3_guide2': '其他赌博性内容',
  'studio.rating_build_review.self_review_req.qtn3_guide2_1': '存在可使用现金或等同于现金的Cash进行玩家间交易或出售货币的拍卖行、交易所等场所。',
  'studio.rating_build_review.self_review_req.qtn6_guide': '毒品类词语',
  'studio.rating_build_review.self_review_req.qtn6_guide_1': '包含毒品类、强力胶、气体、致幻剂及幻觉效果。<br/>包含暗示毒品交易的现场、句子、词汇。',
  'studio.rating_build_review.self_review.under_review_stt_2_verifying': '审核中',
  'studio.rating_build_review.self_review.under_review_stt_3_verify_rejected': '审核驳回',
  'studio.rating_build_review.self_review.under_review_stt_4_verify_passed': '审核完成',
  'studio.rating_build_review.self_review.under_review_stt_5_reg_completed': '添加完成',
  'studio.prj_prod_mngmt.rating_build_review.edit_cf_msg1': '如果游戏已经发布，修改的分级信息将立即生效。',
  'studio.prj_prod_mngmt.rating_build_review.type_self_review': '自审等级分类',
  'studio.prj_prod_mngmt.rating_build_review.type_direct_input': '韩国分级编码',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_cancelled': '游戏分级取消',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_rejected': '拒绝游戏分级',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_revision_passed': '游戏分级申诉',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_revision_rejected': '游戏分级申诉驳回',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_register': '游戏分级提交',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_modify': '游戏分级修改',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_delete_msg': '游戏分级信息已删除。',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.global_rating_delete_msg': '国际分级编号已删除。',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_verify_rejected': '游戏分级驳回',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_revision_pass': '游戏分级内容修改申报',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_revision_reject': '游戏分级内容修改申报驳回',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_delete': '游戏分级删除',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_reclassification_adjusted': '游戏分级等级调整',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_reclassification_committee_adjusted': '游戏分级强制重新分级',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.global_rating_register': '国际分级编号注册',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.global_rating_modify': '国际分级编号修改',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.global_rating_delete': '国际分级编号删除',
  'studio.prj_prod.this_prod.product_data.build.home_guide1_1': '上传完成后，请刷新列表。',
  'studio.build_mgmt.list_reload_btn': '刷新列表',
  'studio.build_mgmt.uploader_running_alert': '正在运行Studio Uploader',
  'studio.build_mgmt.uploader_running_alert_msg1': '如未安装Uploader，请先下载并安装后再继续。',
  'studio.build_mgmt.uploader_running_alert_msg2': '若上传完成后仍看不到构建，请刷新页面。',
  'studio.build_mgmt.uploader_download_btn': '下载Uploader',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_guide_title': 'STOVE Studio Uploader安装指南',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_guide_msg': '已安装STOVE Studio Uploader。<br/>将删除已有程序并重新安装。',
  'studio.common.btn_yes': '是',
  'studio.build_mgmt.uploader_update_guide_popup_msg': '新版本已更新。<br/>必须完成更新才能运行上传器。',
  'studio.build_mgmt.uploader_update_btn': '立即更新',
  'studio.build_mgmt.uploader_update_ver_check_msg': '正在检查Uploader版本。<br>可能需要最多5分钟，请稍等！',
  'studio.build_mgmt.uploader_update_in_prog_msg': '更新中…',
  'studio.build_mgmt.uploader_update_error_msg': '更新过程中发生错误。<br/>请重启Uploader。<br/>※ 如持续出现该问题，请手动安装。',
  'studio.build_mgmt.uploader_update_error.manual_run_btn': '手动安装',
  'studio.build_mgmt.uploader_update_complete_msg': '更新已完成。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_file_upload_guide4': '若在构建列表中看不到已上传完成的构建，请刷新列表。',
  'studio.build_mgmt.uploader_build_no_change_msg': '与LIVE版本构建相比无更改项。<br/>请检查文件后重试。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_file_transfer_completed_msg': '文件上传完成！<br/>请在检查结束后进行测试。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide1_1':
    '绑定STOVE平台提供的STOVE PC SDK后，即可利用能力值、排名、挑战任务、匹配等游戏支持服务，还能查看玩家的游戏时长。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide2_1': '上传构建后，发布前请通过STOVE PC客户端确认游戏能否正常运行。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide3_1':
    '能力值会保存用户的活动数据并量化数值，用于提供排名和挑战任务，同时支持数据统计。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide5_1':
    '该服务确保游戏玩家在任何地区登录，都能享受低延迟时间的游戏体验，提供流畅稳定的游戏环境。',
  'studio.prj_prod.this_prod.product_data.build_msg': '测试和发布构建前请完成运行设置。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_failed_pop_msg2': '上传过程中出现错误。<br/>请删除记录后重新上传。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_failed_pop_msg3': '用户已取消。<br/>请删除记录后重新上传。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_msg1':
    '如果未联动STOVE PC SDK，请在正式发布前应用DRM Maker以保护游戏版权。<br/>如果已联动STOVE PC SDK，则无需应用DRM Maker。<br/>在SDK联动的情况下应用DRM Maker，可能会导致游戏无法正常安装。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_msg2': 'DRM Maker的应用可能需要1~3分钟才能完成。如果应用失败，请解除后重新应用。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_msg3': '因运行验证而导致超时时，请修改计时器。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_msg4': 'DRM Maker应用后，安装中出现错误时，请重新应用后再运行。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_msg5': '应用DRM Maker时，请选择并保存exe文件。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_timeout_sec': '秒',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.run_option_invalid_msg': '请重新设置运行选项，<br/>测试通过后再进行构建更新。',
  'studio.run_setting_pg_redirect_btn': '前往运行设置',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_required_msg': '请设置条款实施日期。',
  'studio.prj_prod_mngmt.prod_home.create_term.type1_detailed_guide':
    '安装商品时，输入的软件用户同意条款（EULA）内容将在客户端以如下方式向用户展示！',
  'studio.member_manage.history_status_declined_details': '{nickName}已拒绝加入。',
  'studio.member_manage.history_status_edit_depth_details_added_msg1': '{roleName}职责分配成功。',
  'studio.member_manage.history_status_edit_depth_details_added_msg2': '{perName}添加成功。',
  'studio.member_manage.history_status_edit_depth_details_added_msg2_2': '{perName1}、{perName2}添加成功。',
  'studio.member_manage.history_status_edit_depth_details_removed_msg1': '{roleName}职责删除成功。',
  'studio.member_manage.history_status_edit_depth_details_removed_msg2': '{perName}删除成功。',
  'studio.member_manage.history_status_edit_depth_details_removed_msg2_2': '{perName1}、{perName2}删除成功。',
  'studio.prj_prod.this_prod.home_search_recent': '最近搜索词',
  'studio.client_exe_in_prog.popup_title': '正在运行PC客户端',
  'studio.client_exe_in_prog.popup_msg': '如未安装客户端，<br/>请先下载并安装后再继续。',
  'studio.client_download_btn': '下载客户端',
  'studio.prj_prod.this_prod.release_stt_filter_none_check_guide': '需选择',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_page_required_msg': '请选择商品页面。',
  'studio.prj_prod.this_prod.release_details_with_build_title': '商品页面和构建将同时发布。',
  'studio.prj_prod.this_prod.review_status_pbar_msg2': '已提交检查请求。管理员检查完成之前，无法取消检查请求。',
  'studio.prj_prod.this_prod.release_details_release_plan_product_page_open_msg':
    '考虑到检查时间，商品页面公开日期最早可设置为1周后。在商品页面公开之前，可自由进行修改。',
  'studio.release_details.period_settings.end_before_start_val_msg1': '结束日期不得早于开始日期。请重新设置开始日期和结束日期。',
  'studio.release_details.period_settings.end_date_input_n_val_msg3': '请设置结束日期。',
  'studio.release_details.period_settings.end_date_after_official_release_val_msg4': '结束日期不得晚于正式发布日期。',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_y_guide': '游戏内商店已添加。',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_n_guide': '没有添加游戏内商店',
  'studio.release_details.build_prep.no_build_list_display_guide': '若在运行设置中将平台设置为Web，构建列表将不会显示。',
  'studio.event_period_settings.limit_sale_end_before_release_val_msg': '请将限量销售的结束日期设定在正式发布日期之后。',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_release_date_msg':
    '请输入玩家可购买、下载和运行游戏构建的正式发布日期。发布前可随时修改正式发布日期。',
  'studio.event_period_settings.case_pp_open_after_official_release': '正式发布日期不得早于商品页面公开日期。',
  'studio.release_info_settings.cannot_set_pre_purchase_msg': '商品页面公开日期和正式发布日期相同时，无法设置预购。',
  'studio.release_info_settings.cannot_set_early_access_msg': '商品页面公开日期和正式发布日期相同时，无法设置抢先体验文案。',
  'studio.home.release_timeline.prod_pg_item.release_plan_download_install_allow_n': '禁止下载安装',
  'studio.home.release_timeline.prod_pg_item.release_plan_exe_allow_n': '禁止运行',
  'studio.member_manage.member_details_group_owner_menu_permission_title': '选择团队菜单权限',
  'studio.member_manage.member_details_owner_product_permission_title': '选择商品权限',
  'studio.grp_prj_transfer.transfer_apply.receiver_email_required_msg': '请输入移交对象的邮箱。 ',
  'studio.grp_prj_transfer.transfer_apply.receiver_email_not_added_msg': '请添加移交对象的邮箱。',
  'studio.prod_home.pur_cond.pur_cond_prod_none': '可在发布后添加到购买条件商品中。',
  'studio.common.tutorial_video.tooltip': '教程',
  'studio.common.tutorial_video.first_entry_guide1': 'Studio教程视频',
  'studio.common.tutorial_video.first_entry_guide2': '观看各菜单教程视频<br />轻松便捷注册游戏！',
  'studio.brand_page.mobile_app_sign_up_alert': '请在PC环境下进行注册。',
  'studio.brand_page.feature1_main_title': '查看改版后Studio的全部功能',
  'studio.brand_page.feature1_sub_title': '来看看与原先的Studio相比有哪些变化吧！',
  'studio.brand_page.feature2_main_title': '注册、创建项目和商品',
  'studio.brand_page.feature2_sub_title': '注册并创建项目和商品',
  'studio.brand_page.feature3_main_title': '商品主页及商品设置',
  'studio.brand_page.feature3_sub_title': '了解商品主页功能，介绍商品设置。',
  'studio.brand_page.feature4_main_title': '预先公开商品页面',
  'studio.brand_page.feature4_sub_title': '预先公开商品页面，与用户展开互动吧！',
  'studio.brand_page.feature5_main_title': '上传构建版本并配置运行设置',
  'studio.brand_page.feature5_sub_title': '为您讲解上传构建版本、版本运行设置和PC客户端测试的全部流程！',
  'studio.brand_page.feature6_main_title': '添加公司银行信息，并获取自主评级',
  'studio.brand_page.feature6_sub_title': '为您介绍如何添加公司银行信息，并免费获取自主评级！',
  'studio.brand_page.feature7_main_title': '正式发布前，设置价格和条款',
  'studio.brand_page.feature7_sub_title': '为您介绍设置商品销售价格和设置服务所需条款的方法。',
  'studio.brand_page.feature8_main_title': '正式发布构建',
  'studio.brand_page.feature8_sub_title': '如果您已经准备好，就将最终构建上传并正式发布吧！',
  'studio.brand_page.feature9_main_title': '正式发布后，设置优惠及各功能更新',
  'studio.brand_page.feature9_sub_title': '为您介绍正式发布后商品页面、优惠等的更新方法。',
  'studio.discount.register_sales_quantity_req_msg': '请输入销售数量',
  'studio.prj_prod.this_prod.edit_gamepreview_add_img_required msg': '请添加图片。',
  'studio.prod_pg_edit.additional_info_item_name_required_msg': '请输入条目名称。 ',
  'studio.prod_pg_edit.additional_info_item_name_length_msg': '条目名称不得超过15个字。',
  'studio.prod_pg_edit.additional_info_min_spec_length_msg': '最低配置不得超过80个字。',
  'studio.prod_pg_edit.additional_info_recommended_spec_length_msg': '推荐配置不得超过80个字。',
  'studio.prj_prod.this_proj.this_prod.registered_edited_date_tooltip': '创建日期（编辑日期）',
  'studio.build_run_test.operator_review_pg.select_group': '选择团队',
  'studio.build_run_test.operator_review_pg.pre_search_def_guide': '请搜索商品编号或构建编号。',
  'studio.prj_prod.this_prod.execution_setting_basic_option_title': '默认运行选项',
  'studio.prj_prod.this_prod.execution_setting.option_change_guide':
    '通过Web平台保存时，<br/>已添加的构建和自主评级将被删除。<br/>是否更改为所选选项？',
  'studio.common.popup_case_change_short_btn': '更改',
  'studio.prj_prod.this_prod.execution_setting.option_change_to_pc_guide': '通过PC平台保存时，<br/>可上传构建。',
  'studio.prj_prod.this_prod.execution_setting.build_not_uploaded_msg': '未找到已完成上传的构建。<br/>请先上传构建后重试。',
  'studio.build_upload_btn': '上传',
  'studio.prj_prod.this_prod.execution_setting_option_final_run_file': '最终运行文件',
  'studio.prj_prod.this_prod.execution_setting_option_final_run_file_place_holder': '请输入最终运行文件',
  'studio.prj_prod.execution_setting_option_delete_pop_msg': '删除后保存，将无法恢复。<br/>是否删除所选选项？',
  'studio.prj_prod.execution_install_set_enabled_guide2_1':
    '商品发布前，可自由修改安装文件夹名称。用户安装商品时，输入的安装文件夹名称将被创建于C:\\Program Files\\Smilegate\\Games\\（安装文件夹名称）路径。',
  'studio.prj_prod.execution_install_set_enabled_guide2_2':
    '商品发布后，修改安装文件夹名称时，已安装的用户将维持原路径，仅对新安装的用户应用修改后的安装文件夹名称。',
  'studio.prj_prod.execution_exe_opt_enabled_guide4': 'PC平台',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_1_2':
    '-请输入已上传构建中游戏或Utility的可执行文件名(exe)。<br/><br/>若可运行文件位于子路径中，请正确填写完整文件夹路径，否则将无法启动！<br/>（例如：STOVE.exe，Smilegate\\STOVE.exe）',
  'studio.prj_prod.execution_exe_opt_enabled_guide5': 'Web平台',
  'studio.prj_prod.execution_exe_opt_enabled_guide6': 'Mobile平台',
  'studio.prj_prod.execution_exe_opt_enabled_guide_opt_name': '运行选项名',
  'studio.prj_prod.execution_exe_opt_enabled_guide_opt_name_content': '- 如果存在2个以上选项，请详细输入信息，便于用户选择运行选项并进行操作。',
  'studio.prj_prod.execution_exe_opt_enabled_guide_final_run_file': '最终运行文件',
  'studio.prj_prod.execution_exe_opt_enabled_guide_final_run_file_content':
    '- 如果运行文件与实际提供游戏的最终运行文件不同，请输入实际可运行的EXE文件名（包含子路径）。',
  'studio.prj_prod.execution_exe_opt_enabled_guide_web_opt_name': '运行选项名',
  'studio.prj_prod.execution_exe_opt_enabled_guide_web_opt_name_content': '- 如果存在2个以上选项，请详细输入信息，便于用户选择运行选项并进行操作。',
  'studio.build_mgmt_pg_redirect_btn': '前往构建管理',
  'studio.build_run_test.search_place_holder': '输入搜索词',
  'studio.build_run_test.no_build_uploaded_msg2': '如果已上传的构建未显示，<br />请确认Studio运行设置中是否已添加PC运行选项。',
  'studio.build_run_test.dlc_guide_1': '所选DLC安装完成后，在开启基础游戏后即可畅玩。',
  'studio.build_run_test.dlc_guide_2': '每个商品只能选择1个构建ID。<br />（DLC非必选）',
  'studio.build_run_test.dlc_list_filter.header1_select': '选择',
  'studio.build_run_test.dlc_list_filter.header2_prod_name': '商品名称',
  'studio.build_run_test.dlc_list_filter.header3_build_no': '构建编号',
  'studio.build_run_test.dlc_list_filter.header4_install_yn': '是否安装',
  'studio.build_run_test.dlc_intall_y': '安装完成',
  'studio.build_run_test.dlc_intall_n': '未安装',
  'studio.build_run_test.dlc_select_completed': '已选择',
  'studio.build_run_test.dlc_run_option': '运行选项',
  'studio.build_run_test.dlc_run_option_num': '共{totalOptNum}个',
  'studio.build_run_test.dlc_run_option_set_def_checkbox': '始终使用此选项启动',
  'studio.build_run_test.dlc_run_option_set_def_guide1': '启用此设置后，下次启动时将不再询问。',
  'studio.build_run_test.dlc_run_option_set_def_guide2': '可在游戏设置中随时更改此选项。',
  'studio.play_btn': '开始游戏',
  'studio.prj_prod.execution_install_set_enabled_guide1': '安装设置',
  'studio.prj_prod.execution_install_set_enabled_guide1_1': '请设置在STOVE PC客户端<br/>下载商品的安装路径。',
  'studio.lnb.prj_prod_mgmt.view_all_btn': '查看全部商品',
  'studio.ai_translation.guide1':
    "发布商品时，<span class='text-[#1355FF]'>请务必进行AI翻译，以便全球用户可以查看。</span><br/>使用AI翻译时，部分文本可能会出现遗漏或翻译不准确的情况，请检查各个标签页的翻译内容后再保存！",
  'studio.stu_logged_in.pre_grp_join.guide': '亲爱的创作者，<br/>欢迎使用Studio！',
  'studio.stu_logged_in.pre_grp_join.create_grp_msg3':
    '首次使用Studio时，您需要创建团队。<br/>团队是一个专门用于创作和游戏发布筹备的空间。<br/>如果您是代表，可以创建团队并邀请成员！',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_save_storage_btn_toast': '存储器保存成功！',
  'studio.prj_prod.execution_exe_opt_enabled_guide2_1':
    '根据所选平台将应用于 STOVE PC 客户端及商店的商品页面。<br/>发布后，平台的默认运行设置将无法更改，但可以修改详细设置。请注意，如果将错误信息应用到 LIVE 环境，可能会导致运行异常。<br/>请填写所有必填项，并在 STOVE PC 客户端中测试是否能正常运行。',
  'studio.prj_prod.execution_exe_opt_enabled_guide2_2': '※ 若为PC平台，请添加至默认运行选项。若仅输入Web平台，则需注册自定义评级才能发布。',
  'studio.prj_prod.this_prod.execution_setting_option_msg1':
    '若平台为PC，必须在默认运行选项正确输入必填项，测试STOVE PC客户端时才会显示在构建列表中。',
  'studio.prj_prod.this_prod.home_in_app_pur_cond_type_pc_set_n_to_go': '前往运行设置',
  'studio.prj_prod_mngmt.rating_build_review.self_review.execution_setting_not_completed_guide_popup':
    '未完成运行设置，无法审核。<br/><br/>请完成运行设置。',
  'studio.direct_Execution_setting_pg_btn': '运行设置',
  'studio.prj_prod_mngmt.rating_build_review.self_review.parent_game_exe_setting_not_completed_guide_popup':
    '未完成正式游戏的运行设置，无法审核。<br/><br/>请完成运行设置。',
  'studio.redirect_build_mgmt_btn': '前往构建管理',
  'studio.prj_prod_mngmt.rating_build_review.content_modify_completed_guide_msg': '审核已完成。<br/>请在构建管理中更新构建。',
  'studio.prj_prod.this_prod.home_in_app_pur_cond_type_pc_set_n': '当运行设置的默认运行选项<br/>为PC平台时可使用的菜单。',
  'studio.prj_prod.execution_install_new_guide_title1': '运行设置',
  'studio.prj_prod.execution_install_new_guide_main_des': 'Studio支持PC、Web平台。 ',
  'studio.prj_prod.execution_install_new_guide_sub_des1_1': 'PC ',
  'studio.prj_prod.execution_install_new_guide_sub_des2_1': 'Web ',
  'studio.prj_prod.execution_install_new_guide_sub_des3_1': 'Mobile ',
  'studio.prj_prod.execution_install_new_guide_sub_des4_1': '跨平台 ',
  'studio.prj_prod.execution_install_new_guide_sub_des1_2': '请设置与STOVE PC客户端兼容的构建运行选项。',
  'studio.prj_prod.execution_install_new_guide_sub_des2_2': '选择Web时，请输入可访问<br/>并进行网页游戏的URL。',
  'studio.prj_prod.execution_install_new_guide_sub_des3_2': '请输入可用于在Google Play或App Store下载的URL。',
  'studio.prj_prod.execution_install_new_guide_sub_des4_2': '请先将默认平台设置为PC，再点击添加选项，包含Web。',
  'studio.prj_prod.execution_install_new_guide_pc_title': '平台：PC',
  'studio.prj_prod.execution_install_new_guide_pc_main_title1': '运行文件',
  'studio.prj_prod.execution_install_new_guide_pc_sub_des1': '请输入exe文件名以便在PC客户端中运行构建。（例如：运行文件.exe）',
  'studio.prj_prod.execution_install_new_guide_pc_sub_des2': '若运行文件位于子路径中，请正确输入包含文件夹路径的完整地址。',
  'studio.prj_prod.execution_install_new_guide_pc_sub_des3': '例如：上级文件夹\\运行文件.exe',
  'studio.prj_prod.execution_install_new_guide_pc_main_title2': '最终运行文件',
  'studio.prj_prod.execution_install_new_guide_pc_sub1_des1': '如果PC客户端运行文件与构建默认运行文件不同，请输入最终执行的文件名。',
  'studio.prj_prod.execution_install_new_guide_pc_sub1_des2': '请与默认运行文件保持一致，输入完整的运行文件名或子路径。',
  'studio.prj_prod.execution_install_new_guide_pc_main_title3': '参数值',
  'studio.prj_prod.execution_install_new_guide_pc_sub2_des1': '若执行运行文件时需要通过命令行传递参数，请输入相关参数值。',
  'studio.prj_prod.execution_install_new_guide_pc_main_title4': '工作路径',
  'studio.prj_prod.execution_install_new_guide_pc_sub3_des1': '若执行运行文件所需的文件位置不同，请输入该文件的路径。',
  'studio.prj_prod.execution_install_new_guide_pc_main_title5': '进程文件',
  'studio.prj_prod.execution_install_new_guide_pc_sub4_des1': '对于安装文件与运行文件分开的构建，请输入实际的运行文件名。',
  'studio.prj_prod.execution_install_new_guide_pc_main_title6': '必需程序',
  'studio.prj_prod.execution_install_new_guide_pc_sub5_des1': '请选择PC客户端运行游戏所需的必备程序。 ',
  'studio.prj_prod.execution_install_new_guide_pc_sub5_des2': '未选择必备程序时，构建有可能无法正常运行。',
  'studio.prj_prod.execution_install_new_guide_set_title': '安装设置',
  'studio.prj_prod.execution_install_new_guide_set_main_title1': '安装文件夹',
  'studio.prj_prod.execution_install_new_guide_set_sub_des1': '请输入在STOVE PC客户端下载构建后，安装到用户PC的路径。',
  'studio.prj_prod.execution_install_new_guide_set_sub_des2':
    '默认安装路径<br/>C:\\Program Files\\Smilegate\\Games\\（安装文件夹名），只需输入安装文件夹名即可。',
  'studio.prj_prod.execution_install_new_guide_client_title': 'STOVE PC客户端设置',
  'studio.prj_prod.execution_install_new_guide_client_main_title1': '安装后Windows商品运行图标',
  'studio.prj_prod.execution_install_new_guide_client_sub_des1': '玩家安装游戏后，用作Windows桌面图标的图片。',
  'studio.prj_prod.execution_install_new_guide_client_sub_des2': 'ICO图标可参考下方指南。',
  'studio.prj_prod.execution_install_new_guide_client_main_title2': 'STOVE PC客户端商品缩略图',
  'studio.prj_prod.execution_install_new_guide_client_sub1_des1': '添加的商品商标将在STOVE PC客户端左侧的STOVE游戏菜单或收藏菜单中向玩家显示。',
  'studio.prj_prod.execution_install_new_guide_client_main_title3': 'STOVE PC客户端主要推荐图片',
  'studio.prj_prod.execution_install_new_guide_client_sub2_des1': '请添加当商店管理员将创作者的游戏选为主页推荐时要展示的图片。 ',
  'studio.prj_prod.execution_install_new_guide_web_title': '平台：Web',
  'studio.prj_prod.execution_install_new_guide_web_main_title1': '运行URL ',
  'studio.prj_prod.execution_install_new_guide_web_sub_des1': '请输入可运行Web游戏的URL或Web游戏官网URL。',
  'studio.prj_prod.execution_install_new_guide_web_sub_des2': '点击STOVE PC客户端底部面板的开始游戏按钮后，Web游戏将在网页浏览器中启动。',
  'studio.prj_prod.execution_install_new_guide_mobile_title': '平台：Mobile',
  'studio.prj_prod.execution_install_new_guide_mobile_main_title1': '运行URL',
  'studio.prj_prod.execution_install_new_guide_mobile_sub_des1': '请输入可运行Web游戏的URL或Web游戏官网URL。',
  'studio.prj_prod.execution_install_new_guide_mobile_sub_des2': '商品页面显示商店图片，点击后将跳转至可下载输入的游戏的商店页面。',
  'studio.prj_prod.execution_install_new_guide_pc_2_opt_name':
    '如果默认运行选项设置为PC，并已追加设置PC运行选项，请输入运行选项名，指定点击开始按钮时要运行的文件。',
  'studio.prj_prod_mngmt.guide1': '如果想发布商品，请先创建项目和商品。',
  'studio.prj_prod_mngmt.guide2': '项目可整合管理多个商品，并用于合同签订及结算。',
  'studio.prj_prod_mngmt.guide3': "选择类型并添加商品，将<span class='text-brand-primary font-medium'>生成商品主页</span>。",
  'studio.prj_prod_mngmt.guide4': '添加项目和商品后，在商品主页准备销售吧！',
  'studio.prj_prod.this_prod.home_sales_title_type_msg': 'Demo不提供价格与优惠。',
  'studio.prj_prod.this_prod.stt_build_live': '构建应用至LIVE',
  'studio.prj_prod.restriction_criteria_operation_error': '操作错误',
  'studio.prj_prod.restriction_criteria_other': '其他',
  'studio.prod_home.release_option_select_guide': '请选择发布方式。',
  'studio.prod_home.release_option1_official_rel':
    "<span class='text-brand-primary font-bold'>商品页面和构建</span><span class='text-on-surface-elevation-1 font-bold'>将同时发布。</span>",
  'studio.prod_home.release_option1_descr': '准备好所有发布所需的事项了吗？<br/>您可以制定预发布、抢先体验等计划来销售商品。',
  'studio.prod_home.release_option2_prod_pg_only':
    "<span class='text-on-surface-elevation-1 font-bold'>仅公开</span><span class='text-brand-primary font-bold'>商品页面。</span>",
  'studio.prod_home.release_option2_descr': '您可以将商品标记为即将发布，提前宣传，<br/>并通过社区与玩家沟通。',
  'studio.release_status.view_btn': '查看发布情况',
  'studio.release_status.release_prep_btn': '准备发布',
  'studio.prod_page.immediate_apply_msg': '是否立即应用到商品页面？',
  'studio.prod_page.scheduled_apply_msg': '是否应用商品页面预约？',
  'studio.prod_page.live_page_duplicate_completed_alert': '商品页面已复制。<br/>编辑需要修改的项目后，输入开始日期并点击保存按钮即可应用至LIVE。',
  'studio.prod_page.under_review_page_edit_alert_msg': '可复制并编辑检查中的商品页面。<br/>是否前往已复制的商品页面进行编辑？',
  'studio.prod_page.suspended_page_edit_alert_msg': '可复制并编辑已结束的商品页面。<br/>是否前往已复制的商品页面进行编辑？',
  'studio.business_bank_setting.account.btn_save_alert3': '正在审核银行信息。<br/>请重新查看审核申请内容。',
  'studio.reject_type.product_setting': '商品设置',
  'studio.reject_type.product_page': '商品页面',
  'studio.reject_type.price': '价格',
  'studio.reject_type.build_rating': '构建/游戏分级',
  'studio.reject_type.etc': '其他',
  'studio.rating_review.included_content_none': '无',
  'studio.rating_build_review.rating_teenager_restricted': '未成年人禁止使用',
  'studio.prod_home.release_price_info.discount_plan': '即将发布优惠',
  'studio.grp_home.direct_prj_reg_page': '前往创建项目',
  'studio.prj_prod_mngmt.product_reg_tooltip_title': '请添加商品！',
  'studio.prj_prod_mngmt.product_reg_tooltip_msg1': '添加商品后，将生成商品主页！',
  'studio.prj_prod_mngmt.product_reg_tooltip_msg2': '可在商品主页准备发布。',
  'studio.prj_prod_mngmt.product_reg_completed_tooltip_title': '商品已创建！',
  'studio.prj_prod_mngmt.product_reg_completed_tooltip_msg1': '点击创建的商品即可前往商品主页。',
  'studio.prj_prod_mngmt.product_reg_completed_tooltip_msg2': '可在商品主页准备发布。',
  'studio.prj_prod_mngmt.storage_header_limit_guide': "<p class='text-center'>超过可用容量时，将限制文件上传。<br>请删除不需要的文件。</p>",
  'studio.file_upload.name_max_length_exceed_msg': '文件名需少于50个字符（不含扩展名）<br/>才可以上传。',
  'studio.prod_page.live_page_edit_guide': '{releaseStatus}状态的商品页面。点击编辑按钮就可以编辑复制的商品页面。',
  'studio.edit.btn': '编辑',
  'studio.prod_page.live_page_edit_alert_msg': '可以复制当前LIVE中的商品页面<br/>进行编辑。<br/>是否要在复制的商品页面上进行编辑？',
  'studio.release_list.no_record_msg1': '可在日历中查看发布时的检查状况和历史。',
  'studio.release_list.no_record_msg2': '正式发布后，优惠、构建等更新日程将自动反映在日程表中，方便查看！',
  'studio.release_details_product_page_community_opened_msg': '社区已公开。',
  'studio.prj_prod.this_prod.stt_pre_release': '发布前',
  'studio.release_case_parent_product_verify_pass_n.cannot_request_review_msg':
    '本商品未通过检查。<br/>本商品先通过检查后，才能申请检查下级关联商品（DLC, Utility, Demo）。',
  'studio.event_period_settings.case_a_child_before_parent_pre_purchase_alert':
    '上级商品（Game）的预购日期必须与下级商品（{prodName}）的预购日期（{prePurchaseStartTime}）相同或略早。',
  'studio.event_period_settings.case_a_child_before_parent_official_release_alert':
    '上级商品（Game）的正式发布日期必须与下级商品（{prodName}）的正式发布日期（{releaseStartTime}）相同或略早。',
  'studio.event_period_settings.case_b_child_before_parent_pre_purchase_alert':
    '必须与上级商品（{prodName}）的预购日期（{prePurchaseStartTime}）相同或略晚。',
  'studio.event_period_settings.case_b_child_before_parent_official_release_alert':
    '必须与上级商品（{prodName}）的正式发布日期（{releaseStartTime}）相同或略晚。',
  'studio.release_stt_pbar.sale_suspended_guide.case_page_build': '已停止销售。您可以恢复销售或者前往项目和商品管理页面进行删除。',
  'studio.release_stt_pbar.release_info_del_requested': 'STOVE运营者批准删除后，发布信息将被删除。',
  'studio.release_stt_pbar.user_report_release_suspended_msg': '由于<span>{reportedReason}</span>，已停止发布。',
  'studio.release_stt_pbar.restrict_case_cs_contact_guide':
    '请确认限制理由后，修改相关功能并点击应用至LIVE按钮进行更新！<br/>反映到商店后，可通过<a class="underline" href="https://cs.onstove.com/service/STOVE_INDIE_CS/contact" target="_blank">客服中心（点击）</a>或前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.release_stt_pbar.operator_restrict_release_suspended_msg': '由于<span>运营者{restrictType}</span>，已停止发布。',
  'studio.release_details.build_prep.rating_input_n_guide': '若在运行设置中将平台注册为Web，请在游戏分级及构建审核菜单中查询分级编码后进行设置。',
  'studio.prj_prod_mngmt.case_transfer_in_progress.cannot_delete_alert': '团队移交状态下<br/>无法删除项目或商品。',
  'studio.transfer.mgmt_history.case_transfer_in_progress_alert': '正在进行团队移交。<br/>无法申请移交。',
  'studio.early_access.popup_case_lang_setting_input_required': '输入抢先体验提示后<br/>可设置多语言。<br/>请输入内容后重试。',
  'studio.file_upload.case_unsupported_format_msg': '不支持的文件格式。请先确认文件扩展名后，再上传文件。',
  'studio.group.collection.register_plan_official_release_date_guide':
    '请输入玩家可购买、下载和运行游戏构建的正式发布日期。<br/>发布前可随时修改正式发布日期。',
  'studio.prj_prod_mngmt.del_req_x_on_sale_guide2':
    '请先<span class="text-[3B3D45] font-bold">停止销售</span>并<span class="text-[3B3D45] font-bold">停止公开商品页面</span>后，再申请删除！',
  'studio.prj_prod_mngmt.prod_stt_page_and_sale_suspended': '停止公开商品页面<br/>停止销售',
  'studio.prj_prod_mngmt.suspend_to_delete_guide_msg':
    "请先将状态更改为<span class = 'text-on-surface-elevation-2 font-medium'>停止公开商品页面</span>后<br/>再申请删除！",
  'studio.prj_prod_mngmt.rating_product_review.content_modify_completed_guide_msg': '审核已完成。<br/>商品信息已更新。',
  'studio.group.home.board_metrics_no data_msg': '暂无商品数据。',
  'studio.file_upload.count': '{fileName}外{remainingFileNum}个',
  'studio.early_access.no_change_msg': '抢先体验文案未做修改。<br/>请修改后点击保存。',
  'studio.build_rating_review.details_edit_btn': '修改',
  'studio.rating_build_review.self_review.appeal_rating_request_not_equal_expected_msg1':
    "<span class = 'text-on-surface-elevation-1 font-bold'>您选择了{changRequestRating}，<br/>但根据问卷回答结果预估分级为</span><span class = 'text-tint-red-a400 font-bold'>{surveyExpectedRating}。</span>",
  'studio.rating_build_review.self_review.appeal_rating_request_not_equal_expected_msg2':
    '所申请的分级与预估分级不一致时无法提交审核申请，<br/>请确认问卷后重新申请。',
  'studio.prj_prod.this_prod.release_details_product_page_option_store_community_msg3': '社区已公开。',
  'studio.rating_build_review.case_launch_setting_web.cannot_request_self_review_msg':
    '运行设置为WEB时 无法进行自主审核。<br/>请在详细信息中修改游戏分级信息。',
  'studio.group.collection.apply_prod_info_to_collection_popup': '是否将此商品的页面信息应用到合集？',
  'studio.transfer.mgmt_history.case_no_product_registered_alert': '必须发布至少1个商品<br/>才能移交团队和项目。',
  'studio.prj_prod_mngmt.child_prod_exist_cannot_del': '有关联的子商品。<br/>请先解除子商品关联后再继续！',
  'studio.prj_prod_mngmt.popup_suspend_sale_guide': '若要停止销售，请输入“SUSPEND”。<br/>停止销售后，商品将以停售状态显示在商店中。',
  'studio.prj_prod.this_prod.stt_release_sale_suspended_guide': '若要停止销售，请输入“SUSPEND”。<br/>停止销售后，商品将以停售状态显示在商店中。',
  'studio.prj_prod_mngmt.page_open_cannot_del_msg': '请先将状态更改为<span class="text-[3B3D45] font-bold">停止公开商品页面</span>后再申请删除！',
  'studio.prj_prod_mngmt.on_sale_cannot_del_msg':
    '商品仍在销售中。<br/>请先将状态更改为<span class="text-[3B3D45] font-bold">停止销售</span>后再申请删除！',
  'studio.prj_prod_mngmt.transfer_in_progress_cannot_del_msg': '当前有正在移交的商品，<br/>因此已停止销售。<br/>请在移交完成后重试。',
  'studio.group.home.select_product.guide': '可选择已公开页面或正式发布的商品显示于管理中心。<br/>选定的商品可通过拖拽自由更改显示顺序！',
  'studio.group.home.board_type3_no_data1': '正式发布后，可查看商品的累计销售数量和购买转化率！',
  'studio.group.home.board_type6_no_data1_before': '正式发布后，可查看购买用户的评价和评论！',
  'studio.group.home.board_type7_no_data1_before': ' 商品发布后，可查看在社区中发布的帖子和评论！',
  'studio.group.home.board_type8_no_data1_before': '可查看在Lounge中以商品名称设置的代表标签被提及的情况！',
  'studio.group.home.board_type9_no_data1_before': '商品发布后，可查看在商店中被列入心愿单的次数！',
  'studio.group.home.board_type10_no_data1': '商品发布后，可查看商品页面访问量和登录游戏用户数！',
  'studio.group.home.board_type5_no_data1': '商品发布后，',
  'studio.group.home.board_type5_no_data2': '日程将根据发布计划显示！',
  'studio.prod_page.ready_page_edit_alert_msg': '可复制并编辑即将应用的商品页面。<br/>是否要在复制的商品页面中进行编辑？',
  'studio.group_transfer_in_progress.no_action_allowed_msg': '团队移交期间所有功能皆无法使用。<br/>请向团队负责人确认。',
  'login.studio-login-title': 'STOVE Studio登录',
  'login.studio-login-contents': '可使用STOVE账号登录STOVE Studio。<br/>非STOVE会员请先注册STOVE账号。',
  'login.studio-login-id-placeholder': '请输入邮箱地址。',
  'login.studio-login-pw-placeholder': '请输入密码。',
  'login.studio-login-signup': 'STOVE会员注册',
  'verification.need-check-age-title': '需要验证年龄。',
  'verification.start-verify-age': '请完成身份验证以确认年龄。',
  'verification.use-studio-verification': 'Studio服务仅限已完成身份验证的用户使用。',
  'verification.enter-birth-date': '请输入出生日期。',
  'verification.service-limit-for-age': '输入出生日期后，可能会根据年龄限制服务使用。',
  'studio.not-use-service': '无法使用服务。',
  'login.no-stove-account': '未找到已注册的STOVE账号信息。<br/>请前往STOVE会员注册页面完成注册后再登录。',
  'login.incorrect-stove-account': '与STOVE账号信息不符。<br/>请重新输入邮箱或密码。',
  'login.cancel-studio-signup': '是否取消Studio注册？<br/>取消后输入的内容将会消失。',
  'verification.age-restriction': '抱歉，<br/>未满14周岁无法使用Studio服务。',
  'login.already-studio-account': '该账号已注册Studio。<br/>请通过邮箱或快捷登录重新登录。',
  'studio.page.index.transfer_member.invalid_member_email_contents':
    '已登录其他账号。<br><br>登录的账号与接受移交申请的邮箱信息不一致。<br>请退出后使用接受移交申请的邮箱信息进行登录。 ',
  'studio.page.index.transfer_member.invalid_link':
    '邮箱无效。<br><br>收件邮箱<br>的邮件已过期<br>或已完成验证，无法找到想要的页面。<br>请重新确认。',
  'studio.build_rating_review.awaiting_rating_info_exist_msg1': '有待审核的游戏分级信息。',
  'studio.build_rating_review.awaiting_rating_info_exist_msg2': '提交内容修改申报后，待审核的游戏分级信息将被删除。',
  'studio.group_transfer.transfer_impossible_items_exist_msg': '存在无法移交的项目或商品，无法申请移交。',
  'studio.group_transfer.transfer_requested_prj_exist_msg': '有项目收到了移交审核请求。<br/>在移交完成或拒绝移交后方可申请团队移交。',
  'studio.group_transfer.prj_transfer_in_progress_4958_msg': '项目移交期间所有功能皆无法使用。<br/>请向团队负责人确认。',
  'studio.release_stt_pbar.operator_review_restrict':
    '因运营者<span>{restrictionType}</span>而暂停发布。请前往游戏分级与构建审核页面查看详情，并申请检查。',
  'studio.release_checklist.early_access_setting': '显示抢先体验文本',
  'studio.common.preview_btn': '预览',
  'studio.release_info.discount_setting_title': '优惠设置',
  'studio.release_info.discount_setting_guide':
    '正式发布检查完成后才能激活优惠菜单。如果在发布计划中设置了预购，则在预购期间内设置的优惠将被自动应用。',
  'studio.pre_purchase_settings.case_child_used_parent_set_unused_msg':
    '关联到上级商品（Game）的商品已设置为预购状态。<br/>请先将关联商品的预购设置更改为“未使用”后再行修改！',
  'studio.pre_purchase_settings.case_parent_unused_child_set_used_msg': '上级商品（Game）必须处于预购状态，方可将关联商品设置为预购！',
  'studio.release_info_del_requested.cannot_resume_sale_msg': '在申请删除商品的状态下无法使用该功能。<br/>请取消删除申请后再使用！',
  'studio.product_page.gamepreview_my_home': '个人主页',
  'studio.product_page.gamepreview_my_home_game_list': '已有游戏',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_other': '商品信息',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.bug_fix': 'Bug修复',
  'studio.discount.verify_not_passed.cannot_access_msg': '正式发布构建并完成运营者检查后，方可使用优惠菜单。',
  'studio.grp_home.release_step1_prj_prod_reg': '请添加项目和商品',
  'studio.grp_home.release_step2_release_prep': '请创建要在商店发布的商品页面',
  'studio.grp_home.release_step3_build_upload': '请上传构建',
  'studio.grp_home.release_step4_release': '请发布并销售商品',
  'studio.prj_prod_mngmt.rating_build_review.edit_no_change_msg': '没有变更内容。<br/>已保存当前内容。',
  'studio.registration.close': '继续',
  'studio.registration.do-later': '取消注册',
  'studio.prj_prod.this_prod.home_build_case_web_mobile_msg': 'Web版不提供构建。',
  'studio.build_rating_review.revision_already_in_progress_msg':
    '当内容修改申报或申诉申请正在审核中，或强制重新分级或分级调整处理正在进行时，您无法提交请求。<br/>请在处理完成后再提交请求！',
  'studio.prj_prod.execution_setting_option_requirements_title': '运行构建所需的必备程序',
  'studio.event_period_settings.case_earlier_than_current_time_msg': '发布计划时间设置为过去时间。<br/>请修改为当前时间之后再保存！',
  'studio.prj_prod_mngmt.review_restricted_case_display': '审核限制（展示）',
  'studio.prj_prod_mngmt.review_restricted_case_run': '审核限制（运行）',
  'studio.post_release_exe_opt_update.drm_not_applied_msg': '未应用DRM。<br/>请在该构建详情中应用DRM！',
  'studio.post_release_exe_opt_update.invalid_exe_file_msg': '运行文件（或最终运行文件）请输入包含在DRM列表中的EXE文件路径！',
  'studio.home_early_access_cs_contact_alert':
    '正式发布后无法显示抢先体验文案。<br/>如需显示，请前往<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord</a>咨询Studio运营者。',
  'studio.group.home.label_group_mem_count': '团队成员 {grMemCount}',
  'studio.execution_setting_option.exe_file_invalid_msg': '请输入包含在DRM列表中的EXE文件路径。 ',
  'studio.group.collection.register_product_config_guide':
    "发布后添加合集商品<span class='text-on-surface-elevation-2'>需要约10分钟才能在商店中显示</span>。",
  'studio.prod_page.once.language_sample_tooltip_box': '尝试添加各语言版本的图片吧！',
  'studio.prj_prod_mngmt.rating_build_review.tooltipbox_info': '查看PC SDK对接所需的商品密钥！',
  'studio.transfer_not_available.admin_contact_guide_msg': "目前正在准备数据移交功能。<br/>如需移交服务，请联系stove.support{'@'}smilegate.com！",
  'studio.transfer_in_progress.all_features_unavailable_msg':
    "移交过程中将无法使用任何功能。<br/>请于次日0点(UTC+9)后再次确认！<br/>如有疑问，请联系store.support{'@'}smilegate.com！",
  'studio.product_page.page_display_date_duplicate_msg': '该预约日期已被占用。请重新选择预约日期。',
  'studio.prod_home.pur_cond.pur_cond_type2_tooltip': 'OR条件功能正在开发中。',
  'studio.prj_prod.this_prod.product_data.build.home_build_storage': '团队存储容量',
  'studio.prj_prod.this_prod.product_data.build.home_build_storage_tooltip': '只可上传与之前构建相比有变化的文件！',
  'studio.build_run_option.exe_file_invalid_msg': '你已设置DRM Maker，但可运行文件名不匹配。<br/>请在运行设置中输入包含在DRM列表中的运行文件名！',
  'studio.release_plan.drm_not_applied_msg':
    '为了保护游戏版权，建议在构建详细信息中应用DRM。<br/>如果已输入可运行文件名或最终可运行文件名，最好与DRM Maker保持一致！',
  'studio.release_plan.drm_applied_exe_not_matched_msg':
    'DRM已应用。如果在运行设置中输入了可运行文件名或最终可运行文件名，<br/>为了版权保护，它必须与DRM Maker列表中已应用的文件一致。',
  'studio.prod_page.one_page_only.cannot_del_msg': '仅有一个待应用的商品页面时，无法删除。',
  'studio.prod_page.tooltip_go_to_store_page': '移动到商店页面。',
  'studio.storage.no_folder_available.cannot_move_file_msg': '没有可用于移动文件的文件夹。',
  'studio.uploader.launching_in_progress_msg': '可能需要最多5分钟。请稍等！',
  'studio.event_period_settings.sel_discount_immediate_apply.possible_delay_msg': '选择“立刻”应用优惠后，将在1-5分钟内反映到商店。',
  'studio.execution_setting.review_in_progress.cannot_edit_msg': '检查进行时无法修改。<br/>请确认检查结果后重试。',
  'studio.live_test_page.guide_title': '我们正在准备新的STOVE Studio！',
  'studio.live_test_page.guide_msg': '更新完成后，即可使用STOVE Studio。<br/> \\n 请稍等片刻！',
  'studio.live_test_page.guide_info_service_name': '服务名称',
  'studio.live_test_page.guide_info_test_period': '维护时间',
  'studio.live_test_page.guide_info_test_details': '维护内容',
  'studio.product_page.save_complete_popup': '保存完成。<br/>现在请在商品主页准备发布。',
  'studio.supported_lang.ms': '马来语',
  'studio.supported_lang.ar': '阿拉伯语',
  'studio.supported_lang.nl': '荷兰语',
  'studio.supported_lang.pl': '波兰语',
  'studio.supported_lang.cs': '捷克语',
  'studio.supported_lang.tr': '土耳其语',
  'studio.supported_lang.etc': '其他语言',
  'studio.member_manage.invite_link_activate_guide': '需要启用邀请链接，才能显示链接！',
  'studio.product_page_resumed_msg': '商品页面已重新开放。<br/>请在商品主页 > 商品页面菜单中将显示设置更改为开启（ON）。',
  'studio.prj_prod.this_prod.product_data.build.uploader_file_failed_dll_msg':
    '由于包含 DRMChecker.dll 或 DRMCheckerV3.dll，上传已被中断。请删除该文件后重新上传。 \\n [%ErrorCode%]',
  'studio.discount.discount_rate_min_payment_range_val_msg': '结算价格可存为优惠后的价格，即USD 0或0.99以上，或KRW 0或10韩元以上。',
  'studio.build_test.guide_popup.client_latest_ver_download_msg': '为了进行Studio构建测试，请退出STOVE PC客户端，重新启动并更新至最新版本。',
  'studio.verification_code.check_btn': '查看验证码',
  'studio.prj_prod.this_prod.edit_gamepreview_lang_setting_not': '请确认未添加的语言。',
  'studio.prj_prod.this_prod.edit_gamepreview_file_register_guide': '最多可添加20张图片！<br/>如果未添加图片，将显示基础语言中添加的图片！',
  'studio.drm_intergrity_check.not_available_for_v2_build_msg':
    '2025年3月27日之前添加的构建无法应用DRM制造商和完整性检查选项。<br/>若要更新，请先添加新的构建，然后修改相关选项。',
  'studio.game_build_upload_complete.one_time_popup_msg':
    '如果包含支持DRM制造商和完整性检查的文件，这些功能将自动应用。<br/>上传构建后，请刷新页面以修改DRM和完整性设置。<br/><br/>是否要现在检查构建运行设置？',
  'studio.run_settings_dir_btn': '前往运行设置',
  'studio.dlc_build_upload_complete.one_time_popup_msg': '如果包含支持完整性检查的文件，它将自动应用。<br/>上传构建后，请刷新页面以修改完整性设置。',
  'studio.build_manage.execution_settings_not_entered.cannot_revise_popup':
    '尚未填写运行设置，无法提交内容修改报告。<br/><br/>请填写运行设置并保存。',
  'studio.post_release_build_upd.requirements_by_change_category_guide1': '与当前应用的构建相比，所选构建有哪些变更？',
  'studio.post_release_build_upd.requirements_by_change_category_guide2':
    '如果仅进行Bug修复，可以直接更新构建，无需申报。<br/>其他更改需要提交内容修改申报。',
  'studio.back_to_previous_page_btn': '上一页',
  'studio.build_upd_review_not_required.set_live_schedule_guide':
    '更新信息已保存。<br/>请在运行设置菜单中设置LIVE应用的日期和时间。<br/>必须完成LIVE应用，构建才会实际生效。<br/>如果未应用，则无法生效，请注意。',
  'studio.build_rating_review_dir_btn.go_to_submit_request': '进行游戏分级及构建审核',
  'studio.build_review_complete.set_live_schedule_guide':
    '构建审核已完成。<br/>现在，请前往运行设置菜单并设置LIVE应用日期和时间。<br/>您需要完成LIVE应用，才能使构建和运行设置生效。',
  'studio.build_rating_review_dir_btn.go_to_view_result': '查看游戏分级及构建审核',
  'studio.execution_setting.page_title': 'PC客户端运行设置',
  'studio.execution_setting.settings_saved_no_build_guide':
    '运行设置已保存。<br/>当您上传构建后，相应的运行设置将被应用，让您可以在PC客户端上进行执行测试。',
  'studio.build_mgmt_dir_btn': '上传构建',
  'studio.execution_setting.test_package_tab_tooltip_title': '<b>运行设置已创建。</b>',
  'studio.execution_setting.test_package_tab_tooltip_msg':
    '对于其他上传的构建，您可以在此更改运行设置。<br/>修改后的设置可以应用于LIVE或正在审核中的构建并进行更新。',
  'studio.execution_setting.test_package_guide1':
    '<span class="text-on-surface-elevation-2 font-medium">此设置适用于所有测试构建，</span> <span class="text-brand-primary font-medium">除LIVE状态、内容修改申报、异议申请、职权再分类<br/>或分级调整处理</span><span class="text-on-surface-elevation-2 font-medium">中的构建外。</span>',
  'studio.execution_setting.test_package_guide2': '更改新创建的设置中的运行选项并进行测试。<br/>保存后，点击LIVE应用按钮，该设置将应用于LIVE构建。',
  'studio.execution_setting.fetch_live_package_data_btn': '加载LIVE运行设置',
  'studio.execution_setting.fetch_live_data_confirm_popup': '是否要自动加载LIVE运行设置？<br/>如果加载，您可以修改设置值并进行测试。',
  'studio.execution_setting.fetch_live_data_cf_btn': '加载',
  'studio.common.case_save_btn': '保存',
  'studio.execution_setting.test_package_added.save_tooltip': '可以将运行设置应用于除LIVE或已完成审核的构建外的构建。<br/>保存后，请进行Studio测试。',
  'studio.execution_setting.test_package_added.live_apply_tooltip': '可以将运行设置应用于LIVE或已完成审核的构建。<br/>请在充分测试后应用于LIVE。',
  'studio.execution_setting.live_apply_popup_title': '应用至LIVE',
  'studio.execution_setting.live_apply_popup_select_build': '选择构建',
  'studio.execution_setting.live_apply_popup_build_required_msg': '请选择要应用的构建。',
  'studio.execution_setting.live_apply_date_title': 'LIVE应用日期',
  'studio.execution_setting.live_apply_popup_immediate': '立即',
  'studio.execution_setting.live_apply_popup_scheduled': '预约',
  'studio.event_period_settings.execution_setting.before_current_time_invalid_msg': '请选择当前时间之后的日期。',
  'studio.execution_setting.select_build.build_category_live': '[LIVE应用中]',
  'studio.execution_setting.select_build.build_category_under_review': '[审核中]',
  'studio.execution_setting.select_build.build_category_review_passed': '[审核完成]',
  'studio.execution_setting.select_build.build_category_fix_bug': '[bug修复]',
  'studio.execution_setting.select_build.build_category_direct_input': '[游戏分级手动输入]',
  'studio.execution_setting.select_build.build_scheduled': '[预约]',
  'studio.execution_setting.test_tab': '运行设置',
  'studio.execution_setting.scheduled_tab': '运行设置预约',
  'studio.execution_setting.live_tab': 'LIVE运行设置',
  'studio.execution_setting.scheduled_info_guide': '构建和执行设置将应用于LIVE。',
  'studio.execution_setting.build_info': '构建信息',
  'studio.build_exe_test_ok.popup_title': '测试确认',
  'studio.build_exe_test_ok.popup_guide': "如果您已完成测试，请输入'TESTOK'。<br/>未测试直接进行，可能会在游戏运行过程中出现问题。",
  'studio.common.popup_case_next_btn': '继续 ',
  'studio.execution_setting.scheduled_pack_cancel_btn': '取消计划',
  'studio.execution_setting.scheduled_pack_cancel_confirm_popup': 'LIVE执行设置已被排定。取消后需要重新设置。<br/>是否继续？',
  'studio.brand_page.feature2-1_main_title': '尝试邀请成员并管理角色',
  'studio.brand_page.feature2-1_sub_title': '将成员邀请到群组并分配角色。',
  'studio.execution_setting.select_scheduled_build.warning_msg': '原先已排定的构建将被取消，并由新的构建替代。',
  'studio.execution_setting.exe_file_extension_required_msg': '请在运行文件名中填写“.exe”。',
  'studio.execution_setting.final_exe_entered.exe_file_required_msg': '如果已输入最终运行文件，请同时输入运行文件。',
  'studio.prj_prod.execution_install_new_guide_pc_sub_des4': '工具类产品可以不带运行文件进行注册，此时 STOVE PC客户端 将打开安装文件夹。',
  'studio.member_manage.new_join_request_guide': '已有{requestNum}位成员申请加入。<br/>请点击下方的［待加入］按钮查看！',
  'studio.business_bank_setting.checkbox_use_representative_info': '与代表人信息相同。',
  'studio.business_bank_setting.non_kr_postal_code_place_holder': '邮政编码（选填）',
  'studio.business_bank_setting.jp_address_place_holder': '请输入地址（选填）',
  'studio.business_bank_setting.non_kr_detailed_address_place_holder': '请输入详细地址（选填）',
  'studio.business_bank_setting.usa_building_name_place_holder': '请输入大楼名称（选填）',
  'studio.business_bank_setting.usa_street_name_place_holder': '请输入街道名称（选填）',
  'studio.business_bank_setting.usa_city_name_place_holder': '请输入城市名称（选填）',
  'studio.business_bank_setting.usa_district_name_place_holder': '请输入道/市/郡（选填）',
  'studio.build_manage.upload_description_required_msg': '请输入构建说明。',
  'studio.common.def_key.emoji_n': '请勿使用表情符号。',
  'studio.execution_setting.live_apply_popup_select_build_guide':
    '在构建管理菜单中，仅显示已完成错误修复或内容修改报告等操作的构建。<br/>但如果是手动输入韩国等级信息的情况，将显示所有已上传的构建。',
  'studio.build_manage.review_completed_build_update.all_data_reset_msg':
    '该构建已完成内容修改申报、异议申请、职权再分类或分级调整处理，并已计划应用至LIVE。<br/><br/>如果重新发起审核，之前的审核结果及已排定的LIVE应用将全部取消。是否继续？',
  'studio.execution_setting.select_build.build_category_utility': '[已保存更新]',
  'studio.execution_setting.select_build.build_category_coming_soon': '[计划发布]',
  'studio.execution_setting.data_empty.cannot_apply_live_msg':
    '由于临时错误，运行选项未能成功保存。给您带来不便，我们深感抱歉。请再次尝试应用至LIVE。'
};
